msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-21 16:13-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid " - Monitor for potential changes"
msgstr " - Monitorear posibles cambios"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag a window and give it a title and description. "
msgstr " — arrastre para definir un intervalo y asígnele un título y una descripción. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag across a window for its High, Low, Range, and Mean. Drag the edges to adjust; "
msgstr " — arrastre sobre un intervalo para ver su máximo, mínimo, rango y promedio. Arrastre los bordes para ajustarlo; "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — drag the edge of either side pane, or the divider between Tags and Tag Configuration."
msgstr " — arrastre el borde de cualquiera de los paneles laterales o el separador entre Etiquetas y Configuración de etiquetas."

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid " — mark label rows as “anomaly” on the right, or draw labels in View mode."
msgstr " — marque las filas de etiquetas como “anomalía” a la derecha o dibuje etiquetas en el modo Vista."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — one click pins a sample's value and timestamp."
msgstr " — un clic fija el valor y la marca de tiempo de una muestra."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " — signing…"
msgstr " — firmando…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the bell shows or hides them on the chart. "
msgstr " — la campana las muestra u oculta en el gráfico. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the eye on the Selected Tags rail hides every pen at once; click any row to hide or show just that one."
msgstr " — el ojo del panel Etiquetas seleccionadas oculta todos los trazos a la vez; haga clic en una fila para ocultar o mostrar solo ese trazo."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the info icon on the Tags pane and the Selected Tags rail shows or hides them."
msgstr " — el icono de información de los paneles Etiquetas y Etiquetas seleccionadas las muestra u oculta."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the list narrows as you type, matching tag names and descriptions at once."
msgstr " — la lista se filtra mientras escribe y busca a la vez en los nombres y las descripciones de las etiquetas."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " — the panel buttons at the top right hide either side rail entirely."
msgstr " — los botones de panel de la esquina superior derecha ocultan por completo cualquiera de los paneles laterales."

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid " · {magnitude}× band"
msgstr " · banda de {magnitude}×"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " · drift "
msgstr " · deriva "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " · err scale "
msgstr " · escala del error "

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid " · kept {formattedKept}"
msgstr " · conservados {formattedKept}"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · measured"
msgstr " · medido"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · method "
msgstr " · método "

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · n="
msgstr " · n="

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · n={value356_38}"
msgstr " · n={value356_38}"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " · residual"
msgstr " · residuo"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid " · Rev {revision}"
msgstr " · Rev. {revision}"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · split_date="
msgstr " · split_date="

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid " · std"
msgstr " · desv. est."

#: src/features/timeSeries/experiment/CleaningControls.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " · target"
msgstr " · objetivo"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid " · target "
msgstr " · objetivo "

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · test "
msgstr " · prueba "

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · test="
msgstr " · prueba="

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · train "
msgstr " · entrenamiento "

#: src/features/sentinels/components/SentinelList.tsx
#: src/features/sentinels/components/SentinelList.tsx
msgid " · updated"
msgstr " · actualizado"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid " · val"
msgstr " · validación"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " · val="
msgstr " · validación="

#: src/features/sentinels/components/CasesPanel.tsx
msgid " (band ±"
msgstr " (banda ±"

#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid " (derived)"
msgstr " (derivado)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " (every"
msgstr " (cada"

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid " (predicted)"
msgstr " (previsto)"

#: src/features/timeSeries/components/InterpolatedValueTooltip.tsx
msgid " (predicted):"
msgstr " (previsto):"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " (q={value315_25})"
msgstr " (q={value315_25})"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid " (r={value296_31})"
msgstr " (r={value296_31})"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " (revision {planRevision} — redesigning replaces it)"
msgstr " (revisión {planRevision}; rediseñarlo la reemplaza)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " (saved"
msgstr " (guardado"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " (the most recent "
msgstr " (el más reciente "

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " = k ("
msgstr " = k ("

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid " ⚠ in training data"
msgstr " ⚠ en datos de entrenamiento"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " across the chart to zoom into a time window."
msgstr " a lo largo del gráfico para ampliar un intervalo de tiempo."

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid " add event"
msgstr " agregar evento"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid " add range"
msgstr " agregar rango"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid " Add window"
msgstr " Agregar intervalo"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " adds separate name and description fields, AND/OR matching, multi-select, and filtering by point source and recent data. "
msgstr " agrega campos separados de nombre y descripción, coincidencias AND/OR, selección múltiple y filtros por origen de puntos y datos recientes. "

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " and has neither finished nor failed — its training job was likely killed. Delete it and design a new one."
msgstr " y no ha terminado ni fallado; es probable que el trabajo de entrenamiento se haya detenido. Elimínelo y diseñe uno nuevo."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " around expected / zero residual."
msgstr " alrededor del valor esperado o del residuo cero."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " brings you back."
msgstr " le permite volver."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " calibration rows ("
msgstr " filas de calibración ("

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid " can never happen — this rule would never fire."
msgstr " nunca puede ocurrir; esta regla nunca se activaría."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " captures the chart as an image."
msgstr " captura el gráfico como imagen."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " Case opened at {value492_41} — see the Monitor tab."
msgstr " Caso abierto el {value492_41}; consulte la pestaña Monitor."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " connects them, sloping between samples for analog tags and holding each value until the next one for digital and step tags."
msgstr " los conecta: traza una pendiente entre muestras en las etiquetas analógicas y mantiene cada valor hasta el siguiente en las etiquetas digitales y escalonadas."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid " days out of "
msgstr " días de "

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid " days per run — shorten the range."
msgstr " días por ejecución; acorte el rango."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " days, native interval"
msgstr " días, intervalo nativo"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid " Details"
msgstr " Detalles"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " discards local edits and reloads the saved version."
msgstr " descarta las modificaciones locales y vuelve a cargar la versión guardada."

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid " each side (step "
msgstr " a cada lado (paso "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " finds both"
msgstr " encuentra ambos"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid " It stopped reporting a while ago — its job most likely died. Start it again below; nothing was kept."
msgstr " Dejó de informar hace un tiempo; lo más probable es que el trabajo haya terminado inesperadamente. Inícielo de nuevo abajo; no se conservó nada."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " keeps your changes; the pencil renames. The first save of a new view asks for a name."
msgstr " conserva los cambios; el lápiz permite cambiar el nombre. Al guardar una vista nueva por primera vez, se solicita un nombre."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading drivers…"
msgstr " Cargando variables predictoras…"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid " Loading labels…"
msgstr " Cargando etiquetas…"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading sentinel…"
msgstr " Cargando centinela…"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Loading sentinels…"
msgstr " Cargando centinelas…"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " min), scored with models trained through "
msgstr " min), evaluados con modelos entrenados hasta "

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid " Opening case…"
msgstr " Abriendo caso…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " opens the full list to rename or delete;"
msgstr " abre la lista completa para cambiar nombres o eliminar;"

#: src/features/timeSeries/components/InterpolatedValueTooltip.tsx
msgid " out of band"
msgstr " fuera de la banda"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " outside the band (white dots on the chart). Worst offenders:"
msgstr " fuera de la banda (puntos blancos del gráfico). Mayores desviaciones:"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid " overlap training data"
msgstr " se superponen con los datos de entrenamiento"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " per period, drawn beside the raw pen."
msgstr " por período, dibujado junto al trazo original."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " removes a chip."
msgstr " elimina un término."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid " rows · train="
msgstr " filas · entrenamiento="

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid " sec)"
msgstr " s)"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Sentinels"
msgstr " Centinelas"

#: src/pages/metrics/Metrics.tsx
msgid " Showing the last loaded selection below."
msgstr " A continuación se muestra la última selección cargada."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " shows the actual sampled values;"
msgstr " muestra los valores muestreados reales;"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid " slots bound"
msgstr " campos vinculados"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " starts blank."
msgstr " comienza en blanco."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to box-zoom both axes."
msgstr " para ampliar un área en ambos ejes."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " to build one."
msgstr " para crear uno."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to lock a term in as a "
msgstr " para fijar un término como "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid " to put it away."
msgstr " para guardarlo."

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid " to upload reports"
msgstr " para cargar informes"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid " Training — this updates on its own."
msgstr " Entrenando; esto se actualiza automáticamente."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid " vs expected"
msgstr " frente a lo esperado"

#: src/features/sentinels/components/CasesPanel.tsx
msgid " vs expected "
msgstr " frente a lo esperado "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "-day scoring limit, so the band covers "
msgstr "-días de límite de evaluación; la banda cubre "

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "— not present"
msgstr "— no presente"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", below the tag list, sets each pen's color and y-axis — one scale per pen with "
msgstr ", debajo de la lista de etiquetas, establece el color y el eje Y de cada trazo: una escala por trazo con "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", or a shared one with "
msgstr ", o una escala compartida con "

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ", started"
msgstr ", iniciado"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid ", then add another. Every chip must match, in any order — no wildcards needed: "
msgstr ", luego agregue otro. Todos los términos deben coincidir, en cualquier orden; no se necesitan comodines: "

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid ". Changing the dates above moves the chart to match."
msgstr ". Al cambiar las fechas de arriba, el gráfico se ajusta a ellas."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid ". Fresh data"
msgstr ". Datos recientes"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". It updates on its own; every run gets its own sentinel, so a second target off this same context is a new saved model."
msgstr ". Se actualiza automáticamente; cada ejecución tiene su propio centinela, por lo que un segundo objetivo con este mismo contexto es un nuevo modelo guardado."

#: src/features/sentinels/components/MonitorTab.tsx
msgid ". Lower is tighter (more sensitive); the fit seeded this from the model's own band."
msgstr ". Un valor menor ajusta más la banda (mayor sensibilidad); el ajuste inicial proviene de la propia banda del modelo."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". The plots, metrics and served model are on the sentinel itself."
msgstr ". Los gráficos, las métricas y el modelo publicado están en el propio centinela."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ". You can retry or build without it."
msgstr ". Puede volver a intentarlo o crear el modelo sin ello."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· <0>edited</0>"
msgstr "· <0>editado</0>"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "· applied "
msgstr "· aplicado "

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "· Downloaded {downloadedAgo}"
msgstr "· Descargado {downloadedAgo}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· kind: <0>{kind}</0>"
msgstr "· tipo: <0>{kind}</0>"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgctxt "LOTO panel title"
msgid "· page {pageNumber}"
msgstr "· página {pageNumber}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· ref: <0/>"
msgstr "· ref.: <0/>"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "· rows "
msgstr "· filas "

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· source: <0>{source}</0>"
msgstr "· fuente: <0>{source}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· tag: <0>{tagDerived}</0>"
msgstr "· etiqueta: <0>{tagDerived}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· value: <0>{displayValue}</0>"
msgstr "· valor: <0>{displayValue}</0>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "· value: <0>null</0>"
msgstr "· valor: <0>null</0>"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "“{name}” will be removed for everyone at this site. The attached documents are not affected."
msgstr "“{name}” se eliminará para todos en este sitio. Los documentos adjuntos no se ven afectados."

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "\"{selfText}\" is this document's own drawing number"
msgstr "\"{selfText}\" es el número de plano de este mismo documento"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty message)"
msgstr "(mensaje vacío)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty payload)"
msgstr "(carga útil vacía)"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(empty)"
msgstr "(vacío)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentCardResultCountLabel.tsx
msgid "(filtered from {totalCountLabel})"
msgstr "(filtrado de {totalCountLabel})"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "(Manufacturer Unknown) {model}"
msgstr "(Fabricante desconocido) {model}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no content)"
msgstr "(sin contenido)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no description)"
msgstr "(sin descripción)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no evidence refs)"
msgstr "(sin referencias de evidencia)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no payload fields)"
msgstr "(sin campos de carga útil)"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(no thresholds)"
msgstr "(sin umbrales)"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "(occurred {occurredLabel})"
msgstr "(ocurrió {occurredLabel})"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "(payload not loaded)"
msgstr "(carga útil no cargada)"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ") — change it with the range selector below the chart."
msgstr "); cámbielo con el selector de rango debajo del gráfico."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid ") × err_scale ("
msgstr ") × err_scale ("

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid ") where err_scale ="
msgstr ") donde err_scale ="

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "). No retraining."
msgstr "). Sin volver a entrenar."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "). Not per-day or per-point — one scalar per model."
msgstr "). No por día ni por punto; un único escalar por modelo."

#: src/features/chatbot/components/CitationTooltip.tsx
msgid "[{abbreviatedFile}, {abbreviatedSection}, p.{pageNumber}]"
msgstr "[{abbreviatedFile}, {abbreviatedSection}, p.{pageNumber}]"

#: src/features/richText/nodes/ImageNode.tsx
#: src/features/richText/nodes/ImageNode.tsx
msgid "[Image]"
msgstr "[Imagen]"

#: src/features/timeSeries/components/timeSeriesScatterplot/useUPlotGenerators.ts
msgid "[non-string-label]"
msgstr "[non-string-label]"

#. placeholder {0}: activeFilterPills.length
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{0, plural, one {# active filter} other {# active filters}}"
msgstr "{0, plural, one {# filtro activo} other {# filtros activos}}"

#. placeholder {0}: counts.alerts
#. placeholder {0}: target.alerts.length
#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{0, plural, one {# alert} other {# alerts}}"
msgstr "{0, plural, one {# alerta} other {# alertas}}"

#. placeholder {0}: allAliasKeys.length
#: src/features/fimReview/ReviewActions.tsx
msgid "{0, plural, one {# alias} other {# aliases}}"
msgstr "{0, plural, one {# alias} other {# alias}}"

#. placeholder {0}: dataIssues.length
#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "{0, plural, one {# Asset Instance not represented in the catalog} other {# Asset Instances not represented in the catalog}}"
msgstr "{0, plural, one {# instancia de activo no representada en el catálogo} other {# instancias de activo no representadas en el catálogo}}"

#. placeholder {0}: props.numTotalUnitsAtSite
#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "{0, plural, one {# Asset} other {# Assets}}"
msgstr "{0, plural, one {# activo} other {# activos}}"

#. placeholder {0}: citation.region.boxes.length
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "{0, plural, one {# box} other {# boxes}}"
msgstr "{0, plural, one {# recuadro} other {# recuadros}}"

#. placeholder {0}: mdCasesWithDiagnostics.length
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{0, plural, one {# case excluded due to M&D diagnostics.} other {# cases excluded due to M&D diagnostics.}}"
msgstr "{0, plural, one {# caso excluido debido a diagnósticos de M&D.} other {# casos excluidos debido a diagnósticos de M&D.}}"

#. placeholder {0}: slot.channel_count
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {# channel} other {# channels}}"
msgstr "{0, plural, one {# canal} other {# canales}}"

#. placeholder {0}: missing.length
#: src/features/fimReview/InspectSources.tsx
msgid "{0, plural, one {# constituent record is no longer in this site’s source data.} other {# constituent records are no longer in this site’s source data.}}"
msgstr "{0, plural, one {# registro constituyente ya no está en los datos de origen de este sitio.} other {# registros constituyentes ya no están en los datos de origen de este sitio.}}"

#. placeholder {0}: counts.documents
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# doc} other {# docs}}"
msgstr "{0, plural, one {# doc} other {# docs}}"

#. placeholder {0}: conversation.turn_count
#. placeholder {0}: s.messageCount
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# mensaje} other {# mensajes}}"

#. placeholder {0}: stats.open
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "{0, plural, one {# Open Anomaly} other {# Open Anomalies}}"
msgstr "{0, plural, one {# anomalía abierta} other {# anomalías abiertas}}"

#. placeholder {0}: subjectLineage.length
#: src/features/fimReview/IdentityPanel.tsx
msgid "{0, plural, one {# prior Subject} other {# prior Subjects}}"
msgstr "{0, plural, one {# sujeto anterior} other {# sujetos anteriores}}"

#. placeholder {0}: models.length
#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "{0, plural, one {# saved model} other {# saved models}}"
msgstr "{0, plural, one {# modelo guardado} other {# modelos guardados}}"

#. placeholder {0}: group.sites.length
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "{0, plural, one {# site} other {# sites}}"
msgstr "{0, plural, one {# sitio} other {# sitios}}"

#. placeholder {0}: alertCard.streamCount
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "{0, plural, one {# stream} other {# streams}}"
msgstr "{0, plural, one {# flujo} other {# flujos}}"

#. placeholder {0}: p.after_subjects.length
#: src/features/fimReview/DecisionHistory.tsx
msgid "{0, plural, one {# subject} other {# subjects}}"
msgstr "{0, plural, one {# sujeto} other {# sujetos}}"

#. placeholder {0}: subsystems.length
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{0, plural, one {# subsystem} other {# subsystems}}"
msgstr "{0, plural, one {# subsistema} other {# subsistemas}}"

#. placeholder {0}: counts.tags
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# tag} other {# tags}}"
msgstr "{0, plural, one {# tag} other {# tags}}"

#. placeholder {0}: counts.timeWindows
#: src/features/chatbot/components/AttachmentPills.tsx
msgid "{0, plural, one {# time range} other {# time ranges}}"
msgstr "{0, plural, one {# rango de tiempo} other {# rangos de tiempo}}"

#. placeholder {0}: candidateRows.length
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {# unconfirmed candidate} other {# unconfirmed candidates}}"
msgstr "{0, plural, one {# candidato sin confirmar} other {# candidatos sin confirmar}}"

#. placeholder {0}: activityEvents.length
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "{0, plural, one {# update} other {# updates}}"
msgstr "{0, plural, one {# actualización} other {# actualizaciones}}"

#. placeholder {0}: group.overflow.count
#. placeholder {0}: group.overflowCount
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/mdCases/components/CaseStorySection.tsx
msgid "{0, plural, one {+ # additional linked alert} other {+ # additional linked alerts}}"
msgstr "{0, plural, one {+ # alerta vinculada adicional} other {+ # alertas vinculadas adicionales}}"

#. placeholder {0}: reviewSaves.failedCount
#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "{0, plural, one {A review did not save. Open it to retry or discard it.} other {# reviews did not save. Open them to retry or discard them.}}"
msgstr "{0, plural, one {Una revisión no se guardó. Ábrela para reintentar o descartarla.} other {# revisiones no se guardaron. Ábrelas para reintentar o descartarlas.}}"

#. placeholder {0}: emails.length || 1
#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{0, plural, one {Invite} other {Invite # people}}"
msgstr "{0, plural, one {Invitar} other {Invitar a # personas}}"

#. placeholder {0}: folded.length
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{0, plural, one {No evidence yet for # optional slot:} other {No evidence yet for # optional slots:}}"
msgstr "{0, plural, one {Aún no hay evidencia para # espacio opcional:} other {Aún no hay evidencia para # espacios opcionales:}}"

#. placeholder {0}: inspectionReports.length
#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "{0, plural, one {Report} other {Reports}}"
msgstr "{0, plural, one {Informe} other {Informes}}"

#. placeholder {0}: subjectLineage.length
#: src/features/fimReview/IdentityPanel.tsx
msgid "{0, plural, one {This Subject includes records that previously belonged to another Subject.} other {This Subject includes records that previously belonged to # other Subjects.}}"
msgstr "{0, plural, one {Este sujeto incluye registros que antes pertenecían a otro sujeto.} other {Este sujeto incluye registros que antes pertenecían a otros # sujetos.}}"

#. placeholder {0}: selected.length
#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "{0, plural, one {Type: #} other {Types: #}}"
msgstr "{0, plural, one {Tipo: #} other {Tipos: #}}"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}{value121_36} = {value122_7}h"
msgstr "{abs} × {interval}{value121_36} = {value122_7}h"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}{value127_36} = {value128_7}min"
msgstr "{abs} × {interval}{value127_36} = {value128_7}min"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "{abs} × {interval}s = {seconds}s"
msgstr "{abs} × {interval}s = {seconds}s"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{activeCount} active"
msgstr "{activeCount} activos"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "{activeHitNumber} of {hitCount}"
msgstr "{activeHitNumber} de {hitCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{added} added"
msgstr "{added} agregados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsMoney.ts
msgid "{amount} (currency not supplied)"
msgstr "{amount} (moneda no proporcionada)"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "{anomalyCount, plural, one {# anomaly detected in current timeframe} other {# anomalies detected in current timeframe}}"
msgstr "{anomalyCount, plural, one {# anomalía detectada en el período actual} other {# anomalías detectadas en el período actual}}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{archivedCount} archived"
msgstr "{archivedCount} archivados"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "{axis} axis"
msgstr "Eje {axis}"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "{baselineRows} baseline rows · data through {dataThrough}"
msgstr "{baselineRows} filas de referencia · datos hasta {dataThrough}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{boundSlots} of {slotCount}"
msgstr "{boundSlots} de {slotCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "{capCount} bins reached the calculation cap. These are not precise life estimates."
msgstr "{capCount} celdas alcanzaron el límite de cálculo. No son estimaciones precisas de vida útil."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{changed} changed"
msgstr "{changed} modificados"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{checkCount} · {signals} signals"
msgstr "{checkCount} · {signals} señales"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{checks, plural, one {# check} other {# checks}}"
msgstr "{checks, plural, one {# comprobación} other {# comprobaciones}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "{chipLabel} · p.{pageNum}"
msgstr "{chipLabel} · p.{pageNum}"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "{count, plural, one {# Connected Asset} other {# Connected Assets}}"
msgstr "{count, plural, one {# activo conectado} other {# activos conectados}}"

#: src/features/kestrelViewer/labelOverlay/LabelOverlayLayer.tsx
msgid "{count, plural, one {# label} other {# labels}}"
msgstr "{count, plural, one {# etiqueta} other {# etiquetas}}"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{count, plural, one {# open item} other {# open items}}"
msgstr "{count, plural, one {# elemento pendiente} other {# elementos pendientes}}"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "{count, plural, one {# record} other {# records}}"
msgstr "{count, plural, one {# registro} other {# registros}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{count, plural, one {# result} other {# results}}"
msgstr "{count, plural, one {# resultado} other {# resultados}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{count, plural, one {Retrieved # source} other {Retrieved # sources}}"
msgstr "{count, plural, one {Se encontró # fuente} other {Se encontraron # fuentes}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} available"
msgstr "{count} disponibles"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} missing"
msgstr "{count} faltantes"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{count} need review (not counted as missing)"
msgstr "{count} requieren revisión (no se cuentan como faltantes)"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "{coverage} of pages have a human confirmation"
msgstr "{coverage} de las páginas tienen una confirmación humana"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{current} of {total}"
msgstr "{current} de {total}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/PaginationControls.tsx
msgid "{currentPageNumber} of {totalPages}"
msgstr "{currentPageNumber} de {totalPages}"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "{currentPosition} of {totalCount}"
msgstr "{currentPosition} de {totalCount}"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{currentTypeLabel} — User type"
msgstr "{currentTypeLabel} — Tipo de usuario"

#: src/pages/manageAccess/components/userType/UserTypeSelect.tsx
msgid "{currentTypeLabel} — user type for {personName}"
msgstr "{currentTypeLabel} — tipo de usuario de {personName}"

#: src/features/modelOperations/fimShared.ts
msgid "{day}d ago"
msgstr "hace {day} d"

#: src/features/fimReview/relativeTime.ts
msgid "{days}d ago"
msgstr "hace {days} d"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "{daysBeyond}/{ofDays} days"
msgstr "{daysBeyond}/{ofDays} días"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "{deleted} file(s) deleted, {failed} failed. Retry to delete the remaining files."
msgstr "Archivos eliminados: {deleted}. Eliminaciones fallidas: {failed}. Vuelve a intentarlo para eliminar los archivos restantes."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{docs, plural, one {# doc} other {# docs}}"
msgstr "{docs, plural, one {# doc.} other {# docs.}}"

#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "{document} · page {pageNumber}"
msgstr "{document} · página {pageNumber}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetOpenOnDrawing.tsx
msgid "{document} p.{pageNumber}"
msgstr "{document} p. {pageNumber}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "{documentCount, plural, one {# source} other {# sources}}"
msgstr "{documentCount, plural, one {# fuente} other {# fuentes}}"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "{documentName} · page {pageNumber}"
msgstr "{documentName} · página {pageNumber}"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "{drawingName} p.{pageList}"
msgstr "{drawingName} pág. {pageList}"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "{drawingNumber} · page {pageNumber}"
msgstr "{drawingNumber} · página {pageNumber}"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "{driverCount} drivers"
msgstr "{driverCount} variables predictoras"

#: src/pages/cases/md/MdCaseDetailsProvider.tsx
msgid "{entryTypeLabel} Updated"
msgstr "{entryTypeLabel} actualizado"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "{existingFileCount} files"
msgstr "{existingFileCount} archivos"

#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
msgid "{extensionTitle} Error"
msgstr "Error de {extensionTitle}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "{extraDatapointCount, plural, one {+# more datapoint} other {+# more datapoints}}"
msgstr "{extraDatapointCount, plural, one {+# punto de dato más} other {+# puntos de dato más}}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "{fieldLabel} updated"
msgstr "{fieldLabel} actualizado"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
msgid "{fileCount, plural, one {# file} other {# files}}"
msgstr "{fileCount, plural, one {# archivo} other {# archivos}}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "{fileCount, plural, one {# file} other {# files}} · {createdAt}"
msgstr "{fileCount, plural, one {# archivo} other {# archivos}} · {createdAt}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "{filename} + {remainingCount} more"
msgstr "{filename} + {remainingCount} más"

#: src/features/facilityModel/columns.ts
msgid "{filledCount} filled, {gapCount} gaps of {totalCount}"
msgstr "{filledCount} completados, {gapCount} vacíos de {totalCount}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{finishedUploadAttemptCountLabel} / {expectedUploadCountLabel} files · {uploadedPercent}%"
msgstr "{finishedUploadAttemptCountLabel} / {expectedUploadCountLabel} archivos · {uploadedPercent}%"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/StreamingReferences.tsx
msgid "{first} +{rest} more"
msgstr "{first} +{rest} más"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "{firstVisibleRowLabel}-{lastVisibleRowLabel} of {totalRows}"
msgstr "{firstVisibleRowLabel}-{lastVisibleRowLabel} de {totalRows}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
msgid "{folderCount, plural, one {# folder} other {# folders}}"
msgstr "{folderCount, plural, one {# carpeta} other {# carpetas}}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted} °F"
msgstr "{formatted} °F"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted} dB"
msgstr "{formatted} dB"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "{formatted} pts vs {versionLabel}"
msgstr "{formatted} pts vs. {versionLabel}"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "{formatted} pts vs previous config"
msgstr "{formatted} pts vs. la configuración anterior"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted}%"
msgstr "{formatted}%"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "{formatted}°F"
msgstr "{formatted}°F"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "{fromLabel} -> {toLabel}"
msgstr "{fromLabel} -> {toLabel}"

#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "{groupCount, plural, one {Found {totalDuplicates} CDFs with identical parameters in # group} other {Found {totalDuplicates} CDFs with identical parameters in # groups}}"
msgstr "{groupCount, plural, one {Se encontraron {totalDuplicates} CDF con parámetros idénticos en # grupo} other {Se encontraron {totalDuplicates} CDF con parámetros idénticos en # grupos}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{headline} ({impact} impact)"
msgstr "{headline} (impacto {impact})"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "{hidablePenCount, plural, one {Hide the # tag pen, leaving the KPI and its expectation} other {Hide all # tag pens, leaving the KPI and its expectation}}"
msgstr "{hidablePenCount, plural, one {Ocultar el trazo de la etiqueta y dejar el KPI y su valor esperado} other {Ocultar los trazos de las # etiquetas y dejar el KPI y su valor esperado}}"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "{hidablePenCount, plural, one {Show the # tag pen again} other {Show the # tag pens again}}"
msgstr "{hidablePenCount, plural, one {Volver a mostrar el trazo de # etiqueta} other {Volver a mostrar los trazos de # etiquetas}}"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "{hitCount}-source"
msgstr "{hitCount} fuentes"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{hours} h"
msgstr "{hours} h"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "{hours} hour{value138_27} ago"
msgstr "hace {hours} hora{value138_27}"

#: src/features/fimReview/relativeTime.ts
msgid "{hours}h ago"
msgstr "hace {hours} h"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
#: src/features/timeSeries/agentTab/useAgentView.ts
msgid "{hours}h rolling average of {tag}"
msgstr "Promedio móvil de {hours} h de {tag}"

#: src/features/modelOperations/fimShared.ts
msgid "{hr}h ago"
msgstr "hace {hr} h"

#: src/features/timeSeries/agentTab/chat/TagLinkedMarkdown.tsx
msgid "{id} · add to the chart"
msgstr "{id} · añadir al gráfico"

#: src/features/timeSeries/agentTab/chat/TagLinkedMarkdown.tsx
msgid "{id} · on the chart"
msgstr "{id} · en el gráfico"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "{inviteCount, plural, one {Invite {personName} as an administrator?} other {Invite these # people as administrators?}}"
msgstr "{inviteCount, plural, one {¿Invitar a {personName} como administrador?} other {¿Invitar a estas # personas como administradores?}}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "{issueCount} of {issueCount} issues"
msgstr "{issueCount} de {issueCount} problemas"

#: src/features/fimReview/InspectSources.tsx
msgid "{kind} · {precision} · norm: {norm}"
msgstr "{kind} · {precision} · norma: {norm}"

#: src/features/knowledgeDocumentViewer/artifacts/pdf/PdfFooter.tsx
msgid "{label} · Page {pageNumber} of {totalPages}"
msgstr "{label} · Página {pageNumber} de {totalPages}"

#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
msgid "{label} (You are here)"
msgstr "{label} (Usted está aquí)"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "{label} failed: {reason}"
msgstr "{label} falló: {reason}"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "{label} information"
msgstr "Información de {label}"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "{label} is required for every invitation and cannot be removed."
msgstr "{label} es obligatorio en cada invitación y no se puede quitar."

#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "{leading}, and {last}"
msgstr "{leading} y {last}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{linkedDocsCount, plural, one {# linked document} other {# linked documents}}"
msgstr "{linkedDocsCount, plural, one {# documento vinculado} other {# documentos vinculados}}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
msgid "{linkedDocumentCount} linked documents"
msgstr "{linkedDocumentCount} documentos vinculados"

#: src/features/timeSeries/services/thresholdService.ts
msgid "{lowerName} threshold ({lowerValue}) must be less than {upperName} threshold ({upperValue})"
msgstr "El umbral {lowerName} ({lowerValue}) debe ser menor que el umbral {upperName} ({upperValue})"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "{magnitudeLabel}× band"
msgstr "Banda de {magnitudeLabel}×"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "{manufacturer} (Model Unknown)"
msgstr "{manufacturer} (modelo desconocido)"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "{matchCount} matching documents — click to choose"
msgstr "{matchCount} documentos coincidentes — haga clic para elegir"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{matchedCount} matched in system"
msgstr "{matchedCount} coinciden en el sistema"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{matchedCount} matched in system · {unmatchedCount} may be missing"
msgstr "{matchedCount} coinciden en el sistema · {unmatchedCount} pueden faltar"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "{maxDecibel} dB"
msgstr "{maxDecibel} dB"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "{maxTemp}°F"
msgstr "{maxTemp}°F"

#: src/features/modelOperations/fimShared.ts
msgid "{min}m ago"
msgstr "hace {min} min"

#: src/features/fimReview/relativeTime.ts
msgid "{mins}m ago"
msgstr "hace {mins} min"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{minutes} min"
msgstr "{minutes} min"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "{minutes} minute{value136_49} ago"
msgstr "hace {minutes} minuto{value136_49}"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "{minutes}m"
msgstr "{minutes}m"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "{minutes}m {remainingSeconds}s"
msgstr "{minutes}m {remainingSeconds}s"

#: src/features/fim/matchingRuns.ts
msgid "{minutes}m {seconds}s"
msgstr "{minutes} min {seconds} s"

#: src/features/timeSeries/agentTab/useActiveModel.ts
msgid "{modelName} · expected ±{bandSigmas}σ"
msgstr "{modelName} · esperado ±{bandSigmas}σ"

#: src/features/modelOperations/fimShared.ts
msgid "{mon}mo ago"
msgstr "hace {mon} meses"

#: src/pages/metrics/helpers/monthly.ts
msgid "{monthLabel} MTD"
msgstr "{monthLabel} (parcial)"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Checked data coverage on # tag} other {Checked data coverage on # tags}}"
msgstr "{n, plural, one {Se verificó la cobertura de datos en # etiqueta} other {Se verificó la cobertura de datos en # etiquetas}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Checking data coverage on # tag} other {Checking data coverage on # tags}}"
msgstr "{n, plural, one {Verificando la cobertura de datos en # etiqueta} other {Verificando la cobertura de datos en # etiquetas}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Cross-checked # tag against each other} other {Cross-checked # tags against each other}}"
msgstr "{n, plural, one {Se cotejó # etiqueta} other {Se cotejaron # etiquetas entre sí}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Cross-checking # tag against each other} other {Cross-checking # tags against each other}}"
msgstr "{n, plural, one {Cotejando # etiqueta} other {Cotejando # etiquetas entre sí}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitted {kpi} against # driver} other {Fitted {kpi} against # drivers}}"
msgstr "{n, plural, one {Se ajustó {kpi} respecto de # variable predictora} other {Se ajustó {kpi} respecto de # variables predictoras}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitted the model against # driver} other {Fitted the model against # drivers}}"
msgstr "{n, plural, one {Se ajustó el modelo respecto de # variable predictora} other {Se ajustó el modelo respecto de # variables predictoras}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitting {kpi} against # driver} other {Fitting {kpi} against # drivers}}"
msgstr "{n, plural, one {Ajustando {kpi} respecto de # variable predictora} other {Ajustando {kpi} respecto de # variables predictoras}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Fitting the model against # driver} other {Fitting the model against # drivers}}"
msgstr "{n, plural, one {Ajustando el modelo respecto de # variable predictora} other {Ajustando el modelo respecto de # variables predictoras}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulled # tag into {dataset}} other {Pulled # tags into {dataset}}}"
msgstr "{n, plural, one {Se incorporó # etiqueta a {dataset}} other {Se incorporaron # etiquetas a {dataset}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulled # tag} other {Pulled # tags}}"
msgstr "{n, plural, one {Se obtuvo # etiqueta} other {Se obtuvieron # etiquetas}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulling # tag into {dataset}} other {Pulling # tags into {dataset}}}"
msgstr "{n, plural, one {Incorporando # etiqueta a {dataset}} other {Incorporando # etiquetas a {dataset}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Pulling # tag} other {Pulling # tags}}"
msgstr "{n, plural, one {Obteniendo # etiqueta} other {Obteniendo # etiquetas}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Tested # date for step changes in {kpi}} other {Tested # dates for step changes in {kpi}}}"
msgstr "{n, plural, one {Se probó # fecha para detectar cambios escalonados en {kpi}} other {Se probaron # fechas para detectar cambios escalonados en {kpi}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Tested # date for step changes} other {Tested # dates for step changes}}"
msgstr "{n, plural, one {Se probó # fecha para detectar cambios escalonados} other {Se probaron # fechas para detectar cambios escalonados}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Testing # date for step changes in {kpi}} other {Testing # dates for step changes in {kpi}}}"
msgstr "{n, plural, one {Probando # fecha para detectar cambios escalonados en {kpi}} other {Probando # fechas para detectar cambios escalonados en {kpi}}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{n, plural, one {Testing # date for step changes} other {Testing # dates for step changes}}"
msgstr "{n, plural, one {Probando # fecha para detectar cambios escalonados} other {Probando # fechas para detectar cambios escalonados}}"

#: src/features/knowledgeDocumentViewer/utils/textHelpers.ts
msgid "{normalizedDrawingNumber} - s.{normalizedSheetNumber}"
msgstr "{normalizedDrawingNumber} - h.{normalizedSheetNumber}"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "{pageCount, plural, one {# page} other {# pages}}"
msgstr "{pageCount, plural, one {# página} other {# páginas}}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "{pageSize, plural, one {# row} other {# rows}}"
msgstr "{pageSize, plural, one {# fila} other {# filas}}"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "{pageStartText}–{pageEndText} of {activeTotalText}"
msgstr "{pageStartText}–{pageEndText} de {activeTotalText}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTrendCard.tsx
msgid "{penCount, plural, one {# pen} other {# pens}}"
msgstr "{penCount, plural, one {# trazo} other {# trazos}}"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "{penCount, plural, one {Fetching # pen — this can take a moment.} other {Fetching # pens — this can take a moment.}}"
msgstr "{penCount, plural, one {Obteniendo # trazo; esto puede tardar un momento.} other {Obteniendo # trazos; esto puede tardar un momento.}}"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "{penCount, plural, one {Fetching # pen.} other {Fetching # pens.}}"
msgstr "{penCount, plural, one {Obteniendo # trazo.} other {Obteniendo # trazos.}}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{piTags} PI tags · {regimeCount} regimes · {specsNeededCount} specs needed · {manualsNeeded} manuals needed"
msgstr "{piTags} etiquetas PI · {regimeCount} regímenes · {specsNeededCount} especificaciones necesarias · {manualsNeeded} manuales necesarios"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "{pointCount, plural, one {# isolation point, in hang order} other {# isolation points, in hang order}}"
msgstr "{pointCount, plural, one {# punto de aislamiento, en orden de colocación} other {# puntos de aislamiento, en orden de colocación}}"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "{pointCount, plural, one {# isolation point} other {# isolation points}}"
msgstr "{pointCount, plural, one {# punto de aislamiento} other {# puntos de aislamiento}}"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "{position} of {total} · p. {pageNumber}"
msgstr "{position} de {total} · p. {pageNumber}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{preparedPercent}% - {duplicateSkippedCount, plural, one {# duplicate skipped} other {# duplicates skipped}}"
msgstr "{preparedPercent}% - {duplicateSkippedCount, plural, one {# duplicado omitido} other {# duplicados omitidos}}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{preparedPercent}% complete"
msgstr "{preparedPercent}% completado"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{priorSubjectsLabel}; collapse the list"
msgstr "{priorSubjectsLabel}; contraer la lista"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{priorSubjectsLabel}; expand the list"
msgstr "{priorSubjectsLabel}; expandir la lista"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCount, plural, one {# reference} other {# references}}"
msgstr "{referenceCount, plural, one {# referencia} other {# referencias}}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCountLabel}; collapse {aliasValue}"
msgstr "{referenceCountLabel}; contraer {aliasValue}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "{referenceCountLabel}; expand {aliasValue}"
msgstr "{referenceCountLabel}; expandir {aliasValue}"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "{referenceLabel}, page {pageNumber}"
msgstr "{referenceLabel}, página {pageNumber}"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{rejectedEmails} do not look like email addresses."
msgstr "{rejectedEmails} no parecen direcciones de correo válidas."

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "{rejectedEmails} does not look like an email address."
msgstr "{rejectedEmails} no parece una dirección de correo válida."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "{removed} removed"
msgstr "{removed} eliminados"

#: src/components/SearchBar.tsx
msgid "{resultCount, plural, =0 {No results} one {# result} other {# results}}"
msgstr "{resultCount, plural, =0 {Sin resultados} one {# resultado} other {# resultados}}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{reviewSlots, plural, one {# slot awaiting adjudication} other {# slots awaiting adjudication}}"
msgstr "{reviewSlots, plural, one {# espacio en espera de resolución} other {# espacios en espera de resolución}}"

#: src/pages/manageAccess/components/table/RoleGroupCells.tsx
msgid "{roleLabel} — {personName}"
msgstr "{roleLabel} — {personName}"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/fim/matchingRuns.ts
msgid "{seconds}s"
msgstr "{seconds}s"

#: src/features/knowledgeDocumentViewer/components/table/GeckoPowerTable.tsx
msgid "{selectedCount} {name} Selected"
msgstr "{selectedCount} {name} seleccionados"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "{selectedCount} selected"
msgstr "{selectedCount} seleccionados"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "{selectedPipelineConfigId} · preview"
msgstr "{selectedPipelineConfigId} · vista previa"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "{selectedRowCount, plural, one {# row selected} other {# rows selected}}"
msgstr "{selectedRowCount, plural, one {# fila seleccionada} other {# filas seleccionadas}}"

#: src/components/table/TableComponent.tsx
msgid "{selectedRowCount} {footerName} Selected"
msgstr "{selectedRowCount} {footerName} seleccionados"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "{seriesCount, plural, one {# datapoint} other {# datapoints}}"
msgstr "{seriesCount, plural, one {# punto de datos} other {# puntos de datos}}"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "{severityLabel} severity"
msgstr "Gravedad {severityLabel}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{shelvedCount} shelved"
msgstr "{shelvedCount} archivados temporalmente"

#: src/features/timeSeries/regressionHelpers.ts
msgid "{sign} {coefStr}t^{i}"
msgstr "{sign} {coefStr}t^{i}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{stagedCount, plural, one {# file} other {# files}} · {selectedBytesLabel}"
msgstr "{stagedCount, plural, one {# archivo} other {# archivos}} · {selectedBytesLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{stagedCount} tags selected — they will apply to your next message."
msgstr "{stagedCount} etiquetas seleccionadas: se aplicarán a tu próximo mensaje."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{stagedLabel} selected — it will apply to your next message."
msgstr "{stagedLabel} seleccionada: se aplicará a tu próximo mensaje."

#: src/pages/manageAccess/components/table/UsersTablePager.tsx
msgid "{start}–{end} of {total}"
msgstr "{start}–{end} de {total}"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "{startAt} -> {endAt}"
msgstr "{startAt} -> {endAt}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadProgressPanel.tsx
msgid "{stepLabel} progress"
msgstr "Progreso de {stepLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{streamCount, plural, one {# stream} other {# streams}}"
msgstr "{streamCount, plural, one {# flujo} other {# flujos}}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "{subject}, smoothed over {days} days"
msgstr "{subject}, suavizado durante {days} días"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "{subjectName} trends"
msgstr "Tendencias de {subjectName}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{subsystemCount} · {equipmentCount} equipment · {outputs} primary outputs"
msgstr "{subsystemCount} · {equipmentCount} equipos · {outputs} salidas principales"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "{tabCount, plural, one {{activeLabel}. # open tab} other {{activeLabel}. # open tabs}}"
msgstr "{tabCount, plural, one {{activeLabel}. # pestaña abierta} other {{activeLabel}. # pestañas abiertas}}"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "{tag} dropped at position {position} of {count}."
msgstr "{tag} se soltó en la posición {position} de {count}."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "{tag} moved to position {position} of {count}."
msgstr "{tag} se movió a la posición {position} de {count}."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{tags} PI tags"
msgstr "{tags} etiquetas PI"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "{title} — page {startPage}"
msgstr "{title} — página {startPage}"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "{title} — pages {startPage}–{endPage}"
msgstr "{title} — páginas {startPage}–{endPage}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "{title} (optional)"
msgstr "{title} (opcional)"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} drafted"
msgstr "{title} creado como borrador"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "{title} selected"
msgstr "{title} seleccionado"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} updated"
msgstr "{title} actualizado"

#: src/features/knowledgeDocumentViewer/artifacts/artifactText.ts
msgid "{title} updated · {changedSections, plural, one {# section changed} other {# sections changed}}"
msgstr "{title} actualizado · {changedSections, plural, one {# sección modificada} other {# secciones modificadas}}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, new reply"
msgstr "{title}, nueva respuesta"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned"
msgstr "{title}, fijado"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned, new reply"
msgstr "{title}, fijado, nueva respuesta"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, pinned, thinking"
msgstr "{title}, fijado, pensando"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "{title}, thinking"
msgstr "{title}, pensando"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "{tooltipLinkedCount, plural, one {# document} other {# documents}}"
msgstr "{tooltipLinkedCount, plural, one {# documento} other {# documentos}}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "{totalCount} filtered"
msgstr "{totalCount} filtrados"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "{totalFilteredAssetsNum, plural, one {# Asset} other {# Assets}}"
msgstr "{totalFilteredAssetsNum, plural, one {# activo} other {# activos}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "{truncatedChipLabel} · p.{pageNum}"
msgstr "{truncatedChipLabel} · p.{pageNum}"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "{typeLabel} is different"
msgstr "{typeLabel}: no coincide"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "{typeLabel} is missing"
msgstr "Falta: {typeLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "{unitCount} proposed"
msgstr "{unitCount} propuestas"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "{unmatchedCount} may be missing"
msgstr "{unmatchedCount} pueden faltar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "{unreadable} documents could not be read."
msgstr "No se pudieron leer {unreadable} documentos."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "{unresolvedItems, plural, one {# item needs verification} other {# items need verification}}"
msgstr "{unresolvedItems, plural, one {# elemento necesita verificación} other {# elementos necesitan verificación}}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
msgid "{uploadedPercent}% complete"
msgstr "{uploadedPercent}% completado"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "{value} (OCR variant)"
msgstr "{value} (variante de OCR)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "{value} as of {timestamp}"
msgstr "{value} al {timestamp}"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "{value}%+ confidence"
msgstr "{value}% o más de confianza"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "{value}+ sources"
msgstr "{value} o más fuentes"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "{value1029_37}× band"
msgstr "Banda de {value1029_37}×"

#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "{value116_23} (active — click to deactivate, Esc to exit)"
msgstr "{value116_23} (activo; haga clic para desactivar, Esc para salir)"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "{value131_20} ({value131_47}) must be less than {value131_93} ({value131_124})"
msgstr "{value131_20} ({value131_47}) debe ser menor que {value131_93} ({value131_124})"

#: src/features/timeSeries/experiment/overlays.ts
msgid "{value182_16} ±band (experiment)"
msgstr "{value182_16} ±banda (experimento)"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value204_34} Y min"
msgstr "{value204_34} Y mín."

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "{value215_28} Y min"
msgstr "{value215_28} Y mín."

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value215_34} Y max"
msgstr "{value215_34} Y máx."

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "{value231_27} FP/30d"
msgstr "{value231_27} FP/30 d"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "{value233_28} Y max"
msgstr "{value233_28} Y máx."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "{value234_27}x band"
msgstr "{value234_27}x banda"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value255_38} — computed"
msgstr "{value255_38} — calculado"

#: src/features/timeSeries/agentTab/modelCard.ts
msgid "{value256_21} (this chat)"
msgstr "{value256_21} (este chat)"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value265_34} Y min"
msgstr "{value265_34} Y mín."

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "{value276_34} Y max"
msgstr "{value276_34} Y máx."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value305_21}h rolling average, drawn on {value305_66}"
msgstr "Promedio móvil de {value305_21} h, dibujado en {value305_66}"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "{value335_38} Y min"
msgstr "{value335_38} Y mín."

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "{value348_38} Y max"
msgstr "{value348_38} Y máx."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value380_38} Y min"
msgstr "{value380_38} Y mín."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{value384_23}σ below expected — worth a look"
msgstr "{value384_23}σ por debajo de lo esperado; conviene revisarlo"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "{value385_23}σ — within the band"
msgstr "{value385_23}σ; dentro de la banda"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "{value389_38} Y max"
msgstr "{value389_38} Y máx."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "{value454_15} of this label's pens are not in this site's tag list and were not added."
msgstr "{value454_15} de los trazos de esta etiqueta no están en la lista de etiquetas de este sitio y no se agregaron."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid ""
"{value456_25}: {value456_37} rows ({value456_53} train / {value456_82} test)\n"
"{value456_109} → {value456_128}"
msgstr ""
"{value456_25}: {value456_37} filas ({value456_53} entrenamiento / {value456_82} prueba)\n"
"{value456_109} → {value456_128}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid ""
"{value457_25}: {value457_37} rows\n"
"{value457_53} → {value457_72}"
msgstr ""
"{value457_25}: {value457_37} filas\n"
"{value457_53} → {value457_72}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "{value463_25} train / {value463_54} test"
msgstr "{value463_25} entrenamiento / {value463_54} prueba"

#: src/features/timeSeries/components/TagNamesSidebar.tsx
msgid "{value59_28} predicted value for {value59_72}"
msgstr "Valor previsto de {value59_28} para {value59_72}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "{value634_34}% out of band · worst {value634_98}σ"
msgstr "{value634_34}% fuera de la banda · mayor desviación {value634_98}σ"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "{value637_21} of {value637_48} labels"
msgstr "{value637_21} de {value637_48} etiquetas"

#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "{value78_35} (active)"
msgstr "{value78_35} (activo)"

#: src/features/sentinels/useSentinelList.ts
msgid "{value90_17} · {value90_49} drivers"
msgstr "{value90_17} · {value90_49} variables predictoras"

#: src/features/sentinels/useSentinelList.ts
msgid "{value91_17} tags in {value91_49} families"
msgstr "{value91_17} etiquetas en {value91_49} familias"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "{visibleCountText} of {activeTotalText}"
msgstr "{visibleCountText} de {activeTotalText}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "{years} years · calculated minimum"
msgstr "{years} años · mínimo calculado"

#: src/features/modelOperations/fimShared.ts
msgid "{yr}y ago"
msgstr "hace {yr} años"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "* — in the date picker, keeps the chart pinned to now. Zooming pauses it. "
msgstr "*: en el selector de fechas, mantiene el gráfico anclado al momento actual. El zoom lo pausa. "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "* Data syncs every 5 minutes and depends on the VPN connection."
msgstr "* Los datos se sincronizan cada 5 minutos y dependen de la conexión VPN."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "% of each un-assigned chunk → test"
msgstr "% de cada bloque sin asignar → prueba"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "% of rows become test, the rest train (shown as “mixed”). Clicking a chunk still assigns it a whole-chunk role; click past test to hand it back to the tail split."
msgstr "Un porcentaje de las filas se destina a prueba y el resto a entrenamiento (se muestra como “mixto”). Al hacer clic en un bloque, se le asigna un rol completo; avance más allá de prueba para devolverlo a la división de la parte final."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Functions: sqrt, abs, sin, cos, log, exp, etc."
msgstr "• Funciones: sqrt, abs, sin, cos, log, exp, etc."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Type numbers and operators (+, -, *, /, ^) directly"
msgstr "• Escriba números y operadores (+, -, *, /, ^) directamente"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "• Type sensor names and press space or Enter to add them"
msgstr "• Escriba nombres de sensores y presione espacio o Intro para agregarlos"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "← Jump to earlier data"
msgstr "← Ir a datos anteriores"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "+ Add another Subject"
msgstr "+ Agregar otro sujeto"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "+ after driver ffill("
msgstr "+ después de ffill de variables predictoras ("

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "+{hiddenDocCount} more"
msgstr "+{hiddenDocCount} más"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "+{otherTabCount} more"
msgstr "+{otherTabCount} más"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "±2 h"
msgstr "±2 h"

#: src/pages/systemView/components/AnnotationsTab.tsx
msgid "<0>⚠️ Kestrel Viewer Required</0>To edit annotations, please start the Kestrel viewer in the panel on the right. The edit popup will appear there when you click an annotation."
msgstr "<0>⚠️ Se requiere Kestrel Viewer</0>Para editar anotaciones, inicie el visor Kestrel en el panel de la derecha. La ventana emergente de edición aparecerá allí cuando haga clic en una anotación."

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Double Click</0> to focus on point"
msgstr "Haga <0>doble clic</0> para enfocar el punto"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Scroll Wheel</0> or <1>Right Mouse + Drag</1> to zoom"
msgstr "Use la <0>rueda del mouse</0> o <1>botón derecho + arrastrar</1> para acercar o alejar"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "<0>Shift + Left Mouse + Drag</0> to pan"
msgstr "Use <0>Mayús + botón izquierdo + arrastrar</0> para desplazar la vista"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value57_34}s"
msgstr "~{value57_34}s"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value59_34}m"
msgstr "~{value59_34}min"

#: src/features/timeSeries/utils/maxZoom.ts
msgid "~{value60_15}h"
msgstr "~{value60_15}h"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "~Fit / band-calib"
msgstr "~Ajuste / calibración de banda"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "⌘+Click"
msgstr "⌘+Clic"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "★ champion per model (lowest test MAE) · green = best MAE across the board."
msgstr "★ mejor por modelo (menor MAE de prueba) · verde = mejor MAE de todos."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "⚠️ This action will permanently delete the selected rows and cannot be undone."
msgstr "⚠️ Esta acción eliminará permanentemente las filas seleccionadas y no se puede deshacer."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "✓ available"
msgstr "✓ disponible"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "1 day"
msgstr "1 día"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "24 h"
msgstr "24 h"

#: src/pages/details/visualization/tools/ThreeDimensionsToggle.tsx
msgid "2D mode"
msgstr "Modo 2D"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "3+ sources"
msgstr "3 o más fuentes"

#: src/pages/details/visualization/tools/ThreeDimensionsToggle.tsx
msgid "3D mode"
msgstr "Modo 3D"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/PhotoOutlineBridge.tsx
msgid "3D outline partially projected"
msgstr "Contorno 3D proyectado parcialmente"

#: src/features/navbar/navConfig.ts
msgid "3D View"
msgstr "Vista 3D"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "7 d"
msgstr "7 d"

#: src/pages/metrics/Metrics.tsx
msgid "7-day avg"
msgstr "Prom. de 7 días"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "7-Day Trend"
msgstr "Tendencia de 7 días"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid ""
"8f3a-tempA\n"
"8f3a-tempB\n"
"8f3a-flow01\n"
"8f3a-pressure"
msgstr ""
"8f3a-tempA\n"
"8f3a-tempB\n"
"8f3a-flow01\n"
"8f3a-pressure"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "a baseline window is required"
msgstr "se requiere un intervalo de referencia"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision is missing from the uploaded documents"
msgstr "Una revisión declarada no está presente en los documentos cargados"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision is missing from the uploaded documents."
msgstr "Una revisión declarada no está presente en los documentos cargados."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "A declared revision may be missing"
msgstr "Puede faltar una revisión declarada"

#: src/features/fim/useFimService.ts
msgid "A fill is already in progress for this asset — wait for it to finish, then try again."
msgstr "Ya se están completando los datos de este activo. Espere a que termine y vuelva a intentarlo."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "A full pass: find tags, plot and scale them, then zoom."
msgstr "Un recorrido completo: buscar etiquetas, graficarlas y ajustar sus escalas, y luego ampliar."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "A gap that lives in one band only is usually a physical regime, not a whole-machine decline."
msgstr "Una brecha que aparece en una sola banda suele indicar un régimen físico, no un deterioro de toda la máquina."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "a little while ago"
msgstr "hace un momento"

#: src/pages/details/visualization/Visualization.tsx
msgid "A measurement data layer is overlaid on the asset, colored by the active color scale. All values are in metric units (meters, degrees Celsius, mega-pascals, etc)."
msgstr "Sobre el activo se muestra una capa de datos de medición con los colores de la escala activa. Todos los valores están en unidades métricas (metros, grados Celsius, megapascales, etc.)."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "A model normally takes the chart over — its tags, nothing else. With this on your other pens stay in the list above, just hidden, so they are one click away instead of a search in the tag browser. Applies the next time a model is drawn."
msgstr "Normalmente, un modelo reemplaza el gráfico con sus propias etiquetas. Con esta opción, los otros trazos permanecen en la lista superior, ocultos, para recuperarlos con un clic en lugar de buscarlos. Se aplica la próxima vez que se dibuje un modelo."

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "A negative lead time means the model only noticed after the event began. Zero days scored means no at-load days survived the gate in that window, which is a coverage problem rather than a detection one."
msgstr "Un tiempo de anticipación negativo significa que el modelo detectó el evento después de que comenzara. Cero días evaluados significa que ningún día con carga superó el filtro en ese intervalo; esto es un problema de cobertura, no de detección."

#: src/features/knowledgeDocumentViewer/components/metadata/PageRevisionFamilyDropdown.tsx
msgid "A newer revision is available"
msgstr "Hay una revisión más reciente disponible"

#: src/features/fimReview/ReviewActions.tsx
msgid "A reason is required to remove input."
msgstr "Debe indicar un motivo para eliminar la entrada."

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "A reason is required. Deferred pages stay out of your default unlabeled pool."
msgstr "Se requiere un motivo. Las páginas diferidas quedan fuera de su grupo predeterminado de páginas sin etiquetar."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "A reopen reason is required to move this case back to Open."
msgstr "Debe indicar un motivo para volver a abrir este caso."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "A ruler measuring a window, and a pinned point annotation."
msgstr "Una regla que mide un intervalo y una anotación de punto fijada."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "A run needs a target, at least one driver, and at least one method."
msgstr "Una ejecución necesita un objetivo, al menos una variable predictora y al menos un método."

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "a second Asset Instance already resolved to this Subject"
msgstr "una segunda instancia de activo ya está vinculada a este sujeto"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "A sigma is only as good as what it is divided by. This one is the gap against how much the daily gap itself wandered during the baseline — not against hourly noise, which would flatter it."
msgstr "La utilidad de sigma depende de su denominador. Aquí se compara la brecha con la variación de la propia brecha diaria durante el período de referencia, no con el ruido horario, que exageraría el resultado."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "A split needs at least two source records to separate."
msgstr "Se necesitan al menos dos registros de origen para realizar una separación."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "A split needs at least two Subjects."
msgstr "Se necesitan al menos dos sujetos para realizar una separación."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "A template fill is queued."
msgstr "La tarea de completar la plantilla está en cola."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "A template fill is running."
msgstr "Se está completando la plantilla."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "A training job is fitting this plan, so it can no longer be edited."
msgstr "Un trabajo de entrenamiento está ajustando este plan, por lo que ya no se puede editar."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "A valid inspection, component, and CDS are required to generate LTAs."
msgstr "Para generar áreas de adelgazamiento localizado (LTA), se requiere una inspección, un componente y un CDS válidos."

#: src/pages/assetLens/AssetLens.tsx
msgid "A valid Unit ID is required to view the Asset Lens."
msgstr "Se requiere un ID de unidad válido para ver Asset Lens."

#: src/features/timeSeries/experiment/KnobHelp.tsx
#: src/pages/manageAccess/components/table/ColumnHeaderHelp.tsx
msgid "About {label}"
msgstr "Acerca de {label}"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "About best shifts"
msgstr "Acerca de los mejores desfases"

#: src/pages/manageAccess/components/table/ColumnHeaderHelp.tsx
msgid "About this column"
msgstr "Acerca de esta columna"

#: src/features/timeSeries/experiment/KnobHelp.tsx
msgid "About this setting"
msgstr "Acerca de esta opción"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Above expected range"
msgstr "Por encima del rango esperado"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "abs quantile"
msgstr "cuantil absoluto"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Abs quantile"
msgstr "Cuantil absoluto"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Accept"
msgstr "Aceptar"

#: src/features/terms/TermsModal.tsx
msgid "Accept Terms"
msgstr "Aceptar términos"

#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Acceptance review"
msgstr "Revisión de aceptación"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "accepted"
msgstr "aceptado"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Access removed for this view."
msgstr "Acceso eliminado para esta vista."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Access revoked. The user was removed."
msgstr "Acceso revocado. El usuario fue eliminado."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Accurate"
msgstr "Preciso"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Acknowledge"
msgstr "Reconocer"

#: src/pages/alerts/AlertDetails.tsx
msgid "Acknowledge Alert"
msgstr "Reconocer alerta"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Acknowledged"
msgstr "Reconocida"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "acoustic"
msgstr "acústico"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Acoustic + Thermal Imaging Timeline"
msgstr "Cronología de imágenes acústicas y térmicas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Images"
msgstr "Imágenes acústicas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Acoustic Scan - {comparisonImageDate}"
msgstr "Inspección acústica - {comparisonImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Acoustic Scan - {currentImageDate}"
msgstr "Inspección acústica - {currentImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Scan - {imageDate}"
msgstr "Inspección acústica - {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Acoustic Scan from {imageDate}"
msgstr "Inspección acústica del {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Acoustic Trend Analysis"
msgstr "Análisis de tendencia acústica"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Acoustic trend is"
msgstr "La tendencia acústica es"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Actions"
msgstr "Acciones"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Actions for {userName}"
msgstr "Acciones para {userName}"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Actions for {value125_43}"
msgstr "Acciones para {value125_43}"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Active"
msgstr "Activo"

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Active"
msgstr "Activo"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Active ({activeCount})"
msgstr "Activos ({activeCount})"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "Active Anomalies"
msgstr "Anomalías activas"

#: src/features/sentinels/coverage.ts
msgid "Active monitor · {experimentsLabel}"
msgstr "Monitor activo · {experimentsLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Active regimes"
msgstr "Regímenes activos"

#: src/pages/cases/activity/ActivitySection.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Activity"
msgstr "Actividad"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Activity is collapsed by default."
msgstr "La actividad se muestra contraída de forma predeterminada."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Actual"
msgstr "Real"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Actual date"
msgstr "Fecha real"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Actual finish"
msgstr "Finalización real"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual labor cost"
msgstr "Costo real de mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual labor hours"
msgstr "Horas reales de mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual material cost"
msgstr "Costo real de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual service cost"
msgstr "Costo real de servicios"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Actual start"
msgstr "Inicio real"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Actual tool cost"
msgstr "Costo real de herramientas"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Actual vs expected and the residual band for this method draw directly on the main chart (target pen + shaded band), where zoom, tooltip, and ruler work."
msgstr "El valor real frente al esperado y la banda del residuo de este método se dibujan directamente en el gráfico principal (trazo objetivo y banda sombreada), donde funcionan el zoom, la información emergente y la regla."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Actual y"
msgstr "Y real"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/richText/components/TaggableUsersCard.tsx
#: src/features/timeSeries/components/PensTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Add"
msgstr "Agregar"

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Add {lowerCaseSingularTitle}"
msgstr "Agregar {lowerCaseSingularTitle}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Add {newRole}"
msgstr "Agregar {newRole}"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Add {value523_49} to the chart"
msgstr "Agregar {value523_49} al gráfico"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Add a comment..."
msgstr "Agregue un comentario..."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Add a range"
msgstr "Agregar un rango"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Add a window the machine was healthy in."
msgstr "Agregue un intervalo en el que la máquina estuviera en buenas condiciones."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add all"
msgstr "Agregar todo"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Add an event"
msgstr "Agregar un evento"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Add any additional details..."
msgstr "Agregue cualquier detalle adicional..."

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Add Case"
msgstr "Agregar caso"

#: src/features/chatbot/components/FeedbackMenu.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
msgid "Add comment"
msgstr "Agregar comentario"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Add Comment"
msgstr "Agregar comentario"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Add Custom Field"
msgstr "Agregar campo personalizado"

#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Add Data"
msgstr "Agregar datos"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Add Document"
msgstr "Agregar documento"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add document reference"
msgstr "Agregar referencia a documento"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/AddFilter.tsx
msgid "Add filter"
msgstr "Agregar filtro"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Add from search results"
msgstr "Añadir desde los resultados de búsqueda"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Add new tab"
msgstr "Agregar nueva pestaña"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Add Org"
msgstr "Agregar organización"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Add page {pageNum} of {title}"
msgstr "Añadir la página {pageNum} de {title}"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Add pen"
msgstr "Agregar trazo"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Add photo"
msgstr "Agregar foto"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add PI Tag reference"
msgstr "Agregar referencia a etiqueta PI"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Add range"
msgstr "Agregar rango"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Add Reference"
msgstr "Agregar referencia"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags"
msgstr "Agregar etiquetas referenciadas"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags from {value738_62} to chart"
msgstr "Agregar al gráfico las etiquetas referenciadas de {value738_62}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add referenced tags to chart"
msgstr "Agregar etiquetas referenciadas al gráfico"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Add Regression"
msgstr "Agregar regresión"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
#: src/pages/noSites/NoSites.tsx
#: src/pages/site/CreateSite.tsx
msgid "Add Site"
msgstr "Agregar sitio"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Add tags or derived values to configure them."
msgstr "Agregue etiquetas o valores derivados para configurarlos."

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Add the residual (actual − expected), computed from the saved fit"
msgstr "Agregar el residuo (real − esperado), calculado a partir del ajuste guardado"

#: src/features/lotoReports/components/LotoSelectedReport.tsx
msgid "Add this page"
msgstr "Añadir esta página"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Add this pen to the chart"
msgstr "Agregar este trazo al gráfico"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Add this role"
msgstr "Agregar este rol"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Add to chart"
msgstr "Agregar al gráfico"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "Add to context"
msgstr "Agregar al contexto"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Add to favorites"
msgstr "Agregar a favoritos"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Add to Process Data"
msgstr "Agregar a Datos de proceso"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Add to the comparison table"
msgstr "Agregar a la tabla comparativa"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Added"
msgstr "Agregado"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "added by the agent"
msgstr "agregado por el agente"

#: src/features/timeSeries/agentTab/useAgentView.ts
msgid "Added by the agent"
msgstr "Agregado por el agente"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Additional Notes"
msgstr "Notas adicionales"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Address"
msgstr "Dirección"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Adds driver lags and a rolling mean; the usual default."
msgstr "Agrega retardos de las variables predictoras y un promedio móvil; es el valor predeterminado habitual."

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Adds prior target values; can hide slow target drift."
msgstr "Agrega valores anteriores del objetivo; puede ocultar una deriva lenta del objetivo."

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Admin"
msgstr "Administrador"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Admins can manage people and permissions. Members can’t manage access."
msgstr "Los administradores pueden gestionar personas y permisos. Los miembros no pueden gestionar el acceso."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Advanced: cleaning plan JSON"
msgstr "Avanzado: JSON del plan de limpieza"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "After"
msgstr "Después"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "After {startDate}"
msgstr "Después de {startDate}"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "After cleaning"
msgstr "Después de la limpieza"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "After lag warm-up"
msgstr "Después del período inicial de retardos"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "After:"
msgstr "Después:"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Agent"
msgstr "Agente"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Agent automation"
msgstr "Automatización del agente"

#: src/features/timeSeries/agentTab/useActiveModel.ts
msgid "agent model"
msgstr "modelo del agente"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "Agent model {value193_36}"
msgstr "Modelo del agente {value193_36}"

#: src/features/fimReview/provenance.ts
msgid "Agent-asserted"
msgstr "Afirmado por el agente"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Agent’s reading"
msgstr "Interpretación del agente"

#: src/features/embeddedSidebar/sessions/documentChatSessionRolodex.ts
msgid "Agentic search"
msgstr "Búsqueda con agente"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "agg {value99_24}→{value99_44}"
msgstr "agregación {value99_24}→{value99_44}"

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Aggregate"
msgstr "Agregar por intervalos"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Aggregate (prod): put every tag onto a shared time grid by binning historian samples (e.g. 10 min mean). Raw: pull every available historian point and outer-join on exact timestamps — tags only share a row when stamps match exactly. Raw is denser but much sparser across tags."
msgstr "Agregado (producción): alinea todas las etiquetas en una cuadrícula de tiempo común agrupando muestras del historiador (por ejemplo, promedio de 10 min). Sin procesar: obtiene todos los puntos disponibles del historiador y los une por marcas de tiempo exactas; las etiquetas solo comparten fila cuando las marcas coinciden exactamente. Los datos sin procesar son más densos, pero tienen muchos más vacíos entre etiquetas."

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Aggregate onto grid (prod default)"
msgstr "Agregar en cuadrícula (predeterminado en producción)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Aggregation"
msgstr "Agregación"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Aggregation pipelines in progress: {aggregationCount}"
msgstr "Procesos de agregación en curso: {aggregationCount}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Agreement"
msgstr "Coincidencia"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardAgreementByField.tsx
msgid "Agreement by field"
msgstr "Coincidencia por campo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Agreements and business terms"
msgstr "Acuerdos y términos comerciales"

#: src/features/chatbot/components/ChatbotSidePanel.tsx
msgid "AI Chat unavailable"
msgstr "Chat de IA no disponible"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "AI explanation"
msgstr "Explicación de la IA"

#: src/features/fimReview/IdentityPanel.tsx
msgid "AI merge"
msgstr "Fusión con IA"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "AI search"
msgstr "Búsqueda con IA"

#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "AI Search"
msgstr "Búsqueda con IA"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "AI search (7d avg)"
msgstr "Búsqueda con IA (prom. de 7 días)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "AI search could not complete — found {resultLabel} via standard search"
msgstr "La búsqueda con IA no pudo completarse — se encontró {resultLabel} mediante la búsqueda estándar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "AI search could not complete. Showing standard document search results — this is not a full AI answer."
msgstr "La búsqueda con IA no pudo completarse. Se muestran los resultados de la búsqueda estándar de documentos — esta no es una respuesta completa de la IA."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "AI-extracted page metadata vs human-confirmed per site"
msgstr "Metadatos de página extraídos por IA vs. confirmados por una persona, por sitio"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "AI-labeled metadata vs human labels across <0>{organizationName}</0>"
msgstr "Metadatos etiquetados por IA frente a etiquetas humanas en <0>{organizationName}</0>"

#: src/features/fimReview/provenance.ts
msgid "AI-matched — cited evidence"
msgstr "Coincidencia de IA — evidencia citada"

#: src/pages/details/visualization/Visualization.tsx
#: src/pages/homepage/Homepage.tsx
msgid "AIR · AI + Robotics"
msgstr "AIR · IA + Robótica"

#: src/pages/alerts/alertStatusLabel.ts
msgid "Alarm"
msgstr "Alarma"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "alert"
msgstr "alerta"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/mdCases/hooks/useOpenAlertInProcessData.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Alert"
msgstr "Alerta"

#: src/pages/alerts/AlertDetails.tsx
msgid "Alert - {timestamp}"
msgstr "Alerta - {timestamp}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Alert detected"
msgstr "Alerta detectada"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Alert markers"
msgstr "Marcadores de alertas"

#: src/pages/alerts/AlertDetails.tsx
msgid "Alert not found."
msgstr "No se encontró la alerta."

#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Alert Range"
msgstr "Rango de la alerta"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Alert Range {alertRangeLabel}"
msgstr "Rango de la alerta {alertRangeLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Alerted value"
msgstr "Valor que generó la alerta"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Alerted Value"
msgstr "Valor que generó la alerta"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Alerting"
msgstr "Alertas"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Alerting needs a saved model — there is nothing to schedule until this one has an entry. Ask the agent to save it."
msgstr "Las alertas necesitan un modelo guardado; no hay nada que programar hasta que este tenga un registro. Pida al agente que lo guarde."

#: src/pages/alerts/components/AlertsTable.tsx
msgid "alerts"
msgstr "alertas"

#: src/features/navbar/navConfig.ts
#: src/pages/alerts/Alerts.tsx
#: src/pages/alerts/Alerts.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
msgid "Alerts"
msgstr "Alertas"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "Alerts "
msgstr "Alertas "

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Alerts ({alertCount})"
msgstr "Alertas ({alertCount})"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Alias"
msgstr "Alias"

#: src/features/fimReview/ReviewActions.tsx
msgid "Aliases"
msgstr "Alias"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/MultiSelectFilter.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/MultiSelectFilter.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/TagsTab.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
#: src/pages/overview/sidebar/filterSelects/groupingsFilter/GenerateGroupingSelect.tsx
#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "All"
msgstr "Todos"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "All ({totalCount})"
msgstr "Todos ({totalCount})"

#: src/features/lotoReports/components/LotoEditorSaveState.tsx
msgid "All changes saved"
msgstr "Todos los cambios guardados"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "All orgs"
msgstr "Todas las organizaciones"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "All other files for asset"
msgstr "Todos los demás archivos del activo"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "All other reports for asset"
msgstr "Todos los demás informes del activo"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "All required slots filled"
msgstr "Todos los campos requeridos están completos"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "All results"
msgstr "Todos los resultados"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "All saved models"
msgstr "Todos los modelos guardados"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "All Severity"
msgstr "Todas las severidades"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "All shown"
msgstr "Todos visibles"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "all sites"
msgstr "todos los sitios"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "All sites"
msgstr "Todos los sitios"

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "All sources"
msgstr "Todas las fuentes"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "All Status"
msgstr "Todos los estados"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "All statuses"
msgstr "Todos los estados"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "All Subjects"
msgstr "Todos los sujetos"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "All tags"
msgstr "Todas las etiquetas"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "All Time Ranges"
msgstr "Todos los rangos de tiempo"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "All types"
msgstr "Todos los tipos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "All upload types"
msgstr "Todos los tipos de carga"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "All vendors"
msgstr "Todos los proveedores"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Allow Freeform Aspect Ratio"
msgstr "Permitir relación de aspecto libre"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Allow Natural Asset Dimensions"
msgstr "Permitir dimensiones naturales del activo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Also save model weights (slower re-fit)"
msgstr "Guardar también los pesos del modelo (reajuste más lento)"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Always open links in new tab"
msgstr "Abrir siempre los enlaces en una pestaña nueva"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Ambient Temperature"
msgstr "Temperatura ambiente"

#: src/features/fimReview/ReviewActions.tsx
msgid "An alias is spelled wrong"
msgstr "Un alias está mal escrito"

#: src/features/fimReview/TypeCombobox.tsx
msgid "An asset template exists for this type — validated subjects can be instantiated"
msgstr "Existe una plantilla de activo para este tipo; se pueden crear instancias de los sujetos validados"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "An error occurred during upload"
msgstr "Se produjo un error durante la carga"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "An invitation is already being sent."
msgstr "Ya se está enviando una invitación."

#: src/features/timeSeries/components/DerivedValues.tsx
msgid "An unknown error occurred."
msgstr "Se produjo un error desconocido."

#: src/pages/assetLens/components/AssetTabs.tsx
msgid "Analysis"
msgstr "Análisis"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Analysis State"
msgstr "Estado del análisis"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Ancestor"
msgstr "Antecesor"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Annotate"
msgstr "Anotar"

#: src/pages/systemView/components/DataPanel.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Annotations"
msgstr "Anotaciones"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Annotations save with the view."
msgstr "Las anotaciones se guardan con la vista."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Annual trend"
msgstr "Tendencia anual"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Anomaly"
msgstr "Anomalía"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Anomaly Cases"
msgstr "Casos de anomalías"

#: src/pages/assetLens/components/AssetTabs.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Anomaly Dashboard"
msgstr "Panel de anomalías"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/CompositeTimeSeriesAnalysis.tsx
msgid "Anomaly detected"
msgstr "Anomalía detectada"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Anomaly Detected"
msgstr "Anomalía detectada"

#: src/features/navbar/navConfig.ts
msgid "Anomaly Detection"
msgstr "Detección de anomalías"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Anomaly status updated to {statusLabel}"
msgstr "Estado de la anomalía actualizado a {statusLabel}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageAnomalyDisplay.tsx
msgid "Anomaly: {description}"
msgstr "Anomalía: {description}"

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Another active admin is required before you can change your own user type."
msgstr "Se requiere otro administrador activo para cambiar tu propio tipo de usuario."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Answer"
msgstr "Respuesta"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "Any"
msgstr "Cualquiera"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any confidence"
msgstr "Cualquier nivel de confianza"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any fill status"
msgstr "Cualquier estado de completado"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any kind"
msgstr "Cualquier clase"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Any monitor coverage"
msgstr "Cualquier cobertura de monitoreo"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Any observations or notes about this scan (e.g., operating conditions, suspected issues)"
msgstr "Observaciones o notas sobre esta inspección (por ejemplo, condiciones de operación o posibles problemas)"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any sources"
msgstr "Cualquier fuente"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any system"
msgstr "Cualquier sistema"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any template"
msgstr "Cualquier plantilla"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any type"
msgstr "Cualquier tipo"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Any validation state"
msgstr "Cualquier estado de validación"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Anything generally helpful, confusing, or missing?"
msgstr "¿Hay algo útil, confuso o que falte en general?"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "anything the agent should know about this asset"
msgstr "cualquier información sobre este activo que el agente deba conocer"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "API 570"
msgstr "API 570"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "API 653"
msgstr "API 653"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Appendix F"
msgstr "Apéndice F"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Applies-to type is required — it is how fusion matches this template to Subjects."
msgstr "Se requiere el tipo al que se aplica; la fusión lo utiliza para asociar esta plantilla con los sujetos."

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Apply"
msgstr "Aplicar"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Apply & refit"
msgstr "Aplicar y reajustar"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Apply best shifts (all)"
msgstr "Aplicar los mejores desfases (todos)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Apply gate to test range"
msgstr "Aplicar filtro al rango de prueba"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Apply moving window operations to reduce noise"
msgstr "Aplicar operaciones de ventana móvil para reducir el ruido"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Apply previewed change"
msgstr "Aplicar el cambio previsualizado"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Apply revert"
msgstr "Aplicar reversión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Apply selection"
msgstr "Aplicar selección"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Apply to all sensors"
msgstr "Aplicar a todos los sensores"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Applying…"
msgstr "Aplicando…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Archive"
msgstr "Archivar"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Archive all"
msgstr "Archivar todos"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Archive Case"
msgstr "Archivar caso"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archive chats"
msgstr "Archivar chats"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Archive notification"
msgstr "Archivar notificación"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archive recent chats?"
msgstr "¿Archivar chats recientes?"

#: src/features/forecastNotifications/notificationUtils.ts
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Archived"
msgstr "Archivadas"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Archived ({archivedCount})"
msgstr "Archivados ({archivedCount})"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Archived chat actions"
msgstr "Acciones de chats archivados"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Archived chats"
msgstr "Chats archivados"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Archiving..."
msgstr "Archivando..."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Archiving…"
msgstr "Archivando…"

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "Are you still there?"
msgstr "¿Sigue ahí?"

#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "Are you sure you want to delete this case?"
msgstr "¿Confirma que desea eliminar este caso?"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Are you sure you want to make {personName} an administrator? They will be able to manage access, including inviting and deactivating people in the selected scope."
msgstr "¿Seguro que quieres convertir a {personName} en administrador? Podrá gestionar el acceso, incluyendo invitar y desactivar personas en el ámbito seleccionado."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Are you sure you would like to delete \"{deletingWhiteboardName}\"? This action cannot be undone."
msgstr "¿Confirma que desea eliminar \"{deletingWhiteboardName}\"? Esta acción no se puede deshacer."

#: src/features/dataFilter/categoryFilter/ValueBreakdownDisplayTypeSelector.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/details/visualization/markupEditing/RectAreaDisplay.tsx
msgid "Area"
msgstr "Área"

#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "Area: {unitArea}"
msgstr "Área: {unitArea}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Arm a role in the toolbar and drag on the chart, or Add window."
msgstr "Active un rol en la barra de herramientas y arrastre sobre el gráfico, o use Agregar intervalo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "as of {timestampText}"
msgstr "al {timestampText}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Ascending"
msgstr "Ascendente"

#: src/features/chatbot/components/ChatbotInputCard.tsx
msgid "Ask a question..."
msgstr "Haga una pregunta..."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Ask about this case"
msgstr "Pregunte sobre este caso"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
msgid "Ask Cantilever"
msgstr "Pregunte a Cantilever"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
msgid "Ask Cantilever to reopen this assessment to generate a report."
msgstr "Pídele a Cantilever que vuelva a abrir esta evaluación para generar un informe."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatResultsHeader.tsx
msgid "Ask Cantilever..."
msgstr "Pregúntale a Cantilever..."

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Ask for a model, an edit, or an explanation…"
msgstr "Solicite un modelo, una modificación o una explicación…"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Ask Rolodex for "
msgstr "Consultar a Rolodex por "

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
msgid "Asset"
msgstr "Activo"

#: src/pages/homepage/constants.ts
msgid "Asset Database"
msgstr "Base de datos de activos"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Asset Details"
msgstr "Detalles del activo"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Asset Documents"
msgstr "Documentos del activo"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Asset enrichment"
msgstr "Enriquecimiento del activo"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "Asset instances"
msgstr "Instancias de activos"

#: src/pages/assetLens/AssetLens.tsx
msgid "Asset Lens: {unitLabel} | {DEFAULT_DOCUMENT_TITLE}"
msgstr "Asset Lens: {unitLabel} | {DEFAULT_DOCUMENT_TITLE}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset meter"
msgstr "Medidor del activo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset meters"
msgstr "Medidores del activo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Asset model"
msgstr "Modelo del activo"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Asset Model Editor"
msgstr "Editor de modelos de activos"

#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Asset Name"
msgstr "Nombre del activo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset register"
msgstr "Registro de activos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Asset specification"
msgstr "Especificación del activo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset specifications"
msgstr "Especificaciones del activo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Asset type"
msgstr "Tipo de activo"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Asset Type: {assetTypeLabel}"
msgstr "Tipo de activo: {assetTypeLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/AssetTypeFilter.tsx
msgid "Asset Types"
msgstr "Tipos de activo"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Asset view"
msgstr "Vista del activo"

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
msgid "Asset viewer"
msgstr "Visor de activos"

#: src/pages/details/visualization/Visualization.tsx
msgid "Asset visualization description"
msgstr "Descripción de la visualización del activo"

#: src/features/navbar/navConfig.ts
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseSidebar.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/systemView/components/DataPanel.tsx
msgid "Assets"
msgstr "Activos"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Assign Admin Permissions"
msgstr "Asignar permisos de administrador"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign alias(es) as junk"
msgstr "Marcar alias como no válidos"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign as junk"
msgstr "Marcar como no válido"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assign each source to Subject A or Subject B."
msgstr "Asigne cada fuente al sujeto A o al sujeto B."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Assign each time chunk to train, val, or test. Train fits the model; val (if any) calibrates the residual band; test is held out for metrics. Click a chunk to cycle roles. Prod default ≈ first 90% train, last 10% test."
msgstr "Asigne cada bloque de tiempo a entrenamiento, validación o prueba. Entrenamiento ajusta el modelo; validación, si existe, calibra la banda del residuo; prueba se reserva para las métricas. Haga clic en un bloque para cambiar su rol. Valor predeterminado en producción: aproximadamente el primer 90 % para entrenamiento y el último 10 % para prueba."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Assign every source record before previewing ({unassigned} unassigned)."
msgstr "Asigne todos los registros de origen antes de previsualizar ({unassigned} sin asignar)."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Assigned owner group"
msgstr "Grupo responsable asignado"

#: src/features/fimReview/ReviewActions.tsx
msgid "Assigning…"
msgstr "Asignando…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Assistant is responding"
msgstr "El asistente está respondiendo"

#: src/features/chatbot/hooks/useReconnect.ts
#: src/features/chatbot/utils/mapBackendMessages.ts
msgid "Assistant message errored"
msgstr "El mensaje del asistente falló"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Assistant: {content}"
msgstr "Asistente: {content}"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "at {fromLabel}"
msgstr "en {fromLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "At approval"
msgstr "Al aprobar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "At calculation floor"
msgstr "En el límite inferior del cálculo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "At calculation limit"
msgstr "En el límite de cálculo"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "at least"
msgstr "al menos"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/features/timeSeries/services/thresholdService.ts
msgid "At least one threshold must be configured when enabled"
msgstr "Debe configurar al menos un umbral cuando esté activado"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Attach an image"
msgstr "Adjuntar una imagen"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Attach failed"
msgstr "No se pudo adjuntar"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach or paste screenshots to help explain the issue. Images are sent to Gecko Support when you submit."
msgstr "Adjunta o pega capturas de pantalla para ayudar a explicar el problema. Las imágenes se envían al equipo de soporte de Gecko cuando envías el informe."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach PNG, JPEG, or GIF images."
msgstr "Adjunte imágenes PNG, JPEG o GIF."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Attach screenshots"
msgstr "Adjuntar capturas de pantalla"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Attached"
msgstr "Adjunto"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "Attached drawings"
msgstr "Planos adjuntos"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Attached page {position} of {count}"
msgstr "Página adjunta {position} de {count}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Attached page {position} of {count}: {drawing} could not be loaded."
msgstr "Página adjunta {position} de {count}: no se pudo cargar {drawing}."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "Attached photos"
msgstr "Fotos adjuntas"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Attaching…"
msgstr "Adjuntando…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Attribute"
msgstr "Atributo"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Audit"
msgstr "Auditoría"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Audit state: {auditState}"
msgstr "Estado de la auditoría: {auditState}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Author"
msgstr "Autor"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Auto"
msgstr "Automático"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Auto adjust"
msgstr "Ajuste automático"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "auto-applicable"
msgstr "aplicable automáticamente"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Auto-saving..."
msgstr "Guardando automáticamente..."

#: src/features/navbar/navConfig.ts
msgid "Availability Planning"
msgstr "Planificación de disponibilidad"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Availability reflects the recorded calculation, not installed or consumed parts."
msgstr "La disponibilidad refleja el cálculo registrado, no las piezas instaladas o utilizadas."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "available"
msgstr "disponibles"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Available"
msgstr "Disponible"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Available balance field"
msgstr "Campo de saldo disponible"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Available count unknown"
msgstr "Cantidad disponible desconocida"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Available under"
msgstr "Disponible en"

#: src/pages/nnpp/imports/NnppImportProcessingPage.tsx
msgid "Available when processing completes successfully."
msgstr "Disponible cuando el procesamiento finalice correctamente."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Average cost"
msgstr "Costo promedio"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Average Decibel (dB)"
msgstr "Nivel promedio (dB)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Average Temperature (°F)"
msgstr "Temperatura promedio (°F)"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Average thickness"
msgstr "Espesor promedio"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Average Thickness"
msgstr "Espesor promedio"

#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Axial"
msgstr "Axial"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewHeader.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Back"
msgstr "Atrás"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Back to {parentLabel}"
msgstr "Volver a {parentLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Back to {referenceOriginLabel}"
msgstr "Volver a {referenceOriginLabel}"

#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/AlertDetails.tsx
msgid "Back to alerts"
msgstr "Volver a las alertas"

#: src/pages/cases/components/CaseHeader.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Back to cases"
msgstr "Volver a los casos"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Back to charts"
msgstr "Volver a los gráficos"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingBack.tsx
msgid "Back to dashboard"
msgstr "Volver al panel"

#: src/pages/evaluations/components/BackToEvaluations.tsx
msgid "Back to Evaluations"
msgstr "Volver a Evaluaciones"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "Back to home"
msgstr "Volver al inicio"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Back to Issues"
msgstr "Volver a los problemas"

#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
msgid "Back to landing"
msgstr "Volver a la página principal"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Back to overview"
msgstr "Volver al resumen"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
msgid "Back to report"
msgstr "Volver al informe"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
msgid "Backend could not create an upload session."
msgstr "El backend no pudo crear una sesión de carga."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Backend did not return an approval result for this file."
msgstr "El backend no devolvió un resultado de aprobación para este archivo."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
msgid "Backend response"
msgstr "Respuesta del backend"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload approval response."
msgstr "El backend devolvió una respuesta de aprobación de carga no válida."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history files response."
msgstr "El backend devolvió una respuesta inválida del historial de archivos cargados."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history response."
msgstr "El backend devolvió una respuesta de historial de cargas no válida."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload history sessions response."
msgstr "El backend devolvió una respuesta inválida de sesiones del historial de cargas."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload processing status response."
msgstr "El backend devolvió una respuesta de estado de procesamiento de carga no válida."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Backend returned an invalid upload transfer failure response."
msgstr "El backend devolvió una respuesta inválida de fallo de transferencia."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Backtest"
msgstr "Prueba retrospectiva"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Backtest {value152_51}"
msgstr "Prueba retrospectiva de {value152_51}"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest a saved model"
msgstr "Evaluar retrospectivamente un modelo guardado"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest end"
msgstr "Fin de la prueba retrospectiva"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Backtest start"
msgstr "Inicio de la prueba retrospectiva"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Backtesting needs a saved model. Ask the agent to save this one first."
msgstr "Las pruebas retrospectivas necesitan un modelo guardado. Pida al agente que guarde este primero."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "bad direction"
msgstr "dirección desfavorable"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Bad response"
msgstr "Respuesta deficiente"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "band"
msgstr "banda"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "band (±)"
msgstr "banda (±)"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "band (1σ, sd of daily fit error)"
msgstr "banda (1σ, desv. estándar del error diario de ajuste)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "band {value74_25}→{value74_45}"
msgstr "banda {value74_25}→{value74_45}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Band compares {intervalMinutes}-minute averages against the model."
msgstr "La banda compara los promedios de {intervalMinutes} minutos con el modelo."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Band cov."
msgstr "Cobertura de banda"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band estimator"
msgstr "Estimador de banda"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Band from {bandSource}. Leave-one-out, so the fit is not graded against rows it memorised."
msgstr "Banda de {bandSource}. Validación dejando una muestra fuera: el ajuste no se evalúa con filas que ya memorizó."

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band k"
msgstr "K de la banda"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Band k (multiplier)"
msgstr "K de la banda (multiplicador)"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Band quantile"
msgstr "Cuantil de banda"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Band width (x residual scale) — breach when |residual| exceeds this"
msgstr "Ancho de banda (× escala del residuo): se supera cuando |residuo| excede este valor"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "band_k {value72_27}→{value72_48}"
msgstr "band_k {value72_27}→{value72_48}"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "banded {bandStart} → {bandEnd}"
msgstr "rango {bandStart} → {bandEnd}"

#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Bands"
msgstr "Bandas"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "baseline"
msgstr "referencia"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Baseline — learned from"
msgstr "Referencia: aprendido a partir de"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "baseline <0>{baselineMedian}</0>"
msgstr "referencia <0>{baselineMedian}</0>"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "baseline median"
msgstr "mediana de referencia"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "baseline rows"
msgstr "filas de referencia"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "basis: {basis}"
msgstr "base: {basis}"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Before"
msgstr "Antes"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "Before {endDate}"
msgstr "Antes de {endDate}"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
msgid "Before:"
msgstr "Antes:"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Below expected range"
msgstr "Por debajo del rango esperado"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Below minimum thickness"
msgstr "Por debajo del espesor mínimo"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "best shift"
msgstr "mejor desfase"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Beta"
msgstr "Beta"

#: src/features/permissions/profiles/power.ts
msgid "Beta features"
msgstr "Funciones beta"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Bin"
msgstr "Ubicación de almacenamiento"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Bin balance"
msgstr "Saldo de la ubicación de almacén"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Bin balances"
msgstr "Saldos por ubicación"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Bin columns [{xStart}, {xEnd}), rows [{yStart}, {yEnd})"
msgstr "Columnas de celdas [{xStart}, {xEnd}), filas [{yStart}, {yEnd})"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "Bin size: {formattedBinSize}"
msgstr "Tamaño de celda: {formattedBinSize}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Bin-level stock snapshot; not a reservation or availability guarantee."
msgstr "Instantánea de existencias por ubicación de almacén; no constituye una reserva ni garantiza disponibilidad."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Blank"
msgstr "En blanco"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Blanks every pen on days the gate or a masked range removed, so the chart shows only what the fit graded. The axis still spans the full window, so the gaps stay visible."
msgstr "Oculta todos los trazos en los días excluidos por el filtro o por un rango enmascarado, de modo que el gráfico muestra solo lo que evaluó el ajuste. El eje sigue cubriendo todo el intervalo, por lo que los vacíos permanecen visibles."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Bold (Ctrl+B)"
msgstr "Negrita (Ctrl+B)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Bold method = lowest test MAE within its run. Metrics come from each method's held-out test split."
msgstr "Método en negrita = menor MAE de prueba de su ejecución. Las métricas provienen de la partición de prueba reservada de cada método."

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Bookmarked point"
msgstr "Punto marcado"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Both blank"
msgstr "Ambos en blanco"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Bottom"
msgstr "Inferior"

#: src/features/workbench/LayoutToggles.tsx
msgid "bottom panel"
msgstr "panel inferior"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Bound"
msgstr "Vinculado"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Bounds max"
msgstr "Límite máximo"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Bounds min"
msgstr "Límite mínimo"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Bounds on the target"
msgstr "Límites del objetivo"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "Box {boxId}"
msgstr "Cuadro {boxId}"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Brightness"
msgstr "Brillo"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoViewerToolbar.tsx
msgid "Brightness / contrast (A: toggle auto-adjust; double-click to auto)"
msgstr "Brillo / contraste (A: alternar ajuste automático; doble clic para ajustar)"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Browse labeled"
msgstr "Ver páginas etiquetadas"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Browse search results"
msgstr "Explorar resultados de búsqueda"

#: src/features/permissions/profiles/power.ts
msgid "Browse, search, and download documents."
msgstr "Explora, busca y descarga documentos."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Bucket"
msgstr "Intervalo de agrupación"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "bucket by"
msgstr "agrupar por"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Bucket interval"
msgstr "Intervalo de agrupación"

#: src/features/navbar/navConfig.ts
msgid "Budgeting"
msgstr "Presupuesto"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Bug"
msgstr "Error"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Bug details"
msgstr "Detalles del error"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Build"
msgstr "Crear"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Build & run everything"
msgstr "Crear y ejecutar todo"

#: src/features/timeSeries/agentTab/AgentChatPanel.tsx
msgid "Build a health model for the gas turbine compressor: isentropic efficiency, field-fitted against 2022."
msgstr "Cree un modelo de condición para el compresor de la turbina de gas: eficiencia isentrópica, ajustada con datos de campo de 2022."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Build context"
msgstr "Crear contexto"

#: src/features/sentinels/useSentinelList.ts
msgid "building context…"
msgstr "creando contexto…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Building context…"
msgstr "Creando contexto…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Building the context bundle"
msgstr "Creando el conjunto de contexto"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Builds the context, then designs, fits and evaluates end to end without the per-stage buttons. Stops early if the context is ineligible or the plan cannot run."
msgstr "Crea el contexto y luego diseña, ajusta y evalúa de principio a fin sin los botones de cada etapa. Se detiene si el contexto no es apto o si el plan no se puede ejecutar."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Bulk Actions"
msgstr "Acciones masivas"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Bulk Delete"
msgstr "Eliminación masiva"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Bulk Edit Field"
msgstr "Editar campo en bloque"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Bullet List"
msgstr "Lista con viñetas"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Business and organizational information"
msgstr "Información comercial y organizacional"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Business correspondence and project narratives"
msgstr "Correspondencia comercial y narrativas de proyecto"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "by {user}"
msgstr "por {user}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By month"
msgstr "Por mes"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By N days"
msgstr "Por N días"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "By year"
msgstr "Por año"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "C Extent"
msgstr "Extensión C"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Cadence"
msgstr "Frecuencia"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Calculated as of"
msgstr "Calculado al"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Calculated from available bins; not an inspection interval or an asset pass/fail assessment."
msgstr "Calculado a partir de las celdas disponibles; no es un intervalo de inspección ni una evaluación de aprobación o rechazo del activo."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Calculating"
msgstr "Calculando"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "calib rows"
msgstr "filas de calibración"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Calibrated"
msgstr "Calibrado"

#: src/features/chatbot/hooks/useMessageSender.ts
#: src/features/chatbot/hooks/useMessageSender.ts
msgid "Calling {functionName}"
msgstr "Llamando a {functionName}"

#: src/features/chatbot/utils/mapBackendMessages.ts
msgid "Calling {toolName}"
msgstr "Llamando a {toolName}"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Camera orientation"
msgstr "Orientación de la cámara"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Camera pose projections"
msgstr "Proyecciones de posiciones de cámara"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Camera poses"
msgstr "Posiciones de cámara"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Can open Manage Access and change who has access, including inviting and deactivating people."
msgstr "Puede abrir Administrar acceso y cambiar quién tiene acceso, incluida la invitación y desactivación de personas."

#: src/components/NamePromptModal.tsx
#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
#: src/features/lotoReports/components/LotoLeaveDialog.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
#: src/pages/manageAccess/components/dialogs/ManagedUserConfirmDialog.tsx
#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Cancel"
msgstr "Cancelar"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Cancel choose edit scope"
msgstr "Cancelar la selección del alcance de edición"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Cancel editing"
msgstr "Cancelar edición"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Cancel editing document metadata"
msgstr "Cancelar la edición de metadatos del documento"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Cancel editing page metadata"
msgstr "Cancelar la edición de metadatos de la página"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Cancel rename"
msgstr "Cancelar cambio de nombre"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Cancel training"
msgstr "Cancelar entrenamiento"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Cancelled"
msgstr "Cancelado"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Cannot open Manage Access or change other people's access."
msgstr "No puede abrir Administrar acceso ni cambiar el acceso de otras personas."

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Cannot save a comment without a document id"
msgstr "No se puede guardar un comentario sin un ID de documento"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Cannot save chart: Invalid chart ID"
msgstr "No se puede guardar el gráfico: ID de gráfico no válido"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentMetadataUserEditSaveActions.ts
msgid "Cannot save document metadata without a document id"
msgstr "No se pueden guardar los metadatos del documento sin un ID de documento"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataUserEditSaveActions.ts
msgid "Cannot save page metadata without a document id"
msgstr "No se pueden guardar los metadatos de la página sin un ID de documento"

#: src/pages/cases/md/MdCasesListProvider.tsx
msgid "Cannot shelve an M&D case without a current user email"
msgstr "No se puede aplazar un caso de M&D sin el correo del usuario actual"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Canonical name is required."
msgstr "Se requiere el nombre canónico."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatColumn.tsx
msgid "Cantilever can make mistakes. Double-check responses."
msgstr "Cantilever puede cometer errores. Verifique las respuestas."

#: src/features/terms/TermsModal.tsx
msgid "Cantilever Terms of Service"
msgstr "Términos de servicio de Cantilever"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidencePreview.tsx
msgid "Cantilever was unable to verify this claim. Please verify the source."
msgstr "Cantilever no pudo verificar esta afirmación. Por favor verifique la fuente."

#: src/pages/assetLens/components/AssetTabs.tsx
msgid "Canvas"
msgstr "Lienzo"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlook.tsx
msgid "CapEx Outlook"
msgstr "Proyección de CapEx"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "CapEx outlook settings"
msgstr "Configuración de la proyección de CapEx"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Caption"
msgstr "Leyenda"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Caption save failed: {reason}"
msgstr "No se pudo guardar la descripción: {reason}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Capture what we know, what we checked, and what still needs follow-up."
msgstr "Registre lo que sabemos, lo que verificamos y lo que aún requiere seguimiento."

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Captured {capturedAt} (at upload time)"
msgstr "Capturada el {capturedAt} (hora de carga)"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Captured {capturedAt} (from the camera clock)"
msgstr "Capturada el {capturedAt} (según el reloj de la cámara)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Captured from"
msgstr "Capturado de"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentViewModeToggle.tsx
msgid "Card"
msgstr "Tarjeta"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "carry forward"
msgstr "propagar el último valor"

#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Case"
msgstr "Caso"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Case context unavailable. Open this case directly to accept."
msgstr "Contexto del caso no disponible. Abra este caso directamente para aceptar."

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Case Controls"
msgstr "Controles del caso"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Case created"
msgstr "Caso creado"

#: src/features/cases/components/CreateCaseModal.tsx
msgid "Case created successfully!"
msgstr "¡Caso creado correctamente!"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Case Details"
msgstr "Detalles del caso"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Case Information"
msgstr "Información del caso"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Case not found"
msgstr "Caso no encontrado"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Case Priority"
msgstr "Prioridad del caso"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Case signals · {target}"
msgstr "Señales del caso · {target}"

#: src/features/cases/forms/caseFormFields.ts
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Case Status"
msgstr "Estado del caso"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Case title"
msgstr "Título del caso"

#: src/features/cases/forms/caseFormFields.ts
msgid "Case Title"
msgstr "Título del caso"

#: src/features/cases/forms/caseFormFields.ts
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Case Type"
msgstr "Tipo de caso"

#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/contexts/CaseDetailsProvider.tsx
msgid "Case Updated"
msgstr "Caso actualizado"

#: src/pages/cases/components/CasesTable.tsx
#: src/pages/cases/components/CasesTable.tsx
msgid "cases"
msgstr "casos"

#: src/features/navbar/navConfig.ts
#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/sentinels/components/CasesPanel.tsx
#: src/pages/cases/CasesList.tsx
#: src/pages/cases/components/CaseHeader.tsx
#: src/pages/cases/components/CasesTable.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Cases"
msgstr "Casos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Catalog code"
msgstr "Código de catálogo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Catalog item"
msgstr "Artículo del catálogo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Catalog specifications; not proof of installation."
msgstr "Especificaciones del catálogo; no prueban la instalación."

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Category"
msgstr "Categoría"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds greatly exceed asset model bounds"
msgstr "Los límites del CDF exceden ampliamente los límites del modelo de activo"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds slightly exceed asset model bounds"
msgstr "Los límites del CDF exceden ligeramente los límites del modelo de activo"

#: src/pages/details/visualization/alerts/specificAlerts/DimensionMismatchAlert.tsx
msgid "CDF bounds somewhat exceed asset model bounds"
msgstr "Los límites del CDF exceden moderadamente los límites del modelo de activo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Centered window over each denoised tag, "
msgstr "Ventana centrada sobre cada etiqueta sin ruido, "

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ActiveEditScopeBanner.tsx
msgid "Change"
msgstr "Cambiar"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Change {personName} from {currentTypeLabel} to {nextTypeLabel}? This updates their Cantilever access in the selected scope."
msgstr "¿Cambiar a {personName} de {currentTypeLabel} a {nextTypeLabel}? Esto actualiza su acceso a Cantilever en el ámbito seleccionado."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Change details are unavailable."
msgstr "Los detalles del cambio no están disponibles."

#: src/features/knowledgeDocumentViewer/components/metadata/ActiveEditScopeBanner.tsx
msgid "Change edit scope"
msgstr "Cambiar alcance de edición"

#: src/features/fimReview/ReviewActions.tsx
msgid "Change the name, kind, or type"
msgstr "Cambiar el nombre, la clase o el tipo"

#: src/features/fimReview/ReviewActions.tsx
msgid "Change the name, kind, or type to save."
msgstr "Cambie el nombre, la clase o el tipo para guardar."

#: src/features/navbar/ThemeModeToggle.tsx
#: src/features/navbar/ThemeModeToggle.tsx
msgid "Change theme to {theme}"
msgstr "Cambiar tema a {theme}"

#: src/features/navbar/UnitsToggle.tsx
msgid "Change units to inches"
msgstr "Cambiar las unidades a pulgadas"

#: src/features/navbar/UnitsToggle.tsx
msgid "Change units to millimeters"
msgstr "Cambiar las unidades a milímetros"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Change user type?"
msgstr "¿Cambiar tipo de usuario?"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Changed"
msgstr "Cambiado"

#: src/features/cases/components/CasePropertyChangedContent.tsx
msgid "Changed {fieldName}"
msgstr "Se cambió {fieldName}"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Changing Drawing # or Sheet # removes this document from the revision family."
msgstr "Cambiar el Plano # o la Hoja # quita este documento de la familia de revisiones."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Changing Drawing # removes this document from the revision family."
msgstr "Cambiar el Plano # quita este documento de la familia de revisiones."

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Chart"
msgstr "Gráfico"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "chart · {changes}"
msgstr "gráfico · {changes}"

#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
msgid "Chart Configuration"
msgstr "Configuración del gráfico"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Chart has unsaved changes"
msgstr "El gráfico tiene cambios sin guardar"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Chart ID"
msgstr "ID del gráfico"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Chart mode"
msgstr "Modo del gráfico"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Chart name"
msgstr "Nombre del gráfico"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Chart overlay visibility"
msgstr "Visibilidad de las superposiciones del gráfico"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Chart overlays"
msgstr "Superposiciones del gráfico"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Chart saved successfully!"
msgstr "¡Gráfico guardado correctamente!"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Chart shows "
msgstr "El gráfico muestra "

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Chart x-axis pinned to "
msgstr "Eje X del gráfico anclado a "

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Chat"
msgstr "Chat"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Chat history"
msgstr "Historial de chat"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Chat scoped to case"
msgstr "Chat limitado al caso"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Chat Session"
msgstr "Sesión de chat"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Check cadence"
msgstr "Frecuencia de comprobación"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/CitedResponseSegments.tsx
msgid "Check how this was calculated"
msgstr "Compruebe cómo se calculó esto"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Check the query, answer, checks, and cited documents before this case is saved."
msgstr "Compruebe la consulta, la respuesta, las comprobaciones y los documentos citados antes de guardar este caso."

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Check two or more saved models on the shelf to compare their test metrics side by side."
msgstr "Seleccione dos o más modelos guardados para comparar sus métricas de prueba en paralelo."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Checked (default): gate ops drop failing rows across the whole window — train, val, AND test (matches prod behavior). Unchecked: gates only remove train/val rows; the test range keeps every row, so held-out metrics stay honest about all operating regimes instead of only scoring the gated one."
msgstr "Activado (predeterminado): los filtros eliminan las filas que no cumplen las condiciones en todo el intervalo: entrenamiento, validación y prueba (igual que en producción). Desactivado: los filtros solo eliminan filas de entrenamiento y validación; el rango de prueba conserva todas las filas, para que las métricas reflejen todos los regímenes de operación y no solo el régimen filtrado."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Checked data coverage"
msgstr "Se verificó la cobertura de datos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Checking data coverage"
msgstr "Verificando la cobertura de datos"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Checking links…"
msgstr "Verificando vínculos…"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Checking this site's pipeline configs…"
msgstr "Verificando las configuraciones de pipeline de este sitio…"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Checking..."
msgstr "Comprobando..."

#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Checkmark"
msgstr "Marca de verificación"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Chip search: lock terms in, refine live, toggle tags on and off."
msgstr "Búsqueda por términos: fije términos, refine en tiempo real y active o desactive etiquetas."

#: src/features/fimReview/ReviewActions.tsx
msgid "Choose a decision first."
msgstr "Elija primero una decisión."

#: src/features/fimReview/ReviewActions.tsx
msgid "Choose a decision to continue."
msgstr "Elija una decisión para continuar."

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Choose a destination:"
msgstr "Elige un destino:"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose a different subject to merge."
msgstr "Elija otro sujeto para combinar."

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "Choose a LOTO"
msgstr "Elige un LOTO"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose a source record…"
msgstr "Elija un registro de origen…"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Choose an action:"
msgstr "Elija una acción:"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Choose document edit scope"
msgstr "Elija el alcance de edición del documento"

#: src/features/lotoReports/components/LotoPresetCombobox.tsx
msgid "Choose or type…"
msgstr "Elige o escribe…"

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "Choose page edit scope"
msgstr "Elegir el alcance de edición de la página"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose Subject…"
msgstr "Elegir sujeto…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Choose the misread value…"
msgstr "Elija el valor leído incorrectamente…"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose the observed OCR value."
msgstr "Elija el valor de OCR observado."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose the source record with the OCR error."
msgstr "Elija el registro de origen que contiene el error de OCR."

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Choose which sites {userName} can reach. Access within each site is set on that site's page."
msgstr "Elija los sitios a los que puede acceder {userName}. Los permisos de cada sitio se configuran en su página."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Choose which subject survives the merge."
msgstr "Elija qué sujeto se conservará después de la combinación."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Chunk unit"
msgstr "Unidad del bloque"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Chunks appear after a data preview loads."
msgstr "Los bloques aparecen después de cargar una vista previa de datos."

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Chunks appear once the data preview loads — pick a target and drivers first."
msgstr "Los bloques aparecen cuando se carga la vista previa de datos; seleccione primero un objetivo y variables predictoras."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Circ"
msgstr "Circunf."

#: src/features/copcPointClouds/CopcPointCloudScene.tsx
#: src/features/copcPointClouds/CopcPointCloudScene.tsx
msgid "Circumferential"
msgstr "Circunferencial"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Circumferential Critical Thickness Profile"
msgstr "Perfil crítico de espesor circunferencial"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Cited"
msgstr "Citada"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Cited documents"
msgstr "Documentos citados"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Cited evidence"
msgstr "Evidencia citada"

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Cited text"
msgstr "Texto citado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "City"
msgstr "Ciudad"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Civil and geotechnical analysis"
msgstr "Análisis civil y geotécnico"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Civil/Structural Details"
msgstr "Detalles civiles/estructurales"

#: src/features/fimReview/ReviewActions.tsx
msgid "Classification change preview"
msgstr "Vista previa del cambio de clasificación"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Cleaning"
msgstr "Limpieza"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Cleaning for {tag}"
msgstr "Limpieza de {tag}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadAttachments.tsx
#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Clear"
msgstr "Limpiar"

#: src/features/timeSeries/components/EditableRangeInput.tsx
msgid "Clear (auto scale)"
msgstr "Borrar (escala automática)"

#: src/pages/metrics/components/FilterPopover.tsx
msgid "Clear {label} filter"
msgstr "Borrar filtro de {label}"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingFilterActions.tsx
msgid "Clear all"
msgstr "Borrar todo"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Clear all custom ranges and auto-scale every pen"
msgstr "Borrar todos los rangos personalizados y ajustar automáticamente la escala de cada trazo"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Clear filters"
msgstr "Borrar filtros"

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Clear highlight"
msgstr "Quitar resaltado"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Clear ops"
msgstr "Borrar operaciones"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Clear position for {tag}"
msgstr "Borrar posición para {tag}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Clear recents"
msgstr "Borrar recientes"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Clear runs"
msgstr "Borrar ejecuciones"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Clear selection"
msgstr "Borrar selección"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Clear this filter"
msgstr "Borrar este filtro"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Cleared"
msgstr "Borrado"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Click a node on the drawing to add an isolation point."
msgstr "Haz clic en un nodo del plano para añadir un punto de aislamiento."

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Click a point outside the band to open a case for that breach — then run RCA from the Cases tab."
msgstr "Haga clic en un punto fuera de la banda para abrir un caso por esa desviación; luego ejecute el análisis de causa raíz desde la pestaña Casos."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Click a row to plot the tag; click again to remove it."
msgstr "Haga clic en una fila para graficar la etiqueta; haga clic de nuevo para quitarla."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Click a UT point or drag the origin"
msgstr "Haz clic en un punto UT o arrastra el origen"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Click an artifact or file in the lineage to view it here."
msgstr "Haga clic en un artefacto o archivo del linaje para verlo aquí."

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Click equipment on the drawing to add or remove it. Press Esc when done."
msgstr "Haz clic en un equipo del plano para añadirlo o quitarlo. Pulsa Esc al terminar."

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click on the asset to add a label."
msgstr "Haga clic en el activo para agregar una etiqueta."

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click on the asset to add an icon."
msgstr "Haga clic en el activo para agregar un ícono."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Click or drag file to this area to upload"
msgstr "Haga clic o arrastre un archivo a esta área para cargarlo"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Click tags above — the first becomes the modeled tag, every further one a driver feeding it."
msgstr "Haga clic en las etiquetas de arriba: la primera será la etiqueta modelada y las siguientes serán variables predictoras."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Click the document menu button above to list or upload documents"
msgstr "Haga clic en el botón del menú de documentos de arriba para enumerar o cargar documentos"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Click the view's title to search and switch views."
msgstr "Haga clic en el título de la vista para buscar y cambiar de vista."

#: src/features/timeSeries/agentTab/chat/ToolCard.tsx
msgid "Click to add to the chart"
msgstr "Haz clic para añadir al gráfico"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "click to browse"
msgstr "haga clic para explorar"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Click to hide this pen"
msgstr "Haga clic para ocultar este trazo"

#: src/pages/alerts/AlertDetails.tsx
msgid "Click to mark as unacknowledged"
msgstr "Haga clic para marcar como no reconocido"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Click to open"
msgstr "Haga clic para abrir"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/OffPageConnectorTooltip.tsx
msgid "Click to open • Cmd/Ctrl + click for new tab"
msgstr "Clic para abrir • Cmd/Ctrl + clic para abrir en una pestaña nueva"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to open the chart for this answer."
msgstr "Haz clic para abrir el gráfico de esta respuesta."

#: src/features/knowledgeDocumentViewer/graph/GraphTooltip.tsx
msgid "Click to open the connected page."
msgstr "Haz clic para abrir la página conectada."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to put this series on the chart."
msgstr "Haz clic para poner esta serie en el gráfico."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "Click to put this tag on the chart."
msgstr "Haz clic para poner esta etiqueta en el gráfico."

#: src/features/timeSeries/components/FormulaTokenElement.tsx
msgid "Click to replace with a sensor or value"
msgstr "Haga clic para reemplazarlo con un sensor o valor"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Click to restore alert highlight"
msgstr "Haga clic para restaurar el resaltado de la alerta"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Click to set the location of the new rectangle."
msgstr "Haga clic para establecer la ubicación del rectángulo nuevo."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Click to show this pen"
msgstr "Haga clic para mostrar este trazo"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "Click: {resolvedClickHint}"
msgstr "Clic: {resolvedClickHint}"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Clickable Assets"
msgstr "Activos interactivos"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Clip quantile high"
msgstr "Cuantil superior de recorte"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Clip quantile low"
msgstr "Cuantil inferior de recorte"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Clip unavailable"
msgstr "Recorte no disponible"

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
#: src/features/richText/nodes/MentionNode.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Close"
msgstr "Cerrar"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Close (Escape)"
msgstr "Cerrar (Escape)"

#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "Close {label} tab"
msgstr "Cerrar pestaña {label}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Close Comparison"
msgstr "Cerrar comparación"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Close cross-reference"
msgstr "Cerrar referencia cruzada"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Close destination lookup"
msgstr "Cerrar búsqueda de destino"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Close document"
msgstr "Cerrar documento"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Close find"
msgstr "Cerrar búsqueda"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ImagePreviewPanel.tsx
msgid "Close image preview"
msgstr "Cerrar vista previa de imagen"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "Close LOTO panel"
msgstr "Cerrar panel LOTO"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Close modal"
msgstr "Cerrar ventana"

#: src/features/navbar/MenuDrawer.tsx
msgid "Close navigation"
msgstr "Cerrar navegación"

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "Close node panel"
msgstr "Cerrar panel del nodo"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/ReelAnnotationsPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/annotation/ReelAnnotationsPanel.tsx
msgid "Close photo reel"
msgstr "Cerrar carrete de fotos"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "Close preview"
msgstr "Cerrar vista previa"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "Close revision compare"
msgstr "Cerrar comparación de revisiones"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Close search"
msgstr "Cerrar búsqueda"

#: src/features/chatbot/components/SessionTabs.tsx
msgid "Close session"
msgstr "Cerrar la sesión de chat"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Close subject panel"
msgstr "Cerrar panel del sujeto"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Close Subject picker"
msgstr "Cerrar selector de sujetos"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Close tab"
msgstr "Cerrar pestaña"

#: src/features/terms/TermsModal.tsx
msgid "Close terms of service"
msgstr "Cerrar términos de servicio"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/TrendPreviewPanel.tsx
msgid "Close trend preview"
msgstr "Cerrar vista previa de la tendencia"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Close view settings"
msgstr "Cerrar ajustes de la vista"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Closed"
msgstr "Cerrado"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgctxt "LOTO isolation position"
msgid "Closed"
msgstr "Cerrada"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "CMMS"
msgstr "CMMS"

#: src/features/embeddedSidebar/cmmsSidebarNav.ts
msgid "CMMS Explorer"
msgstr "Explorador de CMMS"

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "CMMS explorer is not enabled for this site."
msgstr "El explorador de CMMS no está habilitado para este sitio."

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "CMMS record"
msgstr "Registro de CMMS"

#: src/features/fimReview/provenance.ts
msgid "CMMS row"
msgstr "Fila de CMMS"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Coefficient"
msgstr "Coeficiente"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Collapse"
msgstr "Contraer"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Collapse all"
msgstr "Contraer todo"

#: src/features/knowledgeDocumentViewer/components/table/TableBodyRow.tsx
msgid "Collapse row"
msgstr "Contraer fila"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Color"
msgstr "Color"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Color Labels By"
msgstr "Colorear etiquetas por"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Color scale"
msgstr "Escala de colores"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Color scale settings"
msgstr "Configuración de la escala de colores"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Color scale thresholds"
msgstr "Umbrales de la escala de colores"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/ColumnConfiguration.tsx
msgid "Columns"
msgstr "Columnas"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Combine plotted tags into a calculated pen, such as a difference, a ratio, or a unit conversion."
msgstr "Combina etiquetas graficadas en un trazo calculado, como una diferencia, una relación o una conversión de unidades."

#: src/features/fimReview/IdentityPanel.tsx
msgid "Combined records"
msgstr "Registros combinados"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "combined variance reduction · flatness="
msgstr "reducción de varianza combinada · uniformidad="

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Coming soon: System View Configuration"
msgstr "Próximamente: configuración de la vista del sistema"

#: src/designSystem/components/Command.tsx
msgid "Command Palette"
msgstr "Paleta de comandos"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Comment"
msgstr "Comentario"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Comment (optional)"
msgstr "Comentario (opcional)"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Comment added"
msgstr "Comentario agregado"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Comment added, but updated comments could not be refreshed"
msgstr "Comentario agregado, pero no se pudieron actualizar los comentarios"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalComments.tsx
msgid "Comment is saved when you Confirm or Defer."
msgstr "El comentario se guarda al Confirmar o Diferir."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Comments"
msgstr "Comentarios"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Commercial and financial records"
msgstr "Registros comerciales y financieros"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Company"
msgstr "Empresa"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Compare"
msgstr "Comparar"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Compare · test metrics · "
msgstr "Comparar · métricas de prueba · "

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Compare ({compareCount})"
msgstr "Comparar ({compareCount})"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Compare {value208_37}"
msgstr "Comparar {value208_37}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Compare runs"
msgstr "Comparar ejecuciones"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Compare saved models"
msgstr "Comparar modelos guardados"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Compare with Next"
msgstr "Comparar con el siguiente"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Compare with Previous"
msgstr "Comparar con el anterior"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Compared pages"
msgstr "Páginas comparadas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Compared with revision {from}"
msgstr "Comparado con la revisión {from}"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Comparing "
msgstr "Comparando "

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Compartments shown"
msgstr "Compartimentos mostrados"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "Complete"
msgstr "Completar"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Complete the document details and requirement selection to continue."
msgstr "Completa los detalles del documento y la selección de requisitos para continuar."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "complete_rows {value80_25}→{value80_70}"
msgstr "complete_rows {value80_25}→{value80_70}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Completed"
msgstr "Completado"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Completing import…"
msgstr "Completando la importación…"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
#: src/pages/details/visualization/tools/VizControlTools.tsx
msgid "Component"
msgstr "Componente"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Component fabrication and assembly details"
msgstr "Detalles de fabricación y ensamblaje de componentes"

#: src/features/navbar/navConfig.ts
msgid "Components"
msgstr "Componentes"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computed the KPI"
msgstr "Se calculó el KPI"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computed the KPI {name}"
msgstr "Se calculó el KPI {name}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computing the KPI"
msgstr "Calculando el KPI"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Computing the KPI {name}"
msgstr "Calculando el KPI {name}"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Computing…"
msgstr "Calculando…"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Conduit pipelines are currently in progress"
msgstr "Las tuberías de conductos están actualmente en curso"

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confidence"
msgstr "Confianza"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "confidence {confidence}%"
msgstr "confianza del {confidence}%"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Config"
msgstr "Configuración"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Config changed since the last run — results are stale"
msgstr "La configuración cambió desde la última ejecución; los resultados están desactualizados"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Config changed since this run — retrain before saving"
msgstr "La configuración cambió desde esta ejecución; vuelva a entrenar antes de guardar"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "config only"
msgstr "solo configuración"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Configuration saved successfully"
msgstr "La configuración se guardó correctamente"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Configuration section"
msgstr "Sección de configuración"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
msgid "Configure"
msgstr "Configurar"

#: src/features/workbench/WorkbenchShell.tsx
msgid "Configure chart"
msgstr "Configurar gráfico"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Configure Chart"
msgstr "Configurar gráfico"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Configure metadata for System"
msgstr "Configurar metadatos del sistema"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Configure Sensor Thresholds"
msgstr "Configurar umbrales de sensores"

#: src/features/timeSeries/components/ChartControls.tsx
msgid "Configure Thresholds"
msgstr "Configurar umbrales"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Configure thresholds for each sensor. You can set any combination of Upper High, Upper, Lower, and Lower Low thresholds. At least one threshold must be configured when enabled. These will be displayed as reference lines on the chart when the Alert Thresholds layer is enabled."
msgstr "Configure umbrales para cada sensor. Puede establecer cualquier combinación de los umbrales alto superior, superior, inferior y bajo inferior. Debe configurar al menos uno cuando estén activados. Se mostrarán como líneas de referencia en el gráfico cuando esté activada la capa Umbrales de alertas."

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Configure View Settings - {entryName}"
msgstr "Configurar ajustes de vista - {entryName}"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Confined space #"
msgstr "N.º de espacio confinado"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "CONFINED SPACE #:"
msgstr "N.º ESPACIO CONFINADO:"

#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm"
msgstr "Confirmar"

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Confirm or defer this page before adding a comment"
msgstr "Confirme o aplace esta página antes de agregar un comentario"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Confirm page metadata"
msgstr "Confirmar metadatos de la página"

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
msgid "Confirm page metadata by hand so the pipeline has ground truth to be scored against."
msgstr "Confirme manualmente los metadatos de las páginas para proporcionar datos de referencia con los que evaluar el proceso automático."

#: src/features/chatbot/components/SessionTabs.tsx
msgid "Confirm rename"
msgstr "Confirmar cambio de nombre"

#: src/features/fimReview/ReviewActions.tsx
msgid "Confirm subject"
msgstr "Confirmar sujeto"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Confirm the full page, or defer with a reason."
msgstr "Confirme la página completa o postérguela indicando un motivo."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm this Subject is correct as shown — the same decision as “Everything looks right” in the review rail"
msgstr "Confirme que este sujeto es correcto tal como se muestra; es la misma decisión que “Todo se ve bien” en el panel de revisión"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Confirm validation"
msgstr "Confirmar validación"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Confirmed"
msgstr "Confirmado"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "Connect Points:"
msgstr "Conectar puntos:"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "Connected Assets"
msgstr "Activos conectados"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Connection"
msgstr "Conexión"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Connection Failure"
msgstr "Falla de conexión"

#: src/features/chatbot/hooks/useMessageSender.ts
msgid "Connection to the assistant was interrupted."
msgstr "Se interrumpió la conexión con el asistente."

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Connector destination lookup"
msgstr "Búsqueda del destino del conector"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "constant ±"
msgstr "constante ±"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Consult with your admin for gaining access"
msgstr "Consulte con su administrador para obtener acceso"

#: src/features/fimReview/ReviewActions.tsx
msgid "Contains multiple subjects"
msgstr "Contiene varios sujetos"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Contents, indexes, and drawing registers"
msgstr "Contenidos, índices y registros de planos"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Context"
msgstr "Contexto"

#: src/features/sentinels/useSentinelList.ts
msgid "context built · not designed"
msgstr "contexto generado · sin diseñar"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Context radius"
msgstr "Radio de contexto"

#: src/features/fimReview/IdentityPanel.tsx
msgid "contextual name"
msgstr "nombre contextual"

#: src/features/fimReview/InspectSources.tsx
msgid "Contextual name"
msgstr "Nombre contextual"

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "Continue"
msgstr "Continuar"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "Continue from"
msgstr "Continuar desde"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Continuous scroll"
msgstr "Desplazamiento continuo"

#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Contrast"
msgstr "Contraste"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Conversation"
msgstr "Conversación"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
msgid "Conversation Explorer"
msgstr "Explorador de conversaciones"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
msgid "Conversation Explorer site"
msgstr "Sitio del Explorador de conversaciones"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Conversation name"
msgstr "Nombre de la conversación"

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
msgid "Coordinate origin · this session"
msgstr "Origen de coordenadas · esta sesión"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Coordinates:"
msgstr "Coordenadas:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copied"
msgstr "Copiado"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copy"
msgstr "Copiar"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Copy conversation"
msgstr "Copiar conversación"

#: src/features/navbar/EmailSupport.tsx
msgid "Copy Email Address"
msgstr "Copiar dirección de correo electrónico"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Copy link"
msgstr "Copiar enlace"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Copy link to {whiteboardLabel}"
msgstr "Copiar enlace a {whiteboardLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Copy response"
msgstr "Copiar respuesta"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Copy shareable link to this whiteboard"
msgstr "Copiar enlace para compartir esta pizarra"

#: src/features/navbar/EmailSupport.tsx
msgid "Copy to Clipboard"
msgstr "Copiar al portapapeles"

#: src/features/fimReview/ReviewActions.tsx
msgid "Correct the alias spelling"
msgstr "Corregir la ortografía del alias"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Corrected"
msgstr "Corregido"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "corrected for the scan"
msgstr "corregido para el escaneo"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Corrected OCR"
msgstr "OCR corregido"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Correlation"
msgstr "Correlación"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Correlation & phase shifts"
msgstr "Correlación y desfases"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Correlation chart loads after preview has drivers + target."
msgstr "El gráfico de correlación se carga cuando la vista previa tiene variables predictoras y objetivo."

#: src/features/fimEvidence/SubjectGlyphs.tsx
msgid "Corroborated by {hitCount} of {totalCount} source types: {hitLabels}"
msgstr "Corroborado por {hitCount} de {totalCount} tipos de fuente: {hitLabels}"

#: src/features/modelOperations/Corroboration.tsx
msgid "Corroborated by {hitCount} of {typeCount} source types: {hitLabels}"
msgstr "Corroborado por {hitCount} de {typeCount} tipos de fuente: {hitLabels}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Corrosion rate"
msgstr "Tasa de corrosión"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Cost Dashboard"
msgstr "Panel de costos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Cost distribution"
msgstr "Distribución de costos"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Cost distributions"
msgstr "Distribuciones de costos"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Costs on tickets and work orders"
msgstr "Costos de tickets y órdenes de trabajo"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not archive"
msgstr "No se pudo archivar"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not archive recent chats. Please try again."
msgstr "No se pudieron archivar los chats recientes. Inténtalo de nuevo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Could not attach that image."
msgstr "No se pudo adjuntar esa imagen."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not change access. Try again in a moment."
msgstr "No se pudo cambiar el acceso. Inténtelo de nuevo en un momento."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not change user type. Try again in a moment."
msgstr "No se pudo cambiar el tipo de usuario. Inténtelo de nuevo en un momento."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Could not copy link"
msgstr "No se pudo copiar el enlace"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Could not create the LOTO report. Try again."
msgstr "No se pudo crear el informe LOTO. Inténtelo de nuevo."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not delete"
msgstr "No se pudo eliminar"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not delete archived chats. Please try again."
msgstr "No se pudieron eliminar los chats archivados. Inténtalo de nuevo."

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Could not delete the LOTO report. Try again."
msgstr "No se pudo eliminar el informe LOTO. Inténtelo de nuevo."

#: src/features/knowledgeDocumentViewer/workOrders/CmmsScrollPage.tsx
msgid "Could not display this page. Try downloading the PDF."
msgstr "No se pudo mostrar esta página. Intenta descargar el PDF."

#: src/features/knowledgeDocumentViewer/hooks/useCrossReference.ts
msgid "Could not find related documents. Try again."
msgstr "No se pudieron encontrar documentos relacionados. Inténtalo de nuevo."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Could not generate the record sheet. Try again."
msgstr "No se pudo generar la hoja de registro. Inténtelo de nuevo."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Could not load access policies. Try again in a moment."
msgstr "No se pudieron cargar las políticas de acceso. Inténtelo de nuevo en un momento."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Could not load chats."
msgstr "No se pudieron cargar los chats."

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "Could not load connected documents. Reload and try again."
msgstr "No se pudieron cargar los documentos vinculados. Recarga e inténtalo de nuevo."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "Could not load documents for this node."
msgstr "No se pudieron cargar los documentos de este nodo."

#: src/features/lotoReports/components/LotoPagePanel.tsx
#: src/features/lotoReports/components/LotoReportsListContent.tsx
msgid "Could not load LOTO reports."
msgstr "No se pudieron cargar los informes LOTO."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Could not load model files"
msgstr "No se pudieron cargar los archivos del modelo"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentFavoritesRepository.ts
msgid "Could not load or import document favorites. Please try again."
msgstr "No se pudieron cargar o importar los documentos favoritos. Inténtalo de nuevo."

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Could not load page details. Pages can be previewed once they load."
msgstr "No se pudieron cargar los detalles de las páginas. Podrá obtener una vista previa cuando se carguen."

#: src/features/timeSeries/agentTab/useConversations.ts
msgid "Could not load past conversations."
msgstr "No se pudieron cargar las conversaciones anteriores."

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Could not load the drawings for this equipment."
msgstr "No se pudieron cargar los planos de este equipo."

#: src/features/lotoReports/components/LotoReportEditorLoader.tsx
msgid "Could not load the LOTO report."
msgstr "No se pudo cargar el informe LOTO."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "Could not load the site’s pipeline configuration."
msgstr "No se pudo cargar la configuración del pipeline del sitio."

#: src/features/fim/photos/photoService.ts
msgid "Could not load this photo. Please try again."
msgstr "No se pudo cargar esta foto. Inténtelo de nuevo."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "Could not load users. Try again in a moment."
msgstr "No se pudieron cargar los usuarios. Inténtelo de nuevo en un momento."

#: src/features/knowledgeDocumentViewer/components/sidebar/EvalMetadataSection.tsx
msgid "Could not load your saved page edits."
msgstr "No se pudieron cargar sus ediciones de página guardadas."

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Could not look up the destination. Try again."
msgstr "No se pudo buscar el destino. Inténtalo de nuevo."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not open"
msgstr "No se pudo abrir"

#: src/features/timeSeries/agentTab/useAgentChat.ts
msgid "Could not open that conversation."
msgstr "No se pudo abrir esa conversación."

#: src/features/knowledgeDocumentViewer/graph/useOpenOffPageConnector.ts
msgid "Could not open the connected page. Please try again."
msgstr "No se pudo abrir la página conectada. Inténtalo de nuevo."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not pin"
msgstr "No se pudo fijar"

#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Could not prepare the print preview. Try again."
msgstr "No se pudo preparar la vista previa de impresión. Inténtelo de nuevo."

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "Could not read nested ZIP archive."
msgstr "No se pudo leer el archivo ZIP anidado."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Could not read that image. Please try another file."
msgstr "No se pudo leer esa imagen. Intente con otro archivo."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadErrors.ts
msgid "Could not read this file from your computer. Make sure it is saved locally, then try again."
msgstr "No se pudo leer este archivo de su computadora. Asegúrese de que esté guardado localmente e inténtelo de nuevo."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Could not refresh the model file list: {errorMessage}"
msgstr "No se pudo actualizar la lista de archivos del modelo: {errorMessage}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not rename"
msgstr "No se pudo cambiar el nombre"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Could not revoke access. Try again in a moment."
msgstr "No se pudo revocar el acceso. Inténtalo de nuevo en un momento."

#: src/features/knowledgeDocumentViewer/hooks/useFavoriteDocuments.ts
msgid "Could not save document favorites. Please try again."
msgstr "No se pudieron guardar los documentos favoritos. Inténtalo de nuevo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Could not save the eval case"
msgstr "No se pudo guardar el caso de evaluación"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Could not save the LOTO report. Try again."
msgstr "No se pudo guardar el informe LOTO. Inténtelo de nuevo."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Could not send the issue report. Please try again."
msgstr "No se pudo enviar el reporte del problema. Inténtelo de nuevo."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Could not send the report with its screenshots. Please retry, or remove the screenshots to send a text-only report."
msgstr "No se pudo enviar el reporte con sus capturas de pantalla. Inténtelo de nuevo o quite las capturas para enviar un reporte de solo texto."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not unarchive"
msgstr "No se pudo desarchivar"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Could not unarchive chats. Please try again."
msgstr "No se pudieron desarchivar los chats. Inténtalo de nuevo."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Could not unpin"
msgstr "No se pudo desfijar"

#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Could not update the print preview. Showing the last version."
msgstr "No se pudo actualizar la vista previa de impresión. Se muestra la última versión."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Could not update the record sheet. Showing the last version."
msgstr "No se pudo actualizar la hoja de registro. Se muestra la última versión."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadErrors.ts
msgid "Could not upload this file to the approved upload session."
msgstr "No se pudo cargar este archivo en la sesión de carga aprobada."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "Couldn't load active pipeline comparisons."
msgstr "No se pudieron cargar las comparaciones del pipeline activo."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "Couldn't load dashboard metrics."
msgstr "No se pudieron cargar las métricas del panel."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Couldn't load labeling counts."
msgstr "No se pudieron cargar los recuentos de etiquetado."

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Couldn't load metadata evaluation metrics."
msgstr "No se pudieron cargar las métricas de evaluación de metadatos."

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Couldn't load preferences. Please try again."
msgstr "No se pudieron cargar las preferencias. Inténtelo de nuevo."

#: src/features/facilityModel/catalogQuery.ts
msgid "Couldn't load subjects — retry."
msgstr "No se pudieron cargar los sujetos; vuelva a intentarlo."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionViewer.tsx
msgid "Couldn't load the labeling queue."
msgstr "No se pudo cargar la cola de etiquetado."

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Couldn't locate on page"
msgstr "No se encontró en la página"

#: src/features/lotoReports/components/LotoSaveStatusText.tsx
msgid "Couldn’t save"
msgstr "No se pudo guardar"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Couldn’t save: {errorMessage}"
msgstr "No se pudo guardar: {errorMessage}"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Counter-case (adversarial)"
msgstr "Caso contrario (adversarial)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Country"
msgstr "País"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Counts"
msgstr "Cantidades"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course"
msgstr "Virola"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course threshold for {courseName} must be a positive number."
msgstr "El umbral de la virola {courseName} debe ser un número positivo."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Course thresholds"
msgstr "Umbrales de las virolas"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Coverage notes"
msgstr "Notas de cobertura"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Covers and document identification"
msgstr "Portadas e identificación de documentos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Craft"
msgstr "Especialidad"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Create"
msgstr "Crear"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Create a Linear ticket."
msgstr "Cree un ticket en Linear."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Create a new Subject"
msgstr "Crear un sujeto nuevo"

#: src/features/lotoReports/components/LotoReportsEmptyState.tsx
msgid "Create a report, then open its drawing pages in the document viewer to add isolation points in hang order."
msgstr "Cree un informe y luego abra sus páginas de planos en el visor de documentos para agregar puntos de aislamiento en orden de colocación."

#: src/features/timeSeries/components/DerivedValues.tsx
msgid "Create calculated values from sensor combinations"
msgstr "Crear valores calculados a partir de combinaciones de sensores"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Create Case"
msgstr "Crear caso"

#: src/pages/details/overlays/inspections/CreatePredictedInspectionCard.tsx
msgid "Create Forecast"
msgstr "Crear pronóstico"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Create New Asset Model"
msgstr "Crear modelo de activo nuevo"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Create new whiteboard"
msgstr "Crear pizarra nueva"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Create the Asset Instance for this validated Subject and queue its template fill"
msgstr "Crear la instancia de activo para este sujeto validado y poner en cola el llenado de su plantilla"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Create Work Order"
msgstr "Crear orden de trabajo"

#: src/pages/details/overlays/inspections/CreatePredictedInspectionCard.tsx
msgid "Create<0/>Forecast"
msgstr "Crear<0/>pronóstico"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Created"
msgstr "Creado"

#: src/features/lotoReports/components/LotoReportCard.tsx
msgid "Created {created}"
msgstr "Creado el {created}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Created {createdAtLabel}"
msgstr "Creado {createdAtLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Created by"
msgstr "Creado por"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Created by: {userName}"
msgstr "Creado por: {userName}"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Created this case"
msgstr "Creó este caso"

#: src/pages/cases/md/MdCasesListPage.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Creating..."
msgstr "Creando…"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Creating…"
msgstr "Creando…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Crew work group"
msgstr "Grupo de trabajo de la cuadrilla"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Critical"
msgstr "Crítico"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Critical Severity"
msgstr "Gravedad crítica"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
msgid "Crop unavailable"
msgstr "Recorte no disponible"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Cross-checked tags against each other"
msgstr "Se cotejaron las etiquetas entre sí"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Cross-checking tags against each other"
msgstr "Cotejando las etiquetas entre sí"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Cross-correlation vs phase shift (periods)"
msgstr "Correlación cruzada frente al desfase (períodos)"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Cross-reference"
msgstr "Referencia cruzada"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/CrossReferenceMarker.tsx
msgid "Cross-reference location"
msgstr "Ubicación de la referencia cruzada"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Cross-reference results"
msgstr "Resultados de referencias cruzadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Currency"
msgstr "Moneda"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Current"
msgstr "Actual"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Current balance"
msgstr "Saldo actual"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Current component selection"
msgstr "Selección de componente actual"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Current estimate"
msgstr "Estimación actual"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Current inspection selection"
msgstr "Selección de inspección actual"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Current model"
msgstr "Modelo actual"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Current page ({currentPageNumber})"
msgstr "Página actual ({currentPageNumber})"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Current progress is saved, but leaving this page will cancel the upload that is still in progress."
msgstr "El progreso actual está guardado, pero si sale de esta página se cancelará la carga que todavía está en curso."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Current shift"
msgstr "Turno actual"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "Current site config"
msgstr "Configuración actual del sitio"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Current slide ({currentPageNumber})"
msgstr "Diapositiva actual ({currentPageNumber})"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Current verdict "
msgstr "Veredicto actual "

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Custom"
msgstr "Personalizado"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Custom color"
msgstr "Color personalizado"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Custom Field"
msgstr "Campo personalizado"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Custom Fields"
msgstr "Campos personalizados"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Custom LiDAR color"
msgstr "Color LiDAR personalizado"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Custom Range"
msgstr "Intervalo personalizado"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Customer"
msgstr "Cliente"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Customize"
msgstr "Personalizar"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Customize the Workspace"
msgstr "Personalizar el espacio de trabajo"

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "CV %"
msgstr "CV %"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "d={value217_19} · y={value217_44} · shared={value217_76}"
msgstr "d={value217_19} · y={value217_44} · compartido={value217_76}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "D1.0"
msgstr "D1.0"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "daily"
msgstr "diario"

#: src/pages/metrics/Metrics.tsx
msgid "Daily"
msgstr "Diario"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Daily overview"
msgstr "Resumen diario"

#: src/pages/metrics/Metrics.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Daily searches"
msgstr "Búsquedas diarias"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "dashboard"
msgstr "panel"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardMetricsUnavailable.tsx
msgid "Dashboard metrics require additional permission."
msgstr "Las métricas del panel requieren un permiso adicional."

#: src/pages/alerts/AlertDetails.tsx
msgid "Data"
msgstr "Datos"

#: src/features/timeSeries/components/ChartConfiguration.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Data from Calculations"
msgstr "Datos de cálculos"

#: src/features/timeSeries/components/ChartConfiguration.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
msgid "Data from Tags"
msgstr "Datos de etiquetas"

#: src/pages/details/visualization/alerts/specificAlerts/CDSMissingWarning.tsx
msgid "Data layer is not tagged to a snapshot"
msgstr "La capa de datos no está etiquetada en una instantánea"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
msgid "Data Layers"
msgstr "Capas de datos"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Data preview failed: "
msgstr "Error en la vista previa de datos: "

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "Data Processing"
msgstr "Procesamiento de datos"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/TimeSeriesSidebar.tsx
msgid "DATA PROCESSING"
msgstr "PROCESAMIENTO DE DATOS"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetCountBreakdownLabels.tsx
msgid "Data Quality"
msgstr "Calidad de los datos"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Data Smoothing"
msgstr "Suavizado de datos"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Data Studio"
msgstr "Estudio de datos"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "data through"
msgstr "datos hasta"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Datapoint IDs"
msgstr "ID de puntos de datos"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Datapoint ids, one per line"
msgstr "ID de puntos de datos, uno por línea"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Dataset"
msgstr "Conjunto de datos"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Datastreams"
msgstr "Flujos de datos"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Date"
msgstr "Fecha"

#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Date Created"
msgstr "Fecha de creación"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Date of Capture"
msgstr "Fecha de captura"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Date unavailable"
msgstr "Fecha no disponible"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Date window"
msgstr "Ventana de fechas"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "DATE:"
msgstr "FECHA:"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Date/Time:"
msgstr "Fecha/Hora:"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Dates come from the work orders — an outage, a valve repair, a wash. With hold-out on, each window is masked out of the baseline before fitting, which is the only honest way to ask whether the model would have seen it coming."
msgstr "Las fechas provienen de las órdenes de trabajo: una parada, una reparación de válvula o un lavado. Con la retención activada, cada ventana se excluye de la referencia antes del ajuste, la única forma válida de evaluar si el modelo lo habría anticipado."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Days"
msgstr "Días"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Days per chunk"
msgstr "Días por bloque"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "days scored"
msgstr "días puntuados"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "days). Zoom in to score the range you are viewing."
msgstr "días). Acerque la vista para puntuar el intervalo que está viendo."

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Deactivated"
msgstr "Desactivado"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Deactivated users cannot be impersonated."
msgstr "No se puede usar la vista de usuarios desactivados."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Deactivated users cannot have their permissions changed."
msgstr "No se pueden cambiar los permisos de usuarios desactivados."

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Debug stats"
msgstr "Estadísticas de depuración"

#: src/features/fimReview/ReviewActions.tsx
msgid "Decision"
msgstr "Decisión"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Decisions"
msgstr "Decisiones"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "declared"
msgstr "declaradas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "decreasing"
msgstr "disminuyendo"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Default"
msgstr "Predeterminado"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "default last 7 days · up to "
msgstr "últimos 7 días de forma predeterminada · hasta "

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Defer"
msgstr "Aplazar"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
msgid "Defer page metadata"
msgstr "Aplazar metadatos de la página"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Defer this page"
msgstr "Aplazar esta página"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalDeferReason.tsx
msgid "Deferral reason:"
msgstr "Motivo del aplazamiento:"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Deferred"
msgstr "Aplazado"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Deferred by me"
msgstr "Aplazadas por mí"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Deferring…"
msgstr "Aplazando…"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Degree"
msgstr "Grado"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/fim/photos/PhotoLightbox.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Delete"
msgstr "Eliminar"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Delete “"
msgstr "Eliminar “"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete \"{modelName}\"? This removes the saved model and its fit series."
msgstr "¿Eliminar \"{modelName}\"? Esto elimina el modelo guardado y su serie de ajuste."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete \"{name}\"? This permanently removes it."
msgstr "¿Eliminar \"{name}\"? Esto lo elimina permanentemente."

#: src/pages/cases/md/MdCasesListPage.tsx
msgid ""
"Delete \"{pendingDeletionLabel}\"?\n"
"\n"
"This action cannot be undone."
msgstr ""
"¿Eliminar \"{pendingDeletionLabel}\"?\n"
"\n"
"Esta acción no se puede deshacer."

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Delete “{title}”? Everyone at this site loses the transcript. Saved models are not affected."
msgstr "¿Eliminar “{title}”? Todos los usuarios de este sitio perderán la transcripción. Los modelos guardados no se verán afectados."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete {filename}"
msgstr "Eliminar {filename}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete {filename}? This cannot be undone."
msgstr "¿Eliminar {filename}? Esta acción no se puede deshacer."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete {modelName}"
msgstr "Eliminar {modelName}"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Delete {title}"
msgstr "Eliminar {title}"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Delete {value235_40}"
msgstr "Eliminar {value235_40}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Delete {value725_48}"
msgstr "Eliminar {value725_48}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Delete {whiteboardLabel}"
msgstr "Eliminar {whiteboardLabel}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete 3D asset file?"
msgstr "¿Eliminar el archivo 3D del activo?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all"
msgstr "Eliminar todos"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all 3D asset files?"
msgstr "¿Eliminar todos los archivos 3D del activo?"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Delete all files in {category}?"
msgstr "¿Eliminar todos los archivos de {category}?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete archived chats?"
msgstr "¿Eliminar chats archivados?"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Delete Case"
msgstr "Eliminar caso"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Delete chat?"
msgstr "¿Eliminar el chat?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete chats"
msgstr "Eliminar chats"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Delete failed: {reason}"
msgstr "Error al eliminar: {reason}"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Delete LOTO report {name}"
msgstr "Eliminar el informe LOTO {name}"

#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Delete LOTO report?"
msgstr "¿Eliminar el informe LOTO?"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Delete M&D Case"
msgstr "Eliminar caso de M&D"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Delete Rows"
msgstr "Eliminar filas"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Delete saved experiment \"{label}\"?"
msgstr "¿Eliminar el experimento guardado \"{label}\"?"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Delete saved model"
msgstr "Eliminar modelo guardado"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Delete this alert?"
msgstr "¿Eliminar esta alerta?"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Delete this alert? It will also be removed from the linked M&D case."
msgstr "¿Eliminar esta alerta? También se eliminará del caso de M&D vinculado."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete this design"
msgstr "Eliminar este diseño"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Delete this label?"
msgstr "¿Eliminar esta etiqueta?"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Delete this model"
msgstr "Eliminar este modelo"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Delete this photo everywhere?"
msgstr "¿Eliminar esta foto de todas partes?"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Delete this sentinel"
msgstr "Eliminar este centinela"

#: src/pages/systemView/components/UnitsTab.tsx
msgid "Delete this unit link?"
msgstr "¿Eliminar este vínculo de unidad?"

#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Delete view"
msgstr "Eliminar vista"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Delete Whiteboard"
msgstr "Eliminar pizarra"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Delete window"
msgstr "Eliminar ventana"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Delete your archived chats for this site from your history and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. Recent chats will stay. Deleted chats cannot be restored."
msgstr "Elimina del historial tus chats archivados de este sitio y cierra sus pestañas abiertas. Se conservarán los chats fijados, las respuestas en curso y los chats con borradores sin enviar. También se conservarán los chats recientes. Los chats eliminados no se pueden restaurar."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Deleted {deleted} model file(s)."
msgstr "Archivos del modelo eliminados: {deleted}."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Deleted {label}"
msgstr "Se eliminó {label}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Deleted current save"
msgstr "Se eliminó el guardado actual"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/cases/components/DeleteCaseModal.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Deleting..."
msgstr "Eliminando…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
#: src/features/lotoReports/components/DeleteLotoReportButton.tsx
msgid "Deleting…"
msgstr "Eliminando…"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Delta"
msgstr "Delta"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Denoise window"
msgstr "Ventana de reducción de ruido"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Dependent Variable (Y)"
msgstr "Variable dependiente (Y)"

#: src/features/fimReview/InspectSources.tsx
msgid "Derived by the {sourceLabel} adapter · not in the upload"
msgstr "Derivado por el adaptador {sourceLabel} · no está en la carga"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag description"
msgstr "Descripción de la etiqueta derivada"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag name"
msgstr "Nombre de la etiqueta derivada"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived tag unit"
msgstr "Unidad de la etiqueta derivada"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Derived Tags"
msgstr "Etiquetas derivadas"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Derived unless set"
msgstr "Derivado, salvo que se establezca"

#: src/features/timeSeries/components/TagsTab.tsx
msgid "Derived Values"
msgstr "Valores derivados"

#: src/features/timeSeries/utils/scatterPlotTableHelpers.ts
msgid "Derived: {value136_54}"
msgstr "Derivado: {value136_54}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Descending"
msgstr "Descendente"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Describe the issue"
msgstr "Describa el problema"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/pages/cases/components/EditCaseForm.tsx
msgid "Describe the issue..."
msgstr "Describa el problema…"

#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Describe what you want graded and the agent finds the tags, checks their health, computes a physics KPI, and field-fits it against a baseline window. Every step appears here as it happens. It can also load and edit any model it saved before."
msgstr "Describe qué quieres evaluar. El agente busca las etiquetas, comprueba su estado, calcula un KPI físico y lo ajusta a los datos de un período de referencia. Aquí verás cada paso en tiempo real. También puede cargar y editar modelos guardados."

#: src/features/fimReview/IdentityPanel.tsx
msgid "description"
msgstr "descripción"

#: src/features/cases/components/CreateCaseModal.tsx
#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Description"
msgstr "Descripción"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Description (optional)"
msgstr "Descripción (opcional)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Description and task text describe scope; status alone does not verify performed work."
msgstr "La descripción y el texto de la tarea describen el alcance; el estado por sí solo no verifica que se haya realizado el trabajo."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Description and task text describe work scope; recorded status alone does not verify the work performed."
msgstr "La descripción y las tareas indican el alcance del trabajo; el estado registrado por sí solo no verifica el trabajo realizado."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Description detail"
msgstr "Detalle de la descripción"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Description:"
msgstr "Descripción:"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Description: {chartDescription}"
msgstr "Descripción: {chartDescription}"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Descriptions"
msgstr "Descripciones"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Design again"
msgstr "Diseñar de nuevo"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Design context"
msgstr "Contexto del diseño"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Design Facility"
msgstr "Instalación de diseño"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Design System Library"
msgstr "Biblioteca del sistema de diseño"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Design the model"
msgstr "Diseñar el modelo"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Design warnings"
msgstr "Advertencias del diseño"

#: src/features/sentinels/useSentinelList.ts
msgid "designed for {value179_35} · not run"
msgstr "diseñado para {value179_35} · sin ejecutar"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Designing…"
msgstr "Diseñando…"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach"
msgstr "Desvincular"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach everywhere and delete the photo"
msgstr "Desvincular de todas partes y eliminar la foto"

#: src/features/fim/photos/SubjectPhotoLightbox.tsx
msgid "Detach failed: {reason}"
msgstr "Error al desvincular: {reason}"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Detach this photo from this Subject?"
msgstr "¿Desvincular esta foto de este sujeto?"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Detail"
msgstr "Detalle"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Details"
msgstr "Detalles"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Details for {tag}"
msgstr "Detalles de {tag}"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Detected"
msgstr "Detectado"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "detected {detectedLabel}"
msgstr "detectado {detectedLabel}"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Detection"
msgstr "Detección"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Detection Time:"
msgstr "Hora de detección:"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Device information"
msgstr "Información del dispositivo"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Diagnosed"
msgstr "Diagnosticado"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Diagnosing… (this can take a minute)"
msgstr "Diagnosticando… (esto puede tardar un minuto)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Diagnostic and root-cause analysis"
msgstr "Análisis de diagnóstico y causa raíz"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Diagnostics"
msgstr "Diagnóstico"

#: src/features/knowledgeDocumentViewer/components/viewer/image/ImageViewerWithOverlay.tsx
msgid "diagram"
msgstr "diagrama"

#: src/features/knowledgeDocumentViewer/components/viewer/image/ImageViewerWithOverlay.tsx
msgid "diagram page {pageNumber}"
msgstr "página del diagrama {pageNumber}"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Did we hit the labels?"
msgstr "¿Se detectaron las etiquetas?"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "different config"
msgstr "configuración diferente"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Direct-issue material availability"
msgstr "Disponibilidad de materiales de entrega directa"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Disabled"
msgstr "Deshabilitado"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverviewTabs.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Disagreements"
msgstr "Desacuerdos"

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSelectedReport.tsx
#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Discard"
msgstr "Descartar"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Discard and continue"
msgstr "Descartar y continuar"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Discard local edits and reload the saved view"
msgstr "Descartar los cambios locales y volver a cargar la vista guardada"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Discard the unfinished Subject correction?"
msgstr "¿Descartar la corrección de sujeto sin terminar?"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Discard unsaved changes to {name}?"
msgstr "¿Descartar los cambios sin guardar de {name}?"

#: src/features/facilityModel/columns.ts
msgid "Discovered"
msgstr "Descubierto"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Discovered subject"
msgstr "Sujeto descubierto"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/timeSeries/agentTab/AgentChatPanel.tsx
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Dismiss"
msgstr "Descartar"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Dismiss notification"
msgstr "Descartar notificación"

#: src/features/timeSeries/agentTab/AgentBandOverlay.tsx
msgid "Dismiss the highlighted range"
msgstr "Descartar el intervalo resaltado"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Display Name"
msgstr "Nombre para mostrar"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Distance from centerline (Port):"
msgstr "Distancia desde la línea central (babor):"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Distances"
msgstr "Distancias"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Dividers, blank leaves, and notes pages"
msgstr "Separadores, hojas en blanco y páginas de notas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Do not include this document"
msgstr "No incluir este documento"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "doc"
msgstr "doc"

#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
msgid "Doc"
msgstr "Doc"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Doc Nav"
msgstr "Navegación de documentos"

#: src/features/facilityModel/columns.ts
msgid "Doc reference"
msgstr "Referencia del documento"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Doc Type"
msgstr "Tipo de documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimeline.tsx
msgid "Docchat conversation"
msgstr "Conversación de DocChat"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
msgid "Dock the chat beside the preview"
msgstr "Acoplar el chat junto a la vista previa"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Document"
msgstr "Documento"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Document {position}"
msgstr "Documento {position}"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Document actions"
msgstr "Acciones del documento"

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Document configuration changed. Reload and try again."
msgstr "La configuración del documento cambió. Recarga e inténtalo de nuevo."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply only to {trimmedFilename}."
msgstr "Los cambios en los datos del documento se aplican solo a {trimmedFilename}."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply only to this document."
msgstr "Los cambios en los datos del documento se aplican solo a este documento."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Document data changes apply to every document in this revision family."
msgstr "Los cambios en los datos del documento se aplican a todos los documentos de esta familia de revisiones."

#: src/features/knowledgeDocumentViewer/components/sidebar/KnowledgeDocumentSidebar.tsx
msgid "Document details"
msgstr "Detalles del documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "Document Details"
msgstr "Detalles del documento"

#: src/features/permissions/profiles/power.ts
msgid "Document Editor"
msgstr "Editor de documentos"

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Document metadata updated"
msgstr "Metadatos del documento actualizados"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Document metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"
msgstr "Metadatos del documento actualizados para {revisionCount, plural, one {# revisión} other {# revisiones}}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document not available"
msgstr "Documento no disponible"

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
msgid "Document not found"
msgstr "Documento no encontrado"

#: src/features/fimReview/provenance.ts
msgid "Document page"
msgstr "Página del documento"

#: src/features/chatbot/components/CitationDocumentModal.tsx
msgid "Document Preview"
msgstr "Vista previa del documento"

#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Document reference"
msgstr "Referencia del documento"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Document references"
msgstr "Referencias de documentos"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Document row {row} needs a label."
msgstr "La fila de documento {row} necesita una etiqueta."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document Title"
msgstr "Título del documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Document to cite"
msgstr "Documento para citar"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Document uploaded successfully"
msgstr "El documento se cargó correctamente"

#: src/features/permissions/profiles/power.ts
msgid "Document Uploader"
msgstr "Cargador de documentos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "Document Uploads"
msgstr "Cargas de documentos"

#: src/features/permissions/profiles/power.ts
msgid "Document Viewer"
msgstr "Lector de documentos"

#: src/features/fimReview/provenance.ts
msgid "Document Vision"
msgstr "Visión de documentos"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/navbar/navConfig.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Documents"
msgstr "Documentos"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Documents ({documentCount})"
msgstr "Documentos ({documentCount})"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Documents and evidence"
msgstr "Documentos y evidencia"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "documents bound"
msgstr "documentos vinculados"

#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Documents hosted"
msgstr "Documentos alojados"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Documents table"
msgstr "Tabla de documentos"

#: src/features/fimReview/DecisionHistory.tsx
msgid "does not exist"
msgstr "no existe"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/timeSeries/components/ScatterplotSidebarAddData.tsx
#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Done"
msgstr "Listo"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Done Editing"
msgstr "Finalizar edición"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Download"
msgstr "Descargar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
msgid "Download {documentLabel}"
msgstr "Descargar {documentLabel}"

#: src/pages/details/extensions/flow/filesExt/FileDownloadButton.tsx
msgid "Download {fileName}"
msgstr "Descargar {fileName}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Download {title}"
msgstr "Descargar {title}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download Document"
msgstr "Descargar documento"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Download File"
msgstr "Descargar archivo"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Download not available"
msgstr "Descarga no disponible"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download original"
msgstr "Descargar original"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
msgid "Download Page {pageNumber}"
msgstr "Descargar página {pageNumber}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Download page range"
msgstr "Descargar rango de páginas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsSearchActions/DownloadSearchResultButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderDownloadButton.tsx
msgid "Download PDF"
msgstr "Descargar PDF"

#: src/features/knowledgeDocumentViewer/components/toolbar/DownloadDocumentButton.tsx
msgid "Download PDF version"
msgstr "Descargar versión PDF"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Downloading…"
msgstr "Descargando…"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Draft"
msgstr "Borrador"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Draft eval"
msgstr "Borrador de evaluación"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Draft the recommendation for publication."
msgstr "Redacte la recomendación para su publicación."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Drag"
msgstr "Arrastrar"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Drag the dot freely or an arrow along its axis"
msgstr "Arrastra el punto libremente o una flecha a lo largo de su eje"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Drag to rotate. Scroll to zoom. Hover to inspect readings. Uncolored areas have no displayed reading."
msgstr "Arrastra para girar. Desplázate para acercar o alejar. Pasa el cursor para ver las lecturas. Las áreas sin color no tienen una lectura mostrada."

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
msgid "Drag to shift this axis vertically. Shift-select multiple axes to drag together."
msgstr "Arrastre para desplazar este eje verticalmente. Use Mayús para seleccionar varios ejes y arrastrarlos juntos."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Drag to zoom, right-drag to box-zoom, reset."
msgstr "Arrastre para acercar; arrastre con el botón derecho para ampliar un recuadro; restablezca."

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Draw {role} windows"
msgstr "Dibujar ventanas de {role}"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Draw {role} windows on the chart"
msgstr "Dibujar ventanas de {role} en el gráfico"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Draw as"
msgstr "Dibujar como"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Draw experiment overlays on the chart"
msgstr "Dibujar superposiciones del experimento en el gráfico"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Draw this model on the chart"
msgstr "Dibujar este modelo en el gráfico"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Drawing"
msgstr "Plano"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Drawing {drawing}"
msgstr "Plano {drawing}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Drawing {drawing}, sheet {sheet}"
msgstr "Plano {drawing}, hoja {sheet}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Drawing {drawingName}"
msgstr "Plano {drawingName}"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Drawing {drawingName}, page {pageNumber}"
msgstr "Plano {drawingName}, página {pageNumber}"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Drawing {role} windows — Esc or click to stop"
msgstr "Dibujando ventanas de {role}; presione Esc o haga clic para detener"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Drawing #"
msgstr "Plano #"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Drawing Number"
msgstr "Número de plano"

#: src/features/fimReview/provenance.ts
msgid "Drawing OCR"
msgstr "OCR del plano"

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Drawing pages this LOTO report covers."
msgstr "Páginas de planos que abarca este informe LOTO."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Drawing reference"
msgstr "Referencia de plano"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionDropdownTrigger.tsx
msgid "Drawing revision"
msgstr "Revisión del plano"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionDropdownTrigger.tsx
msgid "Drawing revision is out of date"
msgstr "La revisión del plano está desactualizada"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportCard.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Drawings"
msgstr "Planos"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Drawings for {name}"
msgstr "Planos de {name}"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Drawings showing {name}"
msgstr "Planos que muestran {name}"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Drawn / custom windows"
msgstr "Ventanas dibujadas/personalizadas"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "drawn on the chart · save it in the model card below to alert or backtest"
msgstr "dibujado en el gráfico · guárdelo en la tarjeta del modelo de abajo para generar alertas o realizar pruebas retrospectivas"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Drift"
msgstr "Deriva"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver ffill limit"
msgstr "Límite de relleno hacia adelante de la variable predictora"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver forward-fill limit"
msgstr "Límite de relleno hacia adelante de la variable predictora"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "driver history"
msgstr "historial de la variable predictora"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver history"
msgstr "Historial de la variable predictora"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver history (lags + rolling)"
msgstr "Historial de variables predictoras (retardos + promedio móvil)"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver lags"
msgstr "Retardos de variables predictoras"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Driver lags (comma-separated periods)"
msgstr "Retardos de variables predictoras (períodos separados por comas)"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Driver lags (periods)"
msgstr "Retardos de variables predictoras (períodos)"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
msgid "Drivers"
msgstr "Variables predictoras"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "drivers · created "
msgstr "variables predictoras · creado "

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Drivers must be conditions — ambient, load, pressure ratio. A sibling of the target smuggles the answer into the fit and hides the very excursion you are hunting."
msgstr "Las variables predictoras deben ser condiciones: ambiente, carga o relación de presión. Una variable hermana del objetivo introduce la respuesta en el ajuste y oculta la excursión que se busca."

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Drivers trail the current period; the target is shifted one period so its own value stays out, as the features are built. Replaces a denoise overlay on the same pen."
msgstr "Las variables predictoras se retrasan respecto del período actual; el objetivo se desplaza un período para excluir su propio valor al generar las características. Reemplaza una superposición de reducción de ruido en el mismo trazo."

#: src/pages/systemView/components/DataPanel.tsx
msgid "Drone Scan"
msgstr "Escaneo con dron"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Drop files or folders below, then review your selection before uploading."
msgstr "Suelte archivos o carpetas abajo y revise la selección antes de cargarlos."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Drop files or folders here, or "
msgstr "Suelte archivos o carpetas aquí, o "

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop points outside these data quantiles (0–1). Typical: 0.01 / 0.99."
msgstr "Excluir puntos fuera de estos cuantiles de datos (0–1). Valores típicos: 0.01/0.99."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop points outside this physical range (sets them missing). Bounds default from raw tag stats."
msgstr "Excluir puntos fuera de este intervalo físico (se marcan como faltantes). Los límites predeterminados provienen de las estadísticas sin procesar de la etiqueta."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Drop runs of more than max_repeat identical consecutive values (stuck sensor)."
msgstr "Excluir secuencias de más de max_repeat valores consecutivos idénticos (sensor atascado)."

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Dropdown"
msgstr "Lista desplegable"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Duplicate content"
msgstr "Contenido duplicado"

#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "Duplicate setting group {groupNumber}:"
msgstr "Grupo de ajustes duplicado {groupNumber}:"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "e.g. (load > 450) & (steady > 0)"
msgstr "p. ej., (load > 450) & (steady > 0)"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "e.g. ambient_t"
msgstr "p. ej., ambient_t"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "e.g. Boiler feed pump 1A outage"
msgstr "p. ej., parada de la bomba de alimentación de caldera 1A"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "e.g. HP bypass valve repair"
msgstr "p. ej., reparación de la válvula de derivación HP"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
msgid "e.g. Pump B isolation"
msgstr "p. ej., Aislamiento de la bomba B"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 1000-5000 Hz"
msgstr "p. ej., 1000-5000 Hz"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 150.2"
msgstr "p. ej., 150.2"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 180.5"
msgstr "p. ej., 180.5"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 65.8"
msgstr "p. ej., 65.8"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., 75.2"
msgstr "p. ej., 75.2"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "e.g., Motor Housing, Pipe Section XYZ"
msgstr "p. ej., carcasa de motor, sección de tubería XYZ"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Each bounded tag marks its own excluded points. A gate drops those rows for every tag in training, but on the chart it marks only its own pen. Quantile clip and frozen have no chart equivalent."
msgstr "Cada etiqueta acotada marca sus propios puntos excluidos. Una compuerta excluye esas filas para todas las etiquetas durante el entrenamiento, pero en el gráfico solo marca su propio trazo. El recorte por cuantil y el congelamiento no tienen equivalente en el gráfico."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Each case is a point where the target left its band. Open one and run the RCA agent to diagnose the real-world cause."
msgstr "Cada caso es un punto en el que el objetivo salió de su banda. Abra uno y ejecute el agente RCA para diagnosticar la causa real."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Each screenshot must be a non-empty image of 5 MB or less."
msgstr "Cada captura debe ser una imagen no vacía de 5 MB o menos."

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Edit"
msgstr "Editar"

#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Edit {name}"
msgstr "Editar {name}"

#: src/features/navbar/siteSelectors/EmbeddedSelectorSection.tsx
msgid "Edit {selectedEditLabel}"
msgstr "Editar {selectedEditLabel}"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Edit all {familySize} revisions"
msgstr "Editar las {familySize} revisiones"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Edit Asset Model"
msgstr "Editar modelo de activo"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
msgid "Edit Case"
msgstr "Editar caso"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit case title"
msgstr "Editar título del caso"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Edit comment"
msgstr "Editar comentario"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Edit coordinate origin"
msgstr "Editar origen de coordenadas"

#: src/pages/site/components/CustomFieldsTableCard.tsx
msgid "Edit Custom Field"
msgstr "Editar campo personalizado"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Edit derived tag"
msgstr "Editar etiqueta derivada"

#: src/features/permissions/profiles/power.ts
msgid "Edit document details including drawing numbers, revisions, etc."
msgstr "Edita los detalles de los documentos, incluidos los números de plano, las revisiones, etc."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Edit document metadata"
msgstr "Editar metadatos del documento"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit investigation notes"
msgstr "Editar notas de investigación"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Edit just this document"
msgstr "Editar solo este documento"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Edit label"
msgstr "Editar etiqueta"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Edit markup layer \"{markupLayerName}\""
msgstr "Editar capa de marcado \"{markupLayerName}\""

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Edit Org"
msgstr "Editar organización"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Edit other people's permissions, plus everything below."
msgstr "Editar los permisos de otras personas, más todo lo de abajo."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Edit page metadata"
msgstr "Editar metadatos de la página"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Edit pens"
msgstr "Editar trazos"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Edit plan JSON"
msgstr "Editar JSON del plan"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
msgid "Edit queued message {position}"
msgstr "Editar mensaje {position} en cola"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Edit recommendation draft"
msgstr "Editar borrador de la recomendación"

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
#: src/pages/site/EditSite.tsx
msgid "Edit Site"
msgstr "Editar sitio"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Edit subject in Facility Model"
msgstr "Editar sujeto en Facility Model"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Edit Unit"
msgstr "Editar unidad"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Editable cleaning plan with a tags map keyed by ID and a summary. Each tag contains a verdict, notes, and operations. Operations: range, clip_quantile, frozen, gate, denoise_mean, denoise_median."
msgstr "Plan de limpieza editable con un mapa de etiquetas indexado por ID y un resumen. Cada etiqueta contiene un veredicto, notas y operaciones. Operaciones: range, clip_quantile, frozen, gate, denoise_mean, denoise_median."

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {relative}"
msgstr "Editado {relative}"

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {when}"
msgstr "Editado el {when}"

#: src/features/lotoReports/components/LotoLastEdited.tsx
msgid "Edited {when} by {editedBy}"
msgstr "Editado el {when} por {editedBy}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Editing: "
msgstr "Editando: "

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Editor"
msgstr "Editor"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Efficiency falling is \"below\"; backpressure rising is \"above\". Daily is the sensible cadence — these are daily-median series, so checking hourly re-reads the same number."
msgstr "La caída de eficiencia corresponde a \"por debajo\"; el aumento de contrapresión, a \"por encima\". La cadencia diaria es la adecuada: estas son series de medianas diarias, por lo que comprobar cada hora vuelve a leer el mismo número."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Elasticsearch native text"
msgstr "Texto nativo de Elasticsearch"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Electrical\n"
"STW"
msgstr ""
"Eléctrico\n"
"STW"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Electrical One Line"
msgstr "Diagrama eléctrico unifilar"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical One-Line Diagram"
msgstr "Diagrama eléctrico unifilar"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical power and protection analysis"
msgstr "Análisis de potencia eléctrica y protección"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical Schematic"
msgstr "Esquema eléctrico"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Electrical Three Line"
msgstr "Diagrama eléctrico trifilar"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Electrical Three-Line Diagram"
msgstr "Diagrama eléctrico trifilar"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "Email addresses"
msgstr "Direcciones de correo"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Email Notifications"
msgstr "Notificaciones por correo electrónico"

#: src/features/navbar/EmailSupport.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Email Support"
msgstr "Escribir a soporte"

#: src/features/richText/nodes/MentionNode.tsx
msgid "Email:"
msgstr "Correo electrónico:"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "Enable {requiredLabel} before enabling {label}."
msgstr "Active {requiredLabel} antes de activar {label}."

#: src/pages/manageAccess/components/table/RoleGroupCells.tsx
msgid "Enable {requiredLabel} before enabling {roleLabel}."
msgstr "Active {requiredLabel} antes de activar {roleLabel}."

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Enable API 510 Evaluation of Pitting"
msgstr "Habilitar la evaluación de corrosión por picadura según API 510"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Enable at least one method in the Models tab"
msgstr "Habilite al menos un método en la pestaña Modelos"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable denoise"
msgstr "Habilitar reducción de ruido"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable frozen"
msgstr "Habilitar detección de congelamiento"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable gate"
msgstr "Habilitar compuerta"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable quantile"
msgstr "Habilitar cuantil"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Enable range"
msgstr "Habilitar intervalo"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enabled"
msgstr "Habilitado"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "End"
msgstr "Fin"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "End date"
msgstr "Fecha de fin"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "End Date"
msgstr "Fecha de fin"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "End Time"
msgstr "Hora de fin"

#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "End time must be after start time."
msgstr "La hora de fin debe ser posterior a la hora de inicio."

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Energized"
msgstr "Energizado"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Engineering"
msgstr "Ingeniería"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Engineering calculations and analysis"
msgstr "Cálculos de ingeniería y análisis"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Enough for kNN (≥"
msgstr "Suficiente para kNN (≥"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Enter"
msgstr "Ingresar"

#: src/components/NamePromptModal.tsx
msgid "Enter a name"
msgstr "Ingrese un nombre"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Enter a name of up to 500 characters."
msgstr "Ingrese un nombre de hasta 500 caracteres."

#: src/features/fimReview/ReviewActions.tsx
msgid "Enter a name to save."
msgstr "Ingrese un nombre para guardar."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Enter a page from 1 to {numPages}."
msgstr "Introduzca una página del 1 al {numPages}."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Enter a page number of 1 or more."
msgstr "Introduzca un número de página de 1 o más."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Enter a report name of up to 500 characters."
msgstr "Ingrese un nombre de informe de hasta 500 caracteres."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Enter document description"
msgstr "Ingrese la descripción del documento"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Enter document title if different from filename"
msgstr "Ingrese el título del documento si es diferente del nombre del archivo"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter lower low threshold"
msgstr "Ingrese el umbral bajo inferior"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter lower threshold"
msgstr "Ingrese el umbral inferior"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Enter pages between 1 and {totalPages}"
msgstr "Ingrese páginas entre 1 y {totalPages}"

#: src/pages/details/visualization/tools/ScreenshotModeToggle.tsx
msgid "Enter screenshot mode"
msgstr "Entrar al modo de captura de pantalla"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Enter the corrected value."
msgstr "Ingrese el valor corregido."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Enter the new value"
msgstr "Ingrese el nuevo valor"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter upper high threshold"
msgstr "Ingrese el umbral alto superior"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Enter upper threshold"
msgstr "Ingrese el umbral superior"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Entire document ({totalPages} pages)"
msgstr "Documento completo ({totalPages} páginas)"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Entire PDF ({totalPages} pages)"
msgstr "PDF completo ({totalPages} páginas)"

#: src/features/navbar/EntryBrowserButton.tsx
#: src/pages/details/visualization/alerts/specificAlerts/DuplicateCDFAlert.tsx
msgid "Entry"
msgstr "Entrada"

#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/navbar/EntryBrowserButton.tsx
#: src/features/navbar/EntryBrowserButton.tsx
#: src/features/navbar/navConfig.ts
msgid "Entry Browser"
msgstr "Explorador de entradas"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Entry:"
msgstr "Entrada:"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Environment"
msgstr "Entorno"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Environmental Correlation Detected"
msgstr "Correlación ambiental detectada"

#: src/features/facilityModel/columns.ts
#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/lotoReports/components/LotoReportCard.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Equipment"
msgstr "Equipo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Equipment descriptions and capabilities"
msgstr "Descripciones y capacidades de equipos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Equipment identity and recorded configuration."
msgstr "Identidad del equipo y configuración registrada."

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Equipment maintenance and condition records"
msgstr "Registros de mantenimiento y condición de equipos"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Equipment/system"
msgstr "Equipo/sistema"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "EQUIPMENT/SYSTEM:"
msgstr "EQUIPO/SISTEMA:"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "err scale"
msgstr "escala de error"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Error"
msgstr "Error"

#: src/features/timeSeries/services/workOrderService.ts
msgid "Error importing data: {message}"
msgstr "Error al importar datos: {message}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Error loading image"
msgstr "Error al cargar la imagen"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Error loading surface: {error}"
msgstr "Error al cargar la superficie: {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"Error parsing JSON before patching! Error below:\n"
"\n"
"{error}"
msgstr ""
"Error al analizar el JSON antes de aplicar el parche. Error:\n"
"\n"
"{error}"

#: src/features/auth/vendors/Auth0Provider.tsx
#: src/features/auth/vendors/CognitoLoginScreen.tsx
#: src/features/auth/vendors/KeycloakLoginScreen.tsx
msgid "Error: {errorDetail}"
msgstr "Error: {errorDetail}"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "Error: {text}"
msgstr "Error: {text}"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Esc"
msgstr "Esc"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "escalation tier {tier}"
msgstr "nivel de escalamiento {tier}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: labor cost"
msgstr "Costo de mano de obra estimado al aprobar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: labor hours"
msgstr "Horas de mano de obra estimadas al aprobar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: material cost"
msgstr "Costo de materiales estimado al aprobar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: service cost"
msgstr "Costo de servicios estimado al aprobar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimate at approval: tool cost"
msgstr "Costo de herramientas estimado al aprobar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated duration (hours)"
msgstr "Duración estimada (horas)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated labor cost"
msgstr "Costo estimado de mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated labor hours"
msgstr "Horas estimadas de mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated material cost"
msgstr "Costo estimado de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated service cost"
msgstr "Costo estimado de servicios"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Estimated tool cost"
msgstr "Costo estimado de herramientas"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Estimator"
msgstr "Estimador"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "eval as"
msgstr "evaluar como"

#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Evals"
msgstr "Evaluaciones"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluate"
msgstr "Evaluar"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Evaluate now"
msgstr "Evaluar ahora"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluating reads the fitted residuals off the run, so it needs a finished one."
msgstr "La evaluación lee los residuos ajustados de la ejecución, por lo que necesita una ejecución finalizada."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Evaluating…"
msgstr "Evaluando…"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Evaluation kind for {value77_57}"
msgstr "Tipo de evaluación para {value77_57}"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
#: src/pages/evaluations/EvaluationsPage.tsx
#: src/pages/evaluations/EvaluationsPage.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
msgid "Evaluations"
msgstr "Evaluaciones"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Events"
msgstr "Eventos"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Every {cadenceMinutes} min"
msgstr "Cada {cadenceMinutes} min"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Every {value138_39}"
msgstr "Cada {value138_39}"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Every 5 min"
msgstr "Cada 5 min"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "every 6 hours"
msgstr "cada 6 horas"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Every hour"
msgstr "Cada hora"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Every plotted tag becomes a pen. "
msgstr "Cada etiqueta graficada se convierte en un trazo. "

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Every Subject needs a source record."
msgstr "Cada sujeto necesita un registro de origen."

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Every tag comes off the chart. The view itself is not deleted."
msgstr "Todas las etiquetas se eliminan del gráfico. La vista no se elimina."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "every window needs a start before its end"
msgstr "cada ventana necesita un inicio anterior a su fin"

#: src/features/fimReview/ReviewActions.tsx
msgid "Everything looks right"
msgstr "Todo se ve bien"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Evidence ({evidenceCount})"
msgstr "Evidencia ({evidenceCount})"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Evidence against"
msgstr "Evidencia en contra"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Evidence for"
msgstr "Evidencia a favor"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Exact overlap with target:"
msgstr "Superposición exacta con el objetivo:"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Excl"
msgstr "Excl."

#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Exclude {subject}"
msgstr "Excluir {subject}"

#: src/pages/metrics/Metrics.tsx
msgid "Exclude Gecko searches"
msgstr "Excluir búsquedas de Gecko"

#: src/pages/metrics/Metrics.tsx
msgid "Exclude org-level searches"
msgstr "Excluir búsquedas a nivel de organización"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Excluded — ignored entirely"
msgstr "Excluido: se ignora por completo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Excluded bins"
msgstr "Celdas excluidas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Excluded cells have no finite calculated result. This is not an inspection coverage percentage."
msgstr "Las celdas excluidas no tienen un resultado calculado finito. Esto no es un porcentaje de cobertura de inspección."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Excluded pages: {excludedLabel} (both values blank or no active output)."
msgstr "Páginas excluidas: {excludedLabel} (ambos valores en blanco o sin resultados de la configuración activa)."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Excluded points are marked with a red x. Other pens keep every sample."
msgstr "Los puntos excluidos se marcan con una x roja. Los demás trazos conservan todas las muestras."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Excluded rows leave the model completely — neither learned from nor graded. That is the difference from the gate, which is about fair operating conditions rather than untrustworthy periods."
msgstr "Las filas excluidas quedan completamente fuera del modelo: no se usan para aprender ni para puntuar. Esa es la diferencia con la compuerta, que se refiere a condiciones operativas justas y no a períodos poco confiables."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Execute Action"
msgstr "Ejecutar acción"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Existence confidence"
msgstr "Confianza de existencia"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "existence confidence {confidence}"
msgstr "confianza de existencia {confidence}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Existing 3D asset files"
msgstr "Archivos 3D existentes del activo"

#: src/features/fimReview/InspectSources.tsx
msgid "Exists"
msgstr "Existe"

#: src/features/fimReview/InspectSources.tsx
msgid "Exists and connected"
msgstr "Existe y está conectado"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
msgid "Exit"
msgstr "Salir"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentFullscreenOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentFullscreenOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Exit fullscreen"
msgstr "Salir de pantalla completa"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Exit labeling mode"
msgstr "Salir del modo de etiquetado"

#: src/pages/details/visualization/tools/ScreenshotModeToggle.tsx
msgid "Exit screenshot mode"
msgstr "Salir del modo de captura de pantalla"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Exp"
msgstr "Exp."

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Expand"
msgstr "Expandir"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCropPair.tsx
msgid "Expand {caption}"
msgstr "Ampliar {caption}"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
msgid "Expand all"
msgstr "Expandir todo"

#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "Expand asset viewer"
msgstr "Ampliar visor de activos"

#: src/features/knowledgeDocumentViewer/components/table/TableBodyRow.tsx
msgid "Expand row"
msgstr "Expandir fila"

#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Expanded search"
msgstr "Búsqueda ampliada"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "expected"
msgstr "esperado"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Expected-range band scored over the visible window · snapshot values on each alert are authoritative."
msgstr "Banda de intervalo esperado puntuada en la ventana visible · los valores de la instantánea de cada alerta son los definitivos."

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Experiment"
msgstr "Experimento"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "experiment name"
msgstr "nombre del experimento"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Explain the problem and propose options."
msgstr "Explique el problema y proponga opciones."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Explanation"
msgstr "Explicación"

#: src/features/navbar/navConfig.ts
msgid "Explorer"
msgstr "Explorador"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Export"
msgstr "Exportar"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Export Data"
msgstr "Exportar datos"

#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/features/timeSeries/components/chartActions/ExportPngButton.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Export PNG"
msgstr "Exportar PNG"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "expression"
msgstr "expresión"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Extend to date"
msgstr "Extender hasta la fecha"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Extracted (active config)"
msgstr "Extraído (configuración activa)"

#: src/features/navbar/navConfig.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Facility Model"
msgstr "Modelo de la instalación"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Facility model presets"
msgstr "Valores preestablecidos del modelo de instalación"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Facility type"
msgstr "Tipo de instalación"

#: src/features/facilityModel/views.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Failed"
msgstr "Fallido"

#: src/features/sentinels/components/SentinelList.tsx
msgid "failed · "
msgstr "falló · "

#: src/features/knowledgeDocumentViewer/hooks/useAppendDocumentPageMetadataUserEditComment.ts
msgid "Failed to add comment"
msgstr "No se pudo agregar el comentario"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to archive case: {reason}"
msgstr "No se pudo archivar el caso: {reason}"

#: src/features/cases/components/CreateCaseModal.tsx
msgid "Failed to create case: {error}"
msgstr "No se pudo crear el caso: {error}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to create case: {reason}"
msgstr "No se pudo crear el caso: {reason}"

#: src/pages/cases/components/CasesTable.tsx
msgid "Failed to create new case"
msgstr "No se pudo crear el caso nuevo"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlow.tsx
msgid "Failed to delete alert: {value281_53}"
msgstr "No se pudo eliminar la alerta: {value281_53}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to delete case: {reason}"
msgstr "No se pudo eliminar el caso: {reason}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to delete label: {value376_53}"
msgstr "No se pudo eliminar la etiqueta: {value376_53}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Failed to delete label: {value536_39}"
msgstr "No se pudo eliminar la etiqueta: {value536_39}"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Failed to delete model files: {errorMessage}"
msgstr "No se pudieron eliminar los archivos del modelo: {errorMessage}"

#: src/features/sentinels/hooks/useDeleteSentinel.ts
msgid "Failed to delete sentinel"
msgstr "No se pudo eliminar el centinela"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Failed to delete view: {error}"
msgstr "No se pudo eliminar la vista: {error}"

#: src/features/knowledgeDocumentViewer/hooks/useInstrumentTimeSeriesData.ts
msgid "Failed to fetch data"
msgstr "Error al obtener los datos"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Failed to fetch time series data"
msgstr "No se pudieron obtener los datos de series temporales"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Failed to generate Local Thin Areas. Please try again."
msgstr "No se pudieron generar las áreas de adelgazamiento localizado. Inténtelo de nuevo."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Failed to load drivers."
msgstr "No se pudieron cargar las variables predictoras."

#: src/features/richText/nodes/ImageNode.tsx
msgid "Failed to load image"
msgstr "No se pudo cargar la imagen"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Failed to load notifications"
msgstr "Error al cargar las notificaciones"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Failed to load: "
msgstr "No se pudo cargar: "

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Failed to load: {error}"
msgstr "No se pudo cargar: {error}"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Failed to rename view: {error}"
msgstr "No se pudo cambiar el nombre de la vista: {error}"

#: src/features/timeSeries/ScatterplotContext.tsx
msgid "Failed to resolve chart {chartID}: {value433_65}"
msgstr "No se pudo resolver el gráfico {chartID}: {value433_65}"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Failed to save allowed users list"
msgstr "No se pudo guardar la lista de usuarios autorizados"

#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Failed to save case title"
msgstr "No se pudo guardar el título del caso"

#: src/features/timeSeries/hooks/useChartSave.ts
msgid "Failed to save chart: {err}"
msgstr "No se pudo guardar el gráfico: {err}"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to save document metadata for all revisions. Confirm cantilever hosts exist."
msgstr "No se pudieron guardar los metadatos del documento para todas las revisiones. Confirme que existan los hosts de cantilever."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to save document metadata. Confirm cantilever hosts exist for this document."
msgstr "No se pudieron guardar los metadatos del documento. Confirme que existan hosts de Cantilever para este documento."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Failed to save feedback: {errorMessage}"
msgstr "No se pudieron guardar los comentarios: {errorMessage}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label range: {value261_57}"
msgstr "No se pudo guardar el intervalo de la etiqueta: {value261_57}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label: {value337_53}"
msgstr "No se pudo guardar la etiqueta: {value337_53}"

#: src/features/timeSeries/components/labelTool/useLabelTool.ts
msgid "Failed to save label: {value358_53}"
msgstr "No se pudo guardar la etiqueta: {value358_53}"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to save page metadata for all revisions. Confirm cantilever hosts exist."
msgstr "Error al guardar los metadatos de página para todas las revisiones. Confirme que existan los hosts de cantilever."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to save page metadata. Confirm cantilever hosts exist for this page."
msgstr "Error al guardar los metadatos de la página. Confirme que existan hosts de cantilever para esta página."

#: src/pages/site/contexts/SiteUXLayer.tsx
#: src/pages/site/contexts/SiteUXLayer.tsx
msgid "Failed to save site"
msgstr "No se pudo guardar el sitio"

#: src/features/knowledgeDocumentViewer/contexts/DocumentTabDataContext.tsx
msgid "Failed to save to Rolodex"
msgstr "Error al guardar en Rolodex"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Failed to send support request: {error}"
msgstr "No se pudo enviar la solicitud de soporte: {error}"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Failed to shelve case: {reason}"
msgstr "No se pudo aplazar el caso: {reason}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Failed to update anomaly status"
msgstr "No se pudo actualizar el estado de la anomalía"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
msgid "Failed to update Document Details for all revisions. Confirm cantilever hosts exist."
msgstr "Error al actualizar los detalles del documento para todas las revisiones. Confirme que existan los hosts de cantilever."

#: src/features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext.tsx
msgid "Failed to update document metadata"
msgstr "Error al actualizar los metadatos del documento"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Failed to update Page Details for all revisions. Confirm cantilever hosts exist."
msgstr "No se pudieron actualizar los detalles de página para todas las revisiones. Confirme que existan los hosts de cantilever."

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Failed to update site config."
msgstr "No se pudo actualizar la configuración del sitio."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Failed to upload document"
msgstr "No se pudo cargar el documento"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Failed to upload image"
msgstr "No se pudo cargar la imagen"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Failure mode · Unit: {unitSlug}"
msgstr "Modo de falla · Unidad: {unitSlug}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Failure modes"
msgstr "Modos de falla"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "False Positive"
msgstr "Falso positivo"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Fault detected."
msgstr "Falla detectada."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "FAVORITES"
msgstr "FAVORITOS"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Feature"
msgstr "Funcionalidad"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Feature request details"
msgstr "Detalles de la solicitud de funcionalidad"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Features"
msgstr "Características"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Feedback"
msgstr "Comentarios"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Feedback and Requests"
msgstr "Comentarios y solicitudes"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Feedback saved"
msgstr "Comentarios guardados"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Feedback sent"
msgstr "Comentarios enviados"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Fetched on the same bucket grid the models train on, drawn stepped."
msgstr "Obtenido en la misma cuadrícula de intervalos con la que se entrenan los modelos y dibujado de forma escalonada."

#: src/pages/cases/md/MdCaseReferenceSparklinePreview.tsx
msgid "Fetching data around alert"
msgstr "Obteniendo datos relacionados con la alerta"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "Fetching live data"
msgstr "Obteniendo datos en vivo"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
msgid "Field"
msgstr "Campo"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "field fit · baseline {baselineStart} → {baselineEnd} · gate {gate} · drivers {drivers}"
msgstr "ajuste de campo · referencia {baselineStart} → {baselineEnd} · filtro {gate} · variables predictoras {drivers}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Field mismatches vs pipeline"
msgstr "Campos que no coinciden con el proceso automático"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Field Name"
msgstr "Nombre del campo"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Field to Edit"
msgstr "Campo a editar"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Fields"
msgstr "Campos"

#: src/features/chatbot/components/CitationTooltip.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/site/components/SiteFilesTableCard.tsx
msgid "File"
msgstr "Archivo"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "File a Help Request to Cantilever AI"
msgstr "Enviar una solicitud de ayuda a Cantilever AI"

#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "File must be smaller than {MAX_FILE_SIZE_MB}MB"
msgstr "El archivo debe ser menor de {MAX_FILE_SIZE_MB} MB"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "File must be smaller than {maxSizeInMB}MB"
msgstr "El archivo debe ser menor de {maxSizeInMB} MB"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "File Name"
msgstr "Nombre de archivo"

#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
msgid "File options for {fileName}"
msgstr "Opciones de archivo para {fileName}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "File Required"
msgstr "Archivo requerido"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "File Too Large"
msgstr "Archivo demasiado grande"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
msgid "File Type"
msgstr "Tipo de archivo"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "File type not accepted. Please upload: {acceptedList}"
msgstr "Tipo de archivo no aceptado. Cargue: {acceptedList}"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
msgid "File with that name already exists."
msgstr "Ya existe un archivo con ese nombre."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Files"
msgstr "Archivos"

#: src/features/fim/assetInventory.ts
msgid "Fill failed"
msgstr "No se pudieron completar los datos"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Fill limit"
msgstr "Límite de llenado"

#: src/features/fim/assetInventory.ts
msgid "Fill queued"
msgstr "Completado de datos en cola"

#: src/features/fim/assetInventory.ts
msgid "Fill stale"
msgstr "Datos completados desactualizados"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Fill status"
msgstr "Estado de completado"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Filled at"
msgstr "Completado el"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Filled slots"
msgstr "Campos completados"

#: src/features/fim/assetInventory.ts
msgid "Filling"
msgstr "Completando"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter"
msgstr "Filtrar"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
msgid "Filter {cellText}"
msgstr "Filtrar {cellText}"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/StringFilter.tsx
msgid "Filter {columnHeaderLower}..."
msgstr "Filtrar {columnHeaderLower}..."

#: src/pages/metrics/components/FilterPopover.tsx
msgid "Filter {label}…"
msgstr "Filtrar {label}…"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Filter By"
msgstr "Filtrar por"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Filter by {value618_41} group"
msgstr "Filtrar por grupo {value618_41}"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Filter by name or KPI…"
msgstr "Filtrar por nombre o KPI…"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Filter by source"
msgstr "Filtrar por fuente"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Filter by ungrouped"
msgstr "Filtrar por no agrupados"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Filter models"
msgstr "Filtrar modelos"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Filter notifications..."
msgstr "Filtrar notificaciones..."

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Filter the facility model"
msgstr "Filtrar el modelo de la instalación"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter this pen"
msgstr "Filtrar este trazo"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Filter upload history"
msgstr "Filtrar el historial de cargas"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Filter upload history (active)"
msgstr "Filtrar el historial de cargas (activo)"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter upper value"
msgstr "Valor superior del filtro"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Filter value"
msgstr "Valor del filtro"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/TextFilterField.tsx
msgid "Filter..."
msgstr "Filtrar..."

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Filters"
msgstr "Filtros"

#: src/features/navbar/navConfig.ts
#: src/pages/metrics/Metrics.tsx
msgid "FIM Metrics"
msgstr "Métricas de FIM"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Find in document"
msgstr "Buscar en el documento"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Find in document (Ctrl+F)"
msgstr "Buscar en el documento (Ctrl+F)"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Find in document..."
msgstr "Buscar en el documento..."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Find models…"
msgstr "Buscar modelos…"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Find Tags"
msgstr "Buscar etiquetas"

#: src/features/timeSeries/components/panes/TagBrowserList.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Find tags..."
msgstr "Buscar etiquetas…"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Find views..."
msgstr "Buscar vistas…"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Finding destination…"
msgstr "Buscando destino…"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Finding related documents…"
msgstr "Buscando documentos relacionados…"

#: src/features/knowledgeDocumentViewer/hooks/useConnectorLookup.ts
msgid "Finding the destination timed out. Try again."
msgstr "La búsqueda del destino agotó el tiempo de espera. Inténtalo de nuevo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Findings are unavailable for this drawing."
msgstr "Los hallazgos no están disponibles para este plano."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Finite result bins"
msgstr "Celdas con resultado finito"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Fired {firedAt}"
msgstr "Activado el {firedAt}"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "first breach"
msgstr "primera salida de banda"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "First thing during working hours."
msgstr "A primera hora del horario laboral."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Fit"
msgstr "Ajustar"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Fit page"
msgstr "Ajustar página"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Fit regression models and predict future values"
msgstr "Ajustar modelos de regresión y predecir valores futuros"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Fit row cap"
msgstr "Límite de filas de ajuste"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitted {kpi}"
msgstr "Se ajustó {kpi}"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Fitted and saved"
msgstr "Ajustado y guardado"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitted the model"
msgstr "Se ajustó el modelo"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitting {kpi}"
msgstr "Ajustando {kpi}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Fitting the model"
msgstr "Ajustando el modelo"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "flagged points"
msgstr "puntos marcados"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Flags fire when |actual − expected| leaves band k × the calibrated residual scale. Wider k = fewer, bigger flags."
msgstr "Las marcas se activan cuando |real − esperado| sale de la banda k × escala residual calibrada. Una k mayor produce menos marcas, pero más grandes."

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Flags over the range"
msgstr "Marcas en el intervalo"

#: src/features/navbar/navConfig.ts
msgid "Fleet Analysis"
msgstr "Análisis de flota"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
msgid "Float the chat over the preview"
msgstr "Mostrar el chat flotante sobre la vista previa"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/FloatingChatWindow.tsx
msgid "Floating chat"
msgstr "Chat flotante"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Focus {tag} on the drawing"
msgstr "Enfocar {tag} en el plano"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Folders"
msgstr "Carpetas"

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
msgid "Followed connector to {destination} page {destinationPage}"
msgstr "Se siguió el conector hasta {destination}, página {destinationPage}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "For best performance, upload folders with fewer than 10,000 files. Compress larger folders into a ZIP before uploading."
msgstr "Para un mejor rendimiento, cargue carpetas con menos de 10,000 archivos. Comprima las carpetas más grandes en un ZIP antes de cargarlas."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "For tail-fraction splits: fraction of rows used as the “head” (usually train). Remainder is the tail (usually test)."
msgstr "En divisiones por fracción de cola: proporción de filas usada como “cabeza” (normalmente entrenamiento). El resto es la cola (normalmente prueba)."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Forecast"
msgstr "Forecast"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Format"
msgstr "Formato"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Format must be like \"1000-5000 Hz\""
msgstr "El formato debe ser como \"1000-5000 Hz\""

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Forward"
msgstr "Adelante"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "FP —"
msgstr "FP —"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "FP/30d"
msgstr "FP/30 d"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Frame:"
msgstr "Marco:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Frequency"
msgstr "Frecuencia"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Frequency Range (Hz)"
msgstr "Rango de frecuencia (Hz)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Frequency unit"
msgstr "Unidad de frecuencia"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
msgid "From"
msgstr "Desde"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "From an asset"
msgstr "Desde un activo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "From bin"
msgstr "Ubicación de origen"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "From drawing"
msgstr "Desde el plano"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "From revision"
msgstr "Revisión de origen"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "From storeroom"
msgstr "Almacén de origen"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "From the inspection analysis of this component."
msgstr "Del análisis de inspección de este componente."

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Front"
msgstr "Frontal"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Frozen repeat limit"
msgstr "Límite de repeticiones congeladas"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Frozen repeats"
msgstr "Repeticiones congeladas"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Frozen sensor"
msgstr "Sensor congelado"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Fullscreen"
msgstr "Pantalla completa"

#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/EvalSessionHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Fullscreen document"
msgstr "Documento en pantalla completa"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Fully agentic — design, run and evaluate automatically"
msgstr "Totalmente autónomo: diseñar, ejecutar y evaluar automáticamente"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Fully resolve"
msgstr "Resolver por completo"

#: src/features/fimReview/IdentityPanel.tsx
msgid "func. location"
msgstr "ubic. funcional"

#: src/features/fimReview/InspectSources.tsx
msgid "Func. location"
msgstr "Ubic. funcional"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Function"
msgstr "Función"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "ƒ marks a role the KPI expression uses."
msgstr "ƒ marca un rol que usa la expresión del KPI."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "gap (σ)"
msgstr "brecha (σ)"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "gap <0>{last30Gap}</0> ({last30Sigma}σ)"
msgstr "brecha <0>{last30Gap}</0> ({last30Sigma}σ)"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Gap by band of "
msgstr "Brecha por banda de "

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Gap fill"
msgstr "Relleno de brechas"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "gate"
msgstr "compuerta"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate ceiling"
msgstr "Techo de la compuerta"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Gate drops rows for every tag, not just this one."
msgstr "La compuerta excluye filas para todas las etiquetas, no solo esta."

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate floor"
msgstr "Piso de la compuerta"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate max"
msgstr "Máximo de la compuerta"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Gate min"
msgstr "Mínimo de la compuerta"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Gate min / max"
msgstr "Mín./máx. de la compuerta"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "gates apply to test range"
msgstr "las compuertas se aplican al intervalo de prueba"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Gates only remove train/val rows — the test range keeps every row, so held-out metrics stay honest about all operating regimes."
msgstr "Las compuertas solo eliminan filas de entrenamiento/validación; el intervalo de prueba conserva todas las filas para que las métricas retenidas representen todos los regímenes operativos."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Gecko switches models on as live monitors during the beta."
msgstr "Durante la beta, Gecko activa los modelos como monitores en vivo."

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "General Arrangement"
msgstr "Disposición general"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Generated {ltaCount, plural, one {# LTA} other {# LTAs}} and {entryCount, plural, one {# entry} other {# entries}}."
msgstr "Se completó la generación de {ltaCount, plural, one {# área de adelgazamiento localizado (LTA)} other {# áreas de adelgazamiento localizado (LTA)}} y {entryCount, plural, one {# registro} other {# registros}}."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "generator mw from exciter"
msgstr "MW del generador desde el excitador"

#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
#: src/features/embeddedSidebar/EmbeddedSidebar.tsx
msgid "Give Feedback"
msgstr "Enviar comentarios"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Give the chart a name before saving so it can be found later."
msgstr "Asigne un nombre al gráfico antes de guardarlo para poder encontrarlo después."

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "Give the view a name before saving so it can be found later."
msgstr "Asigne un nombre a la vista antes de guardarla para poder encontrarla después."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Go back"
msgstr "Volver"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Go to {value712_45}"
msgstr "Ir a {value712_45}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Go to Asset"
msgstr "Ir al activo"

#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.tsx
#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.tsx
msgid "Go to Home"
msgstr "Ir a inicio"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Go to Label"
msgstr "Ir a la etiqueta"

#: src/designSystem/components/Pagination.tsx
msgid "Go to next page"
msgstr "Ir a la página siguiente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/PaginationControls.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/Pagination.tsx
#: src/features/knowledgeDocumentViewer/components/thumbnailSidebar/PageThumbnailItem.tsx
msgid "Go to page {pageNumber}"
msgstr "Ir a la página {pageNumber}"

#: src/designSystem/components/Pagination.tsx
msgid "Go to previous page"
msgstr "Ir a la página anterior"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "Go to tab"
msgstr "Ir a la pestaña"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "Good response"
msgstr "Buena respuesta"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph data could not be loaded."
msgstr "No se pudieron cargar los datos del grafo."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph extraction is incomplete. No overlays are available yet."
msgstr "La extracción del grafo está incompleta. Aún no hay superposiciones disponibles."

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Graph mode"
msgstr "Modo de grafo"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Graph unavailable for the selected pipeline."
msgstr "El grafo no está disponible para el proceso seleccionado."

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Grey"
msgstr "Gris"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Ground height"
msgstr "Altura del suelo"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Ground truth"
msgstr "Valor de referencia"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Ground truth vs active pipeline config"
msgstr "Valor de referencia vs. configuración activa del pipeline"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Group"
msgstr "Grupo"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Group LOTO Record Sheet"
msgstr "Hoja de registro de LOTO grupal"

#: src/features/lotoReports/components/LotoReportsList.tsx
msgid "Group LOTO record sheets for this site and the drawing pages they cover."
msgstr "Hojas de registro LOTO grupales de este sitio y las páginas de planos que abarcan."

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Growth"
msgstr "Crecimiento"

#: src/features/dataFilter/categoryFilter/CategorySelector.tsx
msgid "Growth Work Upper Bound"
msgstr "Límite superior del trabajo de crecimiento"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Guide chapters"
msgstr "Capítulos de la guía"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Handheld Inspection"
msgstr "Inspección manual"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Handheld Scan"
msgstr "Escaneo manual"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Has data"
msgstr "Tiene datos"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Has model weights"
msgstr "Tiene pesos del modelo"

#: src/features/auth/vendors/Auth0Provider.tsx
#: src/features/auth/vendors/CognitoLoginScreen.tsx
#: src/features/auth/vendors/KeycloakLoginScreen.tsx
msgid "Having trouble logging in? Contact <0>support@geckorobotics.com</0>"
msgstr "¿Tiene problemas para iniciar sesión? Contacte a <0>support@geckorobotics.com</0>"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Hazardous Energy Control Program (LOTO)"
msgstr "Programa de control de energías peligrosas (LOTO)"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 1"
msgstr "Encabezado 1"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 2"
msgstr "Encabezado 2"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Heading 3"
msgstr "Encabezado 3"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Health"
msgstr "Condición"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Health Check"
msgstr "Verificación de salud"

#: src/features/navbar/navConfig.ts
#: src/pages/homepage/constants.ts
msgid "Health Plans"
msgstr "Planes de salud"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Heat number"
msgstr "Número de colada"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Heat-trace layouts"
msgstr "Disposiciones de trazado térmico"

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Heatmap disabled"
msgstr "Mapa de calor desactivado"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "held out"
msgstr "Excluidos del ajuste"

#: src/pages/homepage/Homepage.tsx
msgid "Hello, {userName}."
msgstr "Hola, {userName}."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Helpful"
msgstr "Útil"

#: src/features/fim/photos/PhotoHeroAction.tsx
#: src/features/fim/photos/PhotoTile.tsx
#: src/features/fim/photos/PhotoTile.tsx
msgid "Hero"
msgstr "Principal"

#: src/features/fim/photos/useSubjectPhotoActions.ts
msgid "Hero photo change failed: {reason}"
msgstr "No se pudo cambiar la foto principal: {reason}"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Hi"
msgstr "Máx."

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "hid {hidden}"
msgstr "se ocultó {hidden}"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Hidden for any of:"
msgstr "Oculto por cualquiera de:"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Hidden layer sizes"
msgstr "Tamaños de capas ocultas"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Hidden layers"
msgstr "Capas ocultas"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/navbar/PermissionGateToggle.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Hide"
msgstr "Ocultar"

#: src/features/workbench/LayoutToggles.tsx
msgid "Hide {label}"
msgstr "Ocultar {label}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Hide Activity"
msgstr "Ocultar actividad"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Hide all"
msgstr "Ocultar todo"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide all alerts"
msgstr "Ocultar todas las alertas"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide all pens"
msgstr "Ocultar todos los trazos"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Hide Anomalies"
msgstr "Ocultar anomalías"

#: src/pages/details/visualization/tools/CameraControlsToggle.tsx
msgid "Hide camera controls"
msgstr "Ocultar controles de cámara"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Hide candidates"
msgstr "Ocultar candidatos"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Hide CapEx Outlook"
msgstr "Ocultar proyección de CapEx"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Hide chart controls"
msgstr "Ocultar controles del gráfico"

#: src/pages/details/visualization/tools/DebugMenuToggle.tsx
msgid "Hide debug menu"
msgstr "Ocultar menú de depuración"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Hide descriptions"
msgstr "Ocultar descripciones"

#: src/pages/cases/activity/ActivityContent.tsx
msgid "Hide details"
msgstr "Ocultar detalles"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Hide filters"
msgstr "Ocultar filtros"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Hide floor and ground"
msgstr "Ocultar piso y suelo"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Hide Kestrel"
msgstr "Ocultar Kestrel"

#: src/pages/details/visualization/tools/ShowLabelsToggle.tsx
msgid "Hide labels"
msgstr "Ocultar etiquetas"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Hide Legend"
msgstr "Ocultar leyenda"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide LOTO panel"
msgstr "Ocultar panel LOTO"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide Metadata"
msgstr "Ocultar metadatos"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Hide Minimap"
msgstr "Ocultar minimapa"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Hide Page Thumbnails"
msgstr "Ocultar miniaturas de página"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Hide panel"
msgstr "Ocultar panel"

#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Hide past conversations"
msgstr "Ocultar conversaciones anteriores"

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Hide permission gates"
msgstr "Ocultar controles de permisos"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Hide photo counts"
msgstr "Ocultar recuentos de fotos"

#: src/pages/details/visualization/tools/NiraToggle.tsx
msgid "Hide Photogrammetry"
msgstr "Ocultar fotogrametría"

#: src/pages/details/visualization/tools/CopcPointCloudToggle.tsx
#: src/pages/details/visualization/tools/LidarPointCloudToggle.tsx
msgid "Hide Point Cloud"
msgstr "Ocultar nube de puntos"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Hide rows the model filtered out"
msgstr "Ocultar filas filtradas por el modelo"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Hide shelf filters"
msgstr "Ocultar filtros de archivo temporal"

#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
msgid "Hide sidebar"
msgstr "Ocultar barra lateral"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Hide tags"
msgstr "Ocultar etiquetas"

#: src/features/timeSeries/components/AllTagsTab.tsx
msgid "Hide tags without data"
msgstr "Ocultar etiquetas sin datos"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Hide the prior Subjects folded into this one"
msgstr "Ocultar los sujetos anteriores integrados en este"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Hide the references behind this alias"
msgstr "Ocultar las referencias de este alias"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Hide toggles"
msgstr "Ocultar controles"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Hide Toggles"
msgstr "Ocultar controles"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "High"
msgstr "Alta"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "High clip quantile"
msgstr "Cuantil de recorte alto"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Highlight Assets"
msgstr "Resaltar activos"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Highlight changes"
msgstr "Resaltar cambios"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Highlight current pose"
msgstr "Resaltar posición actual"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Historian"
msgstr "Historiador"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "historian tag"
msgstr "etiqueta del historiador"

#: src/features/fimReview/provenance.ts
msgid "Historian tag"
msgstr "Etiqueta del historiador"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "History"
msgstr "Historial"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Hit Train to band the target pen on the chart and see metrics here."
msgstr "Presione Entrenar para agregar la banda al trazo objetivo del gráfico y ver aquí las métricas."

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Hold <0>Left Mouse + Drag</0> to orbit"
msgstr "Mantenga <0>el botón izquierdo del mouse presionado y arrastre</0> para orbitar"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "hold each event out of the baseline"
msgstr "excluir cada evento de la referencia"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Holdout quality of the selected model method: scaled mean absolute error (lower is better), residual drift, and typical residual size"
msgstr "Calidad del método de modelado seleccionado en los datos reservados: error absoluto medio escalado (menor es mejor), deriva residual y tamaño residual típico"

#: src/features/navbar/navConfig.ts
#: src/features/navbar/siteSelectors/EmbeddedSidebarBrandHomeLink.test.tsx
#: src/features/navbar/siteSelectors/useBrandHomeLink.ts
#: src/features/navbar/siteSelectors/useBrandHomeLink.ts
#: src/pages/documents/usePowerCustomerUploadLeaveWarning.ts
msgid "Home"
msgstr "Inicio"

#: src/features/knowledgeDocumentViewer/components/table/SyncedTableHorizontalScrollbar.tsx
#: src/features/knowledgeDocumentViewer/components/table/SyncedTableHorizontalScrollbar.tsx
msgid "Horizontal table scroll"
msgstr "Desplazamiento horizontal de la tabla"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "hourly"
msgstr "por hora"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
msgid "hours"
msgstr "horas"

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Hours"
msgstr "Horas"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Hover over a point to see temperature"
msgstr "Pase el cursor sobre un punto para ver la temperatura"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How far (in sample periods) the correlation scan looks each side of zero. Larger = slower preview but catches longer leads/lags. Time equivalent = max × interval."
msgstr "Distancia (en períodos de muestra) que el análisis de correlación examina a cada lado de cero. Un valor mayor ralentiza la vista previa, pero detecta adelantos/retardos más largos. Equivalente temporal = máx. × intervalo."

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "How good was the investigation framing, reasoning, and evidence?"
msgstr "¿Qué calidad tuvieron el planteamiento, el razonamiento y la evidencia de la investigación?"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How many historical neighbors vote for each prediction. Smaller k = noisier / more local; larger k = smoother / more averaged."
msgstr "Cantidad de vecinos históricos que participan en cada predicción. Una k menor es más ruidosa/local; una k mayor es más suave/promediada."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How multiple raw samples inside one interval bin are collapsed to a single value. Mean is the production default. Median is more outlier-resistant; last_value keeps the newest sample in the bin. Only used in aggregate mode."
msgstr "Cómo se reducen varias muestras sin procesar de un intervalo a un solo valor. La media es el valor predeterminado de producción. La mediana resiste mejor los valores atípicos; last_value conserva la muestra más reciente. Solo se usa en modo agregado."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "How the band is chosen:"
msgstr "Cómo se elige la banda:"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How the residual error scale is measured on calibration rows, then multiplied by Band k. IQR (prod) = P75−P25 of |error|. Std = std(|error|). Abs quantile = chosen percentile of |error|. Band is one constant per model, not per point."
msgstr "Cómo se mide la escala del error residual en filas de calibración y se multiplica por la k de banda. IQR (prod.) = P75−P25 de |error|. Desv. est. = std(|error|). Cuantil abs. = percentil elegido de |error|. La banda es una constante por modelo, no por punto."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "How this run was produced"
msgstr "Cómo se produjo esta ejecución"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "How to carve the timeline into chunks: tail fraction (prod-like), calendar month/year, fixed N-day blocks, or custom date ranges you type in. Custom ranges are the only mode where a row can belong to no chunk — those rows are excluded from fitting and scoring."
msgstr "Cómo dividir la cronología en bloques: fracción de cola, mes/año calendario, bloques fijos de N días o intervalos personalizados. Solo en los intervalos personalizados una fila puede no pertenecer a ningún bloque; esas filas se excluyen del ajuste y la puntuación."

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "How to use this page"
msgstr "Cómo usar esta página"

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Html overlay debug colors"
msgstr "Colores de depuración de la superposición HTML"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Human coverage"
msgstr "Cobertura humana"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Human merge"
msgstr "Fusión manual"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Human split"
msgstr "Separación manual"

#: src/features/fimReview/provenance.ts
msgid "Human-confirmed"
msgstr "Confirmado por una persona"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Human-confirmed pages"
msgstr "Páginas confirmadas por una persona"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "Humans vs pipeline"
msgstr "Humanos vs. proceso automático"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "humidity"
msgstr "humedad"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Humidity"
msgstr "Humedad"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Hung\n"
"Initial"
msgstr ""
"Inic.\n"
"coloc."

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Hung\n"
"Order"
msgstr ""
"Orden\n"
"coloc."

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Hung order"
msgstr "Orden de colocación"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Hung position"
msgstr "Posición al colocar"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Hung Position"
msgstr ""
"Posición colgadaPosición\n"
"al colocar"

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "I'm here!"
msgstr "¡Aquí estoy!"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "ID:"
msgstr "ID:"

#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "ID: {entryID}"
msgstr "ID: {entryID}"

#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Image"
msgstr "Imagen"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Image File"
msgstr "Archivo de imagen"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Image loading..."
msgstr "Cargando imagen..."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Image must be smaller than 5MB!"
msgstr "¡La imagen debe ser menor de 5 MB!"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Image not available"
msgstr "Imagen no disponible"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Image uploaded successfully"
msgstr "Imagen cargada correctamente"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Imagery"
msgstr "Imágenes"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Images"
msgstr "Imágenes"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Impact"
msgstr "Impacto"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "Impact:"
msgstr "Impacto:"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Impersonate user"
msgstr "Ver como usuario"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Impersonation is unavailable for your own account or a user whose access has not loaded."
msgstr "La vista como usuario no está disponible para tu propia cuenta ni para usuarios cuyo acceso no se ha cargado."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Implement a fix and open a PR."
msgstr "Implemente una corrección y abra un PR."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Imported"
msgstr "Importado"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Imported source data. Plans and orders do not establish performed work; stock figures are snapshots."
msgstr "Datos importados del sistema de origen. Los planes y las órdenes no demuestran que el trabajo se haya realizado; las existencias reflejan el estado registrado en ese momento."

#: src/features/navbar/navConfig.ts
msgid "Imports"
msgstr "Importaciones"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
msgid "Improvement"
msgstr "Mejora"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Improvement details"
msgstr "Detalles de la mejora"

#: src/designSystem/components/RecordHeader.tsx
#: src/designSystem/components/RecordHeader.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "In progress"
msgstr "En curso"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "in range ({displayedHealthRatio}×)"
msgstr "dentro del rango ({displayedHealthRatio}×)"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "In Service"
msgstr "En servicio"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Inaccurate"
msgstr "Impreciso"

#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Include {subject}"
msgstr "Incluir {subject}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Includes imported maintenance work orders in your search results."
msgstr "Incluye órdenes de trabajo de mantenimiento importadas en tus resultados de búsqueda."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inclusive end of the historian window (UTC day). Capped at “now”."
msgstr "Fin inclusivo de la ventana del historiador (día UTC). Limitado a “ahora”."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inclusive start of the historian window pulled into the experiment."
msgstr "Inicio inclusivo de la ventana del historiador incorporada al experimento."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Incomplete load"
msgstr "Carga incompleta"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Incorrect Label"
msgstr "Etiqueta incorrecta"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Incorrect Off Page Connector"
msgstr "Conector fuera de página incorrecto"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Incorrect Response"
msgstr "Respuesta incorrecta"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "increasing"
msgstr "en aumento"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Independent Variable(s) (X)"
msgstr "Variable(s) independiente(s) (X)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Indexes, covers and document control"
msgstr "Índices, portadas y control de documentos"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Info"
msgstr "Información"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "Infrared Thermal Images"
msgstr "Imágenes térmicas infrarrojas"

#: src/features/fimReview/ReviewActions.tsx
msgid "Input removal scope"
msgstr "Alcance de la eliminación de entradas"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Input removed"
msgstr "Entrada eliminada"

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Input Type"
msgstr "Tipo de entrada"

#: src/features/timeSeries/components/AllTagsTable.tsx
msgid "input[type=\"checkbox\"]"
msgstr "input[type=\"checkbox\"]"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Inputs that should physically determine the target under normal operation (load, flow, ambient, upstream states). Keep the set small and non-redundant."
msgstr "Entradas que deben determinar físicamente el objetivo durante la operación normal (carga, flujo, ambiente, estados aguas arriba). Mantenga un conjunto pequeño y sin redundancias."

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Insert {entryTypeName}"
msgstr "Insertar {entryTypeName}"

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Insert Entry"
msgstr "Insertar registro"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Inspect sources ({constituentCount})"
msgstr "Inspeccionar fuentes ({constituentCount})"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Inspect sources ({sourceCount})"
msgstr "Inspeccionar fuentes ({sourceCount})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Inspection"
msgstr "Inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection · Remaining life"
msgstr "Inspección · Vida útil restante"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "Inspection {date}"
msgstr "Inspección {date}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Inspection and test results"
msgstr "Resultados de inspección y pruebas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Inspection asset"
msgstr "Activo de la inspección"

#: src/features/navbar/navConfig.ts
msgid "Inspection Dashboard"
msgstr "Panel de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "Inspection data"
msgstr "Datos de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection date"
msgstr "Fecha de inspección"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection field"
msgstr "Campo de inspección"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection form"
msgstr "Formulario de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Inspection heatmap data is unavailable."
msgstr "Los datos del mapa de calor de la inspección no están disponibles."

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Inspection image unavailable"
msgstr "Imagen de inspección no disponible"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Inspection layer"
msgstr "Capa de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "Inspection of {date}"
msgstr "Inspección del {date}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "Inspection of {date} · {state}"
msgstr "Inspección del {date} · {state}"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Inspection processing pipelines in progress: {processInspectionRunsCount}"
msgstr "Procesos de inspección en curso: {processInspectionRunsCount}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection question number"
msgstr "Número de pregunta de inspección"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Inspection response"
msgstr "Respuesta de inspección"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection responses"
msgstr "Respuestas de inspección"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inspection result"
msgstr "Resultado de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Inspection results ready"
msgstr "Resultados de inspección listos"

#: src/features/navbar/navConfig.ts
msgid "Inspection Scheduling"
msgstr "Programación de inspecciones"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Inspection Version"
msgstr "Versión de inspección"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Inspection view"
msgstr "Vista de inspección"

#: src/features/navbar/navConfig.ts
msgid "Inspections"
msgstr "Inspecciones"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Installation and assembly"
msgstr "Instalación y ensamblaje"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instant search — the full catalog is loaded locally"
msgstr "Búsqueda instantánea: el catálogo completo está cargado localmente"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instant search active"
msgstr "Búsqueda instantánea activa"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Instantiate"
msgstr "Crear instancia"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Instantiate failed: {reason}"
msgstr "No se pudo crear la instancia: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Instantiating…"
msgstr "Creando instancia…"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Instructions and technical requirements"
msgstr "Instrucciones y requisitos técnicos"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Instrument"
msgstr "Instrumento"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Instrument "
msgstr "Instrumento "

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Instruments"
msgstr "Instrumentos"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Integer sample-period lead/lag per tag. Positive = treat the tag as leading (at time t use its value from t − N periods). Use the correlation chart / “Apply best shifts” to find useful offsets."
msgstr "Adelanto/retardo entero en períodos de muestra por etiqueta. Positivo = tratar la etiqueta como adelantada (en el tiempo t se usa su valor de t − N períodos). Use el gráfico de correlación o “Aplicar mejores desfases” para encontrar desplazamientos útiles."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 2D visualization of component {componentName} on unit {unitName}."
msgstr "Visualización 2D interactiva del componente {componentName} en la unidad {unitName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 2D visualization of component {componentName}."
msgstr "Visualización 2D interactiva del componente {componentName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 3D visualization of component {componentName} on unit {unitName}."
msgstr "Visualización 3D interactiva del componente {componentName} en la unidad {unitName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive 3D visualization of component {componentName}."
msgstr "Visualización 3D interactiva del componente {componentName}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Interactive asset visualization."
msgstr "Visualización interactiva del activo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Interactive inspection"
msgstr "Inspección interactiva"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Intercept"
msgstr "Intercepto"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "intercept={value122_30}"
msgstr "intercepto={value122_30}"

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "Internal"
msgstr "Interno"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadFailureDetails.tsx
msgid "Internal:"
msgstr "Interno:"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "Interpolate:"
msgstr "Interpolar:"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Interval"
msgstr "Intervalo"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "interval {value70_29}→{value70_51}"
msgstr "intervalo {value70_29}→{value70_51}"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Interval unit"
msgstr "Unidad del intervalo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Introductions and document scope"
msgstr "Introducciones y alcance del documento"

#: src/components/DateTimeWithTimezone.tsx
msgid "Invalid date"
msgstr "Fecha no válida"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Invalid expression"
msgstr "Expresión no válida"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Invalid File Type"
msgstr "Tipo de archivo no válido"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/reportViewSchema.ts
msgid "Invalid report source reference or columns"
msgstr "Referencia de fuente o columnas del informe no válidas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory balance"
msgstr "Saldo de inventario"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory stock"
msgstr "Existencias de inventario"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory usage"
msgstr "Uso de inventario"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Inventory valuation"
msgstr "Valuación del inventario"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Invert Colors"
msgstr "Invertir colores"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Investigate"
msgstr "Investigar"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Investigate with AI"
msgstr "Investigar con IA"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Investigating"
msgstr "Investigando"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Investigation"
msgstr "Investigación"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation completed"
msgstr "Investigación completada"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation failed"
msgstr "La investigación falló"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation notes"
msgstr "Notas de investigación"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Investigation Quality"
msgstr "Calidad de la investigación"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Investigation started"
msgstr "Investigación iniciada"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Invitation only partly succeeded. Try again, even if the person already appears on the roster."
msgstr "La invitación solo se completó en parte. Inténtelo de nuevo, aunque la persona ya aparezca en la lista de usuarios."

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Invitation resent"
msgstr "Invitación reenviada"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Invitations cannot be sent to deactivated users."
msgstr "No se pueden enviar invitaciones a usuarios desactivados."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Invitations sent"
msgstr "Invitaciones enviadas"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "Invite people"
msgstr "Invitar personas"

#: src/pages/manageAccess/users.ts
msgctxt "access status"
msgid "Invited"
msgstr "Invitado"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "IQR (prod)"
msgstr "IQR (prod.)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "IR Scan - {comparisonImageDate}"
msgstr "Inspección IR - {comparisonImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "IR Scan - {currentImageDate}"
msgstr "Inspección IR - {currentImageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "IR Scan - {imageDate}"
msgstr "Inspección IR - {imageDate}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
msgid "IR Scan from {imageDate}"
msgstr "Inspección IR del {imageDate}"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "is tagged as a report"
msgstr "está etiquetado como informe"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Isolated"
msgstr "Aislado"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Isolated pipe spool fabrication"
msgstr "Fabricación de carretes de tubería aislados"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "Isolation point (record sheet row)"
msgstr "Punto de aislamiento (fila de la hoja de registro)"

#: src/features/lotoReports/components/LotoIsolationPointsTable.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Isolation points"
msgstr "Puntos de aislamiento"

#: src/features/lotoReports/components/LotoPointsCoverage.tsx
msgid "Isolation points in hang order"
msgstr "Puntos de aislamiento en orden de colocación"

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Isolation points on page {pageNumber}"
msgstr "Puntos de aislamiento de la página {pageNumber}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Issue Severity"
msgstr "Severidad del problema"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Issue Type"
msgstr "Tipo de problema"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Issue Type *"
msgstr "Tipo de problema *"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Issue unit"
msgstr "Unidad de salida"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Issued by"
msgstr "Emitido por"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "ISSUED BY:"
msgstr "EMITIDO POR:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Issued quantity"
msgstr "Cantidad entregada"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "It is removed from every chart at this site."
msgstr "Se elimina de todos los gráficos de este sitio."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Italic (Ctrl+I)"
msgstr "Cursiva (Ctrl+I)"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "item"
msgstr "elemento"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item"
msgstr "Artículo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item set"
msgstr "Conjunto de artículos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Item type"
msgstr "Tipo de artículo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Item vendors"
msgstr "Proveedores del artículo"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Items"
msgstr "Elementos"

#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Job"
msgstr "Trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Job plan"
msgstr "Plan de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Job plan (jpnum)"
msgstr "Plan de trabajo (jpnum)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Job task"
msgstr "Tarea del plan"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Job-plan revision"
msgstr "Revisión del plan de trabajo"

#: src/features/navbar/navConfig.ts
msgid "Jobs Overview"
msgstr "Resumen de trabajos"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Joined rows"
msgstr "Filas combinadas"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"JSON appears to be malformed! Error below:\n"
"\n"
"{error}"
msgstr ""
"El JSON parece tener un formato incorrecto. Error:\n"
"\n"
"{error}"

#: src/features/timeSeries/services/workOrderService.ts
msgid "JSON data must be an array of work orders."
msgstr "Los datos JSON deben ser una matriz de órdenes de trabajo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Judge criterion"
msgstr "Criterio del juez"

#: src/pages/homepage/Homepage.tsx
msgid "JUMP TO"
msgstr "IR A"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "Jump to later data →"
msgstr "Ir a datos posteriores →"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Jump to latest"
msgstr "Ir a lo más reciente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/JumpToLatestButton.tsx
msgid "Jump to latest message"
msgstr "Ir al último mensaje"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/Pagination.tsx
msgid "Jump to page {page}"
msgstr "Ir a la página {page}"

#: src/features/fimReview/relativeTime.ts
#: src/features/modelOperations/fimShared.ts
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "just now"
msgstr "justo ahora"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "k-nearest-neighbors / APR: expected target = mean of the k most similar historical current-driver snapshots (partial distance if some drivers are missing). No parametric fit; bounded by history."
msgstr "k vecinos más cercanos / APR: el objetivo esperado es la media de las k instantáneas históricas más similares de las variables predictoras actuales (distancia parcial si faltan algunas variables predictoras). Sin ajuste paramétrico; limitado por el historial."

#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Keep"
msgstr "Conservar"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Keep only rows where this tag is in [min, max]. Rows where it falls outside the range are removed across all tags (operating-regime filter)."
msgstr "Conserve solo las filas en las que esta etiqueta esté en [mín., máx.]. Las filas en las que quede fuera del rango se eliminan de todas las etiquetas (filtro de régimen operativo)."

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Keep pens the model does not use (hidden)"
msgstr "Conservar los trazos que el modelo no usa (ocultos)"

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Keyboard Shortcuts"
msgstr "Atajos de teclado"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Kind"
msgstr "Clase"

#: src/features/fimReview/DecisionHistory.tsx
msgid "kind → {kind}"
msgstr "clase → {kind}"

#: src/features/fimReview/InspectSources.tsx
msgid "Kind guess"
msgstr "Clase estimada"

#: src/features/sentinels/methodLabels.ts
msgid "kNN"
msgstr "kNN"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "knn — similarity baseline"
msgstr "knn — línea base de similitud"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "kNN / APR"
msgstr "kNN / APR"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "kNN drivers · the conditions that define “expected”"
msgstr "Variables predictoras de kNN · las condiciones que definen lo «esperado»"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "kNN fit"
msgstr "ajuste kNN"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "kNN k"
msgstr "k de kNN"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "kNN library ({librarySize} pts) — first example neighbors"
msgstr "Biblioteca kNN ({librarySize} puntos): vecinos del primer ejemplo"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "kNN library cap"
msgstr "límite de biblioteca kNN"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "kNN neighbor picks (sample queries)"
msgstr "selecciones de vecinos kNN (consultas de muestra)"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "knn_cap {value77_28}→{value77_45}"
msgstr "knn_cap {value77_28}→{value77_45}"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "knn_k {value75_49}→{value75_60}"
msgstr "knn_k {value75_49}→{value75_60}"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Known events"
msgstr "Eventos conocidos"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Known unknowns"
msgstr "Incertidumbres conocidas"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI line unavailable"
msgstr "Línea de KPI no disponible"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI not chartable"
msgstr "No se puede graficar el KPI"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "KPI only"
msgstr "Solo KPI"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Label"
msgstr "Etiqueta"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardLabelDataButton.tsx
msgid "Label data"
msgstr "Etiquetar datos"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Label one page at a time, or browse pages you already confirmed or deferred."
msgstr "Etiquete una página a la vez o explore las páginas que ya confirmó o aplazó."

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
#: src/pages/evaluations/metadata/components/LabelingActions.tsx
msgid "Label pages"
msgstr "Etiquetar páginas"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingStatusFilter.tsx
msgid "Label status"
msgstr "Estado del etiquetado"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Label title"
msgstr "Título de la etiqueta"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Label tool"
msgstr "Herramienta de etiquetas"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
msgid "Labeled by"
msgstr "Etiquetado por"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalLabeledByBadge.tsx
msgid "Labeled by {labeledBy}"
msgstr "Etiquetada por {labeledBy}"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Labeled by me"
msgstr "Etiquetadas por mí"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLabeledByFilter.tsx
msgid "Labeled by NAES"
msgstr "Etiquetadas por NAES"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Labeler coverage of reviewer pages"
msgstr "Cobertura de etiquetadores en páginas de revisores"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Labelers vs pipeline"
msgstr "Etiquetadores vs. proceso automático"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardBreadcrumb.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFrame.tsx
#: src/pages/evaluations/metadata/dashboard/MetadataEvalsPage.tsx
msgid "Labeling eval"
msgstr "Evaluación de etiquetado"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Labeling mode"
msgstr "Modo de etiquetado"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
#: src/pages/processData/components/WorkbenchChartArea.tsx
msgid "Labels"
msgstr "Etiquetas"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Labels are drawn in View mode with the Label tool; ones touching the target show up here."
msgstr "Las etiquetas se dibujan en el modo Ver con la herramienta Etiqueta; las que tocan el objetivo aparecen aquí."

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "labels hit"
msgstr "etiquetas coincidentes"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Labor"
msgstr "Mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor and cost totals"
msgstr "Totales de mano de obra y costos"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor cost"
msgstr "Costo de mano de obra"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Labor hours"
msgstr "Horas de mano de obra"

#: src/features/navbar/LanguageToggle.tsx
msgid "Language"
msgstr "Idioma"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Last 14 Days"
msgstr "Últimos 14 días"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 24 Hours"
msgstr "Últimas 24 horas"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 3 Months"
msgstr "Últimos 3 meses"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 30 Days"
msgstr "Últimos 30 días"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "last 30d <0>{last30Actual}</0> vs expected <1>{last30Expected}</1>"
msgstr "últimos 30 d <0>{last30Actual}</0> frente a lo esperado <1>{last30Expected}</1>"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "last 30d actual"
msgstr "valor real de los últimos 30 d"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 5 Years"
msgstr "Últimos 5 años"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 7 Days"
msgstr "Últimos 7 días"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last 8 Hours"
msgstr "Últimas 8 horas"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Last 90 Days"
msgstr "Últimos 90 días"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Last cost"
msgstr "Último costo"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Last detection"
msgstr "Última detección"

#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Last edited"
msgstr "Última edición"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "last fit"
msgstr "último ajuste"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last Hour"
msgstr "Última hora"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Last Inspected"
msgstr "Última inspección"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Last inspection: {lastInspectionLabel}"
msgstr "Última inspección: {lastInspectionLabel}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/TooltipSparkline.tsx
msgid "Last measured: {lastMeasuredText}"
msgstr "Última medición: {lastMeasuredText}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Last recorded completion date"
msgstr "Última fecha de finalización registrada"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "last run"
msgstr "última ejecución"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Last scored "
msgstr "Última evaluación: "

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Last update failed"
msgstr "La última actualización falló"

#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Last Updated"
msgstr "Última actualización"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Last Year"
msgstr "Último año"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Latest"
msgstr "Más reciente"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Latest of {matchCount} revisions — click to open"
msgstr "La más reciente de {matchCount} revisiones — haga clic para abrir"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Layouts, geometry and fabrication"
msgstr "Disposiciones, geometría y fabricación"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Lead"
msgstr "Encargado"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "lead (days)"
msgstr "adelanto (días)"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Leave and cancel upload"
msgstr "Salir y cancelar la carga"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Leave blank"
msgstr "Dejar en blanco"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Leave document upload?"
msgstr "¿Salir de la carga de documentos?"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
msgid "Leave photo mode"
msgstr "Salir del modo de fotos"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Left"
msgstr "Izquierda"

#: src/features/workbench/LayoutToggles.tsx
msgid "left panel"
msgstr "panel izquierdo"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Left: minimum aligned rows required to train at all. Right: minimum observed-target train rows (and usable-driver kNN rows). Production uses 1000 / 300; lab defaults are relaxed for faster iteration."
msgstr "Izquierda: filas alineadas mínimas necesarias para poder entrenar. Derecha: filas de entrenamiento mínimas con el objetivo observado (y filas kNN con variables predictoras utilizables). Producción usa 1000 / 300; los valores predeterminados del laboratorio son más flexibles para iterar con mayor rapidez."

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Legend"
msgstr "Leyenda"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Length"
msgstr "Longitud"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Length of the trailing rolling mean on each driver (and on the target when Self history is on), in sample periods. Default 6 → 60 min at a 10 min interval. Smooths short noise; larger windows blur faster dynamics."
msgstr "Número de períodos anteriores usados en la media móvil de cada variable predictora (y del objetivo si Historial propio está activado). Por defecto, 6 períodos de 10 min equivalen a 60 min. Suaviza el ruido de corta duración; ventanas mayores atenúan las variaciones rápidas."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "level"
msgstr "nivel"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Level — sustained drift"
msgstr "Nivel — deriva sostenida"

#: src/features/navbar/navConfig.ts
msgid "Libra"
msgstr "Libra"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Library cap (0 = all)"
msgstr "Límite de biblioteca (0 = todo)"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Line"
msgstr "Línea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line cost"
msgstr "Costo de la línea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line cost in transaction currency"
msgstr "Costo de línea en la moneda de la transacción"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line number"
msgstr "Número de línea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Line type"
msgstr "Tipo de línea"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Linear: OLS residual on the tags. Ratio: target ÷ first against-tag (efficiency-style). Quadratic: OLS on x and x² (curved responses). Log: OLS on ln x — rows with x ≤ 0 are skipped. Power: log-log OLS (y = scale·xᵇ, reports the exponent) — needs x and y > 0. None trains a Sentinel — just intuition for drivers."
msgstr "Lineal: residuo OLS sobre las etiquetas. Proporción: objetivo ÷ primera etiqueta de comparación (estilo eficiencia). Cuadrático: OLS sobre x y x² (respuestas curvas). Log: OLS sobre ln x — se omiten las filas con x ≤ 0. Potencia: OLS log-log (y = escala·xᵇ, informa el exponente) — requiere x e y > 0. Ninguno entrena un Sentinel; solo aporta información sobre las variables predictoras."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Link copied"
msgstr "Enlace copiado"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Link highlights"
msgstr "Vincular resaltados"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Link reference"
msgstr "Vincular referencia"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Linked Alerts"
msgstr "Alertas vinculadas"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Linked detection"
msgstr "Detección vinculada"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Linked subjects for {value769_55}"
msgstr "Sujetos vinculados para {value769_55}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "List Documents"
msgstr "Listar documentos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Listed the saved models"
msgstr "Se listaron los modelos guardados"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Listing the saved models"
msgstr "Listando los modelos guardados"

#: src/features/timeSeries/components/ActiveTimeRangeModeTag.tsx
msgid "Live"
msgstr "En vivo"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Live check"
msgstr "Comprobación en vivo"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Live check — score a recent window with the saved models"
msgstr "Comprobación en vivo — puntuar una ventana reciente con los modelos guardados"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Live count of how many points survive each stage: raw aggregate grid → cleaning → target-observed → lag warm-up → train/val/test → estimated fit/calib rows. Also shows each tag’s native sample spacing vs the chosen interval."
msgstr "Conteo en vivo de cuántos puntos sobreviven en cada etapa: cuadrícula agregada sin procesar → limpieza → objetivo observado → calentamiento de rezagos → entrenamiento/validación/prueba → filas estimadas de ajuste/calibración. También muestra el espaciado de muestra nativo de cada etiqueta frente al intervalo elegido."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Live Tail"
msgstr "En vivo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Live train progress"
msgstr "Progreso del entrenamiento en vivo"

#: src/features/assetVizAdapter/MeasurementStrip.tsx
msgid "Lo"
msgstr "Mín."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Load"
msgstr "Cargar"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Load {value215_29}"
msgstr "Cargar {value215_29}"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Load a model to configure it"
msgstr "Carga un modelo para configurarlo"

#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Load all {value65_29} pens. This chart may take minutes to load and will be hard to read."
msgstr "Cargar los {value65_29} trazos. Este gráfico puede tardar varios minutos en cargar y será difícil de leer."

#: src/features/chatbot/hooks/useReconnect.ts
msgid "Load messages failed"
msgstr "Error al cargar los mensajes"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Load more"
msgstr "Cargar más"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Loaded {value360_18}{value360_43}"
msgstr "Se cargaron {value360_18}{value360_43}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loaded a saved model"
msgstr "Se cargó un modelo guardado"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loaded a saved model ({shortId})"
msgstr "Se cargó un modelo guardado ({shortId})"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Loading"
msgstr "Cargando"

#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
msgid "Loading "
msgstr "Cargando "

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Loading {lowerCaseTitle}..."
msgstr "Cargando {lowerCaseTitle}..."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loading a saved model"
msgstr "Cargando un modelo guardado"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Loading a saved model ({shortId})"
msgstr "Cargando un modelo guardado ({shortId})"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "Loading active pipeline comparisons…"
msgstr "Cargando comparaciones del pipeline activo…"

#: src/pages/cases/activity/ActivityFeed.tsx
msgid "Loading activity..."
msgstr "Cargando actividad..."

#: src/pages/alerts/AlertDetails.tsx
msgid "Loading alert…"
msgstr "Cargando alerta…"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "Loading alerts…"
msgstr "Cargando alertas…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Loading archived chats…"
msgstr "Cargando chats archivados…"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Loading asset information..."
msgstr "Cargando información del activo…"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "Loading asset instances…"
msgstr "Cargando instancias de activos…"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditCaseForm.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Loading case..."
msgstr "Cargando caso…"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Loading cases…"
msgstr "Cargando casos…"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Loading changes…"
msgstr "Cargando cambios…"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Loading chat session…"
msgstr "Cargando sesión de chat…"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Loading chats…"
msgstr "Cargando chats…"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Loading color scale..."
msgstr "Cargando escala de colores…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "Loading comparison…"
msgstr "Cargando comparación…"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Loading conversations"
msgstr "Cargando conversaciones"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOrg.tsx
msgid "Loading dashboard metrics…"
msgstr "Cargando métricas del panel…"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid "Loading data for the plot..."
msgstr "Cargando datos para el gráfico..."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Loading data preview…"
msgstr "Cargando vista previa de datos…"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Loading data statistics..."
msgstr "Cargando estadísticas de datos…"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataContent.tsx
msgid "Loading document details…"
msgstr "Cargando detalles del documento…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Loading document preview"
msgstr "Cargando vista previa del documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsFooter.tsx
msgid "Loading document result controls"
msgstr "Cargando controles de resultados de documentos"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Loading document results"
msgstr "Cargando resultados de documentos"

#: src/features/knowledgeDocumentViewer/components/viewer/PagedDocumentViewer.tsx
msgid "Loading document..."
msgstr "Cargando documento..."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Loading documents"
msgstr "Cargando documentos"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
msgid "Loading documents..."
msgstr "Cargando documentos..."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Loading documents…"
msgstr "Cargando documentos…"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
msgid "Loading drawings"
msgstr "Cargando planos"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Loading drawings…"
msgstr "Cargando planos…"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "Loading entries..."
msgstr "Cargando entradas…"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Loading facility model…"
msgstr "Cargando modelo de la instalación…"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoViewer.tsx
msgid "Loading full-resolution photo"
msgstr "Cargando foto en resolución completa"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Loading full-resolution photo…"
msgstr "Cargando foto de resolución completa…"

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Loading graph…"
msgstr "Cargando grafo…"

#: src/features/richText/nodes/ImageNode.tsx
msgid "Loading image..."
msgstr "Cargando imagen…"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "Loading images at "
msgstr "Cargando imágenes en "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Loading inspection data…"
msgstr "Cargando datos de inspección…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportAssetView.tsx
msgid "Loading inspection model…"
msgstr "Cargando el modelo de inspección…"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Loading Kestrel..."
msgstr "Cargando Kestrel…"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Loading lineage…"
msgstr "Cargando linaje…"

#: src/features/lotoReports/components/LotoReportEditorLoading.tsx
msgid "Loading LOTO report"
msgstr "Cargando informe LOTO"

#: src/features/lotoReports/components/LotoReportsLoading.tsx
msgid "Loading LOTO reports"
msgstr "Cargando informes LOTO"

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "Loading LOTO reports…"
msgstr "Cargando informes LOTO…"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Loading M&D cases…"
msgstr "Cargando casos de M&D…"

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Loading metadata evaluation metrics…"
msgstr "Cargando métricas de evaluación de metadatos…"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Loading model files…"
msgstr "Cargando archivos del modelo…"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Loading monitor config…"
msgstr "Cargando configuración del monitor…"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Loading notifications..."
msgstr "Cargando notificaciones..."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "Loading organization…"
msgstr "Cargando organización…"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataContent.tsx
msgid "Loading page metadata…"
msgstr "Cargando metadatos de página…"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Loading page preview…"
msgstr "Cargando vista previa de la página…"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoPagePlaceholder.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Loading page…"
msgstr "Cargando página…"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Loading pens…"
msgstr "Cargando trazos…"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Loading point cloud…"
msgstr "Cargando nube de puntos…"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Loading preferences..."
msgstr "Cargando preferencias..."

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Loading preview…"
msgstr "Cargando vista previa…"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Loading proposal…"
msgstr "Cargando propuesta…"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Loading revision family edits…"
msgstr "Cargando ediciones de la familia de revisiones…"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Loading saved models…"
msgstr "Cargando modelos guardados…"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "Loading sensor data..."
msgstr "Cargando datos de sensores..."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Loading sentinel…"
msgstr "Cargando centinela…"

#: src/features/sentinels/components/SentinelList.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Loading sentinels…"
msgstr "Cargando centinelas…"

#: src/features/fimReview/InspectSources.tsx
msgid "Loading source records…"
msgstr "Cargando registros de origen…"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Loading Subject…"
msgstr "Cargando sujeto…"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Loading surface…"
msgstr "Cargando superficie…"

#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Loading the conversation"
msgstr "Cargando la conversación"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Loading time series data..."
msgstr "Cargando datos de series temporales…"

#: src/features/facilityModel/catalogQuery.ts
msgid "Loading timed out — retry."
msgstr "Se agotó el tiempo de carga; vuelva a intentarlo."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Loading upload history"
msgstr "Cargando historial de cargas"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "Loading users..."
msgstr "Cargando usuarios…"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Loading visualization..."
msgstr "Cargando visualización…"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
#: src/features/locale/GeckoLocaleProvider.tsx
#: src/features/locale/GeckoLocaleProvider.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/nnpp/components/NnppPageFrame.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
#: src/features/timeSeries/components/PenSubjectLinksSection.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
msgid "Loading…"
msgstr "Cargando…"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Local definitions are unverified. Only source flags set to true are shown; they do not verify permits, compliance or work performed."
msgstr "Las definiciones locales no están verificadas. Solo se muestran los indicadores activados en el origen; no confirman permisos, cumplimiento ni trabajos realizados."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Local issue"
msgstr "Problema local"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Local Thin Areas were generated, but the page could not refresh. Reload to see the latest data."
msgstr "Se generaron las áreas de adelgazamiento localizado, pero no se pudo actualizar la página. Recárguela para ver los datos más recientes."

#: src/features/knowledgeDocumentViewer/components/viewer/search/CitedTextBar.tsx
msgid "Locating cited text..."
msgstr "Buscando el texto citado..."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Location"
msgstr "Ubicación"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Location / Component Part"
msgstr "Ubicación / Parte del componente"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location ancestor"
msgstr "Ubicación superior"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location ancestors"
msgstr "Ubicaciones superiores"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location hierarchy"
msgstr "Jerarquía de ubicaciones"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location meter"
msgstr "Medidor de la ubicación"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location meters"
msgstr "Medidores de la ubicación"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location specification"
msgstr "Especificación de la ubicación"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location specifications"
msgstr "Especificaciones de la ubicación"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Location system"
msgstr "Sistema de ubicaciones"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location systems"
msgstr "Sistemas de ubicación"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Location type"
msgstr "Tipo de ubicación"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Lock\n"
"#"
msgstr ""
"Cand.\n"
"#"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Lock box #"
msgstr "N.º de caja de bloqueo"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOCK BOX #"
msgstr "N.º CAJA DE BLOQUEO"

#: src/features/auth/vendors/LoginPage.tsx
msgid "Log In"
msgstr "Iniciar sesión"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Log out"
msgstr "Cerrar sesión"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Log type"
msgstr "Tipo de registro"

#: src/features/navbar/navConfig.ts
msgid "Logbook"
msgstr "Bitácora"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "Logic Diagram"
msgstr "Diagrama lógico"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Logic Diagram (I&C)"
msgstr "Diagrama lógico (I&C)"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Long range — the recompute can take tens of seconds."
msgstr "Rango largo — el nuevo cálculo puede tardar decenas de segundos."

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Long-term history"
msgstr "Historial a largo plazo"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Longest gap"
msgstr "Brecha más larga"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Longitudinal Critical Thickness Profile"
msgstr "Perfil crítico de espesor longitudinal"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "look back"
msgstr "retrospección"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looked inside a drawing"
msgstr "Se consultó el interior de un plano"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looked inside a drawing for {query}"
msgstr "Se consultó el interior de un plano para buscar {query}"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "Looking for the nearest data…"
msgstr "Buscando los datos más cercanos…"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looking inside a drawing"
msgstr "Consultando el interior de un plano"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Looking inside a drawing for {query}"
msgstr "Consultando el interior de un plano para buscar {query}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Looking up this document…"
msgstr "Buscando este documento…"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Looks right"
msgstr "Se ve bien"

#: src/features/chatbot/contexts/ChatbotDataLayer.tsx
msgid "Lost connection to the assistant. The response may still finish in the background — reload the conversation to check."
msgstr "Se perdió la conexión con el asistente. Es posible que la respuesta se complete en segundo plano — recargue la conversación para verificarlo."

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Lot number"
msgstr "Número de lote"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "LOTO"
msgstr "LOTO"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "LOTO {lotoIndex} · {reportName}"
msgstr "LOTO {lotoIndex} · {reportName}"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "LOTO index #"
msgstr "N.º de índice LOTO"

#: src/features/lotoReports/components/LotoReportTableRow.tsx
msgid "LOTO index # {lotoIndex}"
msgstr "N.º de índice LOTO {lotoIndex}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOTO NDEX #:"
msgstr "N.º ÍNDICE LOTO:"

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "LOTO panel"
msgstr "Panel LOTO"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "LOTO report"
msgstr "Informe LOTO"

#: src/features/lotoReports/components/LotoBackToListLink.tsx
#: src/features/lotoReports/components/LotoReportsList.tsx
#: src/features/lotoReports/useLotoReportWorkspaceTab.ts
#: src/features/navbar/navConfig.ts
msgid "LOTO reports"
msgstr "Informes LOTO"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "LOTO requestor"
msgstr "Solicitante del LOTO"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "LOTO REQUESTOR:"
msgstr "SOLICITANTE DE LOTO:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Low"
msgstr "Baja"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionFindingActions.tsx
msgid "Low area {index} · minimum reading"
msgstr "Zona de bajo espesor {index} · lectura mínima"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Low clip quantile"
msgstr "Cuantil de recorte inferior"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Lower"
msgstr "Inferior"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Lower Low"
msgstr "Inferior bajo"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Lower Low:"
msgstr "Inferior bajo:"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Lower:"
msgstr "Inferior:"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "LTA visualization unavailable"
msgstr "Visualización LTA no disponible"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "M&D agent chat"
msgstr "Chat del agente de M&D"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "M&D case is missing required fields"
msgstr "Al caso de M&D le faltan campos obligatorios"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "MAE/scale"
msgstr "MAE/escala"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Maintenance, repair, and troubleshooting"
msgstr "Mantenimiento, reparación y resolución de problemas"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Major subsystems"
msgstr "Subsistemas principales"

#: src/features/fim/photos/PhotoHeroAction.tsx
msgid "Make hero"
msgstr "Hacer principal"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Manage"
msgstr "Administrar"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Manage Access"
msgstr "Administrar acceso"

#: src/pages/homepage/constants.ts
msgid "Manage Capital Expenditure alongside the health of the assets and systems at your site."
msgstr "Administre los gastos de capital junto con el estado de los activos y sistemas de su sitio."

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Extensions"
msgstr "Administrar extensiones"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Manage Notifications"
msgstr "Administrar notificaciones"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Permissions"
msgstr "Administrar permisos"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Manage Site Access"
msgstr "Gestionar acceso al sitio"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Manage Users"
msgstr "Administrar usuarios"

#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Manage views"
msgstr "Administrar vistas"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Manual"
msgstr "Manual"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "Manual labels"
msgstr "Etiquetas manuales"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Manual needed · Unit: <0/>"
msgstr "Se necesita manual · Unidad: <0/>"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Manual phase shift (periods) per driver:"
msgstr "Desfase manual (períodos) por variable predictora:"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Manual request"
msgstr "Solicitud de manual"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Manufacturer"
msgstr "Fabricante"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Manufacturer and Model Unknown"
msgstr "Fabricante y modelo desconocidos"

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Mark all as read"
msgstr "Marcar todo como leído"

#: src/pages/alerts/AlertDetails.tsx
msgid "Mark as acknowledged"
msgstr "Marcar como reconocido"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Mark as read"
msgstr "Marcar como leído"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Mark as unread"
msgstr "Marcar como no leído"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "masks"
msgstr "máscaras"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Match"
msgstr "Coincidencia"

#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Match tags on name AND description, or either (OR)"
msgstr "Hacer coincidir las etiquetas por nombre Y descripción, o por cualquiera de los dos (O)"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Matched"
msgstr "Coincidente"

#: src/features/fimReview/provenance.ts
msgid "Matched by tag rules"
msgstr "Coincide según las reglas de etiquetas"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Matched in system"
msgstr "Coincide en el sistema"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Matches"
msgstr "Coincidencias"

#: src/features/powerCustomerUploads/state/powerCustomerUploadApprovalResponseMapping.ts
#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadApprovalPipeline.ts
msgid "Matches content already on this site."
msgstr "Coincide con contenido que ya existe en este sitio."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Matches: {matchedLabel}"
msgstr "Coincidencias: {matchedLabel}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Material and product conformance certificates"
msgstr "Certificados de conformidad de materiales y productos"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material availability"
msgstr "Disponibilidad de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material availability status on work orders"
msgstr "Estado de disponibilidad de materiales en las órdenes de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Material availability updated"
msgstr "Actualización de disponibilidad de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Material cost"
msgstr "Costo de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Material usage line"
msgstr "Línea de uso de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Material usage lines"
msgstr "Líneas de uso de materiales"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Materials"
msgstr "Materiales"

#: src/features/dataFilter/rangeFilter/RangeInputs.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/NumberFilter.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Max"
msgstr "Máx."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Max consecutive empty bins a driver may forward-fill before staying NaN. Default 2 (= 20 min at 10 min). Target is never forward-filled. Remaining holes become MLP missingness masks / kNN partial distance."
msgstr "Cantidad máxima de intervalos vacíos consecutivos que una variable predictora puede completar hacia adelante antes de permanecer como NaN. El valor predeterminado es 2 (= 20 min con 10 min). El objetivo nunca se completa hacia adelante. Los huecos restantes se convierten en máscaras de datos faltantes de MLP / distancia parcial de kNN."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Max Decibel"
msgstr "Decibel máximo"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Max iterations"
msgstr "Iteraciones máx."

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Max shift (periods)"
msgstr "Desfase máx. (períodos)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Max Temperature"
msgstr "Temperatura máxima"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Max training iterations for the MLP (with early stopping). Raise if you see under-fitting; lower for faster experiments."
msgstr "Cantidad máxima de iteraciones de entrenamiento para el MLP (con detención temprana). Auméntela si observa un ajuste insuficiente; redúzcala para acelerar los experimentos."

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Max Y"
msgstr "Y máx."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Max zoom"
msgstr "Zoom máx."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Max zoom reached"
msgstr "Se alcanzó el zoom máximo"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Max:"
msgstr "Máx.:"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Max: {acousticMax} dB, Avg: {acousticAvg} dB"
msgstr "Máx.: {acousticMax} dB, prom.: {acousticAvg} dB"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Max: {irMax}°F, Avg: {irAvg}°F"
msgstr "Máx.: {irMax}°F, prom.: {irAvg}°F"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "Maximize"
msgstr "Maximizar"

#: src/features/workbench/WorkbenchDock.tsx
msgid "Maximize panel"
msgstr "Maximizar panel"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Maximo field references"
msgstr "Referencias de los campos de Maximo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Maximo organization"
msgstr "Organización de Maximo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Maximo site"
msgstr "Sitio de Maximo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Maximum"
msgstr "Máximo"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Maximum color threshold"
msgstr "Umbral máximo de color"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Maximum Decibel (dB)"
msgstr "Decibel máximo (dB)"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Maximum historical rows kept in the kNN library. 0 keeps every eligible training row. A smaller library scores faster and uses less memory, but may lose coverage of uncommon operating conditions."
msgstr "Cantidad máxima de filas históricas conservadas en la biblioteca kNN. 0 conserva todas las filas de entrenamiento elegibles. Una biblioteca más pequeña puntúa más rápido y usa menos memoria, pero puede perder cobertura de condiciones operativas poco comunes."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Maximum level"
msgstr "Nivel máximo"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Maximum readings"
msgstr "Lecturas máximas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Maximum Temperature (°F)"
msgstr "Temperatura máxima (°F)"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Maximum value"
msgstr "Valor máximo"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "May be missing"
msgstr "Puede faltar"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Mean"
msgstr "Media"

#: src/features/fimReview/ReviewActions.tsx
msgid "Meaningless subject input removed."
msgstr "Se eliminó una entrada de sujeto sin significado."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Measure"
msgstr "Medida"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Measure and Annotate"
msgstr "Medir y anotar"

#: src/pages/alerts/AlertDetails.tsx
msgid "Measured at alert"
msgstr "Medido al generarse la alerta"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Measurements"
msgstr "Mediciones"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Mechanical component sizing and design analysis"
msgstr "Análisis de dimensionamiento y diseño de componentes mecánicos"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Med"
msgstr "Media"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "median gap"
msgstr "brecha mediana"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "median lead "
msgstr "adelanto mediano "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Medium"
msgstr "Media"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Member"
msgstr "Miembro"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "Mention User"
msgstr "Mencionar usuario"

#: src/features/navbar/Homebar.tsx
msgid "Menu"
msgstr "Menú"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge {label} with existing Subject"
msgstr "Combinar {label} con un sujeto existente"

#: src/features/fimReview/ReviewActions.tsx
msgid "Merge target"
msgstr "Destino de la combinación"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge this Subject into an existing Subject"
msgstr "Combinar este sujeto con un sujeto existente"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge with Subject"
msgstr "Combinar con sujeto"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Merge with: {name}"
msgstr "Combinar con: {name}"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Merged"
msgstr "Combinado"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Merged Subjects"
msgstr "Sujetos combinados"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Metadata evaluation rates"
msgstr "Porcentajes de evaluación de metadatos"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Metadata for Chart"
msgstr "Metadatos del gráfico"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
#: src/pages/evaluations/metadata/labeling/DataLabelingPage.tsx
msgid "Metadata Labeling"
msgstr "Etiquetado de metadatos"

#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
msgid "Metadata scope"
msgstr "Alcance de los metadatos"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Metal loss"
msgstr "Pérdida de metal"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Meter"
msgstr "Medidor"

#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/experiment/NormalizationViewer.tsx
#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Method"
msgstr "Método"

#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
msgid "Methods"
msgstr "Métodos"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Metric"
msgstr "Métrica"

#: src/pages/metrics/Metrics.tsx
msgid "Metrics"
msgstr "Métricas"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Metrics by split role"
msgstr "Métricas por función de partición"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Metrics on the {option} rows"
msgstr "Métricas en las filas de {option}"

#: src/pages/metrics/Metrics.tsx
msgid "Metrics unavailable: {error}"
msgstr "Métricas no disponibles: {error}"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Middle color threshold"
msgstr "Umbral de color intermedio"

#: src/features/dataFilter/rangeFilter/RangeInputs.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/NumberFilter.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Min"
msgstr "Mín"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Min usable / train rows"
msgstr "Filas utilizables / de entrenamiento mín."

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Min Y"
msgstr "Y mín."

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Min:"
msgstr "Mín.:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Minimal"
msgstr "Mínimo"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/DocumentMinimap.tsx
msgid "minimap"
msgstr "minimapa"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/DocumentMinimap.tsx
msgid "minimap page {pageNumber}"
msgstr "página del minimapa {pageNumber}"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Minimize"
msgstr "Minimizar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "Minimum"
msgstr "Mínimo"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Minimum color threshold"
msgstr "Umbral mínimo de color"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Minimum level"
msgstr "Nivel mínimo"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Minimum readings"
msgstr "Lecturas mínimas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Minimum required thickness"
msgstr "Espesor mínimo requerido"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Minimum Thickness"
msgstr "Espesor mínimo"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Minimum value"
msgstr "Valor mínimo"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Minor inconvenience — prioritize accordingly."
msgstr "Inconveniente menor — priorice en consecuencia."

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Minutes"
msgstr "Minutos"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Mismatch"
msgstr "Discrepancia"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Mismatches"
msgstr "Discrepancias"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "missing"
msgstr "faltantes"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Missing"
msgstr "Faltante"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Missing %"
msgstr "% faltante"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Missing count unknown"
msgstr "Cantidad faltante desconocida"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Missing revision"
msgstr "Revisión faltante"

#: src/pages/site/components/CustomFieldInfoModal.tsx
msgid "Missing site information"
msgstr "Falta información del sitio"

#: src/features/knowledgeDocumentViewer/utils/resolveMetadataUserEditSaveContext.ts
msgid "Missing site or organization for edit"
msgstr "Falta el sitio o la organización para editar"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "Missing type"
msgstr "Falta el tipo"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Missing: {missingStoreLabels}"
msgstr "Faltan: {missingStoreLabels}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "mixed (cyan→red tail split)"
msgstr "mixto (división de cola cian→rojo)"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — current drivers"
msgstr "MLP — variables predictoras actuales"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — driver + target history"
msgstr "MLP — historial de variables predictoras + objetivo"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "MLP — driver history"
msgstr "MLP — historial de variables predictoras"

#: src/features/sentinels/methodLabels.ts
msgid "MLP (no drivers)"
msgstr "MLP (sin variables predictoras)"

#: src/features/sentinels/methodLabels.ts
msgid "MLP + drivers"
msgstr "MLP + variables predictoras"

#: src/features/sentinels/methodLabels.ts
msgid "MLP + drivers + own history"
msgstr "MLP + variables predictoras + historial propio"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "MLP hidden sizes"
msgstr "Neuronas por capa oculta (MLP)"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "MLP loss curve ({iterations} iters)"
msgstr "Curva de pérdida MLP ({iterations} iteraciones)"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "MLP max iter"
msgstr "Iter. máx. de MLP"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP that predicts the target from current driver values only — no lags or rolling history. Fast baseline; ignores dynamics."
msgstr "MLP que predice el objetivo solo a partir de los valores actuales de las variables predictoras, sin rezagos ni historial móvil. Línea base rápida; ignora la dinámica."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP with current drivers plus driver lags and rolling means. Captures delayed physical responses without looking at past target."
msgstr "MLP con variables predictoras actuales más rezagos de variables predictoras y medias móviles. Captura respuestas físicas retardadas sin consultar el objetivo anterior."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "MLP with driver history plus prior target history. Often lowest error, but can mask gradual target degradation. Requires Self history on."
msgstr "MLP con historial de variables predictoras más historial previo del objetivo. Suele producir el menor error, pero puede ocultar la degradación gradual del objetivo. Requiere activar Historial propio."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_driver — + driver history"
msgstr "mlp_driver — + historial de variables predictoras"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_driver_own — + self history"
msgstr "mlp_driver_own — + historial propio"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "mlp_none — current drivers"
msgstr "mlp_none — variables predictoras actuales"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
msgid "Mode"
msgstr "Modo"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "model"
msgstr "modelo"

#: src/features/facilityModel/columns.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Model"
msgstr "Modelo"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Model {tagName} instead"
msgstr "Modelar {tagName} en su lugar"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Model builder mode"
msgstr "Modo de creación de modelos"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Model calibrated"
msgstr "Modelo calibrado"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "model configuration"
msgstr "configuración del modelo"

#: src/pages/processData/components/WorkbenchBody.tsx
msgid "Model configuration"
msgstr "Configuración del modelo"

#: src/pages/alerts/AlertDetails.tsx
msgid "Model expected at alert"
msgstr "Valor esperado del modelo al generarse la alerta"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "model health"
msgstr "estado del modelo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Model knobs"
msgstr "Controles del modelo"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Model lifecycle"
msgstr "Ciclo de vida del modelo"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "model name"
msgstr "nombre del modelo"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Model name"
msgstr "Nombre del modelo"

#: src/features/navbar/navConfig.ts
msgid "Model Operations"
msgstr "Operaciones de modelos"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "model output"
msgstr "salida del modelo"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Model quality: MAE "
msgstr "Calidad del modelo: MAE "

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "model saved"
msgstr "modelo guardado"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Model settings"
msgstr "Configuración del modelo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Model Studio"
msgstr "Model Studio"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Model this tag instead"
msgstr "Modelar esta etiqueta en su lugar"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Model type"
msgstr "Tipo de modelo"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Modeling tags"
msgstr "Etiquetas de modelado"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplot.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/WorkbenchChartArea.tsx
msgid "Models"
msgstr "Modelos"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Models of this target"
msgstr "Modelos de este objetivo"

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Modifier"
msgstr "Modificador"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "MoM Growth"
msgstr "Crecimiento mensual"

#: src/features/sentinels/components/DesignRunDetails.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Monitor"
msgstr "Monitor"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Monitor {ordinal}"
msgstr "Monitor {ordinal}"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Monitor and track sensor anomalies and analyze their root cause analyses."
msgstr "Monitoree y rastree anomalías de sensores y analice sus análisis de causa raíz."

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Monitor name"
msgstr "Nombre del monitor"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
#: src/features/mdCases/components/MonitorProvenanceModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Monitor Provenance"
msgstr "Procedencia del monitor"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitor settings are read-only for your role. The monitoring state above reflects the current configuration."
msgstr "Los ajustes del monitor son de solo lectura para su rol. El estado de monitoreo anterior refleja la configuración actual."

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Monitor signal"
msgstr "Señal del monitor"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Monitor specs ({monitorSpecCount})"
msgstr "Especificaciones del monitor ({monitorSpecCount})"

#: src/features/sentinels/components/SentinelAssetPanel.tsx
msgid "Monitored equipment"
msgstr "Equipo monitoreado"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Monitoring"
msgstr "Monitoreo"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Monitoring enabled"
msgstr "Monitoreo habilitado"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitoring every {cadenceMinutes} min"
msgstr "Monitoreo cada {cadenceMinutes} min"

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Monitoring off"
msgstr "Monitoreo desactivado"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Month"
msgstr "Mes"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Monthly analysis"
msgstr "Análisis mensual"

#: src/designSystem/components/RecordHeader.tsx
#: src/features/embeddedSidebar/components/EmbeddedSidebarMoreFeaturesMenu.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "More"
msgstr "Más"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "More actions for {sessionTitle}"
msgstr "Más acciones para {sessionTitle}"

#: src/features/embeddedSidebar/components/EmbeddedSidebarMoreFeaturesMenu.tsx
msgid "More features"
msgstr "Más funciones"

#: src/designSystem/components/Pagination.tsx
msgid "More pages"
msgstr "Más páginas"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "More references to {subjectName} exist on {pageCount, plural, one {page} other {pages}} {pageList}"
msgstr "Existen más referencias a {subjectName} en {pageCount, plural, one {la página} other {las páginas}} {pageList}"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "More save options"
msgstr "Más opciones de guardado"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "More than one window is allowed and often better — if the first period already contains degradation, the model learns the degradation as normal. A second healthy window elsewhere is the check on that. The baseline is shaded on the chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."
msgstr "Se permite más de una ventana y a menudo es mejor: si el primer período ya contiene degradación, el modelo aprende esa degradación como normal. Una segunda ventana saludable en otro lugar sirve para comprobarlo. La línea base aparece sombreada en el gráfico siempre que se dibuja este modelo, para que pueda ver con qué se ajustó en vez de confiar ciegamente en estas fechas."

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Move all your archived chats for this site back to Recent chats. Open tabs and unsent drafts will stay. You can archive these chats again later."
msgstr "Mueve todos tus chats archivados de este sitio a Chats recientes. Se conservarán las pestañas abiertas y los borradores sin enviar. Puedes volver a archivar estos chats más adelante."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Move Around the Chart"
msgstr "Desplazarse por el gráfico"

#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Move to left axis"
msgstr "Mover al eje izquierdo"

#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Move to right axis"
msgstr "Mover al eje derecho"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Move your recent chats for this site to Archived chats and close their open tabs. Pinned chats, running replies, and chats with unsent drafts will stay. You can restore archived chats later."
msgstr "Mueve tus chats recientes de este sitio a Chats archivados y cierra sus pestañas abiertas. Se conservarán los chats fijados, las respuestas en curso y los chats con borradores sin enviar. Puedes restaurar los chats archivados más adelante."

#: src/features/timeSeries/components/YAxisModeSection.tsx
msgid "Multi"
msgstr "Múltiple"

#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Multi Y-Scale"
msgstr "Escala Y múltiple"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Multicall"
msgstr "Multillamada"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Multiplier on err_scale for the shaded ±band. Production uses 2. Higher = wider band (fewer “out of band” points); lower = tighter. Judge with Band coverage on the test/val metrics."
msgstr "Multiplicador de err_scale para la banda sombreada ±. Producción usa 2. Mayor = banda más ancha (menos puntos «fuera de banda»); menor = más ajustada. Evalúelo con Cobertura de banda en las métricas de prueba/validación."

#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
msgid "Multivariate linear regression prediction: {value816_79}"
msgstr "Predicción de regresión lineal multivariante: {value816_79}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Must not state"
msgstr "No debe indicar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Must state"
msgstr "Debe indicar"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "mw from generator exciter"
msgstr "MW del excitador del generador"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "n_valid={value127_55}"
msgstr "n_valid={value127_55}"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/context/AssetLensContext.tsx
#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "N/A"
msgstr "N/D"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_confinedspace"
msgstr "naes_confinedspace"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_crane"
msgstr "naes_crane"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_environmental"
msgstr "naes_environmental"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_insulation"
msgstr "naes_insulation"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_loto"
msgstr "naes_loto"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_lotoid"
msgstr "naes_lotoid"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_moc"
msgstr "naes_moc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_nde"
msgstr "naes_nde"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_nerc"
msgstr "naes_nerc"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outage"
msgstr "naes_outage"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outagedur"
msgstr "naes_outagedur"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outagetype"
msgstr "naes_outagetype"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_outageyear"
msgstr "naes_outageyear"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_projectid"
msgstr "naes_projectid"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_pwht"
msgstr "naes_pwht"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_safety"
msgstr "naes_safety"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_scaffolding"
msgstr "naes_scaffolding"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "naes_welding"
msgstr "naes_welding"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
msgid "Name"
msgstr "Nombre"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Name (e.g., Power Output)"
msgstr "Nombre (p. ej., potencia de salida)"

#: src/features/fimReview/DecisionHistory.tsx
msgid "name → {canonicalName}"
msgstr "nombre → {canonicalName}"

#: src/features/fim/assetInventory.ts
msgid "Name A–Z"
msgstr "Nombre A–Z"

#: src/features/modelOperations/templates/templateModel.ts
msgid "Name is required."
msgstr "El nombre es obligatorio."

#: src/features/modelOperations/templates/templateModel.ts
msgid "Name needs at least one letter or number."
msgstr "El nombre debe contener al menos una letra o un número."

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Name the report. You can fill in the record sheet details next."
msgstr "Asigne un nombre al informe. Luego podrá completar los datos de la hoja de registro."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Name the role and pick a tag first"
msgstr "Primero asigne un nombre a la función y elija una etiqueta"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Name this chart"
msgstr "Nombre este gráfico"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Name this model"
msgstr "Nombre este modelo"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "Name this view"
msgstr "Nombre esta vista"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
#: src/features/richText/nodes/MentionNode.tsx
msgid "Name:"
msgstr "Nombre:"

#: src/features/richText/components/slashCommandCards/ChartSlashCommandCard.tsx
msgid "Name: {chartName}"
msgstr "Nombre: {chartName}"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Name: {systemName}"
msgstr "Nombre: {systemName}"

#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
msgid "Name: {unitName}"
msgstr "Nombre: {unitName}"

#: src/pages/manageAccess/components/invite/EmailChipsInput.tsx
msgid "name@company.com"
msgstr "nombre@empresa.com"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Native spacing"
msgstr "Espaciado nativo"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Navigate"
msgstr "Navegar"

#: src/features/breadcrumbBar/BreadcrumbBar.tsx
msgid "Navigate back to {lastPage}"
msgstr "Volver a {lastPage}"

#: src/pages/details/visualization/alerts/specificAlerts/ConduitPipelineAlert.tsx
msgid "Navigate to Data Ops to view more details"
msgstr "Vaya a Operaciones de datos para ver más detalles"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Navigate to linked document"
msgstr "Ir al documento vinculado"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Navigation"
msgstr "Navegación"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Nearest historical driver snapshots vote on the expected value."
msgstr "Las instantáneas históricas más cercanas de las variables predictoras determinan el valor esperado por votación."

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Needs revalidation"
msgstr "Necesita revalidación"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Needs review"
msgstr "Necesita revisión"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Needs Review"
msgstr "Necesita revisión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Needs-review count unknown (not counted as missing)"
msgstr "Cantidad por revisar desconocida (no se cuenta como faltante)"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Negative correlation"
msgstr "Correlación negativa"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Neighbor ys (nearest→)"
msgstr "Valores y de vecinos (más cercano→)"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Neighbors (k)"
msgstr "Vecinos (k)"

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "Nested ZIP archives exceed the 1 GiB expansion limit. Select smaller archives."
msgstr "Los archivos ZIP anidados superan el límite de expansión de 1 GiB. Selecciona archivos más pequeños."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Neurons per hidden layer of the MLP, e.g. 64,32. Larger nets fit more nonlinear structure but overfit faster and train slower."
msgstr "Neuronas por capa oculta del MLP, p. ej., 64,32. Las redes mayores ajustan estructuras más no lineales, pero sobreajustan antes y entrenan más lentamente."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "New"
msgstr "Nuevo"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "New Alert"
msgstr "Alerta nueva"

#: src/pages/cases/components/CasesTable.tsx
msgid "New Case"
msgstr "Caso nuevo"

#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
msgid "New chat"
msgstr "Chat nuevo"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/chatbot/components/SessionTabs.tsx
msgid "New Chat"
msgstr "Nuevo chat"

#: src/features/chatbot/components/SessionHeaderBar.tsx
#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "New conversation"
msgstr "Nueva conversación"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "New derived tag"
msgstr "Nueva etiqueta derivada"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "New label"
msgstr "Nueva etiqueta"

#: src/features/lotoReports/components/NewLotoReportDialog.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "New LOTO report"
msgstr "Nuevo informe LOTO"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "New LOTO report…"
msgstr "Nuevo informe LOTO…"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "new role"
msgstr "nuevo rol"

#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "New Search"
msgstr "Nueva búsqueda"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "New sentinel"
msgstr "Nuevo Sentinel"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
#: src/features/workspaceTabs/utils/getWorkspaceTabLabel.ts
msgid "New Tab"
msgstr "Nueva pestaña"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "New upload"
msgstr "Nueva carga"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "New Value"
msgstr "Nuevo valor"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
#: src/pages/processData/components/WorkbenchBody.tsx
msgid "New view"
msgstr "Nueva vista"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Newest first"
msgstr "Más recientes primero"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Newest First"
msgstr "Más recientes primero"

#: src/designSystem/components/Pagination.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Next"
msgstr "Siguiente"

#: src/pages/details/overlays/inspections/InspectionsListOverlay.tsx
msgid "Next inspections"
msgstr "Próximas inspecciones"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Next match"
msgstr "Siguiente coincidencia"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Next match (Enter)"
msgstr "Siguiente coincidencia (Enter)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Next page"
msgstr "Página siguiente"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
msgid "Next Page"
msgstr "Página siguiente"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation.tsx
msgid "Next page in queue"
msgstr "Siguiente página en la cola"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Next PM due"
msgstr "Próximo vencimiento de mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Next question"
msgstr "Pregunta siguiente"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Next reference"
msgstr "Referencia siguiente"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Next scheduled date"
msgstr "Próxima fecha programada"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Next search result"
msgstr "Siguiente resultado de búsqueda"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Next time period"
msgstr "Siguiente período"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Next:"
msgstr "Siguiente:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "NII assessment"
msgstr "Evaluación NII"

#: src/features/navbar/navConfig.ts
msgid "NII Dashboard"
msgstr "Panel NII"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "No"
msgstr "No"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "No acoustic images available for this asset."
msgstr "No hay imágenes acústicas disponibles para este activo."

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No active M&D cases match the current filters."
msgstr "Ningún caso de M&D activo coincide con los filtros actuales."

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No active M&D cases match the current filters. Switch to Archived or All to inspect closed work."
msgstr "Ningún caso de M&D activo coincide con los filtros actuales. Cambie a Archivados o Todos para revisar el trabajo cerrado."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "No active output"
msgstr "Sin resultados de la configuración activa"

#: src/pages/cases/activity/ActivityFeed.tsx
msgid "No activity yet"
msgstr "Aún no hay actividad"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "No Agent Response"
msgstr "Sin respuesta del agente"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No alerts for this site yet."
msgstr "Aún no hay alertas para este sitio."

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "No alerts linked to this case yet."
msgstr "Aún no hay alertas vinculadas a este caso."

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
msgid "No alerts raised by this sentinel yet."
msgstr "Este Sentinel todavía no ha generado alertas."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "No anomalies detected"
msgstr "No se detectaron anomalías"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "No anomaly labels touch "
msgstr "Ninguna etiqueta de anomalía toca "

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No archived M&D cases match the current filters."
msgstr "Ningún caso de M&D archivado coincide con los filtros actuales."

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "No archived notifications"
msgstr "No hay notificaciones archivadas"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No asset template exists for this Subject type yet."
msgstr "Aún no existe una plantilla de activo para este tipo de sujeto."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "No baseline window."
msgstr "No hay ventana de línea base."

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "No bin selected"
msgstr "No se seleccionó ningún intervalo"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "No case yet"
msgstr "Todavía no hay ningún caso"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "No cases yet — none of this sentinel's ticks breached."
msgstr "Todavía no hay casos: ninguna marca de este Sentinel superó el límite."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No chart yet — at least one threshold has value: <0>null</0> (source: <1>needed</1>). Stage 3 emits a SKIP-stub for this check (see _render_needed_skip_stub in stage3_generate.py), so the function exists in BQ but always returns SKIP and never asserts. Fill in the spec and regenerate to replace the stub with a real check + fixture."
msgstr "Aún no hay gráfico: al menos un umbral tiene el valor <0>null</0> (fuente: <1>needed</1>). La etapa 3 emite un stub SKIP para esta comprobación (consulte _render_needed_skip_stub en stage3_generate.py), por lo que la función existe en BQ, pero siempre devuelve SKIP y nunca realiza una aserción. Complete la especificación y vuelva a generar para reemplazar el stub con una comprobación y un fixture reales."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No chat messages persisted for this session yet."
msgstr "Aún no se han conservado mensajes de chat para esta sesión."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "No clear cross-reference target here. Try closer to a label or symbol."
msgstr "No hay un destino claro para la referencia cruzada aquí. Intenta más cerca de una etiqueta o un símbolo."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "No component configuration was provided; default forecast settings may apply."
msgstr "No se proporcionó una configuración del componente; pueden aplicarse los ajustes de pronóstico predeterminados."

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "No components found for this unit"
msgstr "No se encontraron componentes para esta unidad"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "No confirmed labels yet for this organization."
msgstr "Aún no hay etiquetas confirmadas para esta organización."

#: src/features/fimReview/InspectSources.tsx
msgid "No constituent source records."
msgstr "No hay registros de origen constituyentes."

#: src/features/richText/components/RichTextViewer.tsx
#: src/pages/cases/components/CaseCommentContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "No content"
msgstr "Sin contenido"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "No conversation id"
msgstr "Sin id de conversación"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "No conversations at this site yet. The one you start will be here for everyone."
msgstr "Aún no hay conversaciones en este sitio. La que inicie aparecerá aquí para todos."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/datapointValueCitations.ts
msgid "no data"
msgstr "sin datos"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
msgid "No data"
msgstr "No hay datos"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No data available"
msgstr "No hay datos disponibles"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "No data found near this range for the selected pens."
msgstr "No se encontraron datos cerca de este rango para los trazos seleccionados."

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "No data in selection"
msgstr "No hay datos en la selección"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/AllTagsTable.tsx
msgid "No data in the last 24 hours"
msgstr "No hay datos en las últimas 24 horas"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "No data in this range"
msgstr "No hay datos en este rango"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No datapoint ID associated with this alert"
msgstr "No hay un ID de punto de datos asociado con esta alerta"

#: src/features/fimEvidence/ProcessDataPanel.tsx
msgid "No datastream on the chart — add one from the details panel."
msgstr "No hay ningún flujo de datos en el gráfico; agregue uno desde el panel de detalles."

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "No denoise ops in this plan."
msgstr "Este plan no contiene operaciones de eliminación de ruido."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionDetailChangeList.tsx
msgid "No detailed changes"
msgstr "Sin cambios detallados"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "No diagnosis text."
msgstr "No hay texto de diagnóstico."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
msgid "No disagreements match these filters."
msgstr "Ningún desacuerdo coincide con estos filtros."

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataContent.tsx
msgid "No document details"
msgstr "Sin detalles del documento"

#: src/features/knowledgeDocumentViewer/components/DocumentTabContent.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "No document found for “{referenceLabel}”"
msgstr "No se encontró ningún documento para “{referenceLabel}”"

#: src/features/knowledgeDocumentViewer/artifacts/useArtifact.ts
msgid "No document is loaded."
msgstr "No hay ningún documento cargado."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No document with this id on this site."
msgstr "No hay ningún documento con este id en este sitio."

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "no documents"
msgstr "sin documentos"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "No documents available for this asset"
msgstr "No hay documentos disponibles para este activo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No documents cited"
msgstr "Ningún documento citado"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "No documents found"
msgstr "No se encontraron documentos"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "No documents match the current filters"
msgstr "Ningún documento coincide con los filtros actuales"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "No documents match your search"
msgstr "Ningún documento coincide con su búsqueda"

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "No documents reference this subject."
msgstr "Ningún documento hace referencia a este sujeto."

#: src/features/knowledgeDocumentViewer/components/sidebar/GraphNodePanel.tsx
msgid "No documents show this node."
msgstr "Ningún documento muestra este nodo."

#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
msgid "No documents yet"
msgstr "Aún no hay documentos"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "No drawings show this equipment."
msgstr "Ningún plano muestra este equipo."

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "No drivers — the fit cannot run without at least one."
msgstr "No hay variables predictoras; el ajuste no puede ejecutarse sin al menos una."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No drivers recorded for this sentinel."
msgstr "No hay variables predictoras registradas para este Sentinel."

#: src/features/richText/editorPlugins/SlashCommandPlugin.tsx
msgid "No entries found"
msgstr "No se encontraron entradas"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No equipment Subjects in the published run."
msgstr "No hay sujetos de equipo en la ejecución publicada."

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "No equipment targeted yet."
msgstr "Aún no hay equipos objetivo."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "No files"
msgstr "No hay archivos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "No files found. Choose a folder with files or select files to upload."
msgstr "No se encontraron archivos. Elija una carpeta con archivos o seleccione archivos para cargar."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "No files found. Drop files or folders, or use Browse to select them."
msgstr "No se encontraron archivos. Suelte archivos o carpetas, o use los botones de búsqueda para seleccionarlos."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "No files in this upload request"
msgstr "No hay archivos en esta solicitud de carga"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPage.tsx
msgid "No files staged"
msgstr "No hay archivos preparados"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "no fill"
msgstr "sin completado"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "No filled asset instance on this site yet. Fill one from the Assets tab first — a sentinel is designed from the fill's bound tags."
msgstr "Todavía no hay ninguna instancia de activo completada en este sitio. Complete una desde la pestaña Activos primero; un Sentinel se diseña a partir de las etiquetas vinculadas del completado."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No fixture found for check \"{nodeName}\" in the {unitSlug} bundle. The bundle exists but the check wasn’t included in the most recent fixture compile."
msgstr "No se encontró un fixture para la comprobación \"{nodeName}\" en el paquete {unitSlug}. El paquete existe, pero la comprobación no se incluyó en la compilación de fixtures más reciente."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "No graph overlays on this page."
msgstr "No hay superposiciones del grafo en esta página."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "no historian tag"
msgstr "sin etiqueta del historiador"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No historian tags are linked to this Subject."
msgstr "No hay etiquetas del historiador vinculadas a este sujeto."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "No history yet — this model has only been saved once. Editing a knob and applying it will push the current settings here."
msgstr "Todavía no hay historial; este modelo solo se ha guardado una vez. Si edita un control y lo aplica, la configuración actual aparecerá aquí."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
msgid "No image available"
msgstr "No hay imagen disponible"

#: src/pages/details/extensions/flow/ImageryExtension.tsx
msgid "No image available at "
msgstr "No hay ninguna imagen disponible en "

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "No inline preview — open in a tab."
msgstr "No hay vista previa en línea; ábralo en una pestaña."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No instrument Subjects in the published run."
msgstr "No hay sujetos de instrumentos en la ejecución publicada."

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No investigation notes yet."
msgstr "Aún no hay notas de investigación."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "No IR images available for this asset."
msgstr "No hay imágenes IR disponibles para este activo."

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "No isolation points yet."
msgstr "Aún no hay puntos de aislamiento."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "No labels at this site yet. Draw one with the label tool on the chart."
msgstr "Todavía no hay etiquetas en este sitio. Dibuje una con la herramienta de etiquetas del gráfico."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "No labels match these filters."
msgstr "Ninguna etiqueta coincide con estos filtros."

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "No linked alerts are attached to this case yet."
msgstr "Aún no hay alertas vinculadas adjuntas a este caso."

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "No linked signal for this group."
msgstr "No hay una señal vinculada para este grupo."

#: src/features/lotoReports/components/LotoReportsEmptyState.tsx
msgid "No LOTO reports yet"
msgstr "Aún no hay informes LOTO"

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No M&D cases match the current filters."
msgstr "Ningún caso de M&D coincide con los filtros actuales."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "No matched pages. Paste its document id or link above and enter a page number."
msgstr "No hay páginas coincidentes. Pegue su id o enlace de documento arriba e introduzca un número de página."

#: src/features/timeSeries/experiment/TagPicker.tsx
msgid "No matches"
msgstr "No hay coincidencias"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "No matches found"
msgstr "No se encontraron coincidencias"

#: src/pages/metrics/components/FilterPopover.tsx
msgid "No matches."
msgstr "Sin coincidencias."

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No matching organizations"
msgstr "No hay organizaciones coincidentes"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No matching sites"
msgstr "No hay sitios coincidentes"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "No matching Subjects."
msgstr "No hay sujetos coincidentes."

#: src/components/DateTimeWithTimezone.tsx
msgid "No matching timezones"
msgstr "No hay zonas horarias coincidentes"

#: src/pages/details/visualization/Visualization.tsx
msgid "No measurement data layer is currently displayed."
msgstr "Actualmente no se muestra ninguna capa de datos de medición."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "No missing revisions found in a complete audit."
msgstr "No se encontraron revisiones faltantes en una auditoría completa."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "No model yet. Ask the agent to build one in the Models panel — the parameters below fill in as it decides them."
msgstr "Todavía no hay ningún modelo. Pida al agente que cree uno en el panel Modelos; los parámetros siguientes se completarán a medida que los decida."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "No models match."
msgstr "Ningún modelo coincide."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "no models yet"
msgstr "aún no hay modelos"

#: src/features/knowledgeDocumentViewer/contexts/PageMetadataEvalSessionContext.tsx
msgid "No more pages in this queue"
msgstr "No hay más páginas en esta cola"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "No multi-component view configured for this unit. Please configure the asset model to enable visualization controls."
msgstr "No hay una vista multicomponente configurada para esta unidad. Configure el modelo de activo para habilitar los controles de visualización."

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "No notifications"
msgstr "Sin notificaciones"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "No notifications match your search"
msgstr "Ninguna notificación coincide con su búsqueda"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/usePhotoAnnotationSession.ts
msgid "No object was found at that point. Try clicking directly on an object."
msgstr "No se encontró ningún objeto en ese punto. Intente hacer clic directamente sobre el objeto."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "No one has access to this site yet."
msgstr "Aún nadie tiene acceso a este sitio."

#: src/pages/manageAccess/components/table/UsersSection.tsx
msgid "No one matches that search."
msgstr "Nadie coincide con la búsqueda."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No openable document for this reference"
msgstr "No hay un documento que se pueda abrir para esta referencia"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
msgid "No options"
msgstr "Sin opciones"

#: src/features/lotoReports/printReport/printPageText.ts
msgid "No P&ID markup for this page"
msgstr "No hay marcas de P&ID para esta página"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataContent.tsx
msgid "No page metadata for page {pageNum}"
msgstr "No hay metadatos para la página {pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewContent.tsx
msgid "No page summary"
msgstr "Sin resumen de página"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSummaryCards.tsx
msgid "No pages in this corpus"
msgstr "No hay páginas en este corpus"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionViewer.tsx
msgid "No pages in this queue"
msgstr "No hay páginas en esta cola"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "No pages match these filters."
msgstr "Ninguna página coincide con estos filtros."

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "No pages yet. Open a drawing in the document viewer and add its pages to this report."
msgstr "Aún no hay páginas. Abra un plano en el visor de documentos y agregue sus páginas a este informe."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "no parameter change"
msgstr "sin cambio de parámetros"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "No pens on the chart"
msgstr "No hay trazos en el gráfico"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No pens with data in the last 7 days."
msgstr "No hay trazos con datos de los últimos 7 días."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "No photos are attached to this Subject."
msgstr "No hay fotos adjuntas a este sujeto."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "No photos are attached to this Subject. Add one from the field or drop a file here."
msgstr "No hay fotos adjuntas a este sujeto. Agregue una desde el campo o suelte un archivo aquí."

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "no PI tags"
msgstr "sin etiquetas de PI"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "No pipeline configs found for this site."
msgstr "No se encontraron configuraciones de pipeline para este sitio."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "No points left the expected ± band for the selected method."
msgstr "Ningún punto salió de la banda esperada ± para el método seleccionado."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "No preview"
msgstr "Sin vista previa"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "No preview available"
msgstr "Vista previa no disponible"

#: src/features/chatbot/components/ChatHistoryDrawer.tsx
msgid "No previous conversations"
msgstr "No hay conversaciones anteriores"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No published fusion run for this site yet."
msgstr "Aún no hay una ejecución de fusión publicada para este sitio."

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No published recommendation"
msgstr "No hay una recomendación publicada"

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "No range or gate ops in this plan."
msgstr "Este plan no contiene operaciones de rango ni de compuerta."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "No ranges yet — set the date window above, then press “Reset to window”. Running with an empty list ignores the custom dates."
msgstr "Todavía no hay rangos; defina arriba la ventana de fechas y luego presione «Restablecer a la ventana». La ejecución con una lista vacía ignora las fechas personalizadas."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No real file behind this reference (entry {entryId}). The LLM may have hallucinated this citation."
msgstr "No hay un archivo real detrás de esta referencia (entrada {entryId}). Es posible que el LLM haya inventado esta cita."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "No recent activity"
msgstr "No hay actividad reciente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "No recent data"
msgstr "Sin datos recientes"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
msgid "No recent data available"
msgstr "No hay datos recientes disponibles"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "No recent searches"
msgstr "No hay búsquedas recientes"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "No recommendation draft yet."
msgstr "Aún no hay un borrador de recomendación."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "No recommended action provided."
msgstr "No se proporcionó ninguna acción recomendada."

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "No recorded events yet."
msgstr "Aún no hay eventos registrados."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
msgid "No recorded rows."
msgstr "No hay filas registradas."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "No recorded values."
msgstr "No hay valores registrados."

#: src/features/timeSeries/components/PenSubjectLinksSection.tsx
msgid "No referenced documents"
msgstr "No hay documentos referenciados"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "No references are attached to this case yet."
msgstr "Aún no hay referencias adjuntas a este caso."

#: src/features/fimReview/IdentityPanel.tsx
msgid "No references recorded for this alias."
msgstr "No hay referencias registradas para este alias."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "No related documents found for this region."
msgstr "No se encontraron documentos relacionados con esta zona."

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "no removals"
msgstr "sin eliminaciones"

#: src/features/chatbot/components/conversationMessage/ConversationMessage.tsx
msgid "No response from AI"
msgstr "Sin respuesta de la IA"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "No results"
msgstr "Sin resultados"

#: src/components/table/TableComponent.tsx
#: src/features/knowledgeDocumentViewer/components/table/GeckoPowerTable.tsx
msgid "No results."
msgstr "Sin resultados."

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "No reviewer comparisons yet"
msgstr "Aún no hay comparaciones de revisores"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "No revision diff available."
msgstr "No hay comparación de revisiones disponible."

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentMetadataUserEdit.ts
#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "No revision family members to save"
msgstr "No hay miembros de la familia de revisiones para guardar"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "no risk assessment or Gecko scan found"
msgstr "no se encontró una evaluación de riesgos ni un escaneo de Gecko"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "No saved experiments"
msgstr "No hay experimentos guardados"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "No saved models for this tag yet — “All” shows the whole shelf."
msgstr "Todavía no hay modelos guardados para esta etiqueta; «Todos» muestra toda la colección."

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "No saved models with weights yet — train and “Save trained model” first."
msgstr "Todavía no hay modelos guardados con pesos; entrene y luego seleccione «Guardar modelo entrenado»."

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "No saved models with weights yet — train, then “Save trained model”."
msgstr "Todavía no hay modelos guardados con pesos; entrene y luego seleccione «Guardar modelo entrenado»."

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "No saved models yet. Ask the agent to build one, then say “save it”."
msgstr "Aún no hay modelos guardados. Pida al agente que cree uno y luego diga “guárdelo”."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "No sensor issues detected"
msgstr "No se detectaron problemas en los sensores"

#: src/features/timeSeries/components/RegressionPrediction.tsx
#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "No sensors selected"
msgstr "No se seleccionaron sensores"

#: src/features/sentinels/components/SentinelList.tsx
msgid "No sentinels for this site yet. Runs from the sentinel backend appear here automatically."
msgstr "Todavía no hay Sentinels para este sitio. Las ejecuciones del backend de Sentinel aparecen aquí automáticamente."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No sentinels match “"
msgstr "Ningún Sentinel coincide con «"

#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "No sentinels on this site."
msgstr "No hay centinelas en este sitio."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "No sentinels yet. Press "
msgstr "Todavía no hay Sentinels. Presione "

#: src/pages/cases/md/mdCasesListHelpers.ts
msgid "No shelved M&D cases match the current filters."
msgstr "Ningún caso de M&D archivado temporalmente coincide con los filtros actuales."

#: src/pages/documents/PowerCustomerUploadRoutePage.tsx
#: src/pages/evaluations/metadata/labeling/DataLabelingPage.tsx
msgid "No site ID"
msgstr "Sin ID de sitio"

#: src/pages/homepage/Homepage.tsx
msgid "No site ID found"
msgstr "No se encontró el ID del sitio"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "No sites available"
msgstr "No hay sitios disponibles"

#: src/pages/noSites/NoSites.tsx
#: src/pages/noSites/NoSites.tsx
msgid "No Sites Found"
msgstr "No se encontraron sitios"

#: src/pages/metrics/components/ConversationExplorerCard.tsx
#: src/pages/metrics/Metrics.tsx
msgid "No sites in the current selection."
msgstr "No hay sitios en la selección actual."

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "No sites in this organization."
msgstr "No hay sitios en esta organización."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "No source asserts this Subject in the published run."
msgstr "Ninguna fuente confirma este sujeto en la ejecución publicada."

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/modelOperations/Corroboration.tsx
msgid "No source corroboration"
msgstr "Sin corroboración de fuentes"

#: src/pages/facilityModel/FacilityModelDataIssues.tsx
msgid "no Subject in the published run"
msgstr "ningún sujeto en la ejecución publicada"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects in the published run."
msgstr "No hay sujetos en la ejecución publicada."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects in this site have been promoted to Asset Instances yet."
msgstr "Aún no se ha promovido ningún sujeto de este sitio a instancia de activo."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "No Subjects match the current filters."
msgstr "Ningún sujeto coincide con los filtros actuales."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "no summary"
msgstr "sin resumen"

#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "No supported destination found."
msgstr "No se encontró un destino respaldado por la información disponible."

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "No synthetic fixture bundle for unit \"{unitSlug}\" yet — the explanation chart is generated downstream from a Constructor V3 fixture, and this unit hasn't been compiled into one."
msgstr "Aún no hay un paquete de fixtures sintéticos para la unidad \"{unitSlug}\"; el gráfico explicativo se genera posteriormente a partir de un fixture de Constructor V3 y esta unidad aún no se ha compilado en uno."

#: src/pages/systemView/components/UnitsTab.tsx
msgid "No tagged units yet."
msgstr "Aún no hay unidades etiquetadas."

#: src/features/timeSeries/components/panes/tagFilters.ts
msgid "No tags match."
msgstr "Ninguna etiqueta coincide."

#: src/features/timeSeries/components/DerivedValuesTab.tsx
msgid "No Tags Selected"
msgstr "No hay etiquetas seleccionadas"

#: src/features/facilityModel/views.ts
#: src/features/fim/assetInventory.ts
msgid "No template"
msgstr "Sin plantilla"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "No template-fill detail is available for this Asset Instance yet."
msgstr "Aún no hay detalles de llenado de plantilla disponibles para esta instancia de activo."

#: src/features/timeSeries/experiment/ResidualMiniPlot.tsx
msgid "No test rows in this split — nothing to residual-plot."
msgstr "No hay filas de prueba en esta partición para graficar residuos."

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
msgid "No thickness data is available inside this LTA region."
msgstr "No hay datos de espesor dentro de esta región LTA."

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "No time series data found for this alert in the specified time range"
msgstr "No se encontraron datos de series temporales para esta alerta en el intervalo especificado"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "No types"
msgstr "Ningún tipo"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "No types match"
msgstr "Ningún tipo coincide"

#: src/features/timeSeries/components/timeSeriesScatterplot/useChartInteractionFunctions.ts
#: src/features/timeSeries/hooks/useInterpolatedHover.ts
#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
#: src/features/timeSeries/hooks/useTimeSeriesUX.ts
#: src/pages/assetLens/AssetLens.tsx
msgid "No Unit"
msgstr "Sin unidad"

#: src/pages/assetLens/AssetLens.tsx
msgid "No Unit ID Provided"
msgstr "No se proporcionó el ID de la unidad"

#: src/pages/systemView/components/UnitsTab.tsx
msgid "No units match the current filters."
msgstr "Ninguna unidad coincide con los filtros actuales."

#: src/features/forecastNotifications/NotificationListPanel.tsx
#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "No unread notifications"
msgstr "No hay notificaciones sin leer"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "No upload history"
msgstr "No hay historial de cargas"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "No uploads match these filters"
msgstr "Ninguna carga coincide con estos filtros"

#: src/features/richText/editorPlugins/MentionPluginBase.tsx
msgid "No users found"
msgstr "No se encontraron usuarios"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "No users in the list. Search and add users above."
msgstr "No hay usuarios en la lista. Busque y agregue usuarios arriba."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "No values available"
msgstr "No hay valores disponibles"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "No vendors"
msgstr "Ningún proveedor"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "No vendors found"
msgstr "No se encontraron proveedores"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "No views match."
msgstr "Ninguna vista coincide."

#: src/features/timeSeries/components/DataLayersControl.tsx
msgid "No work orders available for this asset. Create work orders to see maintenance and inspection events on the timeline."
msgstr "No hay órdenes de trabajo disponibles para este activo. Cree órdenes de trabajo para ver los eventos de mantenimiento e inspección en la cronología."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "No work-log text in this imported record."
msgstr "Este registro importado no contiene notas de trabajo."

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Nominal"
msgstr "Nominal"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Nominal plates are read-only for EMAT inspections."
msgstr "Las placas nominales son de solo lectura en las inspecciones EMAT."

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Nominal Plates shown"
msgstr "Placas nominales mostradas"

#: src/features/facilityModel/columns.ts
msgid "Non-asset"
msgstr "No activo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Non-isometric piping and conduit arrangements"
msgstr "Disposiciones de tuberías y conductos no isométricas"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "none"
msgstr "ninguno"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
#: src/features/lotoReports/components/LotoEquipmentCoverage.tsx
#: src/features/lotoReports/components/LotoPointsCoverage.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "None"
msgstr "Ninguno"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "none (bare id)"
msgstr "ninguno (ID sin sufijo)"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "none selected"
msgstr "ninguno seleccionado"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "normal"
msgstr "normal"

#: src/pages/alerts/alertStatusLabel.ts
msgid "Normal"
msgstr "Normal"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Normalization"
msgstr "Normalización"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Normalization diagnostics"
msgstr "Diagnósticos de normalización"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize"
msgstr "Normalizar"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize against"
msgstr "Normalizar respecto de"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "normalize failed"
msgstr "falló la normalización"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Normalize the target against selected tags. Flatness = variance reduction (1 − var(normalized)/var(target)). Higher = more of the target's movement is explained by the selected tags. With N drivers, the chart shows the combined result plus one trace per driver."
msgstr "Normalice el objetivo respecto de las etiquetas seleccionadas. Planitud = reducción de varianza (1 − var(normalizado)/var(objetivo)). Cuanto mayor sea, más movimiento del objetivo explican las etiquetas seleccionadas. Con N variables predictoras, el gráfico muestra el resultado combinado y un trazo por variable predictora."

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Not Acknowledged"
msgstr "No reconocido"

#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Not an asset"
msgstr "No es un activo"

#: src/features/fimReview/InspectSources.tsx
msgid "Not connected"
msgstr "No conectado"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Not evaluated yet."
msgstr "Todavía no se evaluó."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "not fitted yet"
msgstr "todavía no se ajustó"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Not held out — these events were in the baseline, so the model was taught they were normal. Treat a miss here as uninformative."
msgstr "No se reservó; estos eventos estaban en la línea base, por lo que se enseñó al modelo que eran normales. Considere que una omisión aquí no aporta información."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Not matched"
msgstr "Sin coincidencia"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Not promoted"
msgstr "No promovido"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportView.tsx
msgid "Not recorded"
msgstr "No registrado"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "not saved"
msgstr "sin guardar"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Not saved yet"
msgstr "Todavía no se guardó"

#: src/features/fimReview/ReviewActions.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataCardGrid.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataFieldRow.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Not set"
msgstr "Sin definir"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Not supplied"
msgstr "No proporcionado"

#: src/features/facilityModel/columns.ts
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Not validated"
msgstr "No validado"

#: src/features/fimReview/ReviewActions.tsx
msgid "Note (optional)"
msgstr "Nota (opcional)"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Notes for the design agent"
msgstr "Notas para el agente de diseño"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Nothing is waiting for review."
msgstr "No hay nada pendiente de revisión."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Nothing masked."
msgstr "Nada enmascarado."

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Nothing plotted yet"
msgstr "Todavía no hay nada graficado"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/components/panes/PensPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Nothing plotted yet."
msgstr "Todavía no hay nada graficado."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Nothing saved yet — train, then Save to build your shelf."
msgstr "Todavía no se guardó nada; entrene y luego seleccione Guardar para crear su colección."

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/NotificationsDropdownSidebar.tsx
#: src/features/navbar/navConfig.ts
#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Notifications"
msgstr "Notificaciones"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Notifications ({total})"
msgstr "Notificaciones ({total})"

#: src/features/timeSeries/components/TimeRangeDisplay.tsx
#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Now"
msgstr "Ahora"

#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Now (refreshing every "
msgstr "Ahora (se actualiza cada "

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Number"
msgstr "Número"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Number of A-scans"
msgstr "Cantidad de barridos A"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Number of bins with data"
msgstr "Cantidad de intervalos con datos"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Numbered List"
msgstr "Lista numerada"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Numeric response"
msgstr "Respuesta numérica"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Numeric value"
msgstr "Valor numérico"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Observations, tests and service records"
msgstr "Observaciones, pruebas y registros de servicio"

#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Observed"
msgstr "Observado"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "OCR boxes"
msgstr "Cuadros OCR"

#: src/features/fimReview/DecisionHistory.tsx
msgid "OCR corrected"
msgstr "OCR corregido"

#: src/features/fimReview/IdentityPanel.tsx
msgid "OCR correction"
msgstr "Corrección de OCR"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/InspectSources.tsx
msgid "OCR variant"
msgstr "Variante de OCR"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "of |residual| on "
msgstr "de |residuo| en "

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "of last"
msgstr "del último"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
#: src/features/navbar/KeyboardShortcutsToggle.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "Off"
msgstr "Desactivado"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "off (prod default)"
msgstr "desactivado (valor predeterminado de prod.)"

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Off keeps every test row even where a gate fails, so held-out metrics see all operating regimes; gates then only drop train and val rows."
msgstr "Desactivado conserva todas las filas de prueba incluso cuando falla una compuerta, para que las métricas reservadas vean todos los regímenes operativos; las compuertas solo descartan filas de entrenamiento y validación."

#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
msgid "Off-page connector {offPageConnectorNumber}"
msgstr "Conector fuera de página {offPageConnectorNumber}"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Okay"
msgstr "Aceptable"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Oldest first"
msgstr "Más antiguos primero"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Oldest First"
msgstr "Más antiguos primero"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
#: src/features/navbar/KeyboardShortcutsToggle.tsx
#: src/pages/processData/buildMode/components/OnOffToggle.tsx
msgid "On"
msgstr "Activado"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "on chart"
msgstr "en el gráfico"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "on days"
msgstr "en días"

#: src/features/timeSeries/agentTab/chat/ToolCard.tsx
msgid "On the chart"
msgstr "En el gráfico"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "On this page"
msgstr "En esta página"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "One control on purpose: this is both what gets pulled from the historian and what one point on the chart means. The KPI and its expectation are both drawn at this resolution, and sigma is measured at it too — a finer bucket is noisier, so the band widens. Alert cadence counts buckets, so leave it at 1 day for long-term drift monitoring."
msgstr "Un solo control a propósito: esto define tanto lo que se obtiene del historiador como lo que significa un punto del gráfico. El KPI y su expectativa se dibujan con esta resolución, y sigma también se mide con ella; un intervalo más fino tiene más ruido, por lo que la banda se ensancha. La cadencia de alertas cuenta intervalos, así que déjela en 1 día para monitorear la deriva a largo plazo."

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "One row per modeled tag with its data quality at a glance. Expand a row to bound, clip, de-freeze, or gate that tag."
msgstr "Una fila por etiqueta modelada con su calidad de datos de un vistazo. Expanda una fila para limitar, recortar, descongelar o aplicar una compuerta a esa etiqueta."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "Only an admin can change another admin's user type."
msgstr "Solo un administrador puede cambiar el tipo de usuario de otro administrador."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Only one image available. Date: {singleImageDate}"
msgstr "Solo hay una imagen disponible. Fecha: {singleImageDate}"

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "Only one split Subject can merge into an existing Subject."
msgstr "Solo uno de los sujetos separados puede fusionarse con un sujeto existente."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Only past points, like a Sentinel target’s own history."
msgstr "Solo puntos anteriores, como el historial propio del objetivo de un Sentinel."

#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "Only show data points where conditions are met. Stability filters by coefficient of variance (CV)."
msgstr "Mostrar solo los puntos de datos donde se cumplan las condiciones. La estabilidad filtra por coeficiente de variación (CV)."

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Only show plate minimums ≥ 6” from welds"
msgstr "Mostrar solo mínimos de placa a ≥ 6” de las soldaduras"

#: src/pages/cases/components/CasesTable.tsx
msgid "Only visible to you"
msgstr "Solo visible para usted"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
#: src/features/mdCases/mdCaseDisplay.test.ts
#: src/features/mdCases/mdCaseDisplay.test.ts
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSiteRow.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
msgid "Open"
msgstr "Abrir"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgctxt "anomaly status"
msgid "Open"
msgstr "Abierta"

#: src/features/mdCases/mdCaseDisplay.ts
msgctxt "case status"
msgid "Open"
msgstr "Abierto"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgctxt "LOTO isolation position"
msgid "Open"
msgstr "Abierta"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgctxt "sensor issue status"
msgid "Open"
msgstr "Abierto"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "Open {displayTitle}"
msgstr "Abrir {displayTitle}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Open {docLabel}"
msgstr "Abrir {docLabel}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "Open {document} page {pageNumber}"
msgstr "Abrir {document}, página {pageNumber}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Open {documentName} page {pageNumber} in a new Cantilever tab"
msgstr "Abrir la página {pageNumber} de {documentName} en una pestaña nueva de Cantilever"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {entryLabel} description"
msgstr "Abrir la descripción de {entryLabel}"

#: src/pages/details/extensions/flow/filesExt/FileOpenNewTabButton.tsx
msgid "Open {fileName} in a new tab"
msgstr "Abrir {fileName} en una pestaña nueva"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {fmName}"
msgstr "Abrir {fmName}"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Open {label}"
msgstr "Abrir {label}"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Open {modelName} model card"
msgstr "Abrir la ficha del modelo {modelName}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Open {name}"
msgstr "Abrir {name}"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open {piTag}"
msgstr "Abrir {piTag}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSiteRow.tsx
msgid "Open {siteName}"
msgstr "Abrir {siteName}"

#: src/features/lotoReports/components/LotoSheetOpenOnDrawing.tsx
msgid "Open {tag} on its drawing"
msgstr "Abrir {tag} en su plano"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Open {title} in new tab"
msgstr "Abrir {title} en una pestaña nueva"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open ↗"
msgstr "Abrir ↗"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Open a case on "
msgstr "Abrir un caso el "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Open a trend for {label}"
msgstr "Abrir una tendencia de {label}"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Open AI Assistant"
msgstr "Abrir asistente de IA"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Open alert"
msgstr "Abrir alerta"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open all"
msgstr "Abrir todos"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open all {streamCount} tags as one trend"
msgstr "Abrir las {streamCount} etiquetas en una sola tendencia"

#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
msgid "Open all {timeSeriesCount} datastreams in one Process Data tab"
msgstr "Abrir los {timeSeriesCount} flujos de datos en una pestaña de Datos de proceso"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Open Anomalies"
msgstr "Anomalías abiertas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Open asset"
msgstr "Abrir activo"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
#: src/pages/alerts/AlertDetails.tsx
msgid "Open Case"
msgstr "Abrir caso"

#: src/features/timeSeries/utils/uPlotPlugins.ts
msgid "Open case — click to view"
msgstr "Abrir caso — haga clic para verlo"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Open Cases"
msgstr "Casos abiertos"

#: src/features/navbar/configSettings/ConfigSettingsSidebar.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBar.tsx
msgid "Open config settings menu"
msgstr "Abrir el menú de configuración"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Open document"
msgstr "Abrir documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewContent.tsx
msgid "Open Document"
msgstr "Abrir documento"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Open document for revision {revisionLabel}"
msgstr "Abrir documento de la revisión {revisionLabel}"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
msgid "Open documents"
msgstr "Documentos abiertos"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Open import summary"
msgstr "Abrir resumen de importación"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Open in Datastreams"
msgstr "Abrir en flujos de datos"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open in Documents"
msgstr "Abrir en Documentos"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Open in Maximo"
msgstr "Abrir en Maximo"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Open in new tab"
msgstr "Abrir en una pestaña nueva"

#: src/features/knowledgeDocumentViewer/components/ContextMenu.tsx
msgid "Open in New Tab"
msgstr "Abrir en una pestaña nueva"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
msgid "Open In New Tab"
msgstr "Abrir en pestaña nueva"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/TrendPreviewPanel.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open in Process Data"
msgstr "Abrir en Datos de proceso"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open in Process Data ↗"
msgstr "Abrir en Datos de proceso ↗"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactCard.tsx
#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
msgid "Open in tab"
msgstr "Abrir en una pestaña"

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "Open Labeling eval"
msgstr "Abrir evaluación de etiquetado"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Open link"
msgstr "Abrir enlace"

#: src/features/embeddedSidebar/components/EmbeddedSidebarMobileHeader.tsx
#: src/features/embeddedSidebar/components/EmbeddedSidebarMobileHeader.tsx
msgid "Open navigation menu"
msgstr "Abrir menú de navegación"

#: src/features/forecastNotifications/NotificationsDropdownSidebar.tsx
#: src/features/forecastNotifications/NotificationsDropdownTopBar.tsx
msgid "Open notifications"
msgstr "Abrir notificaciones"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Open page"
msgstr "Abrir página"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Open page {pageNum}"
msgstr "Abrir página {pageNum}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Open page {pageNumber}"
msgstr "Abrir página {pageNumber}"

#: src/features/workspaceTabs/components/WorkspaceTabBar.tsx
msgid "Open pages"
msgstr "Abrir páginas"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Open profile settings menu"
msgstr "Abrir el menú de configuración del perfil"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Open profile settings menu for {userDisplayName}"
msgstr "Abrir el menú de configuración de perfil de {userDisplayName}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Open report"
msgstr "Abrir informe"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Open revision"
msgstr "Abrir revisión"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open sentinel"
msgstr "Abrir centinela"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Open Tab"
msgstr "Abrir pestaña"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Open the document at the cited region"
msgstr "Abrir el documento en la región citada"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "Open the model card — every parameter the agent chose"
msgstr "Abrir la ficha del modelo con todos los parámetros elegidos por el agente"

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "Open the PDF to print"
msgstr "Abrir el PDF para imprimir"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Open the Plan stage to edit this."
msgstr "Abra la etapa Plan para editar esto."

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Open the Process Data guide"
msgstr "Abrir la guía de Datos de proceso"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Open the sentinel"
msgstr "Abrir el Sentinel"

#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Open this alert"
msgstr "Abrir esta alerta"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Open this alert in Process Data"
msgstr "Abrir esta alerta en Datos de proceso"

#: src/features/sentinels/components/SentinelAssetPanel.tsx
msgid "Open this asset in Facility Model"
msgstr "Abrir este activo en Modelo de la instalación"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Open this conversation"
msgstr "Abrir esta conversación"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Open trend"
msgstr "Abrir tendencia"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTrendCard.tsx
msgid "Open trend: {trendLabel} · {penLabel}"
msgstr "Abrir tendencia: {trendLabel} · {penLabel}"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Opened bug report from Process Data guide"
msgstr "Se abrió un informe de error desde la guía de Datos de proceso"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
msgid "Opening…"
msgstr "Abriendo…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Operating location"
msgstr "Ubicación operativa"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operation and configuration"
msgstr "Operación y configuración"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operational and environmental monitoring records"
msgstr "Registros de monitoreo operacional y ambiental"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Operational Status"
msgstr "Estado operativo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Operator mimic and control interfaces"
msgstr "Interfaces de operación y control"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Optional slots still unfilled"
msgstr "Campos opcionales aún sin completar"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Or paste an image. Up to 3 images, 5 MB each."
msgstr "O pegue una imagen. Hasta 3 imágenes de 5 MB cada una."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order date"
msgstr "Fecha de pedido"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Order number"
msgstr "Número de orden"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order quantity"
msgstr "Cantidad del pedido"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Order unit"
msgstr "Unidad del pedido"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Ordered line"
msgstr "Línea del pedido"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Ordered lines"
msgstr "Líneas del pedido"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Ordered scope; not proof of installation or repair."
msgstr "Alcance del pedido; no prueba la instalación ni la reparación."

#: src/features/navbar/navConfig.ts
msgid "Orders"
msgstr "Órdenes"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Org & Site App Config"
msgstr "Configuración de la app por organización y sitio"

#: src/pages/metrics/components/SiteRowsTable.tsx
msgid "Org users"
msgstr "Usuarios de org."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Organization"
msgstr "Organización"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Originating record"
msgstr "Registro de origen"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Originating record class"
msgstr "Clase del registro de origen"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other"
msgstr "Otro"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other business or organizational information"
msgstr "Otra información comercial u organizacional"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionDetailChangeList.tsx
msgid "Other changes"
msgstr "Otros cambios"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other document navigation or control"
msgstr "Otra navegación o control de documentos"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other engineering calculations and analysis"
msgstr "Otros cálculos de ingeniería y análisis"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Other files"
msgstr "Otros archivos"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other instructions or requirements"
msgstr "Otras instrucciones o requisitos"

#: src/features/lotoReports/components/LotoReportSelect.tsx
msgid "Other LOTOs"
msgstr "Otros LOTO"

#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Other pages with no isolation points"
msgstr "Otras páginas sin puntos de aislamiento"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other physical design"
msgstr "Otro diseño físico"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other records and results"
msgstr "Otros registros y resultados"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other system connectivity or behavior"
msgstr "Otra conectividad o comportamiento del sistema"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Other technical reference information"
msgstr "Otra información de referencia técnica"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Out of Date"
msgstr "Desactualizado"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "out of range ({displayedHealthRatio}×)"
msgstr "fuera del rango ({displayedHealthRatio}×)"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "Out of Service"
msgstr "Fuera de servicio"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Out-of-band points"
msgstr "Puntos fuera de banda"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Out-of-bounds flags"
msgstr "Indicadores fuera de límites"

#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "outside span"
msgstr "fuera del intervalo"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "over evaluated window"
msgstr "sobre la ventana evaluada"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Over the scored window, with the selected method"
msgstr "Sobre la ventana puntuada, con el método seleccionado"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Overall"
msgstr "General"

#: src/features/sentinels/components/DesignRunDetails.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverviewTabs.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Overview"
msgstr "Descripción general"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Overwrite the Asset Instance from the current Subject and queue a fresh template fill"
msgstr "Sobrescribir la instancia de activo con los datos del sujeto actual y poner en cola una nueva tarea de completado de plantilla"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Overwrite the existing Asset Instance from the current Subject and queue a fresh template fill (the prior fill stays visible until overwritten)"
msgstr "Sobrescribir la instancia de activo existente con los datos del sujeto actual y poner en cola una nueva tarea de completado de plantilla (los datos anteriores seguirán visibles hasta que se sobrescriban)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Owner"
msgstr "Responsable"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Owner group"
msgstr "Grupo responsable"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "P-Val"
msgstr "Valor p"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "p. {pageList}"
msgstr "p. {pageList}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "p.{pageNum}"
msgstr "p.{pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "p.{pageNumber}"
msgstr "p.{pageNumber}"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
msgid "P&ID"
msgstr "P&ID"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID (optional PDF)"
msgstr "P&ID (PDF opcional)"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "P&ID (Piping & Instrumentation Diagram)"
msgstr "P&ID (diagrama de tuberías e instrumentación)"

#: src/features/modelOperations/fimShared.ts
#: src/features/modelOperations/fimShared.ts
msgid "P&ID graph"
msgstr "Grafo P&ID"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID to send:"
msgstr "P&ID que se enviará:"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID upload failed"
msgstr "Falló la carga del P&ID"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "P&ID upload failed: "
msgstr "Falló la carga del P&ID: "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataScopeToggle.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Page"
msgstr "Página"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Page {bestPageNumber} of {title}"
msgstr "Página {bestPageNumber} de {title}"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Page {currentPage} of {pageCount}"
msgstr "Página {currentPage} de {pageCount}"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
msgid "Page {page}"
msgstr "Página {page}"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Page {page} of {pageCount}"
msgstr "Página {page} de {pageCount}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/EvidenceChip.tsx
msgid "Page {pageNum}"
msgstr "Página {pageNum}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Page {pageNum} of {title} is cited"
msgstr "La página {pageNum} de {title} está citada"

#: src/features/chatbot/components/CitationTooltip.tsx
#: src/features/knowledgeDocumentViewer/components/thumbnailSidebar/PageThumbnailItem.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/continuous/ContinuousPageImage.tsx
#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "Page {pageNumber}"
msgstr "Página {pageNumber}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PageImageStatus.tsx
msgid "Page {pageNumber} could not be displayed"
msgstr "No se pudo mostrar la página {pageNumber}"

#: src/features/knowledgeDocumentViewer/utils/pdfOutlineUnits.ts
msgid "Page {startPage}"
msgstr "Página {startPage}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Page comparisons"
msgstr "Comparaciones por página"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page confirmed"
msgstr "Página confirmada"

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply only to {trimmedFilename}."
msgstr "Los cambios en los datos de página se aplican solo a {trimmedFilename}."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply only to this document."
msgstr "Los cambios en los datos de la página se aplican solo a este documento."

#: src/features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard.tsx
msgid "Page data changes apply to every document in this revision family."
msgstr "Los cambios en los datos de la página se aplican a todos los documentos de esta familia de revisiones."

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page deferred"
msgstr "Página postergada"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "Page Details"
msgstr "Detalles de la página"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Page layout"
msgstr "Diseño de página"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Page metadata updated"
msgstr "Metadatos de la página actualizados"

#: src/features/knowledgeDocumentViewer/hooks/useSaveDocumentPageMetadataUserEdit.ts
msgid "Page metadata updated for {revisionCount, plural, one {# revision} other {# revisions}}"
msgstr "Metadatos de la página actualizados para {revisionCount, plural, one {# revisión} other {# revisiones}}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Page navigation"
msgstr "Navegación de páginas"

#: src/pages/noMatch/NoMatch.tsx
msgid "Page Not Found"
msgstr "Página no encontrada"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Page number"
msgstr "Número de página"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "Page range"
msgstr "Rango de páginas"

#: src/features/knowledgeDocumentViewer/hooks/usePageMetadataEvalActions.ts
msgid "Page saved, but updated metadata could not be refreshed"
msgstr "Página guardada, pero no se pudieron actualizar los metadatos en pantalla"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoPagePlaceholder.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
msgid "Page unavailable"
msgstr "Página no disponible"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
msgid "Pages"
msgstr "Páginas"

#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Pages hosted"
msgstr "Páginas alojadas"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Paragraph"
msgstr "Párrafo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Parameters, signals, and data maps"
msgstr "Parámetros, señales y mapas de datos"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Parent"
msgstr "Elemento superior"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Parent location"
msgstr "Ubicación principal"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Parent work order"
msgstr "Orden de trabajo principal"

#: src/features/fimReview/InspectSources.tsx
msgid "Parsed tag"
msgstr "Etiqueta interpretada"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Partial"
msgstr "Parcial"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Partially failed"
msgstr "Con errores parciales"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Parts and equipment schedules"
msgstr "Listas de piezas y equipos"

#: src/features/navbar/navConfig.ts
msgid "Parts Thread"
msgstr "Hilo de repuestos"

#: src/features/timeSeries/agentTab/AgentTab.tsx
#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Past conversations"
msgstr "Conversaciones anteriores"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Past driver values to include as features, in sample periods. Default 1,3,6 → at 10 min interval that is 10/30/60 min ago. Only used when Driver history is on."
msgstr "Valores anteriores de las variables predictoras que se incluirán como características, en períodos de muestra. Valores predeterminados 1,3,6 → con un intervalo de 10 min corresponden a hace 10/30/60 min. Solo se usan cuando está activado Historial de variables predictoras."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Paste a document id or link"
msgstr "Pegue un id o enlace de documento"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Paste a document id or link."
msgstr "Pegue un id o enlace de documento."

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Paste a document URL or reference identifier."
msgstr "Pegue la URL de un documento o un identificador de referencia."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Paste datapoint ids and the agent assembles a context bundle, designs a model plan from it, and you edit that plan before anything is fitted. The training window is the chart's date range ("
msgstr "Pegue los identificadores de puntos de datos y el agente armará un paquete de contexto, diseñará un plan de modelo y usted podrá editarlo antes de realizar cualquier ajuste. La ventana de entrenamiento es el rango de fechas del gráfico ("

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Paste tags"
msgstr "Pegar etiquetas"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
msgid "Path"
msgstr "Ruta"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Pause the clip"
msgstr "Pausar el clip"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Peak Week"
msgstr "Semana de mayor actividad"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "peak σ"
msgstr "σ máximo"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "pen added"
msgstr "trazo agregado"

#: src/features/timeSeries/components/ColorSwatch.tsx
msgid "Pen color"
msgstr "Color del trazo"

#: src/features/timeSeries/components/panes/TagBrowserList.tsx
#: src/features/timeSeries/components/panes/TagSearchDialogRow.tsx
msgid "Pen limit reached ({MAX_PENS})"
msgstr "Se alcanzó el límite de trazos ({MAX_PENS})"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "pen removed"
msgstr "trazo eliminado"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Pen transforms"
msgstr "Transformaciones de trazos"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Pen visibility"
msgstr "Visibilidad de trazos"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "pending"
msgstr "pendiente"

#: src/features/fim/photos/photoElections.ts
msgid "pending model sync"
msgstr "sincronización del modelo pendiente"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Pending upload"
msgstr "Carga pendiente"

#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Pens"
msgstr "Trazos"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Pens in scope"
msgstr "Trazos incluidos"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "People, roles, and organizational records"
msgstr "Personas, roles y registros organizacionales"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Per-tag ops that drop bad points or gate rows before training: range, clip_quantile, frozen-sensor runs, operating-regime gate. Experiment-only denoise_mean / denoise_median smooth surviving points."
msgstr "Operaciones por etiqueta que descartan puntos incorrectos o filtran filas antes del entrenamiento: rango, clip_quantile, ejecuciones de sensor congelado, compuerta de régimen operativo. denoise_mean / denoise_median, solo para experimentos, suavizan los puntos sobrevivientes."

#: src/features/dataFilter/categoryFilter/ValueBreakdownDisplayTypeSelector.tsx
msgid "Percent"
msgstr "Porcentaje"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Percent of bins in filter range"
msgstr "Porcentaje de intervalos en el rango del filtro"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Percent of bins with data"
msgstr "Porcentaje de intervalos con datos"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Percentile of absolute calibration residuals used when Band estimator = abs quantile (e.g. 0.9 ≈ 90th percentile)."
msgstr "Percentil de residuos absolutos de calibración usado cuando Estimador de banda = cuantil absoluto (p. ej., 0.9 ≈ percentil 90)."

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Permission Gates"
msgstr "Controles de permisos"

#: src/pages/manageAccess/components/table/UserRow.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Permissions are still loading. Please wait."
msgstr "Los permisos se están cargando. Espera un momento."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Persistence is what makes a computed KPI safe to alert on. One bad transmitter day should not open a case."
msgstr "La persistencia es lo que permite generar alertas de forma segura con un KPI calculado. Un día defectuoso de un transmisor no debería abrir un caso."

#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "Person"
msgstr "Persona"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Person group"
msgstr "Grupo de personas"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Personnel qualification records"
msgstr "Registros de calificación del personal"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Phase shift for {tag}"
msgstr "Desfase para {tag}"

#: src/features/fim/photos/types.ts
msgid "Photo"
msgstr "Foto"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Photo attached."
msgstr "Foto adjunta."

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Photo caption"
msgstr "Descripción de la foto"

#: src/features/fim/photos/photoService.ts
msgid "Photo is no longer available."
msgstr "La foto ya no está disponible."

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeHeader.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Photo mode"
msgstr "Modo de fotos"

#: src/features/fim/photos/useSubjectPhotoActions.ts
msgid "Photo remove failed: {reason}"
msgstr "No se pudo quitar la foto: {reason}"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Photograph the physical equipment and attach it to this Subject"
msgstr "Fotografíe el equipo físico y adjunte la foto a este sujeto"

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "Photos ({photoCount})"
msgstr "Fotos ({photoCount})"

#: src/features/fim/photos/SubjectPhotos.tsx
#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeSubjectSection.tsx
msgid "Photos can be attached once this Subject has a tag or name alias."
msgstr "Puede adjuntar fotos cuando este sujeto tenga una etiqueta o un alias de nombre."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Physical count"
msgstr "Conteo físico"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Physical count date"
msgstr "Fecha del conteo físico"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "physics KPI · {kpi}"
msgstr "KPI físico · {kpi}"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "PI Tag"
msgstr "Etiqueta PI"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "PI Tag {position}"
msgstr "Etiqueta PI {position}"

#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "PI tag ID"
msgstr "ID de etiqueta PI"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "PI tags"
msgstr "Etiquetas PI"

#: src/features/sentinels/SentinelInstancePicker.tsx
msgid "PI tags bound"
msgstr "Etiquetas de PI vinculadas"

#: src/features/modelOperations/templates/templateModel.ts
msgid "PI-tag row {row} needs a label."
msgstr "La fila {row} de etiquetas PI necesita un nombre."

#: src/features/lotoReports/components/LotoSheetScheduleField.tsx
msgid "Pick a date to keep this time"
msgstr "Elija una fecha para conservar esta hora"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Pick a document"
msgstr "Seleccione un documento"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Pick a filled asset and the agent builds a monitor from its tags. The training window is the chart's date range."
msgstr "Elija un activo completado y el agente creará un monitor a partir de sus etiquetas. La ventana de entrenamiento es el rango de fechas del gráfico."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Pick a Subject"
msgstr "Seleccione un sujeto"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Pick a target and at least one driver first"
msgstr "Primero elija un objetivo y al menos una variable predictora"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Pick a target and drivers above."
msgstr "Elija arriba un objetivo y variables predictoras."

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Pick a target and drivers to see how many points are used."
msgstr "Elija un objetivo y variables predictoras para ver cuántos puntos se usan."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Pick a tool from the toolbar, use it as many times as you like, press "
msgstr "Elija una herramienta de la barra, úsela tantas veces como quiera y presione "

#: src/pages/processData/buildMode/dock/CleaningSection.tsx
msgid "Pick tags on the left to see their quality here."
msgstr "Elija etiquetas a la izquierda para ver aquí su calidad."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Pick the exact dates for each period. Ranges run from 00:00 on the start date up to (not including) 00:00 on the end date, so set one range's end to the next one's start to butt them together. Rows outside every range are dropped from both fitting and scoring — useful for cutting an outage out of the middle."
msgstr "Elija las fechas exactas de cada período. Los rangos van desde las 00:00 de la fecha inicial hasta las 00:00 de la fecha final (sin incluirla); para unirlos, configure el final de un rango como el inicio del siguiente. Las filas fuera de todos los rangos se excluyen tanto del ajuste como de la puntuación; esto permite eliminar una interrupción intermedia."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Picked up {tag} at position {position} of {count}."
msgstr "Se tomó {tag} en la posición {position} de {count}."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Pin"
msgstr "Fijar"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Pin a tag's chart Y range (custom bounds win over auto). Applies to the viewer's pens immediately and saves with the experiment. Leave a field empty for auto."
msgstr "Fije el rango Y del gráfico de una etiqueta (los límites personalizados prevalecen sobre los automáticos). Se aplica inmediatamente a los trazos del visor y se guarda con el experimento. Deje un campo vacío para usar el valor automático."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Pinecone rich text summary"
msgstr "Resumen de texto enriquecido de Pinecone"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Pipe Support"
msgstr "Soporte de tubería"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Pipeline"
msgstr "Tubería"

#: src/features/navbar/navConfig.ts
msgid "Pipeline Fleet"
msgstr "Flota de pipelines"

#: src/pages/evaluations/metadata/components/OrganizationMetrics.tsx
msgid "Pipeline trends unavailable."
msgstr "No se pudieron cargar las tendencias de pipeline."

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
msgid "Pipeline values are empty. Choose no to confirm that, or fill the fields if it should have metadata."
msgstr "Los valores del pipeline están vacíos. Elija No para confirmarlo, o complete los campos si debería tener metadatos."

#: src/features/navbar/navConfig.ts
msgid "Pipelines"
msgstr "Pipelines"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Piping Isometric"
msgstr "Isométrico de tuberías"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "placebo p (raw)"
msgstr "p de placebo (sin procesar)"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "placebo z"
msgstr "z de placebo"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Placebo z is how far outside the ordinary date-to-date wobble the step sits, measured against steps at 400 arbitrary dates. It gates instead of a p-value because a discovered date's p is flattered by the scan, and a large real step contaminates its own null."
msgstr "La z de placebo indica cuánto se aleja el escalón de la variación normal entre fechas, medida respecto de escalones en 400 fechas arbitrarias. Se usa como compuerta en vez de un valor p porque el escaneo favorece la p de una fecha descubierta y un escalón real grande contamina su propio valor nulo."

#: src/components/table/TableComponent.tsx
msgid "Placeholder"
msgstr "Marcador de posición"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Plan"
msgstr "Plan"

#: src/pages/overview/sidebar/table/SiteViewSidebarTableOrganizers.tsx
msgid "Plan Cost"
msgstr "Costo del plan"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Plan tags: "
msgstr "Etiquetas del plan: "

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned hours"
msgstr "Horas planificadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned instructions and resources; not performed work."
msgstr "Instrucciones y recursos planificados; no constituyen trabajo realizado."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned item"
msgstr "Artículo planificado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned item quantity"
msgstr "Cantidad planificada del artículo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned items"
msgstr "Artículos planificados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned job-plan sequence"
msgstr "Secuencia planificada del plan de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned job-plan sequences"
msgstr "Secuencias de planes de trabajo previstas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned labor"
msgstr "Mano de obra planificada"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned material"
msgstr "Material planificado"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned materials"
msgstr "Materiales planificados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned service"
msgstr "Servicio planificado"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned services"
msgstr "Servicios planificados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned task"
msgstr "Tarea planificada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned tasks"
msgstr "Tareas planificadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planned tool"
msgstr "Herramienta planificada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Planned tools"
msgstr "Herramientas planificadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Planning"
msgstr "Planificación"

#: src/pages/details/visualization/tools/CompartmentsToggle.tsx
msgid "Plates disabled"
msgstr "Placas desactivadas"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Platform Notifications"
msgstr "Notificaciones de la plataforma"

#: src/pages/processData/components/helpGuide/HelpGuideMedia.tsx
msgid "Play the clip"
msgstr "Reproducir el clip"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Please describe the issue and our team will get back to you as soon as possible."
msgstr "Describa el problema y nuestro equipo se comunicará con usted lo antes posible."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please enter a numeric value"
msgstr "Ingrese un valor numérico"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please enter the location or component part"
msgstr "Ingrese la ubicación o la parte del componente"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Please fix the following issues:"
msgstr "Corrija los siguientes problemas:"

#: src/features/timeSeries/components/DerivedValuesTab.tsx
msgid "Please go to the Data from Tags tab and select some tags before creating calculations."
msgstr "Vaya a la pestaña Datos de etiquetas y seleccione algunas etiquetas antes de crear cálculos."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Please select a file to upload"
msgstr "Seleccione un archivo para cargar"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select an image file to upload."
msgstr "Seleccione un archivo de imagen para cargar."

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Please select sensors from the sidebar to configure their thresholds."
msgstr "Seleccione sensores en la barra lateral para configurar sus umbrales."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select the date of capture"
msgstr "Seleccione la fecha de captura"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please select the source of the image"
msgstr "Seleccione el origen de la imagen"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Please upload a file"
msgstr "Cargue un archivo"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Please upload an image file"
msgstr "Cargue un archivo de imagen"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Plot and Style Pens"
msgstr "Graficar y dar estilo a los trazos"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Plot the tags you want to combine, then build a derived tag from them."
msgstr "Grafica las etiquetas que quieres combinar y luego crea una etiqueta derivada a partir de ellas."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PM"
msgstr "PM"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "PM due"
msgstr "Vencimiento de mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PM meter"
msgstr "Medidor de mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "PM meters"
msgstr "Medidores de mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "PO reference"
msgstr "Referencia de orden de compra"

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Point Annotation"
msgstr "Anotación de punto"

#: src/features/timeSeries/components/timeSeriesScatterplot/EmbeddedChartToolbar.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotContent.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Point annotations require time on the x-axis"
msgstr "Las anotaciones de puntos requieren tiempo en el eje X"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Point cloud error: {error}"
msgstr "Error de la nube de puntos: {error}"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Point color"
msgstr "Color de los puntos"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Point marked manually"
msgstr "Punto marcado manualmente"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Point marked manually (in band)"
msgstr "Punto marcado manualmente (dentro de la banda)"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Point size"
msgstr "Tamaño de los puntos"

#: src/features/lotoReports/components/LotoReportCard.tsx
msgid "Points"
msgstr "Puntos"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Poor"
msgstr "Deficiente"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Position"
msgstr "Posición"

#: src/features/lotoReports/components/LotoPointPositionCombobox.tsx
msgid "Position for {tag}"
msgstr "Posición para {tag}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "Positive correlation"
msgstr "Correlación positiva"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Positive shift = driver leads the target. Scan window:"
msgstr "Desfase positivo = la variable predictora se adelanta al objetivo. Ventana de escaneo:"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Post Comment"
msgstr "Publicar comentario"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Postgres linearized text"
msgstr "Texto linealizado de Postgres"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Posting..."
msgstr "Publicando..."

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Potential Causes:"
msgstr "Posibles causas:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Predecessor job plan"
msgstr "Plan de trabajo predecesor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Predecessor task"
msgstr "Tarea predecesora"

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
msgid "Predicted"
msgstr "Predicho"

#: src/pages/processData/buildMode/dock/ModelDockTab.tsx
msgid "Predicts the target from current driver values only."
msgstr "Predice el objetivo solo a partir de los valores actuales de las variables predictoras."

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Prefer to work with JSON?"
msgstr "¿Prefiere trabajar con JSON?"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Preparing"
msgstr "Preparando"

#: src/features/lotoReports/components/LotoPrintButton.tsx
msgid "Preparing {loaded} of {total} pages…"
msgstr "Preparando {loaded} de {total} páginas…"

#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Preparing chart data for the plot."
msgstr "Preparando los datos del gráfico."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Preparing CMMS record…"
msgstr "Preparando registro de CMMS…"

#: src/features/knowledgeDocumentViewer/hooks/useDocumentPrintActions.ts
msgid "Preparing document for printing…"
msgstr "Preparando el documento para imprimir…"

#: src/pages/reporting/reports/rug/hooks/UseDraftPdfGeneration.tsx
msgid "Preparing PDF images..."
msgstr "Preparando imágenes del PDF..."

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentButton.tsx
msgid "Preparing print..."
msgstr "Preparando impresión..."

#: src/features/lotoReports/printReport/useLotoReportPrint.ts
msgid "Preparing the LOTO report for printing…"
msgstr "Preparando el informe LOTO para imprimir…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Preparing this Subject…"
msgstr "Preparando este sujeto…"

#: src/features/lotoReports/components/LotoPrintButton.tsx
#: src/features/lotoReports/components/LotoPrintPreview.tsx
msgid "Preparing…"
msgstr "Preparando…"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: alt months"
msgstr "Preajuste: meses alternos"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: tail 10%"
msgstr "Preajuste: cola del 10 %"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Preset: year holdout"
msgstr "Preajuste: reserva anual"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Press "
msgstr "Presione "

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Prev"
msgstr "Anterior"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Preventive maintenance"
msgstr "Mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Preventive maintenance schedule"
msgstr "Programa de mantenimiento preventivo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/FloatingDocumentPreviewOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview"
msgstr "Vista previa"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Preview {citationLabel}"
msgstr "Previsualizar {citationLabel}"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Preview change"
msgstr "Previsualizar cambio"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview mode off"
msgstr "Modo de vista previa desactivado"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Preview mode on"
msgstr "Modo de vista previa activado"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Preview not available for {fileTypeLabel} files"
msgstr "La vista previa no está disponible para archivos {fileTypeLabel}"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Preview revert"
msgstr "Previsualizar reversión"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Preview unavailable."
msgstr "Vista previa no disponible."

#: src/features/fimReview/DecisionHistory.tsx
msgid "preview: {before} → {after}"
msgstr "vista previa: {before} → {after}"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Previewing revert…"
msgstr "Previsualizando reversión…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Previewing…"
msgstr "Previsualizando…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticChatPage.tsx
msgid "Previews from the chat open here at full width."
msgstr "Las vistas previas del chat se abren aquí a ancho completo."

#: src/designSystem/components/Pagination.tsx
msgid "Previous"
msgstr "Anterior"

#: src/pages/details/overlays/inspections/InspectionsListOverlay.tsx
msgid "Previous inspections"
msgstr "Inspecciones anteriores"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Previous match"
msgstr "Coincidencia anterior"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Previous match (Shift+Enter)"
msgstr "Coincidencia anterior (Shift+Enter)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewPageNavigator.tsx
msgid "Previous page"
msgstr "Página anterior"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageSelector.tsx
msgid "Previous Page"
msgstr "Página anterior"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation.tsx
msgid "Previous page in queue"
msgstr "Página anterior en la cola"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Previous parameter sets"
msgstr "Conjuntos de parámetros anteriores"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Previous question"
msgstr "Pregunta anterior"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Previous reference"
msgstr "Referencia anterior"

#: src/features/knowledgeDocumentViewer/components/toolbar/SearchResultsNavigator.tsx
msgid "Previous search result"
msgstr "Resultado de búsqueda anterior"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Previous time period"
msgstr "Período anterior"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Primary datapoint ID"
msgstr "ID del punto de datos principal"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Primitives"
msgstr "Primitivas"

#: src/features/lotoReports/components/LotoPrintButton.tsx
msgid "Print"
msgstr "Imprimir"

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentButton.tsx
msgid "Print Document"
msgstr "Imprimir documento"

#: src/features/knowledgeDocumentViewer/components/toolbar/PrintDocumentMenuOptions.tsx
msgid "Print page range"
msgstr "Imprimir rango de páginas"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Print preview"
msgstr "Vista previa de impresión"

#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Prio"
msgstr "Prior."

#: src/features/fimReview/IdentityPanel.tsx
msgid "Prior Subjects"
msgstr "Sujetos anteriores"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Priority"
msgstr "Prioridad"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Priority description"
msgstr "Descripción de prioridad"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Priority justification"
msgstr "Justificación de prioridad"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Private"
msgstr "Privado"

#: src/pages/cases/components/CasesTable.tsx
msgid "Private Cases"
msgstr "Casos privados"

#: src/pages/alerts/AlertDetails.tsx
msgid "Probable Causes"
msgstr "Causas probables"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/modelOperations/Corroboration.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Process data"
msgstr "Datos de proceso"

#: src/features/navbar/navConfig.ts
msgid "Process Data"
msgstr "Datos de proceso"

#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Process Data Guide"
msgstr "Guía de Datos de proceso"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Process Data lives in the app's left sidebar. A <0>view</0> is everything on screen — pens, styling, time range, annotations."
msgstr "Datos de proceso está en la barra lateral izquierda de la aplicación. Una <0>vista</0> incluye todo lo que aparece en pantalla: trazos, estilos, rango de tiempo y anotaciones."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Process Data plots any tag on your site over time. Tags on the left, chart in the center, time range along the bottom, live values on the right. The whole setup saves as a view your team can open."
msgstr "Datos de proceso grafica cualquier etiqueta de su sitio a lo largo del tiempo. Las etiquetas están a la izquierda, el gráfico en el centro, el rango temporal abajo y los valores en vivo a la derecha. Toda la configuración se guarda como una vista que su equipo puede abrir."

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Process flow and fluid circuits"
msgstr "Flujos de proceso y circuitos de fluidos"

#: src/features/navbar/navConfig.ts
msgid "Process Flow Diagrams"
msgstr "Diagramas de flujo de proceso"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Process, fluid, and thermal performance analysis"
msgstr "Análisis de desempeño de proceso, fluido y térmico"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Processed"
msgstr "Procesado"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Processing"
msgstr "Procesando"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Product selection and ordering guides"
msgstr "Guías de selección y pedido de productos"

#: src/features/navbar/navConfig.ts
msgid "Production Dashboard"
msgstr "Panel de producción"

#: src/pages/processData/buildMode/hooks/usePromoteSentinel.ts
msgid "promote failed"
msgstr "falló la promoción"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Promote to active monitor"
msgstr "Promover a monitor activo"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Promoted"
msgstr "Promovido"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Promoted asset"
msgstr "Activo promovido"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Promoted only"
msgstr "Solo promovidos"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Promoting…"
msgstr "Promoviendo…"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Promotion State"
msgstr "Estado de promoción"

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Proposed LOTO report"
msgstr "Informe LOTO propuesto"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/alerts/components/AlertProvenanceCard.tsx
msgid "Provenance"
msgstr "Procedencia"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Provide Feedback"
msgstr "Enviar comentarios"

#: src/features/fimReview/InspectSources.tsx
msgid "Proxy"
msgstr "Proxy"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publish"
msgstr "Publicar"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Publish and Share"
msgstr "Publicar y compartir"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Publish as active monitor"
msgstr "Publicar como monitor activo"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/CaseDetailsContent.tsx
msgid "Publish Case"
msgstr "Publicar caso"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Publish observations"
msgstr "Publicar observaciones"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publish the current recommendation to the site."
msgstr "Publicar la recomendación actual en el sitio."

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Published"
msgstr "Publicado"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Published {publishedAtLabel}"
msgstr "Publicado el {publishedAtLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Published recommendation"
msgstr "Recomendación publicada"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Published Recommendation"
msgstr "Recomendación publicada"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Published State"
msgstr "Estado publicado"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publishing the latest saved recommendation."
msgstr "Publicando la última recomendación guardada."

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Publishing to active requires the promote endpoint — rolling out"
msgstr "La publicación como activo requiere el endpoint de promoción; se está implementando"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Publishing..."
msgstr "Publicando..."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulled data"
msgstr "Se obtuvieron datos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulled data into {dataset}"
msgstr "Se obtuvieron datos en {dataset}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulling data"
msgstr "Obteniendo datos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Pulling data into {dataset}"
msgstr "Obteniendo datos en {dataset}"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Pulls fresh data and scores it with the refit model. No retraining, and nothing is saved."
msgstr "Obtiene datos nuevos y los puntúa con el modelo reajustado. No vuelve a entrenar ni guarda nada."

#: src/features/fimReview/ReviewActions.tsx
msgid "Pump, valve, vendor…"
msgstr "Bomba, válvula, proveedor…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchase order"
msgstr "Orden de compra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchase requisition"
msgstr "Solicitud de compra"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Purchasing term"
msgstr "Condición de compra"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Purchasing terms"
msgstr "Condiciones de compra"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Put these labels on the chart"
msgstr "Colocar estas etiquetas en el gráfico"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Quantile"
msgstr "Cuantil"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Quantile clip"
msgstr "Recorte por cuantil"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Quantity"
msgstr "Cantidad"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Quarterly review"
msgstr "Revisión trimestral"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Query"
msgstr "Consulta"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Query ts"
msgstr "Consulta ts"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Question"
msgstr "Pregunta"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Queue a fresh template fill for this Asset Instance"
msgstr "Poner en cola una nueva tarea de completado de plantilla para esta instancia de activo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Queue message"
msgstr "Poner mensaje en cola"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queue paused while editing."
msgstr "Cola en pausa durante la edición."

#: src/features/facilityModel/views.ts
msgid "Queued"
msgstr "En cola"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queued messages"
msgstr "Mensajes en cola"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageQueue.tsx
msgid "Queued messages send in order after the current response."
msgstr "Los mensajes en cola se envían en orden después de la respuesta actual."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Queueing…"
msgstr "Poniendo en cola…"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Quick pick — the experiment's drivers:"
msgstr "Selección rápida — variables predictoras del experimento:"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Quick Select"
msgstr "Selección rápida"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "quiet"
msgstr "sin alertas"

#: src/features/chatbot/components/CitationTooltip.tsx
msgid "Quotations"
msgstr "Citas textuales"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Quote"
msgstr "Cita"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
#: src/pages/processData/buildMode/dock/CompareDockTab.tsx
#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
msgid "R²"
msgstr "R²"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "R² ="
msgstr "R² ="

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Raised when the plan was designed and validated against the fit. Advisory only — none of them blocked this run."
msgstr "Se generaron cuando el plan se diseñó y se validó respecto del ajuste. Son solo informativas; ninguna bloqueó esta ejecución."

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "RAM debug colors"
msgstr "Colores de depuración de RAM"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Ran {readable}"
msgstr "Se ejecutó {readable}"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Random seed"
msgstr "Semilla aleatoria"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Range"
msgstr "Rango"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Range min / max"
msgstr "Mín. / máx. del rango"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Range:"
msgstr "Rango:"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Rating"
msgstr "Calificación"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Raw historian points (all available)"
msgstr "Puntos sin procesar del historiador (todos los disponibles)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Raw mode pulls every historian point and only aligns tags when timestamps match exactly. Prefer a shorter date range — dense tags can be huge."
msgstr "El modo sin procesar obtiene todos los puntos del historiador y solo alinea las etiquetas cuando las marcas de tiempo coinciden exactamente. Prefiera un rango de fechas más corto; las etiquetas densas pueden ser enormes."

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Raw points"
msgstr "Puntos sin procesar"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Raw signal · snapshot values on each alert are authoritative."
msgstr "Señal sin procesar · los valores capturados en cada alerta son la referencia oficial."

#: src/features/fimReview/InspectSources.tsx
msgid "raw source row · agent-asserted"
msgstr "fila de origen sin procesar · afirmada por el agente"

#: src/features/fimReview/InspectSources.tsx
msgid "raw source row · as ingested from the upload"
msgstr "fila de origen sin procesar · tal como se incorporó desde el archivo cargado"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Re-fill"
msgstr "Volver a completar"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Re-fill failed: {reason}"
msgstr "No se pudieron volver a completar los datos: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Re-instantiate"
msgstr "Volver a crear instancia"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Re-instantiate failed: {reason}"
msgstr "No se pudo volver a crear la instancia: {reason}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Re-instantiating…"
msgstr "Volviendo a crear la instancia…"

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Re-pulling and refitting…"
msgstr "Obteniendo y reajustando de nuevo…"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Re-pulls and grades against the rule above without waiting for the schedule."
msgstr "Vuelve a obtener y califica según la regla anterior sin esperar la programación."

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Re-run RCA"
msgstr "Volver a ejecutar el RCA"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Reach out to your Gecko site contact — send a note by email, or schedule a call to walk through what you need. Requests go straight into our product planning."
msgstr "Comuníquese con su contacto del sitio de Gecko: envíe una nota por correo electrónico o programe una llamada para explicar lo que necesita. Las solicitudes llegan directamente a nuestra planificación de productos."

#: src/features/forecastNotifications/notificationUtils.ts
msgid "Read"
msgstr "Leídas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Read live values for {datapointLabel}"
msgstr "Se leyeron valores en tiempo real de {datapointLabel}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Read the instruments on a drawing"
msgstr "Se leyeron los instrumentos de un plano"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Read the instruments on a drawing page {page}"
msgstr "Se leyeron los instrumentos de la página {page} de un plano"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Reading {formattedValue}, {xAxisName} {formattedX}, {yAxisName} {formattedY}. Activate to focus the viewport on this measurement."
msgstr "Lectura {formattedValue}, {xAxisName} {formattedX}, {yAxisName} {formattedY}. Active para centrar la vista en esta medición."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Reading the instruments on a drawing"
msgstr "Leyendo los instrumentos de un plano"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Reading the instruments on a drawing page {page}"
msgstr "Leyendo los instrumentos de la página {page} de un plano"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Reads and charts plant data on your next question"
msgstr "Lee y grafica los datos de la planta en tu próxima pregunta"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "Ready"
msgstr "Listo"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Ready to complete"
msgstr "Listo para completar"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Real-time anomaly detection and management"
msgstr "Detección y gestión de anomalías en tiempo real"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Real-time monitoring"
msgstr "Monitoreo en tiempo real"

#: src/features/knowledgeDocumentViewer/components/metadata/DeferPageMetadataDialog.tsx
msgid "Reason"
msgstr "Motivo"

#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Reason (optional)"
msgstr "Motivo (opcional)"

#: src/features/fimReview/ReviewActions.tsx
msgid "Reason for classification change"
msgstr "Motivo del cambio de clasificación"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Reason for LOTO"
msgstr "Motivo del LOTO"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "REASON FOR LOTO:"
msgstr "MOTIVO DEL LOTO:"

#: src/features/fimReview/ReviewActions.tsx
msgid "Reason for removing input"
msgstr "Motivo de eliminación de la entrada"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Reason for reopening this case:"
msgstr "Motivo para reabrir este caso:"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Reason for structural correction"
msgstr "Motivo de la corrección estructural"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Reason:"
msgstr "Motivo:"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatModelSettingsMenu.tsx
msgid "Reasoning effort"
msgstr "Esfuerzo de razonamiento"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Rebuild context"
msgstr "Volver a crear el contexto"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Recalc"
msgstr "Recalcular"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Receipt state"
msgstr "Estado de recepción"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Receive notifications via email"
msgstr "Recibir notificaciones por correo electrónico"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Received quantity"
msgstr "Cantidad recibida"

#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Recent"
msgstr "Reciente"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Recent Activity"
msgstr "Actividad reciente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "Recent Charts"
msgstr "Gráficos recientes"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Recent chat actions"
msgstr "Acciones de chats recientes"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Recent chats"
msgstr "Chats recientes"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/LandingScrollSections.tsx
msgid "Recent Documents"
msgstr "Documentos recientes"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Recent scatter is {healthRatio}× the baseline band, so a sigma here measures the regime change, not the asset. Refit on a baseline that covers current operation."
msgstr "La dispersión reciente es {healthRatio}× la banda de referencia: aquí, sigma mide el cambio de régimen, no el activo. Reajusta el modelo con datos de referencia que cubran la operación actual."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Recent searches"
msgstr "Búsquedas recientes"

#: src/features/fim/assetInventory.ts
msgid "Recently updated"
msgstr "Actualizados recientemente"

#: src/pages/homepage/Homepage.tsx
msgid "RECENTS"
msgstr "RECIENTES"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reclassified"
msgstr "Reclasificado"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Recommendation"
msgstr "Recomendación"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Recommendation Accuracy"
msgstr "Precisión de la recomendación"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Recommendation draft"
msgstr "Borrador de recomendación"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Recommendation summary"
msgstr "Resumen de la recomendación"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Recommended Actions:"
msgstr "Acciones recomendadas:"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "Recommended:"
msgstr "Recomendado:"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnect failed: HTTP {status}"
msgstr "Falló la reconexión: HTTP {status}"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnection error"
msgstr "Error de reconexión"

#: src/features/chatbot/api/sseClient.ts
msgid "Reconnection stream error"
msgstr "Error del flujo de reconexión"

#: src/designSystem/components/RecordHeader.tsx
msgid "Record actions"
msgstr "Acciones del registro"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Record class"
msgstr "Clase de registro"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Record details"
msgstr "Detalles del registro"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Record kind"
msgstr "Tipo de registro"

#: src/features/lotoReports/components/LotoSheetEditor.tsx
msgid "Record sheet page {pageNumber} of {count}"
msgstr "Página {pageNumber} de {count} de la hoja de registro"

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Record sheet view"
msgstr "Vista de la hoja de registro"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded inspection responses; unanswered fields are not passes."
msgstr "Respuestas de inspección registradas; los campos sin respuesta no indican aprobación."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded location and hierarchy."
msgstr "Ubicación y jerarquía registradas."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded material movement; not proof of installation."
msgstr "Movimiento de materiales registrado; no prueba la instalación."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded material transaction"
msgstr "Transacción de materiales registrada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Recorded material transactions"
msgstr "Movimientos de materiales registrados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded receipt transaction"
msgstr "Transacción de recepción registrada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Recorded receipt transactions"
msgstr "Recepciones registradas"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
msgid "Recorded status: {status}"
msgstr "Estado registrado: {status}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Recorded supplier"
msgstr "Proveedor registrado"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Recorded totals for this record; currency is not supplied. Labor hours measure effort, not elapsed downtime."
msgstr "Totales de este registro; no se proporciona la moneda. Las horas de mano de obra miden el esfuerzo, no el tiempo de inactividad transcurrido."

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Recorded totals in {currency}. Labor hours measure effort, not elapsed downtime."
msgstr "Totales registrados en {currency}. Las horas de mano de obra miden el esfuerzo, no el tiempo de inactividad transcurrido."

#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Recording acceptance decisions is not available yet."
msgstr "El registro de decisiones de aceptación aún no está disponible."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "Records without values: {missing}"
msgstr "Registros sin valores: {missing}"

#: src/pages/details/visualization/markupEditing/EditToolBar.tsx
msgid "Rectangle tool"
msgstr "Herramienta de rectángulos"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Reference only"
msgstr "Solo referencia"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Reference preview"
msgstr "Vista previa de la referencia"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferenceOverlay.tsx
msgid "Reference: {referenceLabel}"
msgstr "Referencia: {referenceLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced asset"
msgstr "Activo referenciado"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced assets"
msgstr "Activos referenciados"

#: src/features/facilityModel/citations.ts
#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Referenced document"
msgstr "Documento referenciado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced inventory"
msgstr "Inventario referenciado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced job plan"
msgstr "Plan de trabajo referenciado"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced job plans"
msgstr "Planes de trabajo referenciados"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Referenced location"
msgstr "Ubicación referenciada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Referenced locations"
msgstr "Ubicaciones referenciadas"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "Referenced off-page connector"
msgstr "Conector fuera de página referenciado"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Referenced:"
msgstr "Referenciado:"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "References"
msgstr "Referencias"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "References ({refCount})"
msgstr "Referencias ({refCount})"

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "References ({referenceCount})"
msgstr "Referencias ({referenceCount})"

#: src/features/chatbot/components/StreamingReferences.tsx
msgid "References ({totalCount})"
msgstr "Referencias ({totalCount})"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "References to {referenceText}"
msgstr "Referencias a {referenceText}"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "refit FAILED — "
msgstr "FALLÓ el reajuste — "

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "refit needed"
msgstr "requiere reajuste"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "refit on the"
msgstr "reajustar en"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
msgid "Refresh"
msgstr "Actualizar"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Refreshing latest case details..."
msgstr "Actualizando los últimos detalles del caso..."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Refreshing preview…"
msgstr "Actualizando vista previa…"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Refreshing…"
msgstr "Actualizando…"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Refs"
msgstr "Refs"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Region"
msgstr "Región"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Regression & Prediction"
msgstr "Regresión y predicción"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Regressions"
msgstr "Regresiones"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/nnpp/acceptance/NnppAcceptanceReviewPage.tsx
msgid "Reject"
msgstr "Rechazar"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "rejected"
msgstr "rechazado"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Rejected"
msgstr "Rechazado"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Rejected (legacy)"
msgstr "Rechazado (heredado)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Rejected quantity"
msgstr "Cantidad rechazada"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Related Asset"
msgstr "Activo relacionado"

#: src/designSystem/components/RecordHeader.tsx
msgid "Related records"
msgstr "Registros relacionados"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Released\n"
"Initial"
msgstr ""
"Inic.\n"
"liberac."

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Released\n"
"Position"
msgstr ""
"Posición\n"
"al liberar"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Released position"
msgstr "Posición al liberar"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Reload"
msgstr "Volver a cargar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Remaining corrosion allowance"
msgstr "Margen de corrosión restante"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Remaining life"
msgstr "Vida restante"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Remaining life unavailable for this selection."
msgstr "La vida útil restante no está disponible para esta selección."

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "remove"
msgstr "eliminar"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/fim/photos/PhotoRemoveButton.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/experiment/SplitBuilder.tsx
#: src/features/timeSeries/experiment/TagPicker.tsx
#: src/pages/details/extensions/fde/NavyRepairPlanningExtension.tsx
msgid "Remove"
msgstr "Quitar"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Remove {aliasValue} from fusion"
msgstr "Eliminar {aliasValue} de la fusión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "Remove {attachmentName}"
msgstr "Quitar {attachmentName}"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "Remove {displayTitle}"
msgstr "Quitar {displayTitle}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove {driver} from the fit"
msgstr "Eliminar {driver} del ajuste"

#: src/pages/manageAccess/components/invite/EmailChipsInput.tsx
msgid "Remove {email}"
msgstr "Quitar {email}"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Remove {filename}"
msgstr "Quitar {filename}"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Remove {label}"
msgstr "Eliminar {label}"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Remove {name}"
msgstr "Eliminar {name}"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove {role}"
msgstr "Eliminar {role}"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Remove {tag}"
msgstr "Quitar {tag}"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove {tagName}"
msgstr "Eliminar {tagName}"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Remove {value291_51} from the chart?"
msgstr "¿Eliminar {value291_51} del gráfico?"

#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Remove {value395_51}"
msgstr "Eliminar {value395_51}"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove {value404_48}"
msgstr "Eliminar {value404_48}"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove {value426_46}"
msgstr "Eliminar {value426_46}"

#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Remove all"
msgstr "Eliminar todo"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Remove All"
msgstr "Eliminar todo"

#: src/features/timeSeries/components/ScatterplotSidebarConfig.tsx
msgid "Remove all data from the chart?"
msgstr "¿Eliminar todos los datos del gráfico?"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Remove all pens"
msgstr "Eliminar todos los trazos"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Remove all pens?"
msgstr "¿Eliminar todos los trazos?"

#: src/features/timeSeries/components/SensorScatterplotTable.tsx
msgid "Remove all sensors from the chart?"
msgstr "¿Eliminar todos los sensores del gráfico?"

#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Remove annotation"
msgstr "Eliminar anotación"

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Remove derived tag"
msgstr "Eliminar etiqueta derivada"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove driver"
msgstr "Eliminar variable predictora"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Remove filter"
msgstr "Quitar filtro"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Remove from chart"
msgstr "Eliminar del gráfico"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/recents/FavoriteDocumentCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/recents/FavoriteDocumentCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "Remove from favorites"
msgstr "Quitar de favoritos"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Remove from Process Data"
msgstr "Quitar de Datos de proceso"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Remove from saved"
msgstr "Quitar de guardados"

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "Remove modeled tag"
msgstr "Eliminar etiqueta modelada"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page"
msgstr "Quitar página"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page {pageId} of {documentName}"
msgstr "Quitar la página {pageId} de {documentName}"

#: src/features/lotoReports/components/LotoPageCard.tsx
msgid "Remove page {pageNumber} of {documentName}"
msgstr "Quitar la página {pageNumber} de {documentName}"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Remove pen"
msgstr "Eliminar trazo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
msgid "Remove queued message {position}"
msgstr "Quitar mensaje {position} de la cola"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Remove role {role}"
msgstr "Eliminar función {role}"

#: src/pages/details/extensions/fde/NavyRepairPlanningExtension.tsx
msgid "Remove scenario"
msgstr "Eliminar escenario"

#: src/features/fimReview/ReviewActions.tsx
msgid "Remove selected aliases"
msgstr "Eliminar alias seleccionados"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Remove sentinel from chart"
msgstr "Eliminar Sentinel del gráfico"

#: src/features/fimReview/ReviewActions.tsx
msgid "Remove the complete subject ({aliasCountLabel})"
msgstr "Eliminar el sujeto completo ({aliasCountLabel})"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Remove the residual pen"
msgstr "Quitar el trazo del residuo"

#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Remove this event"
msgstr "Eliminar este evento"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Remove this pen the agent added"
msgstr "Eliminar este trazo agregado por el agente"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Remove this photo from this Subject (the photo itself is kept)"
msgstr "Quitar esta foto de este sujeto (la foto se conserva)"

#: src/features/fim/photos/PhotoRemoveButton.tsx
msgid "Remove this photo?"
msgstr "¿Quitar esta foto?"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "Remove this range"
msgstr "Eliminar este rango"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Remove this search term"
msgstr "Quitar este término de búsqueda"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Remove user"
msgstr "Eliminar usuario"

#: src/features/cases/components/SupplementaryLinksActivityContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Removed"
msgstr "Eliminado"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "removed {formattedRemovedCount} pts{removedPercentageSuffix}"
msgstr "se eliminaron {formattedRemovedCount} pts{removedPercentageSuffix}"

#: src/features/fim/photos/PhotoUploadRow.tsx
msgid "Removing…"
msgstr "Quitando…"

#: src/features/chatbot/components/SessionTabs.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentTabs.tsx
#: src/pages/details/extensions/flow/filesExt/FileMenuButton.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Rename"
msgstr "Cambiar nombre"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Rename {title}"
msgstr "Cambiar nombre de {title}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Rename {whiteboardLabel}"
msgstr "Cambiar nombre de {whiteboardLabel}"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Rename chat"
msgstr "Cambiar nombre del chat"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ManageViewsDialog.tsx
#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "Rename view"
msgstr "Cambiar nombre de vista"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Rendered from the imported CMMS record."
msgstr "Generado a partir del registro importado del CMMS."

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "Reopen the design flow at the {stage} stage. Refitting overwrites this run."
msgstr "Vuelva a abrir el flujo de diseño en la etapa {stage}. El reajuste sobrescribe esta ejecución."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Reopen this case before rerunning the analysis."
msgstr "Reabra este caso antes de volver a ejecutar el análisis."

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Reorder {tag}"
msgstr "Reordenar {tag}"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "Reordering cancelled. {tag} is back at position {position} of {count}."
msgstr "Reordenación cancelada. {tag} vuelve a la posición {position} de {count}."

#: src/designSystem/components/RecordHeader.tsx
#: src/features/lotoReports/components/LotoReportsTable.tsx
msgid "Report"
msgstr "Informe"

#: src/features/nnpp/nnppReportPresentation.ts
msgid "Report date"
msgstr "Fecha del informe"

#: src/pages/nnpp/reports/NnppReportDetailPage.tsx
msgid "Report ID"
msgstr "ID del informe"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Report issue"
msgstr "Reportar problema"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/pages/processData/components/helpGuide/HelpGuideDialog.tsx
msgid "Report Issue"
msgstr "Reportar problema"

#: src/features/lotoReports/components/LotoNewDraftForm.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/NewLotoReportDialog.tsx
msgid "Report name"
msgstr "Nombre del informe"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Reported"
msgstr "Fecha del reporte"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Reported by"
msgstr "Reportado por"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Reported: {reportedAt}"
msgstr "Reportado el {reportedAt}"

#: src/features/navbar/navConfig.ts
msgid "Reporting"
msgstr "Reportes"

#: src/features/navbar/navConfig.ts
msgid "Reports"
msgstr "Reportes"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Republish"
msgstr "Volver a publicar"

#: src/pages/metrics/hooks/useMetricsDataset.ts
msgid "Request failed"
msgstr "La solicitud falló"

#: src/features/knowledgeDocumentViewer/hooks/useInstrumentTimeSeriesData.ts
msgid "Request timeout"
msgstr "Tiempo de espera agotado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requested line"
msgstr "Línea solicitada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requested lines"
msgstr "Líneas solicitadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requested procurement; not proof of ordering or receipt."
msgstr "Adquisición solicitada; no prueba que se haya realizado el pedido ni la recepción."

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Required"
msgstr "Requerido"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Required date"
msgstr "Fecha requerida"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required docs"
msgstr "Documentos requeridos"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required PI tags"
msgstr "Etiquetas PI requeridas"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Required slots still unfilled"
msgstr "Campos requeridos aún sin completar"

#: src/features/permissions/components/PermissionsGate.tsx
msgid "Requires any of:"
msgstr "Requiere cualquiera de:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requisition issue date"
msgstr "Fecha de emisión de la solicitud"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Requisition term"
msgstr "Condición de la solicitud de compra"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Requisition terms"
msgstr "Condiciones de la solicitud"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Rerun analysis"
msgstr "Volver a ejecutar el análisis"

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
msgid "Resend"
msgstr "Reenviar"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Resend Invite"
msgstr "Reenviar invitación"

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
#: src/features/dataFilter/rangeFilter/RangeSelector.tsx
#: src/features/kestrelViewer/ui/tools/photoreel/adjustments/PhotoAdjustPanel.tsx
msgid "Reset"
msgstr "Restablecer"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset {value223_39} Y range to auto"
msgstr "Restablecer el rango Y de {value223_39} a automático"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset {value284_39} Y range to auto"
msgstr "Restablecer el rango Y de {value284_39} a automático"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Reset {value394_45} Y range"
msgstr "Restablecer el rango Y de {value394_45}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Reset chart to window"
msgstr "Restablecer el gráfico a la ventana"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Reset Data"
msgstr "Restablecer datos"

#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
msgid "Reset extension"
msgstr "Restablecer extensión"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Reset filters"
msgstr "Restablecer filtros"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "Reset this pen’s Y range to auto"
msgstr "Restablecer el rango Y de este trazo a automático"

#: src/features/timeSeries/components/XAxisSection.tsx
#: src/features/timeSeries/components/YAxisItem.tsx
msgid "Reset to automatic scaling"
msgstr "Restablecer al escalado automático"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Reset to Defaults"
msgstr "Restablecer valores predeterminados"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Reset to saved date"
msgstr "Restablecer a la fecha guardada"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Reset to window (90 / 10)"
msgstr "Restablecer a la ventana (90 / 10)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Reset view"
msgstr "Restablecer vista"

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Reset Y range to auto"
msgstr "Restablecer el rango Y a automático"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Reset Zoom"
msgstr "Restablecer zoom"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Residual"
msgstr "Residuo"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Residual band"
msgstr "Banda residual"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Residual histogram"
msgstr "Histograma de residuos"

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Residual lane"
msgstr "Carril de residuos"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Residuals — "
msgstr "Residuos — "

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Resize"
msgstr "Cambiar tamaño"

#: src/features/embeddedSidebar/components/EmbeddedSidebarPagesSplitHandle.tsx
msgid "Resize pages and recent chats"
msgstr "Cambiar el tamaño de las páginas y los chats recientes"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Resizing panes, toggling descriptions, and hiding pens."
msgstr "Cambiar el tamaño de los paneles, alternar las descripciones y ocultar trazos."

#: src/features/assetVizAdapter/ForecastAssetVizWindow.tsx
#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "Resolution"
msgstr "Resolución"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Resolve the import loading error before continuing."
msgstr "Resuelve el error al cargar la importación antes de continuar."

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Resolved"
msgstr "Resuelto"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Resolved by {tierLabel}"
msgstr "Resuelto por {tierLabel}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Resolved Today"
msgstr "Resueltos hoy"

#: src/features/knowledgeDocumentViewer/components/viewer/search/DocReferencePreviewCard.tsx
msgid "Resolving “{referenceLabel}”…"
msgstr "Resolviendo “{referenceLabel}”…"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Respond by"
msgstr "Plazo de respuesta"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Response date"
msgstr "Fecha de respuesta"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Responsibility"
msgstr "Responsabilidad"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionComparePane.tsx
#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore"
msgstr "Restaurar"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore loads the settings; Apply commits them."
msgstr "Restaurar carga la configuración; Aplicar la confirma."

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "Restore loads those settings into the knobs without applying them — you still press Apply, so a rollback is reviewable rather than instant."
msgstr "Restaurar carga esa configuración en los controles sin aplicarla; usted todavía debe presionar Aplicar, por lo que una reversión se puede revisar en vez de ser instantánea."

#: src/features/workbench/WorkbenchDock.tsx
msgid "Restore panel size"
msgstr "Restaurar tamaño del panel"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
msgid "Result"
msgstr "Resultado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Result status"
msgstr "Estado del resultado"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Resume"
msgstr "Reanudar"

#: src/features/fimReview/InspectSources.tsx
msgid "Retired"
msgstr "Retirado"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Retrain {methodCount} models"
msgstr "Volver a entrenar {methodCount} modelos"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Retrain model"
msgstr "Volver a entrenar el modelo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Retrieved sources"
msgstr "Fuentes encontradas"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
#: src/features/knowledgeDocumentViewer/graph/GraphStatus.tsx
#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
#: src/features/lotoReports/components/LotoPrintPreview.tsx
#: src/features/lotoReports/components/LotoSheetEditor.tsx
#: src/pages/cases/md/MdCasesListPage.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardOverview.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingSessionPlaceholder.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Retry"
msgstr "Reintentar"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
msgid "Retry loading page"
msgstr "Reintentar la carga de la página"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalSection.tsx
msgid "Retry loading pages"
msgstr "Reintentar la carga de páginas"

#: src/features/knowledgeDocumentViewer/components/sidebar/EvalMetadataSection.tsx
msgid "Retry loading saved edits"
msgstr "Reintentar cargar las ediciones guardadas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Retry search"
msgstr "Reintentar búsqueda"

#: src/pages/noMatch/NoMatch.tsx
msgid "Return to the <0>landing page?</0>"
msgstr "¿Volver a la <0>página de inicio?</0>"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Returned quantity"
msgstr "Cantidad devuelta"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
msgid "Rev"
msgstr "Rev"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanelHeader.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Rev {revision}"
msgstr "Rev. {revision}"

#: src/features/knowledgeDocumentViewer/utils/revisionHelpers.ts
msgid "Rev {revisionCode}"
msgstr "Rev {revisionCode}"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "Rev {revisionLabel}"
msgstr "Rev {revisionLabel}"

#: src/features/knowledgeDocumentViewer/utils/revisionHelpers.ts
msgid "Rev unknown"
msgstr "Rev desconocida"

#: src/features/knowledgeDocumentViewer/components/sidebar/RelatedDocumentsTable.tsx
msgid "Rev."
msgstr "Rev."

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Rev. Date"
msgstr "Fecha de rev."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Reverse axial direction"
msgstr "Invertir dirección axial"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Reverse circumferential direction"
msgstr "Invertir dirección circunferencial"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Revert"
msgstr "Revertir"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert failed."
msgstr "No se pudo revertir."

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert no longer active"
msgstr "La reversión ya no está activa"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Revert preview failed."
msgstr "No se pudo previsualizar la reversión."

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Revert to auto Y-scaling"
msgstr "Revertir al escalado Y automático"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverted"
msgstr "Revertido"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverted decision"
msgstr "Decisión revertida"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Reverting…"
msgstr "Revirtiendo…"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Review"
msgstr "Revisar"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Review and propose"
msgstr "Revisar y proponer"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Review revision history"
msgstr "Revisar el historial de revisiones"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "review: "
msgstr "revisión: "

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewer coverage of labeler pages"
msgstr "Cobertura de revisores en páginas de etiquetadores"

#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewers vs labelers"
msgstr "Revisores vs. etiquetadores"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
#: src/pages/evaluations/metadata/dashboard/components/DashboardComparisonRows.tsx
msgid "Reviewers vs pipeline"
msgstr "Revisores vs. proceso automático"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Revision"
msgstr "Revisión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Revision {from} to {to}"
msgstr "Revisión {from} a {to}"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderTitle.tsx
msgid "Revision {revisionCode}"
msgstr "Revisión {revisionCode}"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderTitle.tsx
msgid "Revision {revisionCode} ({revisionDate})"
msgstr "Revisión {revisionCode} ({revisionDate})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
msgid "Revision {to}"
msgstr "Revisión {to}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Revision and change history"
msgstr "Historial de revisiones y cambios"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "Revision audit"
msgstr "Auditoría de revisiones"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision audit needs review"
msgstr "La auditoría de revisiones requiere revisión"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionChangeCitations.tsx
msgid "Revision cloud"
msgstr "Nube de revisión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision Code"
msgstr "Código de revisión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision Date"
msgstr "Fecha de revisión"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision history"
msgstr "Historial de revisiones"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "Revision history couldn’t be computed."
msgstr "No se pudo calcular el historial de revisiones."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "Revision stacking failed: duplicate titles or dates"
msgstr "Falló el apilado de revisiones: títulos o fechas duplicados"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
msgid "Revision stacking failed:<0/>duplicate titles or dates"
msgstr "Falló el apilado de revisiones:<0/>títulos o fechas duplicados"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Revision unknown"
msgstr "Revisión desconocida"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Revision-controlled Drawing"
msgstr "Plano con control de revisión"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyList.tsx
msgid "Revisions ({memberCount})"
msgstr "Revisiones ({memberCount})"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdown.tsx
msgid "Revisions ({revisionCount})"
msgstr "Revisiones ({revisionCount})"

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Revoke access"
msgstr "Revocar acceso"

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
msgid "Revoke access for {userName}?"
msgstr "¿Revocar acceso de {userName}?"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Revoke access from an organization or site view."
msgstr "Revoca el acceso desde la vista de una organización o de un sitio."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Revoking access…"
msgstr "Revocando acceso…"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Right"
msgstr "Derecha"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Right now Val = 0 rows → band calibration will use spread blocks inside Train (prod behavior)."
msgstr "Ahora Val = 0 filas → la calibración de la banda usará bloques de dispersión dentro de Entrenamiento (comportamiento de prod.)."

#: src/features/workbench/LayoutToggles.tsx
msgid "right panel"
msgstr "panel derecho"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Right-drag"
msgstr "Arrastre derecho"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "risk"
msgstr "risk"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Risk"
msgstr "Riesgo"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetCountBreakdownLabels.tsx
#: src/pages/overview/sidebar/healthConditionFilter/SiteViewHealthConditionFilter.tsx
msgid "Risk Category"
msgstr "Categoría de riesgo"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Risk Level"
msgstr "Nivel de riesgo"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "RNG seed for MLP init / early-stopping split. Same seed + data → more repeatable fits."
msgstr "Semilla RNG para la inicialización del MLP / partición de detención temprana. La misma semilla + datos produce ajustes más repetibles."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Robotic Inspection"
msgstr "Inspección robótica"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Robotic Scan"
msgstr "Escaneo robótico"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "robust sigma"
msgstr "sigma robusta"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
msgid "ROC Only"
msgstr "Solo ROC"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Role"
msgstr "Función"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Role → tag"
msgstr "Rol → etiqueta"

#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
msgid "Role for {value53_42}"
msgstr "Rol para {value53_42}"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Rolling average"
msgstr "Promedio móvil"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Rolling average for this pen"
msgstr "Promedio móvil de este trazo"

#: src/features/timeSeries/experiment/CleaningControls.tsx
msgid "Rolling median/mean over surviving points (experiment-only; does not remove points)."
msgstr "Mediana/media móvil sobre los puntos restantes (solo experimento; no elimina puntos)."

#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/experiment/ModelKnobs.tsx
#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Rolling window"
msgstr "Ventana móvil"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Rolling window (periods)"
msgstr "Ventana móvil (períodos)"

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Rolodex system doc"
msgstr "Documento de sistema de Rolodex"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Route"
msgstr "Ruta"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Route stop"
msgstr "Parada de la ruta"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "row-level noise"
msgstr "ruido a nivel de fila"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Rows"
msgstr "Filas"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Rows per page"
msgstr "Filas por página"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Rows the gate rejects are neither learned from nor graded. Use it for at-load and steady-state, not to hide periods you dislike — that is what the excluded ranges below are for."
msgstr "Las filas rechazadas por la compuerta no se usan para aprender ni para puntuar. Úsela para condiciones con carga y estado estable, no para ocultar períodos no deseados; para eso sirven los intervalos excluidos de abajo."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Ruler"
msgstr "Regla"

#: src/features/timeSeries/experiment/RunComparison.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Run"
msgstr "Ejecutar"

#: src/features/fimReview/IdentityPanel.tsx
msgid "run {run}"
msgstr "ejecución {run}"

#: src/features/timeSeries/experiment/runPersistence.ts
msgid "Run {runNumber}"
msgstr "Ejecución {runNumber}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Run {value301_24}"
msgstr "Ejecución {value301_24}"

#: src/pages/processData/buildMode/hooks/useBuildSession.ts
msgid "Run {value57_24}"
msgstr "Ejecución {value57_24}"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Run a backtest — flagged points and episodes per method land here."
msgstr "Ejecute una prueba retrospectiva; los puntos y episodios marcados por método aparecerán aquí."

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "run a preview"
msgstr "ejecutar una vista previa"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Run backtest"
msgstr "Ejecutar prueba retrospectiva"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Run detection eval"
msgstr "Ejecutar evaluación de detección"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Run id"
msgstr "ID de ejecución"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Run now"
msgstr "Ejecutar ahora"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Run provenance"
msgstr "Procedencia de la ejecución"

#: src/features/sentinels/components/CasesPanel.tsx
msgid "Run RCA"
msgstr "Ejecutar RCA"

#: src/features/fimReview/SubjectDiagnostics.tsx
msgid "rung {rung}"
msgstr "peldaño {rung}"

#: src/features/facilityModel/views.ts
msgid "Running"
msgstr "En ejecución"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Running {readable}"
msgstr "En ejecución {readable}"

#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/timeSeries/agentTab/dock/BacktestTab.tsx
msgid "Running…"
msgstr "Ejecutando…"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "S Extent"
msgstr "Extensión S"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Safety and work practices"
msgstr "Seguridad y prácticas de trabajo"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Salesforce Account"
msgstr "Cuenta de Salesforce"

#: src/features/fimReview/ReviewActions.tsx
msgid "Same as another subject"
msgstr "Igual que otro sujeto"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Same as page 1. Changes apply to every page."
msgstr "Igual que la página 1. Los cambios se aplican a todas las páginas."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "same knobs"
msgstr "mismos parámetros"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "sampled every"
msgstr "muestreado cada"

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Sampling"
msgstr "Muestreo"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "Sampling mode"
msgstr "Modo de muestreo"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Sampling: aggregate {value146_34} @ {value146_71} {unit} · gap_fill={value146_103}"
msgstr "Muestreo: agregado {value146_34} @ {value146_71} {unit} · gap_fill={value146_103}"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Sampling: RAW historian points, outer-joined on exact timestamps (no mean binning)."
msgstr "Muestreo: puntos SIN PROCESAR del historiador, unidos externamente por marcas de tiempo exactas (sin agrupación por media)."

#: src/components/NamePromptModal.tsx
#: src/features/dataFilter/rangeFilter/RangeSelector.tsx
#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatQueuedMessageRow.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSelectedReport.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/DashboardHeader.tsx
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Save"
msgstr "Guardar"

#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
msgid "Save & Resend"
msgstr "Guardar y reenviar"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save all {familySize} revisions"
msgstr "Guardar las {familySize} revisiones"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Save and continue"
msgstr "Guardar y continuar"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save and Manage Views"
msgstr "Guardar y administrar vistas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Save as eval case"
msgstr "Guardar como caso de evaluación"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Save as LOTO report"
msgstr "Guardar como informe LOTO"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save as new"
msgstr "Guardar como nuevo"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Save caption"
msgstr "Guardar leyenda"

#: src/features/fimReview/ReviewActions.tsx
msgid "Save changes"
msgstr "Guardar cambios"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Save Changes"
msgstr "Guardar cambios"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "Save changes to {name}?"
msgstr "¿Guardar los cambios en {name}?"

#: src/features/timeSeries/components/DashboardHeader.tsx
msgid "Save chart"
msgstr "Guardar gráfico"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save config only"
msgstr "Guardar solo configuración"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Save Configurations"
msgstr "Guardar configuraciones"

#: src/features/richText/components/slashCommandCards/UnitConfigurationModal.tsx
msgid "Save current settings"
msgstr "Guardar ajustes actuales"

#: src/pages/site/components/CustomFieldInfoModal.tsx
msgid "Save Custom Field"
msgstr "Guardar campo personalizado"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Save document data"
msgstr "Guardar datos del documento"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Save document metadata"
msgstr "Guardar metadatos del documento"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Draft"
msgstr "Guardar borrador"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Save Draft + Publish"
msgstr "Guardar borrador + publicar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Save eval case"
msgstr "Guardar caso de evaluación"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Save Feedback"
msgstr "Guardar comentarios"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Save model"
msgstr "Guardar modelo"

#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Save name"
msgstr "Guardar nombre"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Notes"
msgstr "Guardar notas"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Save or discard your field changes to continue."
msgstr "Guarda o descarta los cambios en los campos para continuar."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save page data"
msgstr "Guardar datos de la página"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Save page metadata"
msgstr "Guardar metadatos de la página"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Save rule"
msgstr "Guardar regla"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Save this model so it can be edited, alerted on and backtested"
msgstr "Guarde este modelo para poder editarlo, generar alertas y realizar pruebas retrospectivas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Save this search"
msgstr "Guardar esta búsqueda"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Save Title"
msgstr "Guardar título"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Save trained model"
msgstr "Guardar modelo entrenado"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save view"
msgstr "Guardar vista"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Save Views"
msgstr "Guardar vistas"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "saved"
msgstr "guardado"

#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved"
msgstr "Guardado"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved ({value331_22})"
msgstr "Guardados ({value331_22})"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved ({value53_24})"
msgstr "Guardados ({value53_24})"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffDays}d ago"
msgstr "Guardado hace {diffDays} d"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffHours}h ago"
msgstr "Guardado hace {diffHours} h"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffMinutes}m ago"
msgstr "Guardado hace {diffMinutes} min"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffMonths}mo ago"
msgstr "Guardado hace {diffMonths, plural, one {# mes} other {# meses}}"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffWeeks}w ago"
msgstr "Guardado hace {diffWeeks} sem"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved {diffYears}y ago"
msgstr "Guardado hace {diffYears, plural, one {# año} other {# años}}"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved {value55_25} with model weights"
msgstr "Se guardó {value55_25} con pesos del modelo"

#: src/pages/processData/buildMode/hooks/useSaveExperiment.ts
msgid "Saved {value56_25}"
msgstr "Se guardó {value56_25}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchSuggestionsDropdown.tsx
msgid "Saved & recent searches"
msgstr "Búsquedas guardadas y recientes"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Saved alert"
msgstr "Alerta guardada"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved as {value332_24}"
msgstr "Guardado como {value332_24}"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Saved as a LOTO report."
msgstr "Guardado como informe LOTO."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatMessageActions.tsx
msgid "Saved as eval case"
msgstr "Guardado como caso de evaluación"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Saved experiments"
msgstr "Experimentos guardados"

#: src/features/timeSeries/utils/timeUtils.ts
msgid "Saved just now"
msgstr "Guardado hace un momento"

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Saved model"
msgstr "Modelo guardado"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Saved model to evaluate"
msgstr "Modelo guardado para evaluar"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Saved models"
msgstr "Modelos guardados"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Saved on the context bundle, so this plan survives a reload"
msgstr "Guardado en el paquete de contexto, por lo que este plan persiste tras una recarga"

#: src/features/timeSeries/agentTab/modelSeries.ts
msgid "Saved output of agent model {entryId}"
msgstr "Salida guardada del modelo del agente {entryId}"

#: src/features/timeSeries/experiment/runPersistence.ts
msgid "Saved run"
msgstr "Ejecución guardada"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saved the model"
msgstr "Se guardó el modelo"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saved the model as {name}"
msgstr "Se guardó el modelo como {name}"

#: src/features/knowledgeDocumentViewer/contexts/DocumentTabDataContext.tsx
msgid "Saved to Rolodex"
msgstr "Guardado en Rolodex"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "Saved with model weights"
msgstr "Guardado con pesos del modelo"

#: src/pages/processData/buildMode/rightPanel/PromoteModelAction.tsx
msgid "Saved without model weights — save with “Save trained model” first"
msgstr "Guardado sin pesos del modelo; primero use “Guardar modelo entrenado”"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Saving a view, then loading it from the switcher."
msgstr "Guardar una vista y luego cargarla desde el selector."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Saving access…"
msgstr "Guardando acceso…"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Saving and re-running the fit…"
msgstr "Guardando y volviendo a ejecutar el ajuste…"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Saving Draft..."
msgstr "Guardando borrador…"

#: src/features/timeSeries/agentTab/dock/SaveModelBar.tsx
msgid "Saving re-runs the fit on the server, so the saved model is reproducible from its parameters — then Alerting and Backtest open up."
msgstr "Al guardar, el ajuste vuelve a ejecutarse en el servidor para que el modelo sea reproducible a partir de sus parámetros; después se habilitan Alertas y Prueba retrospectiva."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
msgid "Saving response..."
msgstr "Guardando respuesta..."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Saving the current recommendation draft before publish."
msgstr "Guardando el borrador actual de la recomendación antes de publicar."

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saving the model"
msgstr "Guardando el modelo"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Saving the model as {name}"
msgstr "Guardando el modelo como {name}"

#: src/features/knowledgeDocumentViewer/components/metadata/DocumentMetadataEditSection.tsx
msgid "Saving these edits confirms that all document information is correct."
msgstr "Al guardar estas ediciones confirma que toda la información del documento es correcta."

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEditSection.tsx
msgid "Saving these edits confirms that all page information is correct."
msgstr "Al guardar estas ediciones confirma que toda la información de la página es correcta."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Saving user type…"
msgstr "Guardando tipo de usuario…"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Saving..."
msgstr "Guardando..."

#: src/features/fimReview/ReviewActions.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/MetadataEditFormChrome.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalChrome.tsx
#: src/features/lotoReports/components/LotoLeaveDialog.tsx
#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
#: src/features/lotoReports/components/LotoSaveStatusText.tsx
#: src/features/sentinels/components/MonitorTab.tsx
#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Saving…"
msgstr "Guardando…"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "scale={value123_51}"
msgstr "escala={value123_51}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageComparisonView.tsx
msgid "Scan from {imageDate}"
msgstr "Escaneo de {imageDate}"

#: src/features/timeSeries/components/ScatterplotSidebarDefault.tsx
#: src/features/timeSeries/components/YScaleControls.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Scatter"
msgstr "Dispersión"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Scatter and line, y-scales, and pen colors."
msgstr "Dispersión y línea, escalas Y y colores de los trazos."

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Scatter of the gap over the last {healthWindowDays} days, as a multiple of the baseline band. Past 2× the plant has left the regime the band describes: refit before reading the sigma."
msgstr "Dispersión de la diferencia en los últimos {healthWindowDays} días, como múltiplo de la banda de referencia. Por encima de 2×, la planta salió del régimen que describe la banda: reajusta el modelo antes de interpretar sigma."

#: src/pages/assetLens/components/tabs/canvas/TimeSeriesWorkflow.tsx
msgid "Scatterplot"
msgstr "Diagrama de dispersión"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Schedule"
msgstr "Programación"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Scheduled finish"
msgstr "Fin programado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Scheduled start"
msgstr "Inicio programado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Scheduled work; not evidence of execution."
msgstr "Trabajo programado; no constituye evidencia de ejecución."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "schema v"
msgstr "versión del esquema"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Scope"
msgstr "Alcance"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Scope and calculation details"
msgstr "Alcance y detalles del cálculo"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "Scoped by this label but not on the chart"
msgstr "Incluido por esta etiqueta, pero no en el gráfico"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to <0>{pinnedScopeName}</0>"
msgstr "Limitado a <0>{pinnedScopeName}</0>"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to case {pinnedCaseId}"
msgstr "Limitado al caso {pinnedCaseId}"

#: src/features/chatbot/components/ChatbotContent.tsx
msgid "Scoped to case: {pinnedCaseTitle}"
msgstr "Limitado al caso: {pinnedCaseTitle}"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Score complete rows only"
msgstr "Puntuar solo filas completas"

#: src/features/sentinels/hooks/useScoreRecent.ts
#: src/features/timeSeries/hooks/useSentinelScores.ts
msgid "scoring failed"
msgstr "la puntuación falló"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Scoring failed: "
msgstr "Error de puntuación: "

#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Scoring is capped at "
msgstr "La puntuación está limitada a "

#: src/features/sentinels/components/RecentScorePanel.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "Scoring…"
msgstr "Puntuando…"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Screenshot: {filename}"
msgstr "Captura de pantalla: {filename}"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "Screenshots"
msgstr "Capturas de pantalla"

#: src/components/SearchBar.tsx
#: src/features/embeddedSidebar/components/SidebarSearchMenuRow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/SearchToolbar.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Search"
msgstr "Buscar"

#: src/features/knowledgeDocumentViewer/components/table/cells/HeaderCell.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/ComboboxFilter.tsx
msgid "Search {columnHeaderLower}..."
msgstr "Buscar {columnHeaderLower}..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/MultiSelectFilterField.tsx
msgid "Search {searchPlaceholderLabel}..."
msgstr "Buscar {searchPlaceholderLabel}..."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/TableTopBar.tsx
msgid "Search {tableName}"
msgstr "Buscar en {tableName}"

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Search {title}"
msgstr "Buscar {title}"

#: src/features/navbar/MidSection.tsx
msgid "Search apps..."
msgstr "Buscar aplicaciones..."

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search by description..."
msgstr "Buscar por descripción…"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Search by name or asset type..."
msgstr "Buscar por nombre o tipo de activo…"

#: src/pages/manageAccess/components/table/UserSearchInput.tsx
msgid "Search by name or email"
msgstr "Buscar por nombre o correo"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Search by name, alias, or type..."
msgstr "Buscar por nombre, alias o tipo…"

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search by tag name..."
msgstr "Buscar por nombre de etiqueta…"

#: src/features/embeddedSidebar/components/SidebarNewChatButton.tsx
#: src/features/embeddedSidebar/components/SidebarSearchMenuRow.tsx
msgid "Search Cantilever ({COMMAND_PALETTE_SHORTCUT_LABEL})"
msgstr "Buscar en Cantilever ({COMMAND_PALETTE_SHORTCUT_LABEL})"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search documents"
msgstr "Buscar documentos"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search documents by title or description"
msgstr "Buscar documentos por título o descripción"

#: src/features/chatbot/components/DocumentAttachmentPopover.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Search documents..."
msgstr "Buscar documentos..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Search failed. Try again."
msgstr "La búsqueda falló. Inténtelo de nuevo."

#: src/pages/cases/components/RelatedObjectsSection.tsx
msgid "Search for {lowerCaseTitle}..."
msgstr "Buscar {lowerCaseTitle}…"

#: src/designSystem/components/Command.tsx
msgid "Search for a command to run..."
msgstr "Buscar un comando para ejecutar..."

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Search for..."
msgstr "Buscar..."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Search in {title}"
msgstr "Buscar en {title}"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Search labels"
msgstr "Buscar etiquetas"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Search labels, pens…"
msgstr "Buscar etiquetas y trazos…"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Search organizations"
msgstr "Buscar organizaciones"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Search organizations..."
msgstr "Buscar organizaciones..."

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Search Organizations(…)"
msgstr "Buscar organizaciones(…)"

#: src/pages/manageAccess/components/table/UserSearchInput.tsx
msgid "Search people by name or email"
msgstr "Buscar personas por nombre o correo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Search sensors..."
msgstr "Buscar sensores..."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Search sentinels by name or target tag..."
msgstr "Buscar centinelas por nombre o etiqueta objetivo…"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Search sites"
msgstr "Buscar sitios"

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Search sites..."
msgstr "Buscar sitios..."

#: src/features/navbar/siteSelectors/SiteSelectorsTopBar.tsx
msgid "Search Sites(…)"
msgstr "Buscar sitios(…)"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Search subjects by name, alias, or tag…"
msgstr "Buscar sujetos por nombre, alias o etiqueta…"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
msgid "Search tags"
msgstr "Buscar etiquetas"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTable.tsx
msgid "Search Tags"
msgstr "Buscar etiquetas"

#: src/features/timeSeries/experiment/TagPicker.tsx
msgid "Search tags…"
msgstr "Buscar etiquetas…"

#: src/components/DateTimeWithTimezone.tsx
msgid "Search timezones..."
msgstr "Buscar zonas horarias..."

#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
msgid "Search types"
msgstr "Buscar tipos"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Search users by name or email..."
msgstr "Buscar usuarios por nombre o correo electrónico…"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "Search vendors..."
msgstr "Buscar proveedores…"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Searched for <0>{searchLabel}</0>"
msgstr "Se buscó <0>{searchLabel}</0>"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched tags"
msgstr "Se buscaron etiquetas"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched tags for {query}"
msgstr "Se buscaron etiquetas para {query}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched the drawings"
msgstr "Se buscaron los planos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searched the drawings for {query}"
msgstr "Se buscaron los planos para {query}"

#: src/pages/metrics/components/MonthlyTable.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Searches"
msgstr "Búsquedas"

#: src/pages/metrics/Metrics.tsx
msgid "Searches — 7-day rolling average"
msgstr "Búsquedas — promedio móvil de 7 días"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Searches documents in multiple steps to answer your next question"
msgstr "Busca documentos en varios pasos para responder tu próxima pregunta"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching tags"
msgstr "Buscando etiquetas"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching tags for {query}"
msgstr "Buscando etiquetas para {query}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching the drawings"
msgstr "Buscando en los planos"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Searching the drawings for {query}"
msgstr "Buscando en los planos para {query}"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/CrossReferenceMarker.tsx
msgid "Searching this location"
msgstr "Buscando en esta ubicación"

#: src/features/knowledgeDocumentViewer/components/viewer/search/IntraDocSearchBar.tsx
msgid "Searching..."
msgstr "Buscando..."

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Searching…"
msgstr "Buscando…"

#: src/pages/alerts/AlertDetails.tsx
msgid "See Relevant Documents"
msgstr "Ver documentos relevantes"

#: src/pages/homepage/constants.ts
msgid "See system health, unit/component status, live sensor data, process flow diagrams, and system documentation."
msgstr "Consulte el estado del sistema, el estado de unidades/componentes, los datos de sensores en vivo, los diagramas de flujo de proceso y la documentación del sistema."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
msgid "Select"
msgstr "Seleccionar"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "Select {orgName}"
msgstr "Seleccionar {orgName}"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Select {title}"
msgstr "Seleccionar {title}"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Select a component"
msgstr "Seleccione un componente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Select a document to open it in the preview."
msgstr "Seleccione un documento para abrirlo en la vista previa."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Select a field to edit"
msgstr "Seleccione un campo a editar"

#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Select a notification to view details"
msgstr "Seleccione una notificación para ver los detalles"

#: src/features/timeSeries/components/chartTools/SensorSelect.tsx
#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
#: src/features/timeSeries/components/rulerTool/RulerMetricsPanel.tsx
msgid "Select a pen"
msgstr "Seleccione un trazo"

#: src/features/timeSeries/components/pointTool/PointAnnotationOverlay.tsx
msgid "Select a pen to snap this annotation."
msgstr "Seleccione un trazo para ajustar esta anotación."

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Select a sensor to insert:"
msgstr "Seleccione un sensor para insertar:"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Select a site to browse its facility model."
msgstr "Seleccione un sitio para explorar su modelo de instalación."

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "Select a site to explore its CMMS data."
msgstr "Seleccione un sitio para explorar sus datos de CMMS."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Select a site to open this Subject."
msgstr "Seleccione un sitio para abrir este sujeto."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySidebar.tsx
msgid "Select a site to view chats."
msgstr "Seleccione un sitio para ver los chats."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "Select a site to view its LOTO reports."
msgstr "Seleccione un sitio para ver sus informes LOTO."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Select a Subject from the list to inspect it before using it."
msgstr "Seleccione un sujeto de la lista para revisarlo antes de usarlo."

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Select a subject to see its details."
msgstr "Seleccione un sujeto para ver sus detalles."

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkActionModalEditConfiguration.tsx
msgid "Select a value"
msgstr "Seleccione un valor"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Select Action"
msgstr "Seleccionar acción"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Select alias"
msgstr "Seleccionar alias"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingFilterActions.tsx
msgid "Select all"
msgstr "Seleccionar todo"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Select an issue type"
msgstr "Seleccione un tipo de problema"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Select an organization in the sidebar to manage its access."
msgstr "Seleccione una organización en la barra lateral para administrar su acceso."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
#: src/pages/evaluations/metadata/dashboard/MetadataEvalsPage.tsx
msgid "Select an organization to view metadata evaluation metrics."
msgstr "Seleccione una organización para ver las métricas de evaluación de metadatos."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select annotation"
msgstr "Seleccionar anotación"

#: src/features/fimReview/ReviewActions.tsx
msgid "Select at least one alias to remove."
msgstr "Seleccione al menos un alias para eliminar."

#: src/designSystem/components/DatePicker.tsx
#: src/designSystem/components/DatePicker.tsx
msgid "Select date"
msgstr "Seleccionar fecha"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Select end date"
msgstr "Seleccione la fecha de finalización"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Select every tag that applies."
msgstr "Selecciona todas las etiquetas que correspondan."

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select field"
msgstr "Seleccionar campo"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select measurement"
msgstr "Seleccionar medición"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select metric"
msgstr "Seleccionar métrica"

#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Select on drawing"
msgstr "Seleccionar en el plano"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Select primitive"
msgstr "Seleccionar primitiva"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Select Revision"
msgstr "Seleccionar revisión"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Select sensor"
msgstr "Seleccionar sensor"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Select source"
msgstr "Seleccionar fuente"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
msgid "Select start date"
msgstr "Seleccione la fecha de inicio"

#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Select value"
msgstr "Seleccionar valor"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyCard.tsx
msgid "Selected"
msgstr "Seleccionado"

#: src/features/fimReview/ReviewActions.tsx
msgid "Selected aliases removed from fusion."
msgstr "Los alias seleccionados se eliminaron de la fusión."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Selected inspection option"
msgstr "Opción de inspección seleccionada"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Selected inspection options"
msgstr "Opciones de inspección seleccionadas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Selected response"
msgstr "Respuesta seleccionada"

#: src/features/timeSeries/components/panes/PensPane.tsx
msgid "Selected Tags"
msgstr "Etiquetas seleccionadas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Selection"
msgstr "Selección"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Self history (target lags)"
msgstr "Historial propio (retardos del objetivo)"

#: src/features/timeSeries/agentTab/chat/Composer.tsx
#: src/features/timeSeries/agentTab/chat/Composer.tsx
#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Send"
msgstr "Enviar"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Send a message to the Gecko Support Team."
msgstr "Envíe un mensaje al equipo de soporte de Gecko."

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Send this prompt"
msgstr "Enviar esta solicitud"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "Sending invitations…"
msgstr "Enviando invitaciones…"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Sensor"
msgstr "Sensor"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Sensor Data:"
msgstr "Datos del sensor:"

#: src/pages/alerts/AlertDetails.tsx
msgid "Sensor Name"
msgstr "Nombre del sensor"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Sensor: {sensorValue} mils"
msgstr "Sensor: {sensorValue} mil"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageMetadata.tsx
msgid "Sensor: {sensorValue}°F"
msgstr "Sensor: {sensorValue}°F"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorResultsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorResultsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
msgid "Sensors"
msgstr "Sensores"

#: src/pages/assetLens/components/AssetHeader.tsx
msgid "Sensors Tracked"
msgstr "Sensores rastreados"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Sent To Site"
msgstr "Enviado al sitio"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Sentinel"
msgstr "Centinela"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Sentinel {ordinal}"
msgstr "Centinela {ordinal}"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Sentinel name"
msgstr "Nombre del centinela"

#: src/features/timeSeries/ScatterplotContext.tsx
msgid "Sentinel target tag {target} was not found at this site"
msgstr "No se encontró la etiqueta objetivo del centinela {target} en este sitio"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/pages/facilityModel/FacilityModelCatalog.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Sentinels"
msgstr "Centinelas"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Sentinels ({sentinelCount})"
msgstr "Centinelas ({sentinelCount})"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "Separate addresses with a comma, a space, or Enter."
msgstr "Separe las direcciones con una coma, un espacio o la tecla Intro."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Sequence"
msgstr "Secuencia"

#: src/designSystem/components/RecordHeader.tsx
msgid "Serial"
msgstr "Número de serie"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Serial number"
msgstr "Número de serie"

#: src/features/sentinels/components/MonitorTab.tsx
msgid "Served method — whose residuals are watched"
msgstr "Método servido cuyos residuos se monitorean"

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "Served model"
msgstr "Modelo servido"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Service cost"
msgstr "Costo de servicios"

#: src/features/chatbot/components/ChatHistoryDrawer.tsx
msgid "Session"
msgstr "Sesión"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Session recording: Off (this browser)"
msgstr "Grabación de sesión: Desactivada (este navegador)"

#: src/features/navbar/configSettings/ConfigSettingsSidebarMenuItems.tsx
#: src/features/navbar/configSettings/ConfigSettingsTopBarMenuItems.tsx
msgid "Session recording: On"
msgstr "Grabación de sesión: activada"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Set 11x7 Image Aspect Ratio"
msgstr "Establecer relación de aspecto de imagen 11x7"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Set a target first."
msgstr "Primero establezca un objetivo."

#: src/features/copcPointClouds/CopcCoordinateOriginControl.tsx
msgid "Set origin"
msgstr "Definir origen"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Setpoint"
msgstr "Punto de ajuste"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Sets each driver’s phase shift to the lag with strongest absolute correlation vs the target in the preview scan."
msgstr "Establece el desfase de cada variable predictora en el retardo con mayor correlación absoluta respecto del objetivo en el análisis de vista previa."

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
#: src/features/navbar/configSettings/ConfigSettingsSidebar.tsx
#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Settings"
msgstr "Configuración"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Severity"
msgstr "Severidad"

#: src/features/timeSeries/components/timeSeriesScatterplot/MdDraftAlertCaseFlowPanels.tsx
msgid "Severity not set"
msgstr "Gravedad no establecida"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Severity: {nodeSeverity}"
msgstr "Gravedad: {nodeSeverity}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Severity: {severityLabel}"
msgstr "Gravedad: {severityLabel}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Share"
msgstr "Compartir"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Share Report"
msgstr "Compartir informe"

#: src/pages/cases/components/CasesTable.tsx
msgid "Shared Cases"
msgstr "Casos compartidos"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Sharing feedback and requesting improvements."
msgstr "Compartir comentarios y solicitar mejoras."

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Sharp heatmap"
msgstr "Mapa de calor nítido"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
msgid "Sheet {sheet}"
msgstr "Hoja {sheet}"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Sheet #"
msgstr "Hoja #"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Sheets"
msgstr "Hojas"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Shelve Case"
msgstr "Archivar temporalmente el caso"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Shelved"
msgstr "Archivado temporalmente"

#: src/pages/cases/md/MdCasesListPage.tsx
msgid "Shelved ({shelvedCount})"
msgstr "Archivados temporalmente ({shelvedCount})"

#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Shelving..."
msgstr "Archivando temporalmente…"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "shift (positive = driver leads)"
msgstr "desfase (positivo = variable predictora adelantada)"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/InstrumentTimeSeriesPreview.tsx
msgid "Shift+click: {linkedDocumentCount, plural, one {# doc} other {# docs}}"
msgstr "Shift+clic: {linkedDocumentCount, plural, one {# doc} other {# docs}}"

#: src/features/navbar/navConfig.ts
msgid "Ships"
msgstr "Embarcaciones"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
msgid "Should this page have metadata?"
msgstr "¿Esta página debería tener metadatos?"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
#: src/features/navbar/PermissionGateToggle.tsx
#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Show"
msgstr "Mostrar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Show {hiddenCount} more"
msgstr "Mostrar {hiddenCount} más"

#: src/features/sentinels/components/RecentScorePanel.tsx
#: src/features/workbench/LayoutToggles.tsx
msgid "Show {label}"
msgstr "Mostrar {label}"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Show a single course"
msgstr "Mostrar un solo curso"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Show Activity"
msgstr "Mostrar actividad"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Show all"
msgstr "Mostrar todo"

#: src/pages/details/visualization/tools/features/FeaturesToggleMenu.tsx
msgid "Show All"
msgstr "Mostrar todo"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show all alerts"
msgstr "Mostrar todas las alertas"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show all pens"
msgstr "Mostrar todos los trazos"

#: src/pages/details/visualization/screenshot/ShellCoursesSelector.tsx
msgid "Show all sections"
msgstr "Mostrar todas las secciones"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Show Anomalies"
msgstr "Mostrar anomalías"

#: src/pages/details/visualization/tools/VizDebugMenu.tsx
msgid "Show bin values"
msgstr "Mostrar valores de los intervalos"

#: src/pages/details/visualization/tools/CameraControlsToggle.tsx
msgid "Show camera controls"
msgstr "Mostrar controles de la cámara"

#: src/features/kestrelViewer/ui/tools/photoreel/PhotoReel2DToolbar.tsx
msgid "Show camera poses"
msgstr "Mostrar posiciones de cámara"

#: src/pages/overview/sidebar/capexOutlook/SiteViewCapExOutlookMenu.tsx
msgid "Show CapEx Outlook"
msgstr "Mostrar perspectiva de CapEx"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
msgid "Show chart controls"
msgstr "Mostrar controles del gráfico"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Show coordinate origin"
msgstr "Mostrar origen de coordenadas"

#: src/pages/details/visualization/tools/DebugMenuToggle.tsx
msgid "Show debug menu"
msgstr "Mostrar menú de depuración"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Show denoise as a rolling overlay"
msgstr "Mostrar reducción de ruido como superposición móvil"

#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/chartActions/PenDisplayActions.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Show descriptions"
msgstr "Mostrar descripciones"

#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/pages/cases/activity/ActivityContent.tsx
msgid "Show details"
msgstr "Mostrar detalles"

#: src/features/timeSeries/components/SentinelsTab.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Show drivers"
msgstr "Mostrar variables predictoras"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Show fewer"
msgstr "Mostrar menos"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Show filters"
msgstr "Mostrar filtros"

#: src/features/copcPointClouds/CopcSurfaceControl.tsx
msgid "Show fitted surface"
msgstr "Mostrar superficie ajustada"

#: src/pages/details/visualization/tools/KestrelTools.tsx
msgid "Show Kestrel"
msgstr "Mostrar Kestrel"

#: src/pages/details/visualization/tools/ShowLabelsToggle.tsx
msgid "Show labels"
msgstr "Mostrar etiquetas"

#: src/pages/details/visualization/tools/features/FeaturesToggleMenu.tsx
msgid "Show Labels"
msgstr "Mostrar etiquetas"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Show Legend"
msgstr "Mostrar leyenda"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Show less"
msgstr "Mostrar menos"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Show LiDAR"
msgstr "Mostrar LiDAR"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Show live process data"
msgstr "Mostrar datos de proceso en vivo"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show LOTO panel"
msgstr "Mostrar panel LOTO"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show Metadata"
msgstr "Mostrar metadatos"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Show Minimap"
msgstr "Mostrar minimapa"

#: src/features/forecastNotifications/NotificationPreferencesModal.tsx
msgid "Show notifications in Cantilever"
msgstr "Mostrar notificaciones en Cantilever"

#: src/pages/details/visualization/screenshot/ShellCoursesSelector.tsx
msgid "Show only this section"
msgstr "Mostrar solo esta sección"

#: src/features/knowledgeDocumentViewer/components/toolbar/KnowledgeDocumentHeaderBar.tsx
msgid "Show Page Thumbnails"
msgstr "Mostrar miniaturas de páginas"

#: src/features/navbar/PermissionGateToggle.tsx
msgid "Show permission gates"
msgstr "Mostrar restricciones de permisos"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
msgid "Show photo counts"
msgstr "Mostrar recuentos de fotos"

#: src/pages/details/visualization/tools/NiraToggle.tsx
msgid "Show Photogrammetry"
msgstr "Mostrar fotogrametría"

#: src/pages/details/visualization/tools/CopcPointCloudToggle.tsx
#: src/pages/details/visualization/tools/LidarPointCloudToggle.tsx
msgid "Show Point Cloud"
msgstr "Mostrar nube de puntos"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Show range / gate as pen filters"
msgstr "Mostrar intervalo/compuerta como filtros de trazos"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "Show rulers"
msgstr "Mostrar reglas"

#: src/pages/processData/buildMode/rightPanel/SavedModelsPane.tsx
msgid "Show shelf filters"
msgstr "Mostrar filtros de estante"

#: src/pages/kestrel/components/DesktopSidebarToggle.tsx
msgid "Show sidebar"
msgstr "Mostrar barra lateral"

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "Show tag names"
msgstr "Mostrar nombres de etiquetas"

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "Show tags"
msgstr "Mostrar etiquetas"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Show the prior Subjects folded into this one"
msgstr "Mostrar los sujetos anteriores incorporados en este"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Show the references behind this alias"
msgstr "Mostrar las referencias detrás de este alias"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Show these buckets on the chart"
msgstr "Mostrar estos intervalos en el gráfico"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Show this sentinel's driver tags on the chart too"
msgstr "Mostrar también las etiquetas de las variables predictoras de este centinela en el gráfico"

#: src/features/timeSeries/experiment/ModelKnobs.tsx
msgid "Show this window on the chart"
msgstr "Mostrar esta ventana en el gráfico"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Show toggles"
msgstr "Mostrar controles"

#: src/pages/details/visualization/tools/HideToolbarToggle.tsx
msgid "Show Toggles"
msgstr "Mostrar controles"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Show tooltip when hovering on links"
msgstr "Mostrar información al pasar el cursor sobre los enlaces"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadFailureDetails.tsx
msgid "Show upload failure details"
msgstr "Mostrar detalles del fallo de carga"

#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
msgid "Show/Hide"
msgstr "Mostrar/Ocultar"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "showed {shown}"
msgstr "mostró {shown}"

#: src/features/timeSeries/components/timeSeriesScatterplot/PenCapNotice.tsx
msgid "Showing "
msgstr "Mostrando "

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
msgid "Showing {fromLabel}–{toLabel} of {totalLabel}"
msgstr "Mostrando {fromLabel}–{toLabel} de {totalLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentCardResultCountLabel.tsx
msgid "Showing {rangeStart}-{rangeEnd} of {displayCount, plural, one {# result} other {# results}}"
msgstr "Mostrando {rangeStart}-{rangeEnd} de {displayCount, plural, one {# resultado} other {# resultados}}"

#: src/pages/details/visualization/Visualization.tsx
msgid "Showing inspection \"{inspectionName}\" from {inspectionDate}."
msgstr "Mostrando la inspección \"{inspectionName}\" del {inspectionDate}."

#: src/pages/details/visualization/Visualization.tsx
msgid "Showing inspection \"{inspectionName}\"."
msgstr "Mostrando la inspección \"{inspectionName}\"."

#: src/features/knowledgeDocumentViewer/graph/useDocumentGraph.ts
msgid "Showing partial graph. Extraction is incomplete."
msgstr "Se muestra un grafo parcial. La extracción está incompleta."

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Showing the top {shownCount} of {totalMatchesLabel} matches — narrow the search."
msgstr "Mostrando las primeras {shownCount} de {totalMatchesLabel} coincidencias; restrinja la búsqueda."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Showing the top work-order matches. Narrow your question for more specific results."
msgstr "Se muestran las órdenes de trabajo más relevantes. Precisa tu pregunta para obtener resultados más específicos."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Shows how many rows have the target and drivers present together. Off-frequency sensors do not invent mid-points: a value only appears on a row if that tag had a sample in that bin (aggregate) or that exact timestamp (raw). Limited driver ffill can borrow a few prior driver values; the target is never filled. kNN needs enough drivers on the same row; MLP can mask missing drivers."
msgstr "Muestra cuántas filas tienen juntos el objetivo y las variables predictoras. Los sensores con otra frecuencia no inventan puntos intermedios: un valor solo aparece si la etiqueta tuvo una muestra en ese intervalo (agregado) o en esa marca de tiempo exacta (sin procesar). El relleno limitado puede reutilizar algunos valores anteriores de las variables predictoras; el objetivo nunca se rellena. kNN necesita suficientes variables en la misma fila; MLP puede enmascarar las faltantes."

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Signal"
msgstr "Señal"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Signal roles"
msgstr "Roles de señales"

#: src/features/mdCases/components/CaseStorySection.tsx
msgid "Signals {ordinal}"
msgstr "Señales {ordinal}"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Signature (Control Authority):"
msgstr "Firma (Autoridad de control):"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Signature:"
msgstr "Firma:"

#: src/features/timeSeries/components/YAxisModeSection.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Single"
msgstr "Único"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Single page"
msgstr "Página única"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Single Y-Scale"
msgstr "Escala Y única"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonTable.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardDisagreementFilters.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardFieldDrilldown.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/metrics/components/SiteRowsTable.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Site"
msgstr "Sitio"

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "Site access"
msgstr "Acceso a sitios"

#: src/features/navbar/navConfig.ts
msgid "Site Context & Monitoring"
msgstr "Contexto del sitio y monitoreo"

#: src/pages/site/components/SiteFilesTableCard.tsx
msgid "Site Files"
msgstr "Archivos del sitio"

#: src/pages/site/components/SiteInfoCard.tsx
msgid "Site Info"
msgstr "Información del sitio"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Site name"
msgstr "Nombre del sitio"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Site Name"
msgstr "Nombre del sitio"

#: src/pages/overview/SiteViewPageContainer.tsx
msgid "Site not found"
msgstr "Sitio no encontrado"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Site outputs · {siteId}"
msgstr "Salidas del sitio · {siteId}"

#: src/features/navbar/navConfig.ts
msgid "Site Overview"
msgstr "Resumen del sitio"

#: src/pages/documents/Documents.tsx
msgid "Site unavailable"
msgstr "Sitio no disponible"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Site-specific fields"
msgstr "Campos propios del sitio"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Site: {siteId}"
msgstr "Sitio: {siteId}"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardSites.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Sites"
msgstr "Sitios"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Sites live"
msgstr "Sitios activos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Size"
msgstr "Tamaño"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Skill"
msgstr "Especialidad"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Skip"
msgstr "Omitir"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Skipped"
msgstr "Omitido"

#: src/pages/site/forms/siteInfoFormFields.ts
msgid "Slack Channel"
msgstr "Canal de Slack"

#: src/features/knowledgeDocumentViewer/components/toolbar/OutlineUnitList.tsx
msgid "Slide {startPage}"
msgstr "Diapositiva {startPage}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PdfDownloadMenuOptions.tsx
msgid "Slides"
msgstr "Diapositivas"

#: src/features/facilityModel/columns.ts
msgid "Slots"
msgstr "Campos"

#: src/features/kestrelViewer/ui/tools/photoreel/DockedPhotoReelPanel.tsx
msgid "Smart Select"
msgstr "Smart Select"

#: src/features/kestrelViewer/ui/tools/photoreel/annotation/usePhotoAnnotationSession.ts
msgid "Smart Select failed. Please try again."
msgstr "No se pudo completar Smart Select. Inténtelo de nuevo."

#: src/pages/details/visualization/tools/HeatmapToggle.tsx
#: src/pages/details/visualization/tools/HeatmapToggle.tsx
msgid "Smooth heatmap"
msgstr "Mapa de calor suavizado"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "smoothing {before}→{after}"
msgstr "suavizado {before}→{after}"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "smoothing must be 0 (off) or between 2 and 120 days"
msgstr "el suavizado debe ser 0 (desactivado) o entre 2 y 120 días"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "SMP-03"
msgstr "SMP-03"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Snap to {label} view"
msgstr "Cambiar a la vista {label}"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportPriorityField.tsx
msgid "Solve now, including outside working hours."
msgstr "Resolver ahora, incluso fuera del horario laboral."

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "Some attached pages could not be found. They print as placeholder pages."
msgstr "No se encontraron algunas páginas adjuntas. Se imprimen como páginas de marcador de posición."

#: src/features/knowledgeDocumentViewer/graph/useGraphInstrumentation.ts
msgid "Some linked process data could not be loaded."
msgstr "No se pudieron cargar algunos datos de proceso vinculados."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Some search methods were unavailable or work-order evidence was shortened. Open a source to review the full imported record."
msgstr "Algunos métodos de búsqueda no estuvieron disponibles o se acortó la evidencia de las órdenes de trabajo. Abre una fuente para revisar el registro importado completo."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Something went wrong"
msgstr "Algo salió mal"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "Something went wrong."
msgstr "Ocurrió un error."

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Something wrong? Edit this Subject in the Facility Model"
msgstr "¿Algo incorrecto? Edite este Sujeto en el Facility Model"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort"
msgstr "Ordenar"

#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Sort by {columnLabel}"
msgstr "Ordenar por {columnLabel}"

#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "Sort by {label}"
msgstr "Ordenar por {label}"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Sort by newest first"
msgstr "Ordenar del más reciente al más antiguo"

#: src/pages/cases/activity/ActivitySection.tsx
msgid "Sort by oldest first"
msgstr "Ordenar del más antiguo al más reciente"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort newest first"
msgstr "Ordenar por más reciente primero"

#: src/features/forecastNotifications/NotificationListPanel.tsx
msgid "Sort oldest first"
msgstr "Ordenar más antiguos primero"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgctxt "Drag handle role description"
msgid "sortable"
msgstr "reordenable"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "sorted by relevance"
msgstr "ordenado por relevancia"

#: src/features/fimReview/IdentityPanel.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/timeSeries/components/AllTagsTab.tsx
#: src/features/timeSeries/components/panes/TagFilterControls.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
msgid "Source"
msgstr "Fuente"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Source "
msgstr "Fuente "

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Source changed by"
msgstr "Modificado en origen por"

#: src/features/facilityModel/provenance/ProvenanceChain.tsx
msgid "Source documents ({documentCount})"
msgstr "Documentos de origen ({documentCount})"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Source key"
msgstr "Clave de origen"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Source of Image"
msgstr "Fuente de la imagen"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Source record"
msgstr "Registro de origen"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Source system"
msgstr "Sistema de origen"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Source type"
msgstr "Tipo de fuente"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Source Type"
msgstr "Tipo de fuente"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
#: src/features/knowledgeDocumentViewer/workOrders/workOrderSheet.ts
msgid "Source updated"
msgstr "Origen actualizado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Source version"
msgstr "Versión del origen"

#: src/features/facilityModel/columns.ts
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Sources"
msgstr "Fuentes"

#: src/features/fimReview/InspectSources.tsx
msgid "Spare"
msgstr "Repuesto"

#: src/features/copcPointClouds/CopcSpatialContextControl.tsx
msgid "Spatial context radius from asset"
msgstr "Radio de contexto espacial desde el activo"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Spec needed · Unit: <0/>"
msgstr "Se necesita especificación · Unidad: <0/>"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Spec request"
msgstr "Solicitud de especificación"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Specs needed"
msgstr "Faltan especificaciones"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend Next 10 Years"
msgstr "Gasto en los próximos 10 años"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend Next 25 Years"
msgstr "Gasto en los próximos 25 años"

#: src/pages/overview/sidebar/capexOutlook/kpiCards/SiteViewCapExKPIs.tsx
msgid "Spend This Year"
msgstr "Gasto de este año"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Split"
msgstr "Dividir"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Split builder"
msgstr "Generador de divisiones"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Split each chunk in time instead of assigning whole chunks: the last N% of rows within EVERY un-assigned chunk become test (min 1 test and 1 train row per chunk), the rest train. Chunks you explicitly click keep their whole-chunk role and are never tail-split. A window that collapses to a single chunk always tail-splits (at 1 − train frac) so there is something to score."
msgstr "Divida cada bloque en el tiempo en vez de asignarlo completo: el último N% de las filas de CADA bloque sin asignar se usa para prueba y el resto para entrenamiento, con al menos una fila de cada tipo por bloque. Los bloques que seleccione explícitamente conservan su rol completo y no se dividen. Si la ventana queda en un solo bloque, siempre se reserva su parte final para prueba (1 − fracción de entrenamiento), de modo que haya datos para evaluar."

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "split ranges"
msgstr "intervalos de división"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Split strategy"
msgstr "Estrategia de división"

#: src/features/fimReview/DecisionHistory.tsx
msgid "Split Subject"
msgstr "Dividir sujeto"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Spotted an issue, or need something this page doesn't do yet? We want to hear about it."
msgstr "¿Detectó un problema o necesita una función que esta página aún no ofrece? Queremos conocer su opinión."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "spread blocks carved from Train"
msgstr "bloques de calibración extraídos de Entrenamiento"

#: src/features/chatbot/api/sseClient.ts
msgid "SSE connection error"
msgstr "Error de conexión SSE"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Stability window"
msgstr "Ventana de estabilidad"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Staged"
msgstr "Preparado"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Staging files..."
msgstr "Preparando archivos..."

#: src/features/facilityModel/views.ts
msgid "Stale"
msgstr "Desactualizado"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Standard deviation"
msgstr "Desviación estándar"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "Standard Deviation"
msgstr "Desviación estándar"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Standard search"
msgstr "Búsqueda estándar"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Standard search (7d avg)"
msgstr "Búsqueda estándar (prom. de 7 días)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Start"
msgstr "Inicio"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Start a new chat focused on this case"
msgstr "Iniciar un chat nuevo centrado en este caso"

#: src/features/timeSeries/agentTab/AgentTab.tsx
msgid "Start a new conversation"
msgstr "Iniciar una conversación"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/filters/DateFilter.tsx
#: src/features/timeSeries/components/CustomRangePicker.tsx
msgid "Start date"
msgstr "Fecha de inicio"

#: src/features/timeSeries/components/AbsoluteDateConfig.tsx
#: src/features/timeSeries/components/RelativeDateConfig.tsx
msgid "Start Date"
msgstr "Fecha de inicio"

#: src/pages/evaluations/metadata/components/LabelingActions.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingLanding.tsx
msgid "Start labeling"
msgstr "Comenzar a etiquetar"

#: src/features/timeSeries/components/CustomRangePicker.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Start Time"
msgstr "Hora de inicio"

#: src/components/richText/LexicalEditorWrapper.tsx
msgid "Start typing..."
msgstr "Comience a escribir…"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Starting…"
msgstr "Iniciando…"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "state"
msgstr "estado"

#: src/features/fimReview/InspectSources.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatusFilterMenu.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
#: src/pages/cases/md/mdCasesListSearchContract.ts
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Status"
msgstr "Estado"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed"
msgstr "Estado cambiado"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed from {fromLabel}"
msgstr "El estado cambió de {fromLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed from {fromLabel} to {toLabel}"
msgstr "El estado cambió de {fromLabel} a {toLabel}"

#: src/features/mdCases/components/CaseTimeline.tsx
msgid "Status changed to {toLabel}"
msgstr "El estado cambió a {toLabel}"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Status label"
msgstr "Descripción del estado"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Status unavailable"
msgstr "Estado no disponible"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Status updated"
msgstr "Estado actualizado"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Status: {status}"
msgstr "Estado: {status}"

#: src/pages/documents/PowerCustomerUploadLeaveWarning.tsx
msgid "Stay on page"
msgstr "Permanecer en la página"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Std dev"
msgstr "Desv. est."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "step"
msgstr "salto"

#: src/features/timeSeries/experiment/CorrelationCard.tsx
msgid "Step"
msgstr "Paso"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "Step — something changed"
msgstr "Escalón: algo cambió"

#: src/features/chatbot/components/ChatbotInputCard.tsx
#: src/features/chatbot/components/conversationMessage/UserMessage.tsx
#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Stop"
msgstr "Detener"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatComposerActionButton.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatComposerActionButton.tsx
msgid "Stop generating"
msgstr "Detener generación"

#: src/features/timeSeries/agentTab/chat/Composer.tsx
msgid "Stop the agent"
msgstr "Detener el agente"

#: src/features/chatbot/components/Conversation.tsx
#: src/features/chatbot/components/Conversation.tsx
msgid "Stopped"
msgstr "Detenido"

#: src/features/sentinels/components/SentinelList.tsx
msgid "stopped reporting · "
msgstr "dejó de informar · "

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Stopped."
msgstr "Detenido."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Storeroom material availability"
msgstr "Disponibilidad de materiales en almacén"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Storeroom snapshot; not a reservation or availability guarantee."
msgstr "Instantánea de existencias del almacén; no constituye una reserva ni garantiza disponibilidad."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Storeroom total balance"
msgstr "Saldo total del almacén"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Strategy"
msgstr "Estrategia"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Stretch Asset to Fit Screen"
msgstr "Estirar el activo para ajustarlo a la pantalla"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Stride between shifts in the correlation scan (1 = every period). Larger steps make the scan faster but coarser — best-shift picks may land off the true peak."
msgstr "Paso entre desfases en el análisis de correlación (1 = cada período). Los pasos mayores aceleran el análisis, pero reducen la precisión y pueden alejar la selección del pico real."

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Strikethrough"
msgstr "Tachado"

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Strong"
msgstr "Buena"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Structural correction failed: {message}"
msgstr "Error en la corrección estructural: {message}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Structural load and capacity analysis"
msgstr "Análisis de carga y capacidad estructural"

#: src/pages/details/visualization/tools/StructuresToggle.tsx
msgid "Structures disabled"
msgstr "Estructuras deshabilitadas"

#: src/pages/details/visualization/tools/StructuresToggle.tsx
msgid "Structures shown"
msgstr "Estructuras mostradas"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Style Pens"
msgstr "Aplicar estilo a los trazos"

#: src/features/knowledgeDocumentViewer/components/sidebar/KnowledgeDocumentSidebar.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "Subject"
msgstr "Sujeto"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subject {suffix}"
msgstr "Sujeto {suffix}"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Subject aliases"
msgstr "Alias del sujeto"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subject assignment for {recordId}"
msgstr "Asignación de sujeto para {recordId}"

#: src/features/modelOperations/SubjectDetails.tsx
msgid "Subject classification"
msgstr "Clasificación del sujeto"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject classification updated."
msgstr "Clasificación del sujeto actualizada."

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SubjectTimeSeriesTooltip.tsx
msgid "subject details"
msgstr "detalles del sujeto"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject details"
msgstr "Detalles del sujeto"

#: src/features/fimReview/IdentityPanel.tsx
msgid "Subject history"
msgstr "Historial del sujeto"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject identity"
msgstr "Identidad del sujeto"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject references"
msgstr "Referencias del sujeto"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject review failed: {failureMessage}"
msgstr "La revisión del sujeto falló: {failureMessage}"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject review failed: {reason}"
msgstr "La revisión del sujeto falló: {reason}"

#: src/features/fimReview/ReviewActions.tsx
msgid "Subject review outcome"
msgstr "Resultado de la revisión del sujeto"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Subject target picker"
msgstr "Selector de sujeto de destino"

#: src/features/fimReview/reviewOutcome.ts
msgid "Subject validated."
msgstr "Sujeto validado."

#: src/features/fimReview/reviewOutcome.ts
msgid "Subject validated. Its Asset Instance will appear in Assets."
msgstr "Sujeto validado. Su instancia de activo aparecerá en Activos."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "Subjects"
msgstr "Sujetos"

#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Subjects that have an Asset Instance, in any fill state"
msgstr "Sujetos que tienen una instancia de activo, en cualquier estado de llenado"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Subjects:"
msgstr "Sujetos:"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
#: src/features/chatbot/components/ChatbotInputCard.tsx
#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Submit"
msgstr "Enviar"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Submit & Regenerate"
msgstr "Enviar y volver a generar"

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Submit Request"
msgstr "Enviar solicitud"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Submitting..."
msgstr "Enviando..."

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Subsystem"
msgstr "Subsistema"

#: src/features/mdCases/components/MonitorLineagePanel.tsx
msgid "Subsystem models ({subsystemModelCount})"
msgstr "Modelos de subsistema ({subsystemModelCount})"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Subsystem: {subsystem}"
msgstr "Subsistema: {subsystem}"

#: src/features/notifications/GeckoNotificationContext.tsx
msgid "Success"
msgstr "Éxito"

#: src/features/timeSeries/services/workOrderService.ts
msgid "Successfully imported {value130_42} work orders."
msgstr "Se importaron correctamente {value130_42} órdenes de trabajo."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Successfully sent support email!"
msgstr "¡Correo a soporte enviado correctamente!"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Successfully updated in Rolodex!"
msgstr "Se actualizó correctamente en Rolodex."

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "Suggested update"
msgstr "Actualización sugerida"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Summarize"
msgstr "Resumir"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Summary"
msgstr "Resumen"

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
msgid "superseded"
msgstr "reemplazada"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Supervisor"
msgstr "Supervisor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Supplier identity; not proof of equipment compatibility."
msgstr "Identidad del proveedor; no prueba la compatibilidad del equipo."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "Support request sent successfully"
msgstr "Solicitud de soporte enviada correctamente"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Supported: PDF, Word, Excel, PowerPoint"
msgstr "Compatibles: PDF, Word, Excel, PowerPoint"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Supports JPG, PNG, GIF, WEBP. Max 5MB."
msgstr "Admite JPG, PNG, GIF y WEBP. Máx. 5 MB."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Survivor"
msgstr "Superviviente"

#: src/features/navbar/LanguageToggle.tsx
msgid "Switch language to English"
msgstr "Cambiar el idioma a inglés"

#: src/features/navbar/LanguageToggle.tsx
msgid "Switch language to Spanish"
msgstr "Cambiar el idioma a español"

#: src/features/facilityModel/columns.ts
#: src/features/facilityModel/columns.ts
#: src/features/fimReview/InspectSources.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "System"
msgstr "Sistema"

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "System {subsystem}"
msgstr "Sistema {subsystem}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System connectivity and behavior"
msgstr "Conectividad y comportamiento del sistema"

#: src/features/fimEvidence/SubjectGlyphs.tsx
#: src/features/fimReview/provenance.ts
#: src/features/modelOperations/Corroboration.tsx
msgid "System documents"
msgstr "Documentos del sistema"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System integration and network architecture"
msgstr "Integración de sistemas y arquitectura de red"

#: src/features/navbar/navConfig.ts
#: src/pages/homepage/constants.ts
msgid "System Lens"
msgstr "System Lens"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "System operating principles"
msgstr "Principios de operación del sistema"

#: src/pages/systemView/components/DataPanel.tsx
msgid "System View"
msgstr "Vista del sistema"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "T Threshold"
msgstr "Umbral T"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min by component"
msgstr "t-min por componente"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min by shell course"
msgstr "t-min por virola"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionAnalysisCitations.ts
msgid "t-min given by the user"
msgstr "t-min indicado por el usuario"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentInspectionChip.tsx
msgid "t-min: {tminMethod}"
msgstr "t-min: {tminMethod}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentViewModeToggle.tsx
msgid "Table"
msgstr "Tabla"

#: src/features/chatbot/components/AttachmentPills.tsx
#: src/features/fimReview/IdentityPanel.tsx
msgid "tag"
msgstr "tag"

#: src/features/fimReview/InspectSources.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Tag"
msgstr "Etiqueta"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Tag\n"
"#"
msgstr ""
"Etiq.\n"
"#"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Tag #"
msgstr "N.º de etiqueta"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "tag configuration"
msgstr "configuración de etiquetas"

#: src/features/timeSeries/components/panes/TagConfigurationPane.tsx
#: src/features/timeSeries/components/ScatterplotSidebar.tsx
#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Tag Configuration"
msgstr "Configuración de etiquetas"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Tag drilldown (native interval)"
msgstr "Desglose de etiqueta (intervalo nativo)"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "tag legend"
msgstr "leyenda de etiquetas"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "tag map"
msgstr "mapa de etiquetas"

#: src/features/timeSeries/components/AllTagsTable.tsx
#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
msgid "Tag Name"
msgstr "Nombre de la etiqueta"

#: src/features/timeSeries/components/ScatterplotSidebar.tsx
msgid "Tag Search"
msgstr "Búsqueda de etiquetas"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Tag source"
msgstr "Fuente de la etiqueta"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "Taggable Users for @ Mentions"
msgstr "Usuarios etiquetables en menciones con @"

#: src/features/timeSeries/components/panes/TagBrowserPane.tsx
#: src/features/timeSeries/components/ScatterplotConfigSidebar.tsx
msgid "Tags"
msgstr "Etiquetas"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Tags come from the chart’s pens. Removing a role the expression uses breaks it."
msgstr "Las etiquetas provienen de los trazos del gráfico. Eliminar un rol usado por la expresión la invalida."

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "tags picked · dataset “{dataset}”"
msgstr "etiquetas elegidas · conjunto de datos “{dataset}”"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Tags used to explain/remove structure from the target. Flatness = variance reduction — how much of the target’s movement those tags account for. Each tag’s chip also shows Spearman ρ, a shape-free rank correlation (“is it related at all”), independent of the chosen method."
msgstr "Etiquetas usadas para explicar o eliminar estructura del objetivo. Planitud = reducción de varianza, es decir, cuánto movimiento del objetivo explican. Cada etiqueta también muestra ρ de Spearman, una correlación de rangos independiente del método elegido."

#: src/pages/processData/buildMode/components/BuildCoverageBanner.tsx
msgid "Tags with a live monitor, out of every tag on this site — plus tags with saved experiments that are not promoted yet."
msgstr "Etiquetas con un monitor activo, entre todas las del sitio, más las que tienen experimentos guardados aún sin promover."

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with an active monitor"
msgstr "Etiquetas con un monitor activo"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with experiments but no active monitor"
msgstr "Etiquetas con experimentos, pero sin monitor activo"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags with recent data"
msgstr "Etiquetas con datos recientes"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Tags without recent data"
msgstr "Etiquetas sin datos recientes"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Tail fraction"
msgstr "Fracción de cola"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Tail-split each chunk"
msgstr "Dividir cada bloque por cola"

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "Take a photo"
msgstr "Tomar una foto"

#: src/pages/details/visualization/screenshot/ScreenshotTools.tsx
msgid "Take Screenshot"
msgstr "Tomar captura de pantalla"

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Take these labels off the chart"
msgstr "Quitar estas etiquetas del gráfico"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Take this model off the chart"
msgstr "Quitar este modelo del gráfico"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "Take this model off the chart and bring your pens back"
msgstr "Quitar este modelo del gráfico y restaurar tus trazos"

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModePanel.tsx
msgid "Tap a highlighted subject to add a photo."
msgstr "Toque un sujeto resaltado para agregar una foto."

#: src/pages/processData/buildMode/components/ModelingTagsPane.tsx
msgid "target"
msgstr "objetivo"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "Target"
msgstr "Objetivo"

#: src/features/sentinels/components/CasesPanel.tsx
#: src/features/sentinels/components/MonitorTab.tsx
msgid "Target "
msgstr "Objetivo "

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "target {target}"
msgstr "objetivo {target}"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Target / Drivers"
msgstr "Objetivo / Variables predictoras"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Target + all drivers (exact)"
msgstr "Objetivo + todas las variables predictoras (exacto)"

#: src/features/timeSeries/experiment/SamplingKnobs.tsx
msgid "Target and drivers get a stepped line on this grid, fetched the same way training fetches it."
msgstr "El objetivo y las variables predictoras reciben una línea escalonada en esta cuadrícula, obtenida del mismo modo que en el entrenamiento."

#: src/features/lotoReports/components/LotoProposalCard.tsx
#: src/features/lotoReports/components/LotoTargetEquipmentList.tsx
msgid "Target equipment"
msgstr "Equipo objetivo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Target finish"
msgstr "Finalización prevista"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "target history"
msgstr "historial del objetivo"

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Target history"
msgstr "Historial del objetivo"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Target observed"
msgstr "Objetivo observado"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Target only (hide driver pens)"
msgstr "Solo objetivo (ocultar trazos de las variables predictoras)"

#: src/features/sentinels/components/RecentScorePanel.tsx
msgid "Target scoring — {value451_42} (native interval)"
msgstr "Puntuación del objetivo — {value451_42} (intervalo nativo)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Target start"
msgstr "Inicio previsto"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "Target vs normalized (combined + per driver)"
msgstr "Objetivo frente a valores normalizados (combinados y por variable predictora)"

#: src/features/lotoReports/components/LotoEquipmentCoverage.tsx
msgid "Targeted equipment"
msgstr "Equipos objetivo"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Task (istask=true)"
msgstr "Tarea (istask=true)"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Task duration"
msgstr "Duración de la tarea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Task number"
msgstr "Número de tarea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Task record"
msgstr "Registro de tarea"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Task relationship"
msgstr "Relación entre tareas"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Task relationships"
msgstr "Relaciones entre tareas"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Task sequence"
msgstr "Secuencia de tarea"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "Teal"
msgstr "Turquesa"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Technical and compliance requirements"
msgstr "Requisitos técnicos y de cumplimiento"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Technical reference"
msgstr "Referencia técnica"

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us about the feature you would like..."
msgstr "Cuéntenos sobre la funcionalidad que le gustaría..."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us what we could improve..."
msgstr "Cuéntenos qué podríamos mejorar..."

#: src/features/knowledgeDocumentViewer/components/bugReport/DocumentsBugReportButton.tsx
msgid "Tell us what went wrong..."
msgstr "Cuéntenos qué salió mal..."

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "temperature"
msgstr "temperatura"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Temperature"
msgstr "Temperatura"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Temperature Trend Analysis"
msgstr "Análisis de tendencias de temperatura"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTrendAnalysis.tsx
msgid "Temperature trend is"
msgstr "La tendencia de temperatura es"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/TypeCombobox.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Template"
msgstr "Plantilla"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Term"
msgstr "Condición"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
#: src/features/navbar/profileAndSettings/ProfileAndSettingsTopBar.tsx
msgid "Terms of Service"
msgstr "Términos de servicio"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Test"
msgstr "Prueba"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "test (red)"
msgstr "prueba (rojo)"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "test coverage"
msgstr "cobertura de prueba"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Test MAE"
msgstr "MAE de prueba"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Test residual"
msgstr "Residuo de prueba"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Test RMSE"
msgstr "RMSE de prueba"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Tested for step changes"
msgstr "Se probaron cambios escalonados"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Tested for step changes in {kpi}"
msgstr "Se probaron cambios escalonados en {kpi}"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Testing for step changes"
msgstr "Probando cambios escalonados"

#: src/features/timeSeries/agentTab/toolSentence.ts
msgid "Testing for step changes in {kpi}"
msgstr "Probando cambios escalonados en {kpi}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Testing, inspection, and calibration"
msgstr "Pruebas, inspección y calibración"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Text"
msgstr "Texto"

#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Text Area"
msgstr "Área de texto"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Text response"
msgstr "Respuesta de texto"

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "Textures"
msgstr "Texturas"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "The above equipment has been properly tagged, vented, drained. Work is safe to begin."
msgstr "El equipo anterior se ha etiquetado, venteado y drenado correctamente. Es seguro iniciar el trabajo."

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "The above equipment has been released from the LOTO."
msgstr "El equipo anterior ha sido liberado del LOTO."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "The agent is setting parameters…"
msgstr "El agente está estableciendo parámetros…"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "The agent picks the target and drivers from these. At least three are needed."
msgstr "El agente elige de aquí el objetivo y las variables predictoras. Se necesitan al menos tres."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "The backend could not approve this upload request because it conflicts with existing upload state."
msgstr "El backend no pudo aprobar esta solicitud de carga porque entra en conflicto con el estado de carga existente."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "The backend could not approve this upload request."
msgstr "El backend no pudo aprobar esta solicitud de carga."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the backtest failed"
msgstr "la prueba retrospectiva falló"

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The band and its sigmas are calibrated on interval averages, so raw spikes briefer than the interval are not scored against it"
msgstr "La banda y sus sigmas se calibran con promedios por intervalo, por lo que los picos sin procesar más breves que el intervalo no se puntúan contra ella"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "The baseline window is shaded on the Process Data chart whenever this model is drawn, so you can see what it was fitted against rather than taking these dates on trust."
msgstr "La ventana de referencia aparece sombreada en el gráfico de Datos del proceso cuando se dibuja este modelo, para que pueda ver con qué se ajustó."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "The bottom bar sets exact dates, steps between periods, and zooms."
msgstr "La barra inferior establece fechas exactas, avanza entre períodos y controla el zoom."

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "The bounded Asset Instance read hit its limit. Asset counts and rows below are incomplete."
msgstr "La lectura acotada de instancias de activos alcanzó su límite. Los recuentos y las filas de activos siguientes están incompletos."

#: src/features/lotoReports/components/LotoPrintAlert.tsx
msgid "The browser blocked the print dialog."
msgstr "El navegador bloqueó el cuadro de diálogo de impresión."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "The case was identified as M&D, but the normalized detail shape is incomplete and cannot be edited here yet."
msgstr "El caso se identificó como M&D, pero la estructura de detalles normalizada está incompleta y aún no se puede editar aquí."

#: src/features/timeSeries/experiment/useLabBucketsOnChart.ts
msgid "The chart's bucket read has no {value100_46} aggregation, so this grid cannot be drawn."
msgstr "La lectura por intervalos del gráfico no tiene agregación {value100_46}, por lo que no se puede dibujar esta cuadrícula."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "The chart's pens and the experiment's tags are the same set: every pen on the chart (including ones already there) joins the experiment — the first as target, the rest as drivers — and target/driver tags picked here plot as pens. Removing either side removes both. Removed points and the trained expected/residual band draw over the pens, with the chart's zoom, tooltip, and ruler. Diagnostics live here."
msgstr "Los trazos del gráfico y las etiquetas del experimento forman el mismo conjunto: cada trazo participa en el experimento, el primero como objetivo y los demás como variables predictoras. Las etiquetas elegidas aquí se grafican como trazos. Eliminar cualquiera de los dos lados elimina ambos. Los puntos eliminados y la banda esperada/residual entrenada se dibujan sobre los trazos con el zoom, la información emergente y la regla del gráfico. Los diagnósticos aparecen aquí."

#: src/features/knowledgeDocumentViewer/graph/GraphTooltip.tsx
msgid "The connected page has not been resolved in the graph."
msgstr "La página conectada aún no se ha resuelto en el grafo."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "The corrected value must be different."
msgstr "El valor corregido debe ser diferente."

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "The decision failed."
msgstr "La decisión falló."

#: src/features/fimReview/reviewOutcome.ts
msgid "The decision was recorded, but the current subject was not updated. It will apply during the next fusion run."
msgstr "La decisión se registró, pero el sujeto actual no se actualizó. Se aplicará durante la próxima ejecución de fusión."

#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "The derived tag could not be saved."
msgstr "No se pudo guardar la etiqueta derivada."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The document inventory is not fully in scope."
msgstr "El inventario de documentos no está completamente dentro del alcance."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the evaluation failed"
msgstr "la evaluación falló"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "the expression calls {value116_34}, "
msgstr "la expresión llama a {value116_34}, "

#: src/pages/facilityModel/FacilityModelCatalog.tsx
msgid "The facility model reads the site's published run only. Publish a fusion run in Model Operations to populate it."
msgstr "El modelo de la instalación solo lee la ejecución publicada del sitio. Publique una ejecución de fusión en Operaciones del modelo para completarlo."

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "The feature set every driver contributes: lagged values, a rolling mean, and forward-fill tolerance. Per-driver phase shifts align a leading driver with the target; the suggestion comes from the correlation scan."
msgstr "El conjunto de características que aporta cada variable predictora: valores rezagados, una media móvil y tolerancia de relleno hacia adelante. Los desfases por variable predictora alinean una variable adelantada con el objetivo; la sugerencia proviene del análisis de correlación."

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
msgid "The fit has nothing to call healthy and will refuse to run."
msgstr "El ajuste no tiene datos que pueda considerar saludables y se negará a ejecutarse."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "The full-window refit failed, so this sentinel has no served model and cannot score. The metrics below are still the honest split fit."
msgstr "Falló el reajuste de la ventana completa, por lo que este sentinel no tiene un modelo disponible y no puede puntuar. Las métricas siguientes aún corresponden al ajuste válido de la partición."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "The historian pull and a plot per tag take a few minutes; it appears here on its own when it lands."
msgstr "La extracción del historiador y un gráfico por etiqueta tardan unos minutos; aparecerán aquí automáticamente cuando estén listos."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the history could not be loaded"
msgstr "no se pudo cargar el historial"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "The inputs changed. Preview again before applying."
msgstr "Las entradas cambiaron. Vuelva a obtener una vista previa antes de aplicar."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/InspectionPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportAssetView.tsx
msgid "The inspection model is unavailable."
msgstr "El modelo de inspección no está disponible."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The inventory search is incomplete."
msgstr "La búsqueda en el inventario está incompleta."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the kNN fit needs at least one driver"
msgstr "el ajuste kNN necesita al menos una variable predictora"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "The KPI expression uses this role"
msgstr "La expresión del KPI usa este rol"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "The KPI line cannot draw — {kpiIssue}"
msgstr "No se puede dibujar la línea del KPI: {kpiIssue}"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "The KPI line cannot draw: this site has no pen for {missingForKpi}"
msgstr "No se puede dibujar la línea del KPI: este sitio no tiene un trazo para {missingForKpi}"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the KPI needs a name"
msgstr "el KPI necesita un nombre"

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the KPI needs an expression"
msgstr "el KPI necesita una expresión"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "The last template fill failed."
msgstr "El último llenado de plantilla falló."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "The link may be broken, or the document may not be part of this site's current document set."
msgstr "Es posible que el enlace esté roto o que el documento no forme parte del conjunto de documentos actual de este sitio."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "The link you followed is missing required information. Try going back, or open the page from the menu."
msgstr "Al enlace que siguió le falta información obligatoria. Intente volver atrás o abra la página desde el menú."

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "the model carries no KPI expression"
msgstr "el modelo no contiene ninguna expresión de KPI"

#: src/features/timeSeries/agentTab/ModelPicker.tsx
msgid "The model on the chart is not saved yet, so it is not in this list. Open its card to name and save it."
msgstr "El modelo del gráfico aún no está guardado, por lo que no aparece en esta lista. Abra su tarjeta para asignarle un nombre y guardarlo."

#: src/features/fim/photos/PhotoRemoveButton.tsx
msgid "The photo will be removed from this Subject."
msgstr "La foto se quitará de este Sujeto."

#: src/features/timeSeries/agentTab/dock/useModelDraft.ts
msgid "the refit failed"
msgstr "el reajuste falló"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "The revision audit couldn’t complete — one or more sheets were unreadable. Needs review."
msgstr "La auditoría de revisiones no se pudo completar — una o más hojas no se pudieron leer. Requiere revisión."

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionAuditBadge.tsx
msgid "The revision audit couldn’t complete and needs review"
msgstr "La auditoría de revisiones no se pudo completar y requiere revisión"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "The revision table scan is incomplete."
msgstr "El escaneo de la tabla de revisiones está incompleto."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the rule was NOT saved — {value234_40}"
msgstr "la regla NO se guardó — {value234_40}"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "The same spread as IQR/1.349: what the band was before it became a standard deviation. Far below the sd means fat tails."
msgstr "La misma dispersión que IQR/1.349: el valor de la banda antes de expresarse como desviación estándar. Si es mucho menor que la desviación estándar, indica colas pesadas."

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "The sample window is whatever the chart shows — pan or zoom to change what trains. These knobs shape how rows land on the shared time grid: bin width and how bins aggregate. The preview re-runs automatically on every change."
msgstr "La ventana de muestra es la que muestra el gráfico; desplácese o cambie el zoom para modificar los datos de entrenamiento. Estos controles determinan cómo se ubican las filas en la cuadrícula temporal compartida: el ancho de los intervalos y cómo se agregan. La vista previa se vuelve a ejecutar automáticamente con cada cambio."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "the save failed"
msgstr "el guardado falló"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "The saved view is removed for everyone at this site. Chart data is not affected."
msgstr "La vista guardada se elimina para todas las personas de este sitio. Los datos del gráfico no se ven afectados."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "The selected case could not be loaded for this site. It may have been deleted or moved."
msgstr "No se pudo cargar el caso seleccionado para este sitio. Es posible que se haya eliminado o movido."

#: src/features/fimReview/subjectDecisionBuilders.ts
#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "The selected merge target needs to be regenerated first."
msgstr "Primero se debe volver a generar el destino de combinación seleccionado."

#: src/pages/evaluations/metadata/components/MetricsCard.tsx
msgid "the selected organization"
msgstr "la organización seleccionada"

#: src/features/timeSeries/components/timeSeriesScatterplot/NoDataInRange.tsx
msgid "The selected pens have data"
msgstr "Los trazos seleccionados tienen datos"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "The sensor the model tries to predict. Residuals (actual − expected) are what you watch for anomalies on this tag."
msgstr "El sensor que el modelo intenta predecir. Los residuos (real − esperado) son lo que se supervisa para detectar anomalías en esta etiqueta."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The Sentinels data layer is off — enable it to see the alerting range on the chart."
msgstr "La capa de datos de Sentinels está desactivada; actívela para ver el rango de alertas en el gráfico."

#: src/features/fim/photos/SubjectPhotos.tsx
msgid "The site photo list hit the load ceiling, so some photos may be missing from this view."
msgstr "La lista de fotos del sitio alcanzó el límite de carga, por lo que es posible que falten algunas fotos en esta vista."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "the split fit above"
msgstr "el ajuste de la partición anterior"

#: src/features/fimReview/reviewOutcome.ts
msgid "The subject could not be updated."
msgstr "No se pudo actualizar el sujeto."

#: src/features/facilityModel/catalogQuery.ts
msgid "The Subject search timed out — narrow the query and retry."
msgstr "Se agotó el tiempo de búsqueda de sujetos; restrinja la consulta y vuelva a intentarlo."

#: src/pages/details/extensions/flow/filesExt/ReportItem.tsx
msgid "The URL for this file is not available."
msgstr "La URL de este archivo no está disponible."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "The visible range is longer than the "
msgstr "El rango visible es mayor que el "

#: src/pages/processData/buildMode/dock/SamplingSection.tsx
msgid "The window follows the chart. Rows are the grid after cleaning and alignment, then how the split assigns them. Zero train or test rows means the window or split needs attention."
msgstr "La ventana sigue al gráfico. Las filas corresponden a la cuadrícula después de la limpieza y la alineación, y luego a la forma en que la partición las asigna. Si no hay filas de entrenamiento o prueba, debe revisar la ventana o la partición."

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "The Workbench at a Glance"
msgstr "Resumen del área de trabajo"

#: src/features/navbar/ThemeModeToggle.tsx
msgid "Theme"
msgstr "Tema"

#: src/pages/noSites/NoSites.tsx
msgid "There are no known sites for {organizationName}, or you do not have access to them"
msgstr "No hay sitios conocidos para {organizationName}, o usted no tiene acceso a ellos"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "There is a {percentChange}% change in {readingKind} readings between low and high {factor} conditions. Consider this environmental factor when analyzing {readingKind} data."
msgstr "Hay un cambio del {percentChange}% en las lecturas de {readingKind} entre condiciones de {factor} bajo y alto. Considere este factor ambiental al analizar los datos de {readingKind}."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTurnRows.tsx
msgid "There is likely an issue with the server. Please try again. If the problem persists, please contact support."
msgstr "Probablemente hay un problema con el servidor. Inténtelo de nuevo. Si el problema persiste, contacte a soporte."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "There was an issue parsing the JSON into a GeckoAssetModel! {error}"
msgstr "Se produjo un problema al analizar el JSON como GeckoAssetModel. {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "There was an issue parsing the JSON into a GeckoUnit! {error}"
msgstr "Se produjo un problema al analizar el JSON como GeckoUnit. {error}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"There was an issue patching the data into Rolodex! Error below:\n"
"\n"
"{err}"
msgstr ""
"Se produjo un problema al aplicar el parche de datos en Rolodex. Error:\n"
"\n"
"{err}"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid ""
"There was an issue patching the updated data to the Rolodex Cache! Error below:\n"
"\n"
"{error}"
msgstr ""
"Se produjo un problema al aplicar el parche de datos actualizados en la caché de Rolodex. Error:\n"
"\n"
"{error}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/EnvironmentalCorrelationCard.tsx
msgid "thermal"
msgstr "térmico"

#: src/pages/assetLens/components/tabs/ModelViewerTab.tsx
msgid "Thermal View"
msgstr "Vista térmica"

#: src/features/knowledgeDocumentViewer/utils/sharedMetadataFieldBridge.ts
msgid "These changes also update {surface}: {joined}."
msgstr "Estos cambios también actualizan {surface}: {joined}."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "They lost access, but their sign-in couldn't be removed. Contact an administrator."
msgstr "Se revocó su acceso, pero no se pudo eliminar su inicio de sesión. Comuníquese con un administrador."

#: src/pages/manageAccess/components/dialogs/ConfirmUserTypeChangeDialog.tsx
msgid "They will be able to manage access, including inviting and deactivating people in the selected scope."
msgstr "Podrán gestionar el acceso, incluyendo invitar y desactivar personas en el ámbito seleccionado."

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
msgid "They will be invited to this site and can be given more sites once they appear on the roster."
msgstr "Recibirán una invitación a este sitio. Podrá asignarles más sitios cuando aparezcan en la lista de usuarios."

#: src/pages/manageAccess/components/dialogs/SiteAccessDialog.tsx
msgid "They will not see any sites."
msgstr "No podrán ver ningún sitio."

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/inspectionLayers.ts
msgid "Thickness"
msgstr "Espesor"

#: src/features/chatbot/components/Conversation.tsx
#: src/features/chatbot/components/Conversation.tsx
msgid "Thinking"
msgstr "Pensando"

#: src/features/kestrelViewer/ui/tools/photoreel/DockedPhotoReelPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
#: src/features/timeSeries/agentTab/chat/Transcript.tsx
msgid "Thinking..."
msgstr "Pensando..."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Thinking{dots}"
msgstr "Pensando{dots}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionMissingCard.tsx
msgid "This audit is not complete, so missing revisions cannot be ruled out."
msgstr "Esta auditoría no está completa, por lo que no se pueden descartar revisiones faltantes."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "This case has no linked alerts to re-analyze."
msgstr "Este caso no tiene alertas vinculadas para volver a analizar."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportChart.tsx
msgid "This chart is truncated. Open the source record for complete results."
msgstr "Este gráfico está truncado. Abra el registro de origen para ver los resultados completos."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "This chat will be removed from your history."
msgstr "Este chat se eliminará de su historial."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "This CMMS record has changed since it was cited. Showing the latest imported record."
msgstr "Este registro de CMMS ha cambiado desde que se citó. Se muestra el último registro importado."

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderViewer.tsx
msgid "This CMMS record is unavailable or you do not have access."
msgstr "Este registro de CMMS no está disponible o no tienes acceso."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
msgid "This comparison is unavailable for the requested revisions."
msgstr "Esta comparación no está disponible para las revisiones solicitadas."

#: src/features/timeSeries/experiment/useLabTransformsOnChart.ts
msgid "This config builds no rolling features."
msgstr "Esta configuración no genera características móviles."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "This context build didn't finish."
msgstr "La creación de este contexto no finalizó."

#: src/features/fimReview/reviewOutcome.ts
msgid "This decision is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."
msgstr "Esta decisión está tardando más de lo esperado. Es posible que finalice en segundo plano. Actualice este sujeto antes de volver a intentarlo."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "This deletes all {count} files in {category}. This cannot be undone."
msgstr "Esto elimina los {count} archivos de {category}. Esta acción no se puede deshacer."

#: src/features/kestrelUpload/KestrelModelUploadSection.tsx
msgid "This deletes all source files under assets/models/, including meshes, point clouds, and textures. This cannot be undone."
msgstr "Esto elimina todos los archivos de origen en assets/models/, incluidas las mallas, las nubes de puntos y las texturas. Esta acción no se puede deshacer."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "This detail page only supports M&D cases. The selected case is using a different workflow domain."
msgstr "Esta página de detalles solo admite casos de M&D. El caso seleccionado usa otro dominio de flujo de trabajo."

#: src/features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel.tsx
msgid "This document belongs to a family of {familySize} revisions."
msgstr "Este documento pertenece a una familia de {familySize} revisiones."

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "This document could not be loaded."
msgstr "No se pudo cargar este documento."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document exists only under other pipeline configs. Switch this site's active config to view it here."
msgstr "Este documento existe solo bajo otras configuraciones de pipeline. Cambie la configuración activa de este sitio para verlo aquí."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document isn't available"
msgstr "Este documento no está disponible"

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This document isn't present under any of this site's pipeline configs — it may belong to a different site or have been re-ingested under a new id."
msgstr "Este documento no está presente en ninguna de las configuraciones de pipeline de este sitio — puede pertenecer a otro sitio o haberse vuelto a ingerir con un nuevo id."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "This fill is stale — the Subject or its template changed since it was computed. Re-fill to refresh it."
msgstr "Este llenado está desactualizado: el sujeto o su plantilla cambiaron desde que se calculó. Vuelva a llenarlo para actualizarlo."

#: src/pages/details/visualization/Visualization.tsx
msgid "This is a graphical view; use the visualization toolbar controls and the left sidebar to explore the data."
msgstr "Esta es una vista gráfica; use los controles de la barra de herramientas de visualización y la barra lateral izquierda para explorar los datos."

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "This is a legacy multi-tag sentinel; design a new one to manage it here."
msgstr "Este es un sentinel heredado de varias etiquetas; diseñe uno nuevo para administrarlo aquí."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "This is a legacy multi-tag sentinel."
msgstr "Este es un centinela de varias etiquetas heredado."

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "This label's tags are already on the chart"
msgstr "Las etiquetas de esta marca ya están en el gráfico"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionViewer.tsx
msgid "This layer is unavailable for the selected inspection inputs."
msgstr "Esta capa no está disponible para los datos de inspección seleccionados."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "This link does not open a document."
msgstr "Este enlace no abre un documento."

#: src/features/knowledgeDocumentViewer/components/DocumentUnavailablePanel.tsx
msgid "This link's config"
msgstr "Configuración de este enlace"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "this LOTO"
msgstr "este LOTO"

#: src/features/lotoReports/useLotoLeaveGuards.ts
msgid "This LOTO has unsaved changes. Leave without saving them?"
msgstr "Este LOTO tiene cambios sin guardar. ¿Salir sin guardarlos?"

#: src/features/lotoReports/components/LotoLeaveDialog.tsx
msgid "This LOTO has unsaved changes. Save them before you continue, or discard them."
msgstr "Este LOTO tiene cambios sin guardar. Guárdalos antes de continuar o descártalos."

#: src/features/lotoReports/components/LotoReportEditorLoader.tsx
msgid "This LOTO report does not exist for the selected site and pipeline configuration. It may have been deleted."
msgstr "Este informe LOTO no existe para el sitio y la configuración del pipeline seleccionados. Es posible que se haya eliminado."

#: src/features/lotoReports/components/LotoPagePanel.tsx
msgid "This LOTO report is no longer available."
msgstr "Este informe LOTO ya no está disponible."

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "This model is drawn on the chart"
msgstr "Este modelo está dibujado en el gráfico"

#: src/features/timeSeries/agentTab/AgentHeader.tsx
msgid "This model is not saved — open the model card to name and save it"
msgstr "Este modelo no está guardado; abra la tarjeta del modelo para asignarle un nombre y guardarlo"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "This organization has no sites to manage access for yet."
msgstr "Esta organización aún no tiene sitios cuyo acceso se pueda administrar."

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
msgid "This page"
msgstr "Esta página"

#: src/features/lotoReports/components/LotoSelectedReport.tsx
msgid "This page isn’t in this LOTO yet."
msgstr "Esta página aún no está en este LOTO."

#: src/pages/errorFallback/ErrorFallback.tsx
msgid "This page link is incomplete"
msgstr "Este enlace de página está incompleto"

#: src/features/knowledgeDocumentViewer/components/metadata/EvalPagePending.tsx
msgid "This page's metadata is unavailable. Retry or continue to another page."
msgstr "Los metadatos de esta página no están disponibles. Reintenta o continúa con otra página."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "This person has no access in this view to remove."
msgstr "Esta persona no tiene acceso en esta vista que quitar."

#: src/features/fim/photos/SubjectPhotoUploader.tsx
msgid "This photo is already attached to this Subject."
msgstr "Esta foto ya está adjunta a este Sujeto."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This plan has been fitted, so it is history rather than a draft."
msgstr "Este plan ya se ajustó, por lo que forma parte del historial y ya no es un borrador."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "This point and the ones before it, like a driver feature."
msgstr "Este punto y los anteriores, como una característica predictora."

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "This reference has no page image."
msgstr "Esta referencia no tiene una imagen de página."

#: src/pages/manageAccess/components/dialogs/RevokeUserAccessDialog.tsx
msgid "This removes their access in this view. If they have no access left anywhere, their account is deleted and you will need to reinvite them."
msgstr "Esto quita su acceso en esta vista. Si no le queda acceso en ninguna parte, su cuenta se elimina y tendrá que volver a invitar a esta persona."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/DocumentResultCard.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentHeaderRevisionChip.tsx
msgid "This revision is out of date"
msgstr "Esta revisión está desactualizada"

#: src/features/sentinels/components/DesignRunDetails.tsx
msgid "This run has no entry yet, so it cannot be monitored."
msgstr "Esta ejecución aún no tiene una entrada, por lo que no se puede supervisar."

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "This run started "
msgstr "Esta ejecución comenzó "

#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "This run stopped reporting and never finished — its job likely died. Delete it and design a new one."
msgstr "Esta ejecución dejó de informar y nunca finalizó; es probable que su trabajo se haya detenido. Elimínela y diseñe una nueva."

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "This run stopped reporting and never finished."
msgstr "Esta ejecución dejó de informar y nunca finalizó."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This run stored no fitted methods, so there are no results to show."
msgstr "Esta ejecución no almacenó métodos ajustados, por lo que no hay resultados que mostrar."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
msgid "This run stored no readable plan, so what was fitted cannot be shown."
msgstr "Esta ejecución no almacenó un plan legible, por lo que no se puede mostrar lo que se ajustó."

#: src/pages/documents/Documents.tsx
msgid "This site does not exist or you do not have access to it."
msgstr "Este sitio no existe o no tienes acceso a él."

#: src/features/lotoReports/components/LotoReportsScopeGate.tsx
msgid "This site has no document pipeline configuration, so it has no LOTO reports."
msgstr "Este sitio no tiene una configuración del pipeline de documentos, por lo que no tiene informes LOTO."

#: src/features/knowledgeDocumentViewer/components/sidebar/SubjectDocumentsPanel.tsx
msgid "this subject"
msgstr "este sujeto"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "This Subject changed after you opened it. Refresh and preview the decision again."
msgstr "Este sujeto cambió después de abrirlo. Actualice y vuelva a obtener una vista previa de la decisión."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "This Subject cites no documents in the published run."
msgstr "Este sujeto no cita ningún documento en la ejecución publicada."

#: src/features/knowledgeDocumentViewer/components/photoMode/PhotoModeSubjectSection.tsx
msgid "This Subject could not be loaded. Tap another highlight."
msgstr "No se pudo cargar este sujeto. Toque otro resaltado."

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "This Subject has no taxonomy type, so no template can be matched."
msgstr "Este sujeto no tiene un tipo de taxonomía, por lo que no se puede asociar ninguna plantilla."

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "This Subject is not part of the site’s published fusion run."
msgstr "Este sujeto no forma parte de la ejecución de fusión publicada del sitio."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before it can be merged."
msgstr "Este sujeto debe volver a generarse antes de poder combinarlo."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before it can be split."
msgstr "Este sujeto debe volver a generarse antes de poder dividirlo."

#: src/features/fimReview/subjectDecisionBuilders.ts
msgid "This Subject needs to be regenerated before its OCR can be corrected."
msgstr "Este sujeto debe volver a generarse antes de poder corregir su OCR."

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "This tab displays open sensor anomaly cases. Issues are identified by Gecko experts and categorized by severity."
msgstr "Esta pestaña muestra casos abiertos de anomalías de sensores. Los expertos de Gecko identifican los problemas y los clasifican por gravedad."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ReportTable.tsx
msgid "This table is truncated. Open the source record for complete results."
msgstr "Esta tabla está truncada. Abra el registro de origen para ver los resultados completos."

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "This tag"
msgstr "Esta etiqueta"

#: src/pages/processData/buildMode/dock/EvalsDockTab.tsx
msgid "this target"
msgstr "este objetivo"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "This view is not saved yet — Save view to keep it"
msgstr "Esta vista aún no está guardada; seleccione Guardar vista para conservarla"

#: src/features/assetLifecycleV2/views/observations/LtaObservationCompositeViz.tsx
msgid "This view requires an inspection thickness layer."
msgstr "Esta vista requiere una capa de espesor de inspección."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "This whiteboard has no annotations yet."
msgstr "Esta pizarra aún no tiene anotaciones."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "This will erase all generated content on this case — investigation notes, recommendation draft, references, and the chat thread — and replace it with a fresh AI analysis based on the linked alerts. Comments, feedback, the published recommendation, and the case title are preserved. This cannot be undone."
msgstr "Esto borrará todo el contenido generado de este caso —notas de investigación, borrador de recomendación, referencias y conversación del chat— y lo reemplazará con un análisis de IA nuevo basado en las alertas vinculadas. Se conservarán los comentarios, las observaciones, la recomendación publicada y el título del caso. Esta acción no se puede deshacer."

#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
msgid "This window is at the data's resolution — about one sample every {value437_93}. Zooming in further won't reveal more detail; panning and zooming out still work."
msgstr "Esta ventana está en la resolución de los datos, aproximadamente una muestra cada {value437_93}. Acercar más no mostrará mayor detalle; aún puede desplazarse y alejar el zoom."

#: src/features/chatbot/components/conversationMessage/AIResponseExtras.tsx
msgid "Thought for {thinkingTime}"
msgstr "Razonó durante {thinkingTime}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatCollapsibleThoughts.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Thoughts"
msgstr "Razonamiento"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Three different “validation” ideas: (1) timeline Val chunks — if you assign any, they calibrate the residual band scale; (2) if no Val chunks, band scale uses spread calibration blocks carved out of Train; (3) MLP early_stopping also holds out an internal sklearn slice of its fit rows. Prod’s tail-fraction split often leaves Val empty — band still calibrates via (2)."
msgstr "Hay tres conceptos distintos de “validación”: (1) los segmentos de Validación de la cronología, si asigna alguno, calibran la escala de la banda residual; (2) si no hay segmentos de Validación, la escala de la banda usa bloques de calibración de dispersión extraídos del Entrenamiento; (3) early_stopping de MLP también reserva una porción interna de sklearn de sus filas de ajuste. La partición por fracción final de producción suele dejar Validación vacía; la banda aun así se calibra mediante (2)."

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Threshold"
msgstr "Umbral"

#: src/pages/details/extensions/fde/ffsLtaGeneration/FfsLtaGenerationSidebar.tsx
msgid "Threshold ({thresholdUnitId})"
msgstr "Umbral ({thresholdUnitId})"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Threshold Configuration"
msgstr "Configuración de umbrales"

#: src/pages/assetLens/components/tabs/timeSeriesAnalysis/DataProcessingToolbar.tsx
msgid "Threshold Filtering"
msgstr "Filtrado por umbral"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Threshold: {upper} - {lower}"
msgstr "Umbral: {upper} - {lower}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Thresholds ({thresholdCount})"
msgstr "Umbrales ({thresholdCount})"

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportAgentModeField.tsx
msgid "Ticket only"
msgstr "Solo ticket"

#: src/features/chatbot/components/AttachmentPills.tsx
msgid "time"
msgstr "rango de tiempo"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
#: src/features/timeSeries/hooks/useTimeSeriesDataProcessing.ts
#: src/features/timeSeries/regressionHelpers.ts
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Time"
msgstr "Hora"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Time Interval"
msgstr "Intervalo de tiempo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/TimeSeriesSection.tsx
#: src/pages/cases/md/MdCaseReferencesDrawer.tsx
msgid "Time series"
msgstr "Serie de tiempo"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Time Series"
msgstr "Serie temporal"

#: src/pages/assetLens/components/tabs/canvas/TimeSeriesWorkflow.tsx
msgid "Time Series Points Added"
msgstr "Puntos de serie temporal agregados"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "TIME:"
msgstr "HORA:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Timeline"
msgstr "Cronología"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Timeline Val chunks (if you assign any) calibrate the residual band. If Val is empty — which is normal for the prod-like “tail 10%” preset — band scale still uses spread calibration blocks carved out of Train. Separately, each MLP uses sklearn early_stopping on an internal holdout of its fit rows. So “no Val chunks” does not mean the MLP trains with zero validation."
msgstr "Los segmentos de Validación de la cronología, si asigna alguno, calibran la banda residual. Si Validación está vacía, algo normal con el ajuste preestablecido similar a producción “10 % final”, la escala de la banda sigue usando bloques de calibración de dispersión extraídos del Entrenamiento. Por separado, cada MLP usa early_stopping de sklearn con una reserva interna de sus filas de ajuste. Por eso, “sin segmentos de Validación” no significa que el MLP se entrene sin validación."

#: src/features/chatbot/components/conversationMessage/ProposalCard.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
#: src/pages/cases/components/CasesTableColumns.tsx
msgid "Title"
msgstr "Título"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Title: {caseTitle}"
msgstr "Título: {caseTitle}"

#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
msgid "to"
msgstr "a"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
#: src/features/knowledgeDocumentViewer/components/toolbar/PageRangeControls.tsx
#: src/features/timeSeries/components/LabelsTab.tsx
msgid "To"
msgstr "Hasta"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "To bin"
msgstr "Ubicación de destino"

#: src/features/knowledgeDocumentViewer/artifacts/ArtifactPanel.tsx
msgid "To change this document, tell Cantilever what to edit."
msgstr "Para modificar este documento, dile a Cantilever qué editar."

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
msgid "To drawing"
msgstr "Al plano"

#: src/features/lotoReports/components/LotoSortablePoints.tsx
msgid "To reorder an isolation point, press Space or Enter on its drag handle, move it with the up and down arrow keys, then press Space or Enter to drop it or Escape to cancel."
msgstr "Para reordenar un punto de aislamiento, pulse Espacio o Intro en su control de arrastre, muévalo con las flechas arriba y abajo y, después, pulse Espacio o Intro para soltarlo o Escape para cancelar."

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "To revision"
msgstr "Revisión de destino"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "To storeroom"
msgstr "Al almacén"

#: src/pages/details/rightSidebar/DetailsRightSidebar.tsx
msgid "Toggle {title} extension"
msgstr "Alternar extensión {title}"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
#: src/pages/systemView/components/unitsTab/ActionsRow.tsx
msgid "Toggle Asset Visibility"
msgstr "Alternar visibilidad del activo"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "Toggle between all and unread notifications"
msgstr "Alternar entre todas las notificaciones y las no leídas"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
msgid "Toggle change highlighting"
msgstr "Alternar resaltado de cambios"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Toggle chatbot"
msgstr "Alternar chatbot"

#: src/pages/details/visualization/tools/features/FeaturesToggle.tsx
msgid "Toggle Features..."
msgstr "Alternar características…"

#: src/pages/details/visualization/photogrammetry/NiraHud.tsx
msgid "Toggle navigation help"
msgstr "Alternar ayuda de navegación"

#: src/features/navbar/Homebar.tsx
#: src/features/navbar/Homebar.tsx
msgid "Toggle navigation menu"
msgstr "Mostrar u ocultar el menú de navegación"

#: src/features/knowledgeDocumentViewer/components/toolbar/DocumentPreviewModeSwitch.tsx
msgid "Toggle Preview Mode"
msgstr "Alternar modo de vista previa"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Too many files were selected for one upload request."
msgstr "Se seleccionaron demasiados archivos para una sola solicitud de carga."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Tool"
msgstr "Herramienta"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Tool cost"
msgstr "Costo de herramientas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tool information"
msgstr "Información de la herramienta"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tools"
msgstr "Herramientas"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatAgentsMenu.tsx
msgid "Tools on: {activeAgentNames}"
msgstr "Herramientas activas: {activeAgentNames}"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip disabled"
msgstr "Información emergente deshabilitada"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip disabled (T)"
msgstr "Información emergente deshabilitada (T)"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip enabled"
msgstr "Información emergente habilitada"

#: src/pages/details/visualization/tools/TooltipDisabledToggle.tsx
msgid "Tooltip enabled (T)"
msgstr "Información emergente habilitada (T)"

#: src/features/copcPointClouds/CopcOrientationCube.tsx
msgid "Top"
msgstr "Superior"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Total Anomalies"
msgstr "Anomalías totales"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Total cost"
msgstr "Costo total"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Total deferred"
msgstr "Total de aplazadas"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Total labeled"
msgstr "Total de etiquetadas"

#: src/pages/details/extensions/flow/SummarizerExtension.tsx
msgid "Total number of bins"
msgstr "Cantidad total de intervalos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSummary.tsx
msgid "Total Uploaded"
msgstr "Total cargado"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Totals"
msgstr "Totales"

#: src/pages/overview/sidebar/assetTracker/SiteViewAssetTracker.tsx
msgid "Tracking {trackedAssetCount}"
msgstr "Rastreando {trackedAssetCount}"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Train"
msgstr "Entrenamiento"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgctxt "model training action"
msgid "Train"
msgstr "Entrenar"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "train (cyan)"
msgstr "entrenamiento (cian)"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train {methodCount} models"
msgstr "Entrenar {methodCount} modelos"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Train / val / test"
msgstr "Entrenamiento / validación / prueba"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Train / val / test — click a chunk to cycle roles. Train fits; val calibrates the band; test is held out for metrics."
msgstr "Entrenamiento / validación / prueba: haga clic en un segmento para alternar los roles. Entrenamiento ajusta; validación calibra la banda; prueba se reserva para las métricas."

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Train / val / test windows"
msgstr "Ventanas de entrenamiento / validación / prueba"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "Train a model to calibrate the band."
msgstr "Entrene un modelo para calibrar la banda."

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Train a model to see its metrics here — residuals draw on the chart."
msgstr "Entrene un modelo para ver aquí sus métricas; los residuos se dibujan en el gráfico."

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train again"
msgstr "Volver a entrenar"

#: src/features/timeSeries/experiment/useExperimentApi.ts
#: src/features/timeSeries/experiment/useExperimentApi.ts
msgid "train failed"
msgstr "el entrenamiento falló"

#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Train failed: "
msgstr "El entrenamiento falló: "

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "train frac"
msgstr "fracción de entrenamiento"

#: src/pages/processData/buildMode/dock/WindowsDockTab.tsx
msgid "Train fraction"
msgstr "Fracción de entrenamiento"

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Train model"
msgstr "Entrenar modelo"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Train results"
msgstr "Resultados de entrenamiento"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "Train runs appear here for side-by-side comparison and persist with the saved experiment."
msgstr "Las ejecuciones de entrenamiento aparecen aquí para compararlas lado a lado y se conservan con el experimento guardado."

#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
#: src/pages/processData/buildMode/components/ChartOverlayToggles.tsx
msgid "Train/val/test/excl windows"
msgstr "Ventanas de entrenamiento/validación/prueba/exclusión"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Training"
msgstr "Entrenamiento"

#: src/features/sentinels/components/SentinelList.tsx
msgid "training — {value69_26} · "
msgstr "entrenando — {value69_26} · "

#: src/pages/facilityModel/SentinelDetailPage.tsx
msgid "Training — this updates on its own."
msgstr "Entrenamiento: se actualiza automáticamente."

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Training buckets"
msgstr "Intervalos de entrenamiento"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Training buckets for this pen"
msgstr "Intervalos de entrenamiento para este trazo"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Training: "
msgstr "Entrenamiento: "

#: src/features/timeSeries/experiment/ExperimentTab.tsx
#: src/pages/processData/buildMode/rightPanel/CurrentModelPane.tsx
msgid "Training…"
msgstr "Entrenando…"

#: src/features/sentinels/components/SentinelList.tsx
msgid "training… · "
msgstr "entrenando… · "

#: src/pages/processData/buildMode/components/BuildPrimaryCta.tsx
msgid "Training… Cancel"
msgstr "Entrenando… Cancelar"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Transaction date"
msgstr "Fecha del movimiento"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Transaction type"
msgstr "Tipo de movimiento"

#: src/features/timeSeries/components/PenDrawer.tsx
msgid "Transforms for {value785_54}"
msgstr "Transformaciones para {value785_54}"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Transmittals and document tracking"
msgstr "Transmittals y seguimiento de documentos"

#: src/pages/evaluations/metadata/components/MetricsContent.tsx
msgid "Trend"
msgstr "Tendencia"

#: src/features/knowledgeDocumentViewer/components/sidebar/CrossReferencePanel.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/search/ConnectorLookupPanel.tsx
#: src/features/lotoReports/components/LotoPagePanel.tsx
#: src/features/lotoReports/components/LotoReportsListContent.tsx
#: src/features/lotoReports/components/LotoReportsMessage.tsx
#: src/features/timeSeries/agentTab/chat/ConversationDrawer.tsx
msgid "Try again"
msgstr "Volver a intentar"

#: src/features/permissions/profiles/power.ts
msgid "Try new Doc Chat agents, such as multi-step search, time series, and maintenance records where available."
msgstr "Pruebe los nuevos agentes de Doc Chat, como la búsqueda en varios pasos, las series temporales y los registros de mantenimiento, si están disponibles."

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Turn keyboard shortcuts off"
msgstr "Desactivar atajos de teclado"

#: src/features/navbar/KeyboardShortcutsToggle.tsx
msgid "Turn keyboard shortcuts on"
msgstr "Activar atajos de teclado"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatBetaSwitch.tsx
msgid "Turns on the new Doc Chat tools available at this site. Turn it off to use standard Doc Chat."
msgstr "Activa las nuevas herramientas de Doc Chat disponibles en este sitio. Desactívalo para usar Doc Chat estándar."

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "twice daily"
msgstr "dos veces al día"

#: src/features/knowledgeDocumentViewer/components/toolbar/SettingsMenu.tsx
msgid "Two-page spread"
msgstr "Vista de dos páginas"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/ReviewActions.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/fimReview/StructuralReviewFlow.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportTypeField.tsx
#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/modelOperations/SubjectDetails.tsx
#: src/pages/cases/components/CaseDetailsSidebar.tsx
#: src/pages/cases/components/CaseMetadataForm.tsx
#: src/pages/evaluations/metadata/labeling/components/DataLabelingTypeFilter.tsx
#: src/pages/facilityModel/FacilityModelFilters.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Type"
msgstr "Tipo"

#: src/features/timeSeries/components/panes/tagFilters.ts
msgid "Type {MIN_SEARCH_LENGTH}+ characters to check availability."
msgstr "Escriba al menos {MIN_SEARCH_LENGTH} caracteres para comprobar la disponibilidad."

#: src/features/fimReview/DecisionHistory.tsx
msgid "type → {subjectType}"
msgstr "tipo → {subjectType}"

#: src/features/fimReview/InspectSources.tsx
msgid "Type guess"
msgstr "Tipo estimado"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Type in "
msgstr "Escriba en "

#: src/features/fimReview/TypeCombobox.tsx
msgid "Type suggestions"
msgstr "Sugerencias de tipo"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Type unavailable"
msgstr "Tipo no disponible"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/PositionedTooltip.tsx
msgid "Type: {boxType}"
msgstr "Tipo: {boxType}"

#: src/features/cases/components/CaseCreatedContent.tsx
msgid "Type: {caseType}"
msgstr "Tipo: {caseType}"

#: src/features/richText/components/slashCommandCards/InspectionSlashCommandCard.tsx
msgid "Type: {inspectionType}"
msgstr "Tipo: {inspectionType}"

#: src/features/richText/components/slashCommandCards/SystemSlashCommandCard.tsx
msgid "Type: {systemType}"
msgstr "Tipo: {systemType}"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "Un-assigned chunks split in time: their last"
msgstr "Los segmentos sin asignar se dividen en el tiempo: su último"

#: src/features/knowledgeDocumentViewer/utils/resolveMetadataUserEditSaveContext.ts
msgid "Unable to determine current user for edit"
msgstr "No se pudo determinar el usuario actual para editar"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to get value from editor! Current reference is not set!"
msgstr "No se puede obtener el valor del editor. No se estableció la referencia actual."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unable to load case details"
msgstr "No se pueden cargar los detalles del caso"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocumentResultsContent.tsx
msgid "Unable to load documents"
msgstr "No se pudieron cargar los documentos"

#: src/pages/documents/CmmsExplorerRoutePage.tsx
msgid "Unable to load the site CMMS configuration."
msgstr "No se pudo cargar la configuración de CMMS del sitio."

#: src/features/knowledgeDocumentViewer/components/viewer/shared/SparklineTooltipContent.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Unable to load time series data"
msgstr "No se pudieron cargar los datos de la serie de tiempo"

#: src/pages/noSites/NoSites.tsx
msgid "Unable to locate an organization. Are you sure the ID is correct?"
msgstr "No se pudo encontrar una organización. ¿Está seguro de que el ID es correcto?"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to parse JSON from editor. Reference is not defined!"
msgstr "No se puede analizar el JSON del editor. La referencia no está definida."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch data to Rolodex! Missing field 'raw' on assetModel"
msgstr "No se puede aplicar el parche de datos en Rolodex. Falta el campo 'raw' en assetModel."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch data to Rolodex! Missing field 'raw' on unit"
msgstr "No se puede aplicar el parche de datos en Rolodex. Falta el campo 'raw' en unit."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to patch the data to Rolodex! updatedData is undefined!"
msgstr "No se puede aplicar el parche de datos en Rolodex. updatedData no está definido."

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Unable to reach the upload approval service."
msgstr "No se pudo conectar con el servicio de aprobación de cargas."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unable to refresh case details"
msgstr "No se pueden actualizar los detalles del caso"

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "Unable to resend invitation. Please try again."
msgstr "No se pudo reenviar la invitación. Inténtalo de nuevo."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data, it appears the editor reference has not been set!"
msgstr "No se pueden restablecer los datos; parece que no se estableció la referencia del editor."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data! assetModel appears to be undefined!"
msgstr "No se pueden restablecer los datos. assetModel parece no estar definido."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to reset data! unit appears to be undefined!"
msgstr "No se pueden restablecer los datos. unit parece no estar definido."

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload file! The component information is missing"
msgstr "No se puede cargar el archivo. Falta la información del componente."

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload file! The file was unexpectedly missing"
msgstr "No se puede cargar el archivo. El archivo no estaba presente inesperadamente."

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unable to upload report! CDF is missing"
msgstr "No se puede cargar el informe. Falta el CDF."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to validate and patch new data! Missing field 'raw' on assetModel"
msgstr "No se pueden validar ni aplicar los datos nuevos. Falta el campo 'raw' en assetModel."

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Unable to validate and patch new data! Missing field 'raw' on unit"
msgstr "No se pueden validar ni aplicar los datos nuevos. Falta el campo 'raw' en unit."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Unapplied edits — the chart still shows the saved fit."
msgstr "Cambios sin aplicar; el gráfico aún muestra el ajuste guardado."

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
#: src/features/forecastNotifications/NotificationDetailPanel.tsx
msgid "Unarchive"
msgstr "Desarchivar"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryOverflowMenu.tsx
msgid "Unarchive all"
msgstr "Desarchivar todos"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchive all chats?"
msgstr "¿Desarchivar todos los chats?"

#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchive chats"
msgstr "Desarchivar chats"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionRow.tsx
#: src/features/embeddedSidebar/chatHistory/ChatHistoryBulkActionDialog.tsx
msgid "Unarchiving…"
msgstr "Desarchivando…"

#: src/features/fimReview/StructuralReviewFlow.tsx
msgid "Unassigned"
msgstr "Sin asignar"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Unattached"
msgstr "Sin adjuntar"

#: src/features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdownItem.tsx
#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardComparisonRow.tsx
msgid "Unavailable"
msgstr "No disponible"

#: src/features/timeSeries/agentTab/chat/BuildCard.tsx
msgid "unchanged"
msgstr "sin cambios"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionStatusLegend.tsx
msgid "Unclassified"
msgstr "Sin clasificar"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Under {parentLabel}"
msgstr "Bajo {parentLabel}"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Under Investigation"
msgstr "En investigación"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Underline (Ctrl+U)"
msgstr "Subrayado (Ctrl+U)"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Unexpected AssetEditor state"
msgstr "Estado inesperado de AssetEditor"

#: src/pages/details/extensions/flow/AssetModelEditorExtension.tsx
msgid "Unexpected state!"
msgstr "Estado inesperado."

#: src/features/sentinels/components/SentinelList.tsx
#: src/features/timeSeries/components/SentinelsTab.tsx
msgid "Unfinished"
msgstr "Sin finalizar"

#: src/features/sentinels/components/SentinelList.tsx
msgid "unfinished · "
msgstr "sin finalizar · "

#: src/features/timeSeries/components/LabelsTab.tsx
msgid "Ungrouped"
msgstr "Sin agrupar"

#: src/pages/metrics/components/DailySearchesChart.tsx
#: src/pages/metrics/Metrics.tsx
msgid "Unique users"
msgstr "Usuarios únicos"

#: src/pages/metrics/components/DailySearchesChart.tsx
msgid "Unique users (7d avg)"
msgstr "Usuarios únicos (prom. de 7 días)"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorPreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/sensors/SensorTableColumns.tsx
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/richText/components/slashCommandCards/UnitSlashCommandCard.tsx
#: src/features/timeSeries/components/panes/TagSearchDialog.tsx
#: src/features/timeSeries/experiment/SamplingKnobs.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/details/extensions/flow/filesExt/FileTags.tsx
msgid "Unit"
msgstr "Unidad"

#: src/features/timeSeries/experiment/TagLabel.tsx
msgid "Unit "
msgstr "Unidad "

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Unit (e.g., kW, m/s)"
msgstr "Unidad (p. ej., kW, m/s)"

#: src/features/timeSeries/components/FormulaBuilder.tsx
msgid "Unit conversions:"
msgstr "Conversiones de unidades:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Unit cost"
msgstr "Costo unitario"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Unit cost in transaction currency"
msgstr "Costo unitario en la moneda de la transacción"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Unit for the aggregate bin width (seconds / minutes / hours). Only used in aggregate mode."
msgstr "Unidad del ancho del intervalo de agregación (segundos / minutos / horas). Solo se usa en modo agregado."

#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Unit Magnitude"
msgstr "Magnitud de la unidad"

#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
msgid "Unit Type:"
msgstr "Tipo de unidad:"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Unit: {unit}"
msgstr "Unidad: {unit}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
#: src/features/navbar/UnitsToggle.tsx
msgid "Units"
msgstr "Unidades"

#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionPairPicker.tsx
msgid "unknown"
msgstr "desconocida"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/AlertDetails.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/alerts/components/AssetInfoCard.tsx
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
#: src/pages/facilityModel/SubjectAssetPanel.tsx
#: src/pages/overview/sidebar/filterSelects/unitFilter/UnitTypeFilter.tsx
msgid "Unknown"
msgstr "Desconocido"

#: src/features/lotoReports/components/LotoDrawingsCoverage.tsx
#: src/features/lotoReports/printReport/printPageText.ts
msgid "Unknown drawing"
msgstr "Plano desconocido"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Unknown end"
msgstr "Fin desconocido"

#: src/features/chatbot/api/sseClient.ts
#: src/features/chatbot/hooks/useMessageSender.ts
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/details/extensions/DetailsPageExtensionsProvider.tsx
#: src/pages/errorFallback/ErrorFallback.tsx
msgid "Unknown error"
msgstr "Error desconocido"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unknown patch error!"
msgstr "Error de parche desconocido."

#: src/features/fimReview/provenance.ts
msgid "Unknown source"
msgstr "Fuente desconocida"

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
#: src/pages/cases/md/MdCaseDetailsInspector.tsx
msgid "Unknown start"
msgstr "Inicio desconocido"

#: src/pages/assetLens/components/AssetHeader.tsx
#: src/pages/systemView/components/HealthPlansModal.tsx
msgid "Unknown Unit"
msgstr "Unidad desconocida"

#: src/pages/details/extensions/flow/filesExt/UploadButton.tsx
msgid "Unknown upload error!"
msgstr "Error de carga desconocido."

#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/contexts/CaseDetailsProvider.tsx
#: src/pages/cases/md/MdCaseDetailsProvider.tsx
#: src/pages/cases/md/MdCaseDetailsProvider.tsx
msgid "Unknown User"
msgstr "Usuario desconocido"

#: src/features/knowledgeDocumentViewer/components/metadata/PageMetadataEvalStatusChip.tsx
msgid "Unlabeled"
msgstr "Sin etiqueta"

#: src/pages/evaluations/metadata/labeling/components/DataLabelingLandingCounts.tsx
msgid "Unlabeled remaining"
msgstr "Pendientes de etiquetar"

#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Unmet required slots:"
msgstr "Campos obligatorios sin completar:"

#: src/features/sentinels/coverage.ts
msgid "Unmonitored"
msgstr "Sin supervisión"

#: src/features/timeSeries/components/panes/TagFilterControls.tsx
msgid "Unmonitored tags"
msgstr "Etiquetas sin supervisión"

#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Unnamed point"
msgstr "Punto sin nombre"

#: src/pages/manageAccess/hooks/useListedRoster.ts
#: src/pages/manageAccess/utils/rolodex/rolodexUserMapping.ts
#: src/pages/manageAccess/utils/rolodex/rolodexUserMapping.ts
msgid "Unnamed user"
msgstr "Usuario sin nombre"

#: src/features/embeddedSidebar/chatHistory/AgenticChatHistorySessionOverflowMenu.tsx
msgid "Unpin"
msgstr "Desfijar"

#: src/pages/cases/components/EditCaseForm.tsx
msgid "Unpublish"
msgstr "Anular publicación"

#: src/features/mdCases/mdCaseDisplay.ts
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Unpublished"
msgstr "Sin publicar"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
#: src/features/forecastNotifications/notificationUtils.ts
msgid "Unread"
msgstr "No leídas"

#: src/features/knowledgeDocumentViewer/graph/offPageConnectorTooltipRows.ts
#: src/pages/facilityModel/SubjectAssetPanel.tsx
msgid "Unresolved"
msgstr "Sin resolver"

#: src/pages/processData/components/ProcessDataTopBar.tsx
msgid "Unsaved"
msgstr "Sin guardar"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
#: src/features/timeSeries/components/chartActions/MarkupToolButtons.tsx
msgid "Unsaved annotation changes"
msgstr "Cambios de anotación sin guardar"

#: src/features/lotoReports/components/LotoEditorSaveState.tsx
#: src/features/lotoReports/components/LotoSaveStatusText.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "Unsaved changes"
msgstr "Cambios sin guardar"

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Unsaved recommendation edits will be saved first."
msgstr "Primero se guardarán los cambios no guardados de la recomendación."

#: src/pages/cases/md/mdCaseDetailsHelpers.ts
msgid "Unsupported case type"
msgstr "Tipo de caso no compatible"

#: src/features/lotoReports/components/LotoPointsCoverage.tsx
msgid "Untagged"
msgstr "Sin etiqueta"

#: src/features/lotoReports/components/LotoProposalCard.tsx
msgid "Untagged point"
msgstr "Punto sin etiqueta"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
msgid "Untitled case"
msgstr "Caso sin título"

#: src/pages/cases/components/CaseDetailsContent.tsx
#: src/pages/cases/components/EditableCaseTitle.tsx
msgid "Untitled Case"
msgstr "Caso sin título"

#: src/features/timeSeries/components/DashboardHeader.tsx
#: src/pages/processData/utils/chartDisplayName.ts
msgid "Untitled Chart"
msgstr "Gráfico sin título"

#: src/features/lotoReports/components/LotoAttachmentsSection.tsx
#: src/features/lotoReports/components/LotoIsolationPointRow.tsx
#: src/features/lotoReports/components/LotoSessionOtherPages.tsx
#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Untitled document"
msgstr "Documento sin título"

#: src/features/timeSeries/components/LabelsTab.tsx
#: src/features/timeSeries/components/labelTool/LabelOverlay.tsx
#: src/pages/processData/buildMode/dock/EvalLabelTable.tsx
msgid "Untitled label"
msgstr "Marca sin título"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/WorkbenchBody.tsx
msgid "Untitled view"
msgstr "Vista sin título"

#: src/features/timeSeries/components/DerivedValues.tsx
#: src/features/timeSeries/components/panes/DerivedTagsPane.tsx
msgid "Update"
msgstr "Actualizar"

#: src/features/knowledgeDocumentViewer/components/table/enhancements/BulkEditModal.tsx
msgid "Update Rows"
msgstr "Actualizar filas"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Update save"
msgstr "Actualizar guardado"

#: src/features/knowledgeDocumentViewer/artifacts/sheet/FreeformDocumentSheet.tsx
#: src/features/knowledgeDocumentViewer/artifacts/sheet/FreeformDocumentSheet.tsx
#: src/pages/cases/md/MdCasesCardList.tsx
#: src/pages/cases/md/MdCasesColumnHeader.tsx
msgid "Updated"
msgstr "Actualizado"

#: src/features/knowledgeDocumentViewer/workOrders/WorkOrderCardMetadata.tsx
msgid "Updated {updated}"
msgstr "Actualizado {updated}"

#: src/pages/cases/md/MdCaseDetailsMainColumn.tsx
msgid "Updated {updatedAtLabel}"
msgstr "Actualizado {updatedAtLabel}"

#: src/features/mdCases/components/ProvenanceContentViewer.tsx
msgid "Updated {updatedLabel}"
msgstr "Actualizado {updatedLabel}"

#: src/features/cases/components/CaseContentUpdatedContent.tsx
msgid "Updated case content"
msgstr "Contenido del caso actualizado"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/docChatText.ts
msgid "Updated search query and found {resultLabel}"
msgstr "Se actualizó la consulta de búsqueda y se encontraron {resultLabel}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTimelineRows.tsx
msgid "Updated search query and found <0>{resultLabel}</0>"
msgstr "Se actualizó la consulta de búsqueda y se encontró <0>{resultLabel}</0>"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
msgid "Updated: {updatedAt}"
msgstr "Actualizado: {updatedAt}"

#: src/pages/facilityModel/FacilityModelTable.tsx
msgid "Updating results…"
msgstr "Actualizando resultados…"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTable.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload"
msgstr "Cargar"

#: src/features/powerCustomerUploads/components/powerCustomerUploadHistoryPresentation.ts
msgid "Upload · {date}"
msgstr "Carga · {date}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload Acoustic Image"
msgstr "Cargar imagen acústica"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "Upload approval request was cancelled."
msgstr "La solicitud de aprobación de carga fue cancelada."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Upload Date"
msgstr "Fecha de carga"

#: src/features/powerCustomerUploads/state/powerCustomerUploadHistoryRows.ts
msgid "Upload did not finish."
msgstr "La carga no se completó."

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "Upload Document"
msgstr "Cargar documento"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload documents"
msgstr "Cargar documentos"

#: src/features/navbar/profileAndSettings/ProfileAndSettingsSidebar.tsx
msgid "Upload Documents"
msgstr "Cargar documentos"

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Upload failed"
msgstr "Carga fallida"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload Files"
msgstr "Cargar archivos"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "Upload files or folders separately. Drop only files or only folders."
msgstr "Cargue archivos o carpetas por separado. Suelte solo archivos o solo carpetas."

#: src/features/powerCustomerUploads/uploadRequest/powerCustomerUploadApprovalPipeline.ts
msgid "Upload finalization failed."
msgstr "La finalización de la carga falló."

#: src/features/powerCustomerUploads/components/PowerCustomerUploadSelection.tsx
msgid "Upload Folder"
msgstr "Cargar carpeta"

#: src/features/powerCustomerUploads/hooks/usePowerCustomerUploadHistory.ts
msgid "Upload history could not be loaded."
msgstr "No se pudo cargar el historial de cargas."

#: src/features/powerCustomerUploads/hooks/usePowerCustomerUploadHistory.ts
msgid "Upload history could not be loaded. {detail}"
msgstr "No se pudo cargar el historial de cargas. {detail}"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Upload Image"
msgstr "Cargar imagen"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Upload incomplete"
msgstr "Carga incompleta"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Upload IR Image"
msgstr "Cargar imagen IR"

#: src/features/permissions/profiles/power.ts
msgid "Upload new documents."
msgstr "Carga documentos nuevos."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageGalleryView.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageTimelineView.tsx
msgid "Upload New Image"
msgstr "Cargar imagen nueva"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadReviewTablePagination.tsx
msgid "Upload pages"
msgstr "Páginas de la carga"

#: src/pages/details/extensions/flow/FilesExtension.tsx
msgid "Upload report"
msgstr "Cargar informe"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadHistoryPanel.tsx
msgid "Upload type"
msgstr "Tipo de carga"

#: src/pages/assetLens/components/AssetDocumentsWrapper.tsx
msgid "Upload your first document to get started. Drag & drop or click the upload zone above."
msgstr "Cargue su primer documento para comenzar. Arrastre y suelte o haga clic en la zona de carga de arriba."

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Uploaded"
msgstr "Cargado"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Uploaded by {uploader}"
msgstr "Cargado por {uploader}"

#: src/features/fim/photos/PhotoLightbox.tsx
msgid "Uploaded by {uploader} on {uploadedAt}"
msgstr "Cargado por {uploader} el {uploadedAt}"

#: src/features/powerCustomerUploads/components/powerCustomerUploadProgressModel.ts
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
#: src/features/powerCustomerUploads/components/PowerCustomerUploadStatus.tsx
msgid "Uploading"
msgstr "Cargando"

#: src/features/richText/components/ToolbarPlugin.tsx
#: src/features/richText/editorPlugins/DragDropPastePlugin.tsx
msgid "Uploading image..."
msgstr "Cargando imagen…"

#: src/features/richText/components/ToolbarPlugin.tsx
msgid "Uploading..."
msgstr "Cargando…"

#: src/features/fim/photos/PhotoUploadRow.tsx
#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Uploading…"
msgstr "Cargando…"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Upper"
msgstr "Superior"

#: src/features/timeSeries/utils/chartHelpers.ts
msgid "Upper High"
msgstr "Superior alto"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Upper High:"
msgstr "Superior alto:"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Upper:"
msgstr "Superior:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Usage split"
msgstr "Desglose de uso"

#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Usage splits"
msgstr "Desglose del uso"

#: src/features/lotoReports/components/LotoPresetCombobox.tsx
msgid "Use “{typed}”"
msgstr "Usar «{typed}»"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "Use {selectedName}"
msgstr "Usar {selectedName}"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseCitations.tsx
msgid "Use a DOC-… document id, or a link to a document opened from search."
msgstr "Use un id de documento DOC-…, o un enlace a un documento abierto desde la búsqueda."

#: src/pages/processData/buildMode/dock/EngineeringSection.tsx
msgid "Use best"
msgstr "Usar el mejor"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Use chart range"
msgstr "Usar rango del gráfico"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatEvalCaseReview.tsx
msgid "Use lowercase letters, numbers, hyphens, and underscores."
msgstr "Use letras minúsculas, números, guiones y guiones bajos."

#: src/features/timeSeries/components/ScatterPlotTableLegend.tsx
#: src/features/timeSeries/components/timeSeriesScatterplot/TimeSeriesScatterplotChart.tsx
msgid "Use the Edit pens button to add data to the plot."
msgstr "Use el botón Editar trazos para agregar datos al gráfico."

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Use the viewer tools to place annotations, measurements, or primitives."
msgstr "Use las herramientas del visor para colocar anotaciones, mediciones o primitivas."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Use type"
msgstr "Tipo de uso"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Useful"
msgstr "Útil"

#: src/pages/homepage/Homepage.tsx
#: src/pages/homepage/Homepage.tsx
msgid "User"
msgstr "Usuario"

#: src/features/richText/components/TaggableUsersCard.tsx
msgid "User already in the allowed list"
msgstr "El usuario ya está en la lista de permitidos"

#: src/features/richText/nodes/MentionNode.tsx
msgid "User ID:"
msgstr "ID de usuario:"

#: src/features/richText/nodes/MentionNode.tsx
msgid "User Information"
msgstr "Información del usuario"

#: src/features/navbar/profileAndSettings/useProfileAndSettingsState.ts
msgid "User Name"
msgstr "Nombre de usuario"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "User permissions successfully updated"
msgstr "Permisos del usuario actualizados correctamente"

#: src/pages/manageAccess/components/invite/InviteRoleGroup.tsx
msgid "User Roles"
msgstr "Roles de usuario"

#: src/pages/manageAccess/components/invite/InviteUsersDialog.tsx
#: src/pages/manageAccess/components/table/UsersTableHead.tsx
msgid "User type"
msgstr "Tipo de usuario"

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "User type successfully updated"
msgstr "Tipo de usuario actualizado"

#: src/features/chatbot/components/SessionHeaderBar.tsx
msgid "User: {text}"
msgstr "Usuario: {text}"

#: src/pages/metrics/components/SiteRowsTable.tsx
msgid "Users"
msgstr "Usuarios"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Uses current component configuration with the inspection-linked asset model."
msgstr "Usa la configuración actual del componente con el modelo del activo vinculado a la inspección."

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "UT point size"
msgstr "Tamaño de los puntos UT"

#: src/pages/processData/buildMode/components/WindowDrawToolButtons.tsx
msgid "Val"
msgstr "Validación"

#: src/features/timeSeries/experiment/SplitBuilder.tsx
msgid "val (orange)"
msgstr "validación (naranja)"

#: src/pages/details/extensions/flow/assetModelEditorExt/AssetModelEditorRawJSON.tsx
msgid "Validate"
msgstr "Validar"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validate permanently?"
msgstr "¿Validar permanentemente?"

#: src/features/fimReview/ReviewActions.tsx
msgid "Validate subject"
msgstr "Validar sujeto"

#: src/features/modelOperations/SubjectTargetPickerColumn.tsx
msgid "validated"
msgstr "validado"

#: src/features/facilityModel/columns.ts
#: src/features/fimReview/DecisionHistory.tsx
#: src/features/modelOperations/SubjectDetails.tsx
msgid "Validated"
msgstr "Validado"

#: src/features/fimReview/ReviewActions.tsx
#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validating…"
msgstr "Validando…"

#: src/features/facilityModel/columns.ts
#: src/pages/facilityModel/FacilityModelFilters.tsx
msgid "Validation"
msgstr "Validación"

#: src/features/timeSeries/components/ThresholdConfigurationModal.tsx
msgid "Validation Errors"
msgstr "Errores de validación"

#: src/features/fimReview/reviewOutcome.ts
msgid "Validation is taking longer than expected. It may still finish in the background. Refresh this Subject before trying again."
msgstr "La validación está tardando más de lo esperado. Es posible que finalice en segundo plano. Actualice este sujeto antes de volver a intentarlo."

#: src/features/fimReview/ReviewActions.tsx
msgid "Validation note"
msgstr "Nota de validación"

#: src/pages/facilityModel/SubjectDetailPage.tsx
msgid "Validation writes durable identity constraints; there is no un-validate"
msgstr "La validación escribe restricciones de identidad permanentes; no se puede deshacer la validación"

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "Validation:"
msgstr "Validación:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ScatterPlotTableConfig.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
#: src/pages/systemView/components/unitsTab/FilterControls.tsx
msgid "Value"
msgstr "Valor"

#: src/pages/alerts/components/AlertTimeSeriesChart.tsx
msgid "Value ({unit})"
msgstr "Valor ({unit})"

#: src/features/timeSeries/components/ThresholdFiltering.tsx
msgid "Value 2"
msgstr "Valor 2"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "value at cursor"
msgstr "valor en el cursor"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Value ceiling"
msgstr "Límite superior del valor"

#: src/pages/processData/buildMode/dock/TagCleaningEditor.tsx
msgid "Value floor"
msgstr "Límite inferior del valor"

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "Value must be a number"
msgstr "El valor debe ser un número"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Value range and color threshold controls{unitLabel}"
msgstr "Controles de rango de valores y umbral de color{unitLabel}"

#: src/features/dataFilter/rangeFilter/RangeSlider.tsx
msgid "Value range filter"
msgstr "Filtro de rango de valores"

#: src/features/navbar/navConfig.ts
msgid "Value Stories"
msgstr "Historias de valor"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "Value: {value} {unit}"
msgstr "Valor: {value} {unit}"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to decrease with higher ambient temperatures"
msgstr "Los valores tienden a disminuir con temperaturas ambiente más altas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to decrease with higher humidity"
msgstr "Los valores tienden a disminuir con mayor humedad"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to increase with higher ambient temperatures"
msgstr "Los valores tienden a aumentar con temperaturas ambiente más altas"

#: src/pages/assetLens/components/tabs/imagesTabComponents/utils.ts
msgid "Values tend to increase with higher humidity"
msgstr "Los valores tienden a aumentar con mayor humedad"

#: src/features/lotoReports/components/LotoSheetPointRow.tsx
msgid "Valve/breaker"
msgstr "Válvula/interruptor"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "Valve/Breaker"
msgstr "Válvula/Interruptor"

#: src/features/timeSeries/components/RegressionPrediction.tsx
msgid "Variable"
msgstr "Variable"

#: src/pages/assetLens/components/tabs/canvas/AnalysisState.tsx
msgid "Variables"
msgstr "Variables"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/DocumentPreviewMeta.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentPreview/PreviewDocumentDetailsSection.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types.ts
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/utils/constants.ts
#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
#: src/pages/evaluations/metadata/labeling/components/DataLabelingVendorFilter.tsx
msgid "Vendor"
msgstr "Proveedor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Vendor category"
msgstr "Categoría del proveedor"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Vendor directory"
msgstr "Directorio de proveedores"

#: src/pages/evaluations/metadata/labeling/utils/vendorOptions.ts
msgid "Vendor: {count}"
msgstr "Proveedor: {count}"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Verification incomplete"
msgstr "Verificación incompleta"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid ""
"Verified\n"
"Initial"
msgstr ""
"Inic.\n"
"verif."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Verify the remaining extracted values and links to continue."
msgstr "Verifica los valores extraídos y los vínculos restantes para continuar."

#: src/features/timeSeries/agentTab/dock/AgentDock.tsx
msgid "Versions"
msgstr "Versiones"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "View"
msgstr "Ver"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTurnAttachments.tsx
msgid "View {attachmentName}"
msgstr "Ver {attachmentName}"

#: src/pages/manageAccess/components/scope/SiteSelect.tsx
msgid "View {orgName}"
msgstr "Ver {orgName}"

#: src/pages/assetLens/components/tabs/DocumentsTab.tsx
msgid "View {title}"
msgstr "Ver {title}"

#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/ProcessDataTopBar.tsx
#: src/pages/processData/components/viewSwitcher/ViewSwitcher.tsx
msgid "View actions"
msgstr "Acciones de la vista"

#: src/features/forecastNotifications/NotificationsDropdownContent.tsx
msgid "View all notifications"
msgstr "Ver todas las notificaciones"

#: src/pages/homepage/constants.ts
msgid "View and manage your assets at your site."
msgstr "Vea y administre los activos de su sitio."

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "View as {userName}"
msgstr "Ver como {userName}"

#: src/pages/systemView/components/unitsTab/UnitListItem.tsx
msgid "View Asset"
msgstr "Ver activo"

#: src/features/sentinels/components/SentinelAlertsPanel.tsx
#: src/pages/alerts/components/AlertsTableColumns.tsx
#: src/pages/facilityModel/SentinelOverviewPage.tsx
msgid "View case"
msgstr "Ver caso"

#: src/pages/evaluations/metadata/dashboard/components/dataLabeling/DataLabelingDashboardAgreementByFieldRow.tsx
msgid "View comparisons for {translatedField}"
msgstr "Ver comparaciones de {translatedField}"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "View deleted"
msgstr "Vista eliminada"

#: src/pages/assetLens/components/tabs/AnomalyDashboard.tsx
msgid "View Details"
msgstr "Ver detalles"

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "View Forecast as {userName}?"
msgstr "¿Ver Forecast como {userName}?"

#: src/features/lotoReports/components/LotoPagePanelHeader.tsx
msgid "View full report"
msgstr "Ver informe completo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "View inspection"
msgstr "Ver inspección"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "View linked documents"
msgstr "Ver documentos vinculados"

#: src/features/assetVizAdapter/forecastAssetVizWindow/ForecastAssetVizWindowSurface.tsx
msgid "View mode"
msgstr "Modo de vista"

#: src/features/timeSeries/components/chartActions/ChartSaveAction.tsx
msgid "View name"
msgstr "Nombre de la vista"

#: src/pages/processData/components/viewSwitcher/ViewActionDialogs.tsx
msgid "View renamed"
msgstr "Vista renombrada"

#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
#: src/features/copcPointClouds/CopcViewerOverlay.tsx
msgid "View settings"
msgstr "Ajustes de la vista"

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "View the Manage Access page."
msgstr "Ver la página Administrar acceso."

#: src/pages/manageAccess/users.ts
msgctxt "access role"
msgid "Viewer"
msgstr "Lector"

#: src/pages/processData/buildMode/components/ModeSwitcher.tsx
msgid "Viewer mode"
msgstr "Modo de visualización"

#: src/pages/details/visualization/alerts/specificAlerts/PublishingStateNotice.tsx
msgid "Viewing {stateName} data layer"
msgstr "Viendo la capa de datos {stateName}"

#: src/features/knowledgeDocumentViewer/utils/metadataFieldLabelMessages.ts
msgid "Viewing Rotation"
msgstr "Rotación de visualización"

#: src/pages/processData/components/helpGuide/HelpGuideChapters.tsx
msgid "Views are shared — everyone on the site sees the same list."
msgstr "Las vistas son compartidas; todas las personas del sitio ven la misma lista."

#: src/features/navbar/navConfig.ts
msgid "Virtual Reports"
msgstr "Reportes virtuales"

#: src/pages/cases/components/CaseDetailsSidebar.tsx
msgid "Visibility"
msgstr "Visibilidad"

#: src/pages/cases/components/CasesTable.tsx
msgid "Visible to everyone"
msgstr "Visible para todos"

#: src/features/timeSeries/experiment/RunComparison.tsx
msgid "vs first"
msgstr "frente al primero"

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for import details to finish loading."
msgstr "Espera a que terminen de cargar los detalles de la importación."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for requirement sets to load."
msgstr "Espera a que se carguen los conjuntos de requisitos."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for the current save to finish"
msgstr "Espere a que finalice el guardado actual."

#: src/pages/cases/md/MdCaseDetailsPage.tsx
msgid "Wait for the current update to finish."
msgstr "Espere a que finalice la actualización actual."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for your correction to save."
msgstr "Espera a que se guarde tu corrección."

#: src/pages/nnpp/imports/NnppImportVerificationPage.tsx
msgid "Wait for your reviews to finish saving."
msgstr "Espera a que terminen de guardarse tus revisiones."

#: src/features/powerCustomerUploads/state/powerCustomerUploadRowUpdates.ts
msgid "Waiting for pipeline scan."
msgstr "Esperando el escaneo del pipeline."

#: src/features/navbar/navConfig.ts
msgid "Walkdowns"
msgstr "Recorridos de inspección"

#: src/pages/assetLens/components/tabs/SensorIssuesTab.tsx
#: src/pages/details/visualization/markupEditing/IconSelector.tsx
msgid "Warning"
msgstr "Advertencia"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Warranty and liability terms"
msgstr "Términos de garantía y responsabilidad"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Was the recommendation accurate, partially accurate, or off?"
msgstr "¿La recomendación fue precisa, parcialmente precisa o incorrecta?"

#: src/features/mdCases/mdCaseDisplay.ts
msgid "Watch"
msgstr "Vigilar"

#: src/features/powerCustomerUploads/components/PowerCustomerUploadPicker.tsx
msgid "We couldn't read this selection. Try again or choose different files."
msgstr "No se pudo leer la selección. Inténtelo de nuevo o elija otros archivos."

#: src/pages/cases/components/CaseFeedbackModal.tsx
#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Weak"
msgstr "Débil"

#: src/pages/metrics/components/MonthlyTable.tsx
msgid "Week of {weekStart}"
msgstr "Semana del {weekStart}"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "weekly"
msgstr "semanal"

#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Weekly trend"
msgstr "Tendencia semanal"

#: src/pages/processData/buildMode/rightPanel/SavedModelShelf.tsx
msgid "weights"
msgstr "pesos"

#: src/features/navbar/navConfig.ts
msgid "Weld Map"
msgstr "Mapa de soldaduras"

#: src/pages/cases/components/CaseFeedbackModal.tsx
msgid "Were the linked references useful or lacking context?"
msgstr "¿Las referencias vinculadas fueron útiles o les faltó contexto?"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatRevisionDiffCard.tsx
#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/RevisionComparePreviewPanel.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareLauncher.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareLauncher.tsx
#: src/features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareView.tsx
msgid "What changed"
msgstr "Qué cambió"

#: src/features/timeSeries/agentTab/dock/VersionsTab.tsx
msgid "what changed after it"
msgstr "qué cambió después"

#: src/features/chatbot/components/FeedbackMenu.tsx
msgid "What could be improved?"
msgstr "¿Qué se podría mejorar?"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "What data is actually used{value177_48}"
msgstr "Qué datos se usan realmente{value177_48}"

#: src/features/timeSeries/components/labelTool/LabelConfigPanel.tsx
msgid "What happened in this window?"
msgstr "¿Qué ocurrió en esta ventana?"

#: src/pages/processData/buildMode/dock/BandsDockTab.tsx
msgid "What the last run calibrated for the selected method — retrain after changing the knobs to recalibrate."
msgstr "Lo que calibró la última ejecución para el método seleccionado; vuelva a entrenar después de cambiar los controles para recalibrar."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "What to do when an aggregate bin has no samples. Off (prod) omits empty bins (tags stay sparse/NaN). LOCF carries the last observed value forward across empty bins — fills gaps but invents values. Not used in raw mode (exact timestamps only)."
msgstr "Qué hacer cuando un intervalo agregado no tiene muestras. Desactivado (producción) omite los intervalos vacíos (las etiquetas permanecen dispersas/NaN). LOCF propaga el último valor observado por los intervalos vacíos; rellena huecos, pero inventa valores. No se usa en modo sin procesar (solo marcas de tiempo exactas)."

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "When enabled, lines will be drawn between data points. When disabled, only markers will be shown."
msgstr "Cuando está activado, se dibujan líneas entre los puntos de datos. Cuando está desactivado, solo se muestran marcadores."

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "When enabled, missing data points will be interpolated. This helps create smoother visualizations when data has gaps."
msgstr "Cuando está activado, se interpolan los puntos de datos faltantes. Esto ayuda a crear visualizaciones más uniformes cuando hay huecos en los datos."

#: src/features/sentinels/components/MonitorTab.tsx
msgid "When enabled, this sentinel is scored on the cadence below and a case is opened whenever the target leaves its band. Off by default — nothing runs until you turn it on."
msgstr "Cuando está activado, este sentinel se puntúa con la frecuencia indicada a continuación y se abre un caso cuando el objetivo sale de su banda. Está desactivado de forma predeterminada; no se ejecuta nada hasta que lo active."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, MLP “driver” / “driver+own” methods get lag + rolling-mean features for each driver, not just current values. Off = current drivers only (like mlp_none’s feature set for history)."
msgstr "Cuando está activado, los métodos MLP “driver” / “driver+own” reciben características de rezago y media móvil para cada variable predictora, no solo los valores actuales. Desactivado = solo variables predictoras actuales (como el conjunto de características de historial de mlp_none)."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, MLPs only score rows where the target and every driver feature are present — no placeholder fills for missing inputs. Predictions are cleaner (no jumps from missingness masks) but the monitor goes blind wherever any sensor drops out."
msgstr "Cuando está activado, los MLP solo puntúan filas donde están presentes el objetivo y todas las características de las variables predictoras; no se rellenan las entradas faltantes con marcadores de posición. Las predicciones son más limpias (sin saltos por máscaras de ausencia), pero el monitor pierde visibilidad donde falla cualquier sensor."

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "When on, the “driver+own” MLP also sees prior target lags + rolling mean (never the current target). Powerful for tracking, but can hide slow target drift because the model can copy recent target history."
msgstr "Cuando está activado, el MLP “driver+own” también ve rezagos anteriores del objetivo y su media móvil (nunca el objetivo actual). Es potente para el seguimiento, pero puede ocultar una deriva lenta del objetivo porque el modelo puede copiar su historial reciente."

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "When timestamps don’t line up"
msgstr "Cuando las marcas de tiempo no coinciden"

#: src/features/timeSeries/experiment/TransparencyStrip.tsx
msgid "Where does validation fit in?"
msgstr "¿Dónde interviene la validación?"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Where it stands"
msgstr "Estado actual"

#: src/features/fimReview/ReviewActions.tsx
msgid "Which aliases are junk?"
msgstr "¿Qué alias son irrelevantes?"

#: src/features/timeSeries/agentTab/dock/FitTab.tsx
msgid "Which band of the driver carries the loss."
msgstr "Qué banda de la variable predictora concentra la pérdida."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatTagPickerCard.tsx
msgid "Which tag did you mean for “{identifier}”?"
msgstr "¿A qué etiqueta te referías con «{identifier}»?"

#: src/features/timeSeries/agentTab/agentKpiPen.ts
msgid "which the chart's math cannot evaluate"
msgstr "que las operaciones matemáticas del gráfico no pueden evaluar"

#: src/features/copcPointClouds/CopcLocalizationColorControl.tsx
msgid "White"
msgstr "Blanco"

#: src/pages/systemView/components/SystemViewAnnotationSidebar.tsx
msgid "Whiteboard name"
msgstr "Nombre de la pizarra"

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Who can do what in each part of {organizationName}."
msgstr "Quién puede hacer qué en cada área de {organizationName}."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "Who can do what in each part of the platform."
msgstr "Quién puede hacer qué en cada área de la plataforma."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatInspectionCard.tsx
msgid "Whole grid"
msgstr "Cuadrícula completa"

#: src/features/fimReview/ReviewActions.tsx
msgid "Why is this input meaningless? (required)"
msgstr "¿Por qué esta entrada no tiene significado? (obligatorio)"

#: src/features/timeSeries/experiment/knobCopy.ts
msgid "Width of each aggregate bin on the shared time grid. Production Sentinels default to 10 minutes. All lags/rolling windows are counted in these bins (e.g. lag 3 @ 10 min = 30 min). Ignored in raw mode. You can use seconds for finer grids."
msgstr "Ancho de cada intervalo agregado en la cuadrícula temporal compartida. Los Sentinels de producción usan 10 minutos de forma predeterminada. Todos los rezagos y ventanas móviles se cuentan en estos intervalos (p. ej., rezago 3 a 10 min = 30 min). Se ignora en modo sin procesar. Puede usar segundos para cuadrículas más detalladas."

#: src/features/sentinels/components/DesignRunOverviewSections.tsx
#: src/features/timeSeries/components/DataSmoothing.tsx
#: src/features/timeSeries/components/PenTransformControls.tsx
#: src/features/timeSeries/components/ThresholdFiltering.tsx
#: src/features/timeSeries/sentinelStudio/SentinelComparison.tsx
#: src/pages/processData/buildMode/dock/BacktestDockTab.tsx
msgid "Window"
msgstr "Ventana"

#: src/features/timeSeries/components/PenTransformControls.tsx
msgid "Window ends"
msgstr "Fin de la ventana"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Window role"
msgstr "Rol de la ventana"

#: src/features/timeSeries/components/DataSmoothing.tsx
msgid "Window size"
msgstr "Tamaño de la ventana"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentValueChip.tsx
msgid "window: min {min} · mean {mean} · max {max}"
msgstr "intervalo: mín. {min} · media {mean} · máx. {max}"

#: src/features/timeSeries/agentTab/dock/WindowsTab.tsx
#: src/pages/processData/buildMode/components/BuildDock.tsx
msgid "Windows"
msgstr "Ventanas"

#: src/features/timeSeries/sentinelStudio/SentinelBuilderPanel.tsx
msgid "Without a P&ID the agent plans from the tags and stats alone."
msgstr "Sin un P&ID, el agente planifica únicamente a partir de las etiquetas y las estadísticas."

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "WO group"
msgstr "Grupo de OT"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "WO group (wogroup)"
msgstr "Grupo de órdenes (wogroup)"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work details"
msgstr "Detalles del trabajo"

#: src/pages/evaluations/metadata/labeling/utils/pageClassificationTaxonomy.ts
msgid "Work execution and traceability records"
msgstr "Registros de ejecución de trabajo y trazabilidad"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
msgid "Work log"
msgstr "Registro de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work logs"
msgstr "Registros de trabajo"

#: src/features/knowledgeDocumentViewer/utils/documentTypeLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work order"
msgstr "Orden de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work order (istask=false)"
msgstr "Orden de trabajo (istask=false)"

#: src/features/lotoReports/components/LotoSheetHeaderFields.tsx
msgid "Work order #"
msgstr "N.º de orden de trabajo"

#: src/features/lotoReports/recordSheet/recordSheetLayout.ts
msgid "WORK ORDER #:"
msgstr "N.º ORDEN DE TRABAJO:"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
msgid "Work order reference"
msgstr "Referencia de orden de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Work orders"
msgstr "Órdenes de trabajo"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/AgenticInlineDocumentResults.tsx
msgid "Work orders come from an imported snapshot; results do not represent a complete maintenance history."
msgstr "Las órdenes de trabajo provienen de una captura de datos importada; los resultados no representan el historial completo de mantenimiento."

#: src/features/navbar/siteSelectors/SiteSelectorsSidebar.tsx
msgid "Work Site"
msgstr "Sitio de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/legacyCmmsRecordPdf.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderPresentation.ts
msgid "Work type"
msgstr "Tipo de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Work-order priority"
msgstr "Prioridad de la orden de trabajo"

#: src/features/knowledgeDocumentViewer/workOrders/cmmsDocumentLabels.ts
#: src/features/knowledgeDocumentViewer/workOrders/workOrderFields.ts
msgid "Work-package material availability"
msgstr "Disponibilidad de materiales del paquete de trabajo"

#: src/pages/cases/md/mdCasesListSearchContract.ts
msgid "Workflow Mode"
msgstr "Modo de flujo de trabajo"

#: src/features/workspaceTabs/components/WorkspaceTabSwitcher.tsx
msgid "Workspace"
msgstr "Espacio de trabajo"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "worst σ"
msgstr "peor σ"

#: src/features/timeSeries/agentTab/dock/AlertingTab.tsx
msgid "would alert"
msgstr "generaría una alerta"

#: src/pages/cases/components/CaseCommentInput.tsx
msgid "Write a comment..."
msgstr "Escriba un comentario…"

#: src/features/timeSeries/agentTab/dock/TargetTab.tsx
msgid "Written against the role names below, not tag ids — so repointing a role at a different tag leaves the physics alone. Smoothing is a rolling MEDIAN over that many days; the band is re-derived at the same smoothing, so sigma stays comparable."
msgstr "Se escribe con los nombres de rol indicados a continuación, no con los identificadores de etiqueta; así, reasignar un rol a otra etiqueta no altera la física. El suavizado es una MEDIANA móvil durante esa cantidad de días; la banda se vuelve a calcular con el mismo suavizado para que sigma siga siendo comparable."

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Asset Type"
msgstr "Tipo de activo incorrecto"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Bounding Box"
msgstr "Cuadro delimitador incorrecto"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Document Type"
msgstr "Tipo de documento incorrecto"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong Drawing Number"
msgstr "Número de plano incorrecto"

#: src/features/knowledgeDocumentViewer/components/sidebar/FeedbackModal.tsx
msgid "Wrong System"
msgstr "Sistema incorrecto"

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
msgid "X"
msgstr "X"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "X-Axis Options"
msgstr "Opciones del eje X"

#: src/features/timeSeries/components/XAxisSection.tsx
msgid "X-Axis:"
msgstr "Eje X:"

#: src/features/timeSeries/experiment/NormalizationViewer.tsx
msgid "x²: {value125_39}"
msgstr "x²: {value125_39}"

#: src/features/assetLifecycleV2/views/observations/LtaProfilePlot.tsx
#: src/features/assetLifecycleV2/views/shared/MarkupFocusViz.tsx
msgid "Y"
msgstr "Y"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {terms} (t normalized to [-1,1])"
msgstr "y = {terms} (t normalizado a [-1,1])"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {value315_23} / (1 + e^(-{value315_50}(x - {value315_70})))"
msgstr "y = {value315_23} / (1 + e^(-{value315_50}(x - {value315_70})))"

#: src/features/timeSeries/regressionHelpers.ts
msgid "y = {value430_23} * sin({value430_45}x + {value430_64}) + {value430_83} (period: {value430_108} days)"
msgstr "y = {value430_23} * sen({value430_45}x + {value430_64}) + {value430_83} (período: {value430_108} días)"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y axis ranges"
msgstr "Rangos del eje Y"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "y max"
msgstr "máx. de Y"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y max"
msgstr "Máx. de Y"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Y Max"
msgstr "Y máx."

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Y max override"
msgstr "Anulación del máximo de Y"

#: src/features/timeSeries/agentTab/dock/SettingsTab.tsx
msgid "y min"
msgstr "mín. de Y"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Y min"
msgstr "Mín. de Y"

#: src/features/timeSeries/components/SensorScatterplotTableColumns.tsx
msgid "Y Min"
msgstr "Y mín."

#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
#: src/features/timeSeries/components/panes/TagConfigurationList.tsx
msgid "Y min override"
msgstr "Anulación del mínimo de Y"

#: src/features/timeSeries/components/YAxisModeSection.tsx
msgid "Y-Scale"
msgstr "Escala Y"

#: src/features/timeSeries/components/YScaleControls.tsx
msgid "Y-scale mode"
msgstr "Modo de escala Y"

#: src/features/knowledgeDocumentViewer/components/metadata/ShouldHaveMetadataField.tsx
#: src/features/knowledgeDocumentViewer/graph/nodeTooltip.ts
#: src/pages/site/components/CustomFieldsTableColumns.tsx
#: src/pages/site/forms/customFieldInfoFormFields.ts
msgid "Yes"
msgstr "Sí"

#: src/features/lotoReports/components/LotoTargetDrawings.tsx
msgid "You are here"
msgstr "Estás aquí"

#: src/features/powerCustomerUploads/api/powerCustomerUploadClient.ts
msgid "You are not authorized to upload documents for this site."
msgstr "No está autorizado para cargar documentos en este sitio."

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSuggestedQuestions.tsx
msgid "You can also ask"
msgstr "También puede preguntar"

#: src/features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox.tsx
msgid "You can attach up to {MAX_DOC_CHAT_ATTACHMENTS} images."
msgstr "Puede adjuntar hasta {MAX_DOC_CHAT_ATTACHMENTS} imágenes."

#: src/features/knowledgeDocumentViewer/components/bugReport/BugReportScreenshots.tsx
msgid "You can attach up to 3 screenshots. Remove one before adding more."
msgstr "Puede adjuntar hasta 3 capturas de pantalla. Quite una antes de agregar más."

#: src/features/chatbot/components/ChatbotHelpModal.tsx
msgid "You can expect a response from our team soon."
msgstr "Recibirá pronto una respuesta de nuestro equipo."

#: src/pages/assetLens/components/tabs/imagesTabComponents/ImageUploadModal.tsx
msgid "You can only upload JPG, PNG, GIF, or WEBP files!"
msgstr "Solo puede cargar archivos JPG, PNG, GIF o WEBP."

#: src/pages/manageAccess/components/table/UserRowActions.tsx
msgid "You can't revoke your own access."
msgstr "No puedes revocar tu propio acceso."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You cannot change your own access roles."
msgstr "No puedes cambiar tus propios roles de acceso."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You cannot change your own user type."
msgstr "No puedes cambiar tu propio tipo de usuario."

#: src/pages/manageAccess/ManageAccessPage.tsx
msgid "You do not have access grants in this organization."
msgstr "No tiene permisos de acceso en esta organización."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You do not have permission to change access roles."
msgstr "No tienes permiso para cambiar los roles de acceso."

#: src/pages/manageAccess/components/table/UserRow.tsx
msgid "You do not have permission to change user types."
msgstr "No tienes permiso para cambiar tipos de usuario."

#: src/features/permissions/components/PermissionsGate.tsx
msgid "You do not have permissions to view this page"
msgstr "No tiene permisos para ver esta página"

#: src/features/chatbot/components/ChatbotSidePanel.tsx
msgid "You don't have access to this feature. Contact your admin to request the <0>cantilever:chat:user</0> permission."
msgstr "No tiene acceso a esta función. Contacte a su administrador para solicitar el permiso <0>cantilever:chat:user</0>."

#: src/pages/manageAccess/hooks/useListedRoster.ts
msgid "You don't have permission to revoke this person's access here. Contact an administrator."
msgstr "No tiene permiso para revocar el acceso de esta persona aquí. Comuníquese con un administrador."

#: src/features/terms/TermsModal.tsx
msgid "You must accept the terms to continue."
msgstr "Debe aceptar los términos para continuar."

#: src/features/auth/AuthInactivityMonitor.tsx
msgid "You will be disconnected in {idleModalCountdown, plural, one {# second} other {# seconds}}"
msgstr "Se desconectará en {idleModalCountdown, plural, one {# segundo} other {# segundos}}"

#: src/pages/manageAccess/components/dialogs/ViewAsConfirmDialog.tsx
msgid "You will see navigation and page controls using the permissions shown on this page for {userName}. Site lists and loaded data still use your account. Saving is turned off. Your permissions do not change in the database. An ungated banner at the top of the screen lets you restore your access at any time."
msgstr "Verá la navegación y los controles de las páginas con los permisos de {userName} que se muestran aquí. Las listas de sitios y los datos cargados seguirán usando su cuenta. No podrá guardar cambios. Sus permisos en la base de datos no cambian. Podrá restaurar su acceso en cualquier momento desde el aviso de la parte superior de la pantalla, que siempre estará disponible."

#: src/features/timeSeries/experiment/DiagnosticsPanel.tsx
msgid "your Val timeline chunks"
msgstr "sus segmentos de Validación de la cronología"

#: src/features/timeSeries/components/ActiveTimeRangeSectionWithPopover.tsx
msgid "YTD"
msgstr "Este año"

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "Z — actual "
msgstr "Z — real "

#: src/features/knowledgeDocumentViewer/workOrders/workOrderPdf.ts
msgid "Zero totals do not establish that no work or materials were used."
msgstr "Los totales en cero no demuestran que no se realizaron trabajos ni se utilizaron materiales."

#: src/features/timeSeries/experiment/ExperimentTab.tsx
msgid "zero-width band"
msgstr "banda de ancho cero"

#: src/features/powerCustomerUploads/uploadSource/powerCustomerUploadZipArchiveFiles.ts
msgid "ZIP archives nested more than 10 levels are not supported."
msgstr "No se admiten archivos ZIP anidados en más de 10 niveles."

#: src/features/lotoReports/components/LotoReportEditorHeader.tsx
msgid "Zoom"
msgstr "Zoom"

#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
#: src/pages/processData/buildMode/dock/SplitChunksTable.tsx
msgid "Zoom chart to chunk"
msgstr "Ajustar el gráfico al segmento"

#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
#: src/pages/processData/buildMode/dock/CustomRangesTable.tsx
msgid "Zoom chart to window"
msgstr "Ajustar el gráfico a la ventana"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom in"
msgstr "Acercar"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Zoom In"
msgstr "Acercar"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom out"
msgstr "Alejar"

#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/knowledgeDocumentViewer/components/viewer/shared/ZoomControls.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/ActiveTimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
#: src/features/timeSeries/components/TimeRangeSelector.tsx
msgid "Zoom Out"
msgstr "Alejar"

#: src/features/knowledgeDocumentViewer/components/sidebar/OcrTableColumns.tsx
msgid "Zoom to box"
msgstr "Acercar al cuadro"

#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
#: src/features/facilityModel/components/ReferencePreviewPanel.tsx
msgid "Zoom to citation"
msgstr "Acercar a la cita"

#: src/pages/processData/buildMode/rightPanel/RankingTable.tsx
msgid "σ resid"
msgstr "σ residual"
